/**
 * @author v.lugovsky
 * created on 16.12.2015
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages', [
		'ui.router',
		'ngStorage',
		//'mm.acl',
		'angular-jwt',
		'BlurAdmin.pages.administrador',
		'BlurAdmin.pages.alunos', 
		'BlurAdmin.pages.manutencao', 
		'BlurAdmin.pages.comissao',
		'BlurAdmin.pages.diploma',
		'BlurAdmin.pages.downloads',
		'BlurAdmin.pages.rotinas',
		'BlurAdmin.pages.parecer',
		'BlurAdmin.pages.agendamento',
		'BlurAdmin.pages.proficiencias',
		'BlurAdmin.pages.ui', 
		'BlurAdmin.pages.form',
		
	])
	.constant('AUTH_EVENTS', {
		loginSuccess : 'auth-login-success',
		loginFailed : 'auth-login-failed',
		logoutSuccess : 'auth-logout-success',
		sessionTimeout : 'auth-session-timeout',
		notAuthenticated : 'auth-not-authenticated',
		notAuthorized : 'auth-not-authorized'
	})
	.constant('USER_ROLES', {
		1 : 'aluno',
		2 : 'secretaria',
		3 : 'administrativo',
		4 : 'professor',
	})
	.config(routeConfig)
	.run(run);

	/** @ngInject */
	function routeConfig($urlRouterProvider, $stateProvider, baSidebarServiceProvider,$httpProvider) {
		
	}
	
	function run($rootScope,$location) { //$location
		

		$rootScope.$on('$routeChangeError', function(event, current, previous, rejection){
			if(rejection === 'Unauthorized'){
				$location.path('#/administrador/login');
			}
		});


		$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
			
		});
	}

})();
/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      //'chart.js',
      //'angular-chartist',
      //'angular.morris-chart',
      //'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

/**
 * @author Yury Tinos Pinheiro created on 14/03/2017
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.administrador', [
		'ngSanitize',
		'BlurAdmin.pages.administrador.login',
		'BlurAdmin.pages.administrador.logout',
		'BlurAdmin.pages.administrador.register',
		'BlurAdmin.pages.administrador.login.forgot',
		'BlurAdmin.pages.administrador.register.validador-cpf',
	]).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {

		$urlRouterProvider.when("/administrador", "/administrador/login");
		$urlRouterProvider.otherwise("/administrador/login");
		
		$stateProvider
			.state('administrador', {
				url : '/administrador',
				//abstract: true,
				template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
				title : 'Principal',
				/*sidebarMeta : {
					icon : 'ion-lock-combination',
					order : 0,
				},*/
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos', [
		'ui.select',
		'ngSanitize',
		//'angular-jwt',
		'BlurAdmin.pages.alunos.dadosBasicos',
		'BlurAdmin.pages.alunos.situacao',
		'BlurAdmin.pages.alunos.relatorios'
	]).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		
		$urlRouterProvider.when("/alunos", "/alunos/dadosBasicos/consulta");
		$urlRouterProvider.otherwise("/alunos/dadosBasicos/consulta");
		
		$stateProvider
			.state('alunos', {
				url : '/alunos',
				template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
				title : 'Aluno',
				abstract: true,
				sidebarMeta : {
					icon : 'ion-person',
					order : 10,
				},
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 26/05/2017
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.agendamento', [
		//'BlurAdmin.pages.agendamento.aluno',
		'BlurAdmin.pages.agendamento.relatorios',
		'BlurAdmin.pages.agendamento.preAgendamento',
		'BlurAdmin.pages.agendamento.calendarioFeriado',
		'BlurAdmin.pages.agendamento.anfiteatro',
		'ui.select', 
		'ngSanitize'
	]).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		
		$urlRouterProvider.when("/agendamento", "/agendamento/agendamento");
		$urlRouterProvider.otherwise("/agendamento/agendamento");
		
		$stateProvider
			.state('agendamento', {
				url : '/agendamento',
				abstract: true,
				template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
				title : 'Agendamento',
				sidebarMeta : {
					icon : 'ion-calendar',
					order : 30,
				},
			});
	}

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts', [
      'BlurAdmin.pages.charts.amCharts',
      'BlurAdmin.pages.charts.chartJs',
      'BlurAdmin.pages.charts.chartist',
      'BlurAdmin.pages.charts.morris'
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts', {
          url: '/charts',
          abstract: true,
          template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
          title: 'Charts',
          sidebarMeta: {
            icon: 'ion-stats-bars',
            order: 150,
          },
        });
  }

})();

/**
 * @author 
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.comissao', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
				
		$stateProvider
			.state('comissao', {
				url : '/comissao',
				templateUrl : 'app/pages/comissao/comissao.html',
				title : 'Comissão',
				controller : 'ComissaoPageCtrl',
				sidebarMeta : {
					icon : 'ion-person-stalker',
					order : 80,
				},
			});
	}

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components', [
    'BlurAdmin.pages.components.mail',
    'BlurAdmin.pages.components.timeline',
    'BlurAdmin.pages.components.tree',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('components', {
          url: '/components',
          template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Components',
          sidebarMeta: {
            icon: 'ion-gear-a',
            order: 100,
          },
        });
  }

})();

/**
 * @author 
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.diploma', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
				
		$stateProvider
			.state('diploma', {
				url : '/diploma',
				templateUrl : 'app/pages/diploma/diploma.html',
				title : 'Diploma',
				controller : 'DiplomaPageCtrl',
				sidebarMeta : {
					icon : 'ion-university',
					order : 80,
				},
			});
	}

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard', {
          url: '/dashboard',
          templateUrl: 'app/pages/dashboard/dashboard.html',
          title: 'Dashboard',
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 1,
          },
        });
  }

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.downloads', [
		'BlurAdmin.pages.downloads.ata',
		'BlurAdmin.pages.downloads.ordem',
		'BlurAdmin.pages.downloads.formularios',
		'BlurAdmin.pages.downloads.documentos',
	]).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		
		$urlRouterProvider.when("/downloads", "/downloads/ata");
		$urlRouterProvider.otherwise("/downloads/ata");
		
		$stateProvider
			.state('downloads', {
				url : '/downloads',
				template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
				title : 'Downloads',
				abstract: true,
				sidebarMeta : {
					icon : 'ion-android-download',
					order : 60,
				},
			});
	}

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form', ['ui.select', 'ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    /*$stateProvider
        .state('form', {
          url: '/form',
          template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Form Elements',
          sidebarMeta: {
            icon: 'ion-compose',
            order: 250,
          },
        })
        .state('form.inputs', {
          url: '/inputs',
          templateUrl: 'app/pages/form/inputs/inputs.html',
          title: 'Form Inputs',
          sidebarMeta: {
            order: 0,
          },
        })
        .state('form.layouts', {
          url: '/layouts',
          templateUrl: 'app/pages/form/layouts/layouts.html',
          title: 'Form Layouts',
          sidebarMeta: {
            order: 100,
          },
        })
        .state('form.wizard',
        {
          url: '/wizard',
          templateUrl: 'app/pages/form/wizard/wizard.html',
          controller: 'WizardCtrl',
          controllerAs: 'vm',
          title: 'Form Wizard',
          sidebarMeta: {
            order: 200,
          },
        });*/
  }
})();

/**
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.manutencao', [
		'filters.filters',
		'BlurAdmin.pages.directives',
		'BlurAdmin.pages.manutencao.usuario',
		'BlurAdmin.pages.manutencao.log',
		'BlurAdmin.pages.manutencao.programas',
		'BlurAdmin.pages.manutencao.comissao',
		'BlurAdmin.pages.manutencao.equipe',
		'BlurAdmin.pages.manutencao.portaria',
		'BlurAdmin.pages.manutencao.editar',
		'BlurAdmin.pages.manutencao.adicionar',
		'BlurAdmin.pages.administrador.register.validador-cpf',
	]).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {

		$urlRouterProvider.when("/manutencao", "/manutencao/usuario");
		$urlRouterProvider.otherwise("/manutencao/usuario");

		$stateProvider
			.state('manutencao', {
				url : '/manutencao',
				template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
				title : 'Manutenção',
				sidebarMeta : {
					icon : 'ion-ios-gear',
					order : 100,
				},
			});
	}

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('maps', {
          url: '/maps',
          templateUrl: 'app/pages/maps/maps.html',
          abstract: true,
          title: 'Maps',
          sidebarMeta: {
            icon: 'ion-ios-location-outline',
            order: 500,
          },
        })
        .state('maps.gmap', {
          url: '/gmap',
          templateUrl: 'app/pages/maps/google-maps/google-maps.html',
          controller: 'GmapPageCtrl',
          title: 'Google Maps',
          sidebarMeta: {
            order: 0,
          },
        })
        .state('maps.leaflet', {
          url: '/leaflet',
          templateUrl: 'app/pages/maps/leaflet/leaflet.html',
          controller: 'LeafletPageCtrl',
          title: 'Leaflet Maps',
          sidebarMeta: {
            order: 100,
          },
        })
        .state('maps.bubble', {
          url: '/bubble',
          templateUrl: 'app/pages/maps/map-bubbles/map-bubbles.html',
          controller: 'MapBubblePageCtrl',
          title: 'Bubble Maps',
          sidebarMeta: {
            order: 200,
          },
        })
        .state('maps.line', {
          url: '/line',
          templateUrl: 'app/pages/maps/map-lines/map-lines.html',
          controller: 'MapLinesPageCtrl',
          title: 'Line Maps',
          sidebarMeta: {
            order: 300,
          },
        });
  }

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.proficiencias', [
		'BlurAdmin.pages.proficiencias.consulta',
		'BlurAdmin.pages.proficiencias.carga',
		//'BlurAdmin.pages.proficiencias.certificado',
		'BlurAdmin.pages.proficiencias.declaracao',
	]).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {
		
		$urlRouterProvider.when("/proficiencias", "/proficiencias/consulta");
		$urlRouterProvider.otherwise("/proficiencias/consulta");
		
		$stateProvider
			.state('proficiencias', {
				url : '/proficiencias',
				template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
				title : 'Proficiência',
				abstract: true,
				sidebarMeta : {
					icon : 'ion-ribbon-b',
					order : 20,
				},
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.parecer', [
		'ngSanitize',
		'BlurAdmin.pages.parecer.consulta',
		'BlurAdmin.pages.parecer.editar'
	]).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider ) {

		$urlRouterProvider.when("/parecer", "/parecer/consulta");
		$urlRouterProvider.otherwise("/parecer/consulta");

		$stateProvider
			.state('parecer', {
				url : '/parecer',
				//abstract: true,
				template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
				title : 'Parecer',
				sidebarMeta : {
					icon : 'ion-ios-compose-outline',
					order : 70,
				},
			});
	}

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('profile', {
          url: '/profile',
          title: 'Profile',
          templateUrl: 'app/pages/profile/profile.html',
          controller: 'ProfilePageCtrl',
        });
  }

})();

/**
 * 
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.rotinas', [
		'BlurAdmin.pages.rotinas.protocolo',
		'BlurAdmin.pages.rotinas.oficio',
		'BlurAdmin.pages.rotinas.titulo',
	]).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider) {

		$stateProvider
			.state('rotinas', {
				url : '/rotinas',
				template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
				title : 'Rotinas Administrativas',
				abstract: true,
				sidebarMeta : {
					icon : 'ion-android-desktop',
					order : 60,
				},
			});
	}

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('tables', {
          url: '/tables',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          controller: 'TablesPageCtrl',
          title: 'Tables',
          sidebarMeta: {
            icon: 'ion-grid',
            order: 300,
          },
        }).state('tables.basic', {
          url: '/basic',
          templateUrl: 'app/pages/tables/basic/tables.html',
          title: 'Basic Tables',
          sidebarMeta: {
            order: 0,
          },
        }).state('tables.smart', {
          url: '/smart',
          templateUrl: 'app/pages/tables/smart/tables.html',
          title: 'Smart Tables',
          sidebarMeta: {
            order: 100,
          },
        });
    $urlRouterProvider.when('/tables','/tables/basic');
  }

})();

/**
 * @author k.danovsky
 * created on 12.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui', [
    'BlurAdmin.pages.ui.typography',
    'BlurAdmin.pages.ui.buttons',
    'BlurAdmin.pages.ui.icons',
    'BlurAdmin.pages.ui.modals',
    'BlurAdmin.pages.ui.grid',
    'BlurAdmin.pages.ui.alerts',
    'BlurAdmin.pages.ui.progressBars',
    'BlurAdmin.pages.ui.notifications',
    'BlurAdmin.pages.ui.tabs',
    'BlurAdmin.pages.ui.slider',
    'BlurAdmin.pages.ui.panels',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    /*$stateProvider
        .state('ui', {
          url: '/ui',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'UI Features',
          sidebarMeta: {
            icon: 'ion-android-laptop',
            order: 200,
          },
        });*/
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

/**
 * @author Yury Tinos Pinheiro created on 14/03/2017
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.administrador.login.forgot', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		
		$stateProvider
			.state('administrador.login.forgot', {
				url : '/login',
				templateUrl : 'app/pages/administrador/login/forgot.html',
				title : 'Esqueceu sua Senha',
				controller : 'ForgotPageCtrl',
				/*sidebarMeta : {
					icon : 'ion-ribbon-b',
					order : 0,
				},*/
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 14/03/2017
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.administrador.login', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		
		$stateProvider
			.state('administrador.login', {
				url : '/login',
				templateUrl : 'app/pages/administrador/login/login.html',
				title : 'Login',
				controller : 'LoginPageCtrl',
				/*sidebarMeta : {
					icon : 'ion-ribbon-b',
					order : 0,
				},*/
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 14/03/2017
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.administrador.logout', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		
		$stateProvider
			.state('administrador.logout', {
				url : '/logout',
				title : 'Sair',
				controller : 'LogoutPageCtrl',
				/*sidebarMeta : {
					icon : 'ion-ribbon-b',
					order : 0,
				},*/
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 14/03/2017
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.administrador.register', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		
		$stateProvider
			.state('administrador.register', {
				url : '/register',
				templateUrl : 'app/pages/administrador/register/register.html',
				title : 'Cadastro',
				controller : 'RegisterPageCtrl',
				/*sidebarMeta : {
					icon : 'ion-ribbon-b',
					order : 0,
				},*/
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos.dadosBasicos', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('alunos.consultaDadosBasicos', {
				parent: 'alunos',
				url : '/dadosBasicos/consulta',
				templateUrl : 'app/pages/alunos/dadosBasicos/consulta.html',
				title : 'Ficha de Aluno',
				controller : 'DadosBasicosConsultaAlunosPageCtrl',
				sidebarMeta : {
					order : 10,
					icon: 'ion-clipboard',
				},
			})
			.state('alunos.dadosBasicos', {
				parent: 'alunos',
				url : '/dadosBasicos',
				templateUrl : 'app/pages/alunos/dadosBasicos/dadosBasicos.html',
				title : 'Dados Pessoais',
				controller : 'DadosBasicosAlunoPageCtrl',
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 10/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos.relatorios', [
		'BlurAdmin.pages.alunos.relatorios.relatorio'
	]).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('alunos.relatorios', {
				parent: 'alunos',
				url : '/relatorios',
				templateUrl : 'app/pages/alunos/relatorios/relatorios.html',
				title : 'Relatórios',
				controller: 'RelatoriosAlunosPageCtrl',
				sidebarMeta : {
					order : 20,
				},
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos.situacao', ['ngSanitize',
		'BlurAdmin.pages.alunos.situacao.documentos'
	]).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
//			.state('alunos.consultaSituacao', {
//				parent: 'alunos',
//				url : '/situacao/consulta',
//				templateUrl : 'app/pages/alunos/situacao/consulta.html',
//				title : 'Situação',
//				controller : 'SituacaoConsultaAlunosPageCtrl',
//				sidebarMeta : {
//					icon : 'ion-ribbon-b',
//					order : 2,
//				},
//			})
			.state('alunos.situacao', {
				parent: 'alunos',
				url : '/situacao',
				templateUrl : 'app/pages/alunos/situacao/situacao.html',
				title : 'Dados Acadêmicos',
				controller : 'SituacaoAlunosPageCtrl',
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 27/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.agendamento.anfiteatro', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('agendamento.consultaAnfiteatro', {
				parent: 'agendamento',
				url : '/anfiteatros/consulta',
				templateUrl : 'app/pages/agendamento/anfiteatro/consulta.html',
				title : 'Anfiteatros',
				controller : 'ConsultaAnfiteatroAgendamentoPageCtrl',
				sidebarMeta : {
					order : 40,
				},
			})
			.state('agendamento.anfiteatro', {
				parent: 'agendamento',
				url : '/anfiteatro',
				templateUrl : 'app/pages/agendamento/anfiteatro/anfiteatro.html',
				title : 'Anfiteatro',
				controller : 'AnfiteatroAgendamentoPageCtrl',
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 27/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.agendamento.preAgendamento', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('agendamento.preAgendamento', {
				parent: 'agendamento',
				url : '/agendamento',
				templateUrl : 'app/pages/agendamento/preAgendamento/calendario.html',
				title : 'Agendamentos',
				controller : 'PreAgendamentoPageCtrl',
				sidebarMeta : {
					order : 20,
				},
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 27/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.agendamento.calendarioFeriado', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('agendamento.consultaFeriado', {
				parent: 'agendamento',
				url : '/Feriados/consulta',
				templateUrl : 'app/pages/agendamento/calendarioFeriado/consulta.html',
				title : 'Feriados',
				controller : 'ConsultaCalendarioFeriadoAgendamentoPageCtrl',
				sidebarMeta : {
					order : 30,
				},
			})
			.state('agendamento.feriado', {
				parent: 'agendamento',
				url : '/calendarioFeriado',
				templateUrl : 'app/pages/agendamento/calendarioFeriado/feriado.html',
				title : 'Feriado',
				controller : 'CalendarioFeriadoAgendamentoPageCtrl',
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 26/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.agendamento.relatorios', [
		'BlurAdmin.pages.agendamento.relatorios.relatorio',
		'BlurAdmin.pages.agendamento.relatorios.aluno',
	]).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('agendamento.relatorios', {
				parent: 'agendamento',
				url : '/relatorios',
				templateUrl : 'app/pages/agendamento/relatorios/relatorios.html',
				title : 'Relatórios',
				controller: 'RelatoriosAgendamentoPageCtrl',
				sidebarMeta : {
					order : 10,
				},
			});
	}

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts', [])
      .config(routeConfig).config(amChartConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.amCharts', {
          url: '/amCharts',
          templateUrl: 'app/pages/charts/amCharts/charts.html',
          title: 'amCharts',
          sidebarMeta: {
            order: 0,
          },
        });
  }

  function amChartConfig(baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    AmCharts.themes.blur = {

      themeName: "blur",

      AmChart: {
        color: layoutColors.defaultText,
        backgroundColor: "#FFFFFF"
      },

      AmCoordinateChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmStockChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmSlicedChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark],
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3
      },

      AmRectangularChart: {
        zoomOutButtonColor: '#FFFFFF',
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lens.png"
      },

      AxisBase: {
        axisColor: "#FFFFFF",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#FFFFFF"
      },

      ChartScrollbar: {
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.12,
        graphFillAlpha: 0.5,
        graphLineAlpha: 0,
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.4,
        gridAlpha: 0.15
      },

      ChartCursor: {
        cursorColor: layoutColors.primary,
        color: "#FFFFFF",
        cursorAlpha: 0.5
      },

      AmLegend: {
        color: "#FFFFFF"
      },

      AmGraph: {
        lineAlpha: 0.9
      },
      GaugeArrow: {
        color: "#FFFFFF",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
      },

      GaugeAxis: {
        tickColor: "#FFFFFF",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: '#FFFFFF',
        axisAlpha: 1,
        bandAlpha: 0.8
      },

      TrendLine: {
        lineColor: layoutColors.danger,
        lineAlpha: 0.8
      },

      // ammap
      AreasSettings: {
        alpha: 0.8,
        color: layoutColors.info,
        colorSolid: layoutColors.primaryDark,
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#FFFFFF",
        outlineColor: "#FFFFFF",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverColor: layoutColors.primary,
        rollOverOutlineColor: "#FFFFFF",
        selectedOutlineColor: "#FFFFFF",
        selectedColor: "#f15135",
        unlistedAreasOutlineColor: "#FFFFFF",
        unlistedAreasOutlineAlpha: 0.5
      },

      LinesSettings: {
        color: "#FFFFFF",
        alpha: 0.8
      },

      ImagesSettings: {
        alpha: 0.8,
        labelColor: "#FFFFFF",
        color: "#FFFFFF",
        labelRollOverColor: layoutColors.primaryDark
      },

      ZoomControl: {
        buttonFillAlpha: 0.8,
        buttonIconColor: layoutColors.defaultText,
        buttonRollOverColor: layoutColors.danger,
        buttonFillColor: layoutColors.primaryDark,
        buttonBorderColor: layoutColors.primaryDark,
        buttonBorderAlpha: 0,
        buttonCornerRadius: 0,
        gridColor: "#FFFFFF",
        gridBackgroundColor: "#FFFFFF",
        buttonIconAlpha: 0.6,
        gridAlpha: 0.6,
        buttonSize: 20
      },

      SmallMap: {
        mapColor: "#000000",
        rectangleColor: layoutColors.danger,
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.7,
        borderThickness: 1,
        borderAlpha: 0.8
      },

      // the defaults below are set using CSS syntax, you can use any existing css property
      // if you don't use Stock chart, you can delete lines below
      PeriodSelector: {
        color: "#FFFFFF"
      },

      PeriodButton: {
        color: "#FFFFFF",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
      },

      PeriodButtonSelected: {
        color: "#FFFFFF",
        backgroundColor: "#b9cdf5",
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
      },

      PeriodInputField: {
        color: "#FFFFFF",
        background: "transparent",
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      },

      DataSetSelector: {
        color: "#FFFFFF",
        selectedBackgroundColor: "#b9cdf5",
        rollOverBackgroundColor: "#a8b0e4"
      },

      DataSetCompareList: {
        color: "#FFFFFF",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(0, 0, 0, .3)"
      },

      DataSetSelect: {
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      }

    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/17/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.chartist', {
          url: '/chartist',
          templateUrl: 'app/pages/charts/chartist/chartist.html',
          title: 'Chartist',
          sidebarMeta: {
            order: 100,
          },
        });
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.charts.chartJs', [])
        .config(routeConfig).config(chartJsConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('charts.chartJs', {
                url: '/chartJs',
                templateUrl: 'app/pages/charts/chartJs/chartJs.html',
                title: 'Chart.js',
                sidebarMeta: {
                    order: 200
                }
            });
    }

    function chartJsConfig(ChartJsProvider, baConfigProvider) {
        var layoutColors = baConfigProvider.colors;
        // Configure all charts
        ChartJsProvider.setOptions({
            chartColors: [
                layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight],
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 2500
            },
            scale: {
                gridLines: {
                    color: layoutColors.border
                },
                scaleLabel: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    fontColor: layoutColors.defaultText,
                    showLabelBackdrop: false
                }
            }
        });
        // Configure all line charts
        ChartJsProvider.setOptions('Line', {
            datasetFill: false
        });
        // Configure all radar charts
        ChartJsProvider.setOptions('radar', {
            scale: {
                pointLabels: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    maxTicksLimit: 5,
                    display: false
                }
            }
        });
        // Configure all bar charts
        ChartJsProvider.setOptions('bar', {
            tooltips: {
                enabled: false
            }
        });
    }

})();
/**
 * @author a.demeshko
 * created on 12/18/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris', [])
    .config(routeConfig).config(function(baConfigProvider){
      var layoutColors = baConfigProvider.colors;
      Morris.Donut.prototype.defaults.backgroundColor = 'transparent';
      Morris.Donut.prototype.defaults.labelColor = layoutColors.defaultText;
      Morris.Grid.prototype.gridDefaults.gridLineColor = layoutColors.borderDark;
      Morris.Grid.prototype.gridDefaults.gridTextColor = layoutColors.defaultText;
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.morris', {
          url: '/morris',
          templateUrl: 'app/pages/charts/morris/morris.html',
          title: 'Morris',
          sidebarMeta: {
            order: 300,
          }
        });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('components.mail', {
          url: '/mail',
          abstract: true,
          templateUrl: 'app/pages/components/mail/mail.html',
          controller: "MailTabCtrl",
          controllerAs: "tabCtrl",
          title: 'Mail',
          sidebarMeta: {
            order: 0,
          },
        }).state('components.mail.label', {
          url: '/:label',
          templateUrl: 'app/pages/components/mail/list/mailList.html',
          title: 'Mail',
          controller: "MailListCtrl",
          controllerAs: "listCtrl"
        }).state('components.mail.detail', {
          url: '/:label/:id',
          templateUrl: 'app/pages/components/mail/detail/mailDetail.html',
          title: 'Mail',
          controller: "MailDetailCtrl",
          controllerAs: "detailCtrl"
        });
    $urlRouterProvider.when('/components/mail','/components/mail/inbox');
  }

})();

/**
 * @author a.demeshko
 * created on 1/12/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('components.timeline', {
        url: '/timeline',
        templateUrl: 'app/pages/components/timeline/timeline.html',
          title: 'Timeline',
          sidebarMeta: {
            icon: 'ion-ios-pulse',
            order: 100,
          },
      });
  }
})();
/**
 * @author a.demeshko
 * created on 12.21.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree', [])
    .config(routeConfig)
    .config(function(){
      $.jstree.defaults.core.themes.url = true;
      $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('components.tree', {
          url: '/tree',
          templateUrl: 'app/pages/components/tree/tree.html',
          title: 'Tree View',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.downloads.ata', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider.state('downloads.ata', {
			parent: 'downloads',
			url : '/ata',
			templateUrl : 'app/pages/downloads/ata/ata.html',
			title : 'Ata de Reunião',
			controller : 'AtaPageCtrl',
			sidebarMeta : {
				order : 10,
			},
		});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.downloads.documentos', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider.state('downloads.documentos', {
			parent: 'downloads',
			url : '/documentos',
			templateUrl : 'app/pages/downloads/documentos/documentos.html',
			title : 'Documentos Legislações',
			controller : 'DocumentosPageCtrl',
			sidebarMeta : {
				order : 40,
			},
		});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.downloads.formularios', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider.state('downloads.formularios', {
			parent: 'downloads',
			url : '/formularios',
			templateUrl : 'app/pages/downloads/formularios/formularios.html',
			title : 'Formulários',
			controller : 'FormulariosPageCtrl',
			sidebarMeta : {
				order : 30,
			},
		});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.downloads.ordem', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider.state('downloads.ordem', {
			parent: 'downloads',
			url : '/ordem',
			templateUrl : 'app/pages/downloads/ordem/ordem.html',
			title : 'Ordem do dia',
			controller : 'OrdemPageCtrl',
			sidebarMeta : {
				order : 20,
			},
		});
	}

})();

/**
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.manutencao.adicionar', [
		'BlurAdmin.pages.administrador.register.validador-cpf',
	]).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('manutencao.adicionar', {
				url : '/adicionar',
				templateUrl : 'app/pages/manutencao/adicionar/adicionar.html',
				controller : 'AdicionarPageCtrl',
				title : 'Adicionar'
			});
	}

})();
/**
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.manutencao.comissao', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('manutencao.comissao', {
				url : '/comissao',
				templateUrl : 'app/pages/manutencao/comissao/comissao.html',
				title : 'Comissão de Pós',
				controller : 'ManutencaoComissaoPageCtrl',
				sidebarMeta : {
					icon : 'ion-android-list',
					order : 30,
				},
			});
	}

})();
/**
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.manutencao.editar', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('manutencao.editar',{
				url : '/editar?user',
				templateUrl : 'app/pages/manutencao/editar/editar.html',
				title : 'Editar',
				controller : 'EditarPageCtrl'
			});
	}

})();
/**
 */
(function() {
	'use strict';

	angular.module(
		'BlurAdmin.pages.manutencao.equipe',
		['BlurAdmin.pages.directives']
	)
	.config(routeConfig)
	.constant('BOSS_JOB', 'Chefe de Serviço de Pós-Graduação');

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('manutencao.equipe', {
				url : '/equipe',
				templateUrl : 'app/pages/manutencao/equipe/equipe.html',
				title : 'Equipe',
				controller : 'ManutencaoEquipePageCtrl',
				sidebarMeta : {
					icon : 'ion-android-list',
					order : 30,
				},
			});
	}

})();
/**
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.manutencao.log', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('manutencao.log', {
				url : '/log',
				templateUrl : 'app/pages/manutencao/log/log.html',
				title : 'Auditoria',
				controller : 'LogPageCtrl',
				sidebarMeta : {
					icon : 'ion-ios-people',
					order : 10,
				},
			});
	}

})();
/**
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.manutencao.portaria', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('manutencao.portaria', {
				url : '/portaria',
				templateUrl : 'app/pages/manutencao/portaria/portaria.html',
				title : 'Portaria',
				controller : 'ManutencaoPortariaPageCtrl',
				sidebarMeta : {
					icon : 'ion-android-list',
					order : 30,
				},
			});
	}

})();
/**
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.manutencao.programas', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('manutencao.programas', {
				url : '/programas',
				templateUrl : 'app/pages/manutencao/programas/programas.html',
				title : 'Programas',
				controller : 'ProgramasPageCtrl',
				sidebarMeta : {
					icon : 'ion-ios-keypad',
					order : 20,
				},
			});
	}

})();
/**
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.pages.manutencao.usuario', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('manutencao.usuario', {
				url : '/usuario',
				templateUrl : 'app/pages/manutencao/usuario/usuario.html',
				title : 'Usuário',
				controller : 'UsuarioPageCtrl',
				sidebarMeta : {
					icon : 'ion-ios-people',
					order : 10,
				},
			});
	}

})();
/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.proficiencias.carga', []).config(routeConfig);
	routeConfig.$Inject = ['AuthService'];
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider
			.state('proficiencias.carga', {
				parent: 'proficiencias',
				url : '/carga',
				templateUrl : 'app/pages/proficiencias/carga/carga.html',
				title : 'Carga',
				//auth: ['AuthService',function(AuthService){AuthService.isAuthorizedToAccess([2,3]);}],
				controller : 'CargaProficienciasPageCtrl',
				sidebarMeta : {
					order : 20,
				},
				
				/*
				resolve : {
					'acl' : ['AuthService', function(AuthService){
						return AuthService.isAuthorizedToAccess([2,3]);
					}]
				},
				resolve : {
					'acl' : ['$q', 'AclService', function($q, AclService){
						if(AclService.can('manage_content')){
							// Has proper permissions
							return true;
						} else {
							// Does not have permission
							return $q.reject('Unauthorized');
						}
					}]
				}*/
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.proficiencias.certificado', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider.state('proficiencias.certificado', {
			parent: 'proficiencias',
			url : '/certificado',
			templateUrl : 'app/pages/proficiencias/certificado/certificado.html',
			title : 'Certificado',
			controller : 'CertificadoProficienciasPageCtrl',
			sidebarMeta : {
				order : 2,
			},

		});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.proficiencias.consulta', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider.state('proficiencias.consulta', {
			parent: 'proficiencias',
			url : '/consulta',
			templateUrl : 'app/pages/proficiencias/consulta/consulta.html',
			title : 'Consulta',
			controller : 'ConsultaProficienciasPageCtrl',
			sidebarMeta : {
				order : 10,
			},
		})
		.state('proficiencias.editar', {
			parent: 'proficiencias',
			url : '/editar',
			templateUrl : 'app/pages/proficiencias/consulta/editar.html',
			title : 'Editar Proficiencia',
			controller : 'EditarProficienciasPageCtrl',
		});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.proficiencias.declaracao', []).config(routeConfig);
	angular.module('BlurAdmin.pages.proficiencias.declaracao').filter('capitalize', function() {
	    return function(input, scope) {
	      if (input!=null) {
	          var stringArr = input.split(" ");
	          var result = "";
	          var cap = stringArr.length;
	          for(var x = 0; x < cap; x++) {
	            stringArr[x].toLowerCase();
	            if(x === cap - 1) {
	              result += stringArr[x].substring(0,1).toUpperCase() + stringArr[x].substring(1);
	            } else {
	              result += stringArr[x].substring(0,1).toUpperCase() + stringArr[x].substring(1) + " ";
	            }
	          }
	        return result;
	      }
	    }
  	});

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider.state('proficiencias.declaracao', {
			parent: 'proficiencias',
			url : '/declaracao',
			templateUrl : 'app/pages/proficiencias/declaracao/declaracao.html',
			title : 'Declaração',
			controller : 'DeclaracaoProficienciasPageCtrl',
			/*sidebarMeta : {
				order : 4,
			},*/
		});
	}

})();
/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.parecer.consulta', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('parecer.consulta', {
				parent: 'parecer',
				url : '/consulta',
				templateUrl : 'app/pages/parecer/consulta/parecer.html',
				title : 'Consulta',
				controller : 'ParecerPageCtrl',
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.parecer.editar', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('parecer.editar', {
				parent: 'parecer',
				url : '/parecer-editar',
				templateUrl : 'app/pages/parecer/editar/editarParecer.html',
				title : 'Parecer ',
				controller : 'EditarParecerPageCtrl',
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.rotinas.protocolo', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider.state('rotinas.protocolo', {
			parent: 'rotinas',
			url : '/protocolo',
			templateUrl : 'app/pages/rotinas/protocolo/protocolo.html',
			title : 'Protocolo',
			controller : 'ProtocoloPageCtrl',
			sidebarMeta : {
				order : 20,
			}
		})
		.state('rotinas.protocolo.editar', {
			parent: 'rotinas',
			url : '/protocolo-editar',
			params: {
	            maxCod: null
	        },
			templateUrl : 'app/pages/rotinas/widget/protocolo/editarProtocolo.html',
			title : 'Protocolo',
			controller : 'EditarRotinaProtocoloPageCtrl',
		});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.rotinas.oficio', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider.state('rotinas.oficio', {
			parent: 'rotinas',
			url : '/oficio',
			templateUrl : 'app/pages/rotinas/oficio/oficio.html',
			title : 'Ofício',
			controller : 'OficioPageCtrl',
			sidebarMeta : {
				order : 30,
			},
		});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.rotinas.titulo', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider.state('rotinas.titulo', {
			parent: 'rotinas',
			url : '/titulo',
			templateUrl : 'app/pages/rotinas/titulo/titulo.html',
			title : 'Reconhec. de Título',
			controller : 'TituloPageCtrl',
			sidebarMeta : {
				order : 10,
			},
		});
	}

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.alerts', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.alerts', {
          url: '/alerts',
          templateUrl: 'app/pages/ui/alerts/alerts.html',
          title: 'Alerts',
          sidebarMeta: {
            order: 500,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.buttons', {
          url: '/buttons',
          templateUrl: 'app/pages/ui/buttons/buttons.html',
          controller: 'ButtonPageCtrl',
          title: 'Buttons',
          sidebarMeta: {
            order: 100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.grid', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.grid', {
          url: '/grid',
          templateUrl: 'app/pages/ui/grid/grid.html',
          title: 'Grid',
          sidebarMeta: {
            order: 400,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.icons', {
          url: '/icons',
          templateUrl: 'app/pages/ui/icons/icons.html',
          controller: 'IconsPageCtrl',
          title: 'Icons',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.modals', {
          url: '/modals',
          templateUrl: 'app/pages/ui/modals/modals.html',
          controller: 'ModalsPageCtrl',
          title: 'Modals',
          sidebarMeta: {
            order: 300,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.notifications', {
          url: '/notifications',
          templateUrl: 'app/pages/ui/notifications/notifications.html',
          controller: 'NotificationsPageCtrl',
          title: 'Notifications',
          sidebarMeta: {
            order: 700,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.panels', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.panels', {
          url: '/panels',
          templateUrl: 'app/pages/ui/panels/panels.html',
          controller: 'NotificationsPageCtrl',
          title: 'Panels',
          sidebarMeta: {
            order: 1100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.progressBars', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.progressBars', {
          url: '/progressBars',
          templateUrl: 'app/pages/ui/progressBars/progressBars.html',
          title: 'Progress Bars',
          sidebarMeta: {
            order: 600,
          },
        });
  }

})();

/**
 * @author a.demeshko
 * created on 12/22/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.slider', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.slider', {
          url: '/slider',
          templateUrl: 'app/pages/ui/slider/slider.html',
          title: 'Sliders',
          sidebarMeta: {
            order: 1000,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 21.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.tabs', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.tabs', {
          url: '/tabs',
          templateUrl: 'app/pages/ui/tabs/tabs.html',
          title: 'Tabs & Accordions',
          sidebarMeta: {
            order: 800,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.typography', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.typography', {
          url: '/typography',
          templateUrl: 'app/pages/ui/typography/typography.html',
          title: 'Typography',
          sidebarMeta: {
            order: 0,
          },
        });
  }

})();

/**
 * @author Yury Tinos Pinheiro created on 10/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos.relatorios.relatorio', [
		'BlurAdmin.pages.alunos.relatorios.relatorio.listagens',
		'BlurAdmin.pages.alunos.relatorios.relatorio.periodo',
	]).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('alunos.relatorios.relatorio', {
				parent: 'alunos.relatorios',
				url : '/relatorio',
				template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 03/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos.situacao.documentos', [
		'BlurAdmin.pages.alunos.situacao.documentos.oficios'
	]).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		
		$stateProvider
			.state('alunos.situacao.documentos', {
				parent: 'alunos',
				url : '/documentos',
				template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
				title : 'Documentos',
			})
			.state('alunos.situacao.documentos.bancaDefesa', {
				parent: 'alunos',
				url : '/bancaDefesa',
				templateUrl : 'app/pages/alunos/situacao/documentos/bancaDefesa.html',
				title : 'Banca Defesa',
				controller : 'SituacaoBancaDefesaAlunosPageCtrl',
			})
			.state('alunos.situacao.documentos.recibo', {
				parent: 'alunos',
				url : '/recibo',
				templateUrl : 'app/pages/alunos/situacao/documentos/recibo.html',
				title : 'Recibo',
				controller : 'SituacaoReciboAlunosPageCtrl',
			})
			.state('alunos.situacao.documentos.ataExqua', {
				parent: 'alunos',
				url : '/ataExqua',
				templateUrl : 'app/pages/alunos/situacao/documentos/ataExqua.html',
				title : 'Ata Exqua',
				controller : 'SituacaoAtaExquaAlunosPageCtrl',
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 10/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.agendamento.relatorios.aluno', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('agendamento.relatorios.aluno', {
				parent: 'agendamento',
				url : '/aluno',
				templateUrl : 'app/pages/agendamento/relatorios/aluno/aluno.html',
				title : 'Aluno',
				controller: 'AlunoAgendamentoPageCtrl',
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 10/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.agendamento.relatorios.relatorio', [
		'BlurAdmin.pages.agendamento.relatorios.relatorio.agendamentos'
	]).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('agendamento.relatorios.relatorio', {
				parent: 'agendamento.relatorios',
				url : '/relatorio',
				template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
				abstract: true,
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 18/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos.relatorios.relatorio.listagens', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('alunos.relatorios.relatorio.listagens', {
				parent: 'alunos.relatorios.relatorio',
				url : '/relatorio/listagens/porOrientador',
				abstract: true,
			})
			.state('alunos.relatorios.relatorio.listagens.porOrientador', {
				parent: 'alunos',
				url : '/relatorio/listagens/porOrientador',
				templateUrl : 'app/pages/alunos/relatorios/relatorio/listagens/porOrientador.html',
				title : 'Alunos por Orientador',
				controller: 'RelatorioListagensAlunosPageCtrl',
			})
			/*.state('alunos.relatorios.relatorio.listagens.semPlanoPesquisa', {
				parent: 'alunos',
				url : '/relatorio/listagens/semPlanoPesquisa',
				templateUrl : 'app/pages/alunos/relatorios/relatorio/listagens/semPlanoPesquisa.html',
				title : 'Alunos sem Plano de Pesquisa',
				controller: 'RelatorioListagensAlunosPageCtrl',
			})*/
			.state('alunos.relatorios.relatorio.listagens.porArea', {
				parent: 'alunos',
				url : '/relatorio/listagens/porArea',
				templateUrl : 'app/pages/alunos/relatorios/relatorio/listagens/porArea.html',
				title : 'Alunos por Área',
				controller: 'RelatorioListagensAlunosPageCtrl',
			})
			.state('alunos.relatorios.relatorio.listagens.aptosQualificacao', {
				parent: 'alunos',
				url : '/relatorio/listagens/aptosQualificacao',
				templateUrl : 'app/pages/alunos/relatorios/relatorio/listagens/aptosQualificacao.html',
				title : 'Alunos Aptos para Qualificação',
				controller: 'RelatorioListagensAlunosPageCtrl',
			})
			.state('alunos.relatorios.relatorio.listagens.numeroGeralAlunosPorArea', {
				parent: 'alunos',
				url : '/relatorio/listagens/numeroGeralAlunosPorArea',
				templateUrl : 'app/pages/alunos/relatorios/relatorio/listagens/numeroGeralAlunosPorArea.html',
				title : 'Número Geral de Alunos por Área',
				controller: 'RelatorioListagensAlunosPageCtrl',
			})
			.state('alunos.relatorios.relatorio.listagens.numeroAlunosRegularmenteMatriculadosPorArea', {
				parent: 'alunos',
				url : '/relatorio/listagens/numeroAlunosRegularmenteMatriculadosPorArea',
				templateUrl : 'app/pages/alunos/relatorios/relatorio/listagens/numeroAlunosRegularmenteMatriculadosPorArea.html',
				title : 'Alunos Regularmente Matriculados',
				controller: 'RelatorioListagensAlunosPageCtrl',
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 18/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos.relatorios.relatorio.periodo', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('alunos.relatorios.relatorio.periodo', {
				parent: 'alunos.relatorios.relatorio',
				url : '/relatorio/periodo/comPrazoFinal',
				abstract: true,
			})
			.state('alunos.relatorios.relatorio.periodo.comPrazoFinal', {
				parent: 'alunos',
				url : '/relatorio/periodo/comPrazoFinal',
				templateUrl : 'app/pages/alunos/relatorios/relatorio/periodo/comPrazoFinal.html',
				title : 'Alunos com Prazo Final',
				controller: 'RelatorioPeriodoAlunosPageCtrl',
			})
			.state('alunos.relatorios.relatorio.periodo.comPrazoFinalTrancamento', {
				parent: 'alunos',
				url : '/relatorio/periodo/comPrazoFinalTrancamento',
				templateUrl : 'app/pages/alunos/relatorios/relatorio/periodo/comPrazoFinalTrancamento.html',
				title : 'Alunos com Prazo Final do Trancamento',
				controller: 'RelatorioPeriodoAlunosPageCtrl',
			})
			.state('alunos.relatorios.relatorio.periodo.comExameQualificacao', {
				parent: 'alunos',
				url : '/relatorio/periodo/comExameQualificacao',
				templateUrl : 'app/pages/alunos/relatorios/relatorio/periodo/comExameQualificacao.html',
				title : 'Alunos com Exame de Qualificação',
				controller: 'RelatorioPeriodoAlunosPageCtrl',
			})
			.state('alunos.relatorios.relatorio.periodo.numeroGeralAlunosPorArea', {
				parent: 'alunos',
				url : '/relatorio/periodo/numeroGeralAlunosPorArea',
				templateUrl : 'app/pages/alunos/relatorios/relatorio/periodo/numeroGeralAlunosPorArea.html',
				title : 'Número Geral de Alunos por Área',
				controller: 'RelatorioPeriodoAlunosPageCtrl',
			})
			.state('alunos.relatorios.relatorio.periodo.semExameQualificacao', {
				parent: 'alunos',
				url : '/relatorio/periodo/semExameQualificacao',
				templateUrl : 'app/pages/alunos/relatorios/relatorio/periodo/semExameQualificacao.html',
				title : 'Alunos sem Exame de Qualificação',
				controller: 'RelatorioPeriodoAlunosPageCtrl',
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 03/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos.situacao.documentos.oficios', [
		'BlurAdmin.pages.alunos.situacao.documentos.oficios.membrosAluno',
		'BlurAdmin.pages.alunos.situacao.documentos.oficios.declaracao',
		'BlurAdmin.pages.alunos.situacao.documentos.oficios.diploma',
		'BlurAdmin.pages.alunos.situacao.documentos.oficios.aviso',
		'BlurAdmin.pages.alunos.situacao.documentos.oficios.ata',
		'BlurAdmin.pages.alunos.situacao.documentos.oficios.certificado'
	]).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('alunos.situacao.documentos.oficios', {
				parent: 'alunos.situacao.documentos',
				url : '/oficios',
				templateUrl : 'app/pages/alunos/situacao/documentos/oficios.html',
				title : 'Oficios',
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 10/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.agendamento.relatorios.relatorio.agendamentos', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('agendamento.relatorios.relatorio.agendamentos', {
				parent: 'agendamento.relatorios.relatorio',
				url : '/relatorio/agendamentos/relacaoAgendamentoDefesa',
				abstract: true,
			})
			.state('agendamento.relatorios.relatorio.agendamentos.relacaoAgendamentoDefesa', {
				parent: 'agendamento',
				url : '/agendamentos/relacaoAgendamentoDefesa',
				templateUrl : 'app/pages/agendamento/relatorios/relatorio/agendamentos/relacaoAgendamentoDefesa.html',
				title : 'Relação de Agendamento de Defesa',
				controller: 'RelatorioDefesaAgendamentoPageCtrl',
			})
			.state('agendamento.relatorios.relatorio.agendamentos.resumoTotal', {
				parent: 'agendamento',
				url : '/agendamentos/resumoTotal',
				templateUrl : 'app/pages/agendamento/relatorios/relatorio/agendamentos/resumoTotal.html',
				title : 'Resumo Total',
				controller: 'ResumoTotalPageCtrl',
			})
			.state('agendamento.relatorios.relatorio.agendamentos.relacaoBancas', {
				parent: 'agendamento',
				url : '/agendamentos/relacaoBancas',
				templateUrl : 'app/pages/agendamento/relatorios/relatorio/agendamentos/relacaoBancas.html',
				title : 'Relação de Participação em Bancas',
				controller: 'RelacaoBancasPageCtrl',
			})
			.state('agendamento.relatorios.relatorio.agendamentos.relacaoDissertacaoTese', {
				parent: 'agendamento',
				url : '/agendamentos/relacaoDissertacaoTese',
				templateUrl : 'app/pages/agendamento/relatorios/relatorio/agendamentos/relacaoDissertacaoTese.html',
				title : 'Relação Descritiva de Dissertações e Teses Defendidas',
				controller: 'RelacaoDissertacaoTesePageCtrl',
			})
			.state('agendamento.relatorios.relatorio.agendamentos.numeroTeses', {
				parent: 'agendamento',
				url : '/agendamentos/numeroTeses',
				templateUrl : 'app/pages/agendamento/relatorios/relatorio/agendamentos/numeroTeses.html',
				title : 'Número de Teses e Dissertações Defendidas',
				controller: 'NumeroTesesPageCtrl',
			})
			.state('agendamento.relatorios.relatorio.agendamentos.relacaoDissertacaoTesePorData', {
				parent: 'agendamento',
				url : '/agendamentos/relacaoDissertacaoTesePorData',
				templateUrl : 'app/pages/agendamento/relatorios/relatorio/agendamentos/relacaoDissertacaoTesePorData.html',
				title : 'Relação de Dissertações e Teses por Data com Orientador',
				controller: 'RelacaoDissertacaoTesePorDataPageCtrl',
			})
			.state('agendamento.relatorios.relatorio.agendamentos.relacaoDissertacaoTeseComOrientador', {
				parent: 'agendamento',
				url : '/agendamentos/relacaoDissertacaoTeseComOrientador',
				templateUrl : 'app/pages/agendamento/relatorios/relatorio/agendamentos/relacaoDissertacaoTeseComOrientador.html',
				title : 'Relação de Dissertações e Teses com Orientador',
				controller: 'RelacaoDissertacaoTeseComOrientadorPageCtrl',
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 03/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos.situacao.documentos.oficios.ata', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('alunos.situacao.documentos.oficios.ata', {
				parent: 'alunos',
				url : '/ata',
				templateUrl : 'app/pages/alunos/situacao/documentos/oficios/ata/ata.html',
				title : 'Ata',
				controller : 'SituacaoAtaOficiosAlunosPageCtrl',
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 03/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos.situacao.documentos.oficios.aviso', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('alunos.situacao.documentos.oficios.aviso', {
				parent: 'alunos',
				url : '/aviso',
				templateUrl : 'app/pages/alunos/situacao/documentos/oficios/aviso/aviso.html',
				title : 'Aviso',
				controller : 'SituacaoAvisoOficiosAlunosPageCtrl',
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 03/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos.situacao.documentos.oficios.certificado', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('alunos.situacao.documentos.oficios.consultaCertificado', {
				parent: 'alunos',
				url : '/certificado/consulta',
				templateUrl : 'app/pages/alunos/situacao/documentos/oficios/certificado/consulta.html',
				title : 'Certificado',
				controller : 'SituacaoConsultaCertificadoOficiosAlunosPageCtrl',
			})
			.state('alunos.situacao.documentos.oficios.certificado', {
				parent: 'alunos',
				url : '/certificado',
				templateUrl : 'app/pages/alunos/situacao/documentos/oficios/certificado/certificado.html',
				title : 'Certificado',
				controller : 'SituacaoCertificadoOficiosAlunosPageCtrl',
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 05/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos.situacao.documentos.oficios.declaracao', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('alunos.situacao.documentos.oficios.declaracao', {
				parent: 'alunos',
				url : '/declaracao',
				templateUrl : 'app/pages/alunos/situacao/documentos/oficios/declaracao/declaracao.html',
				title : 'Declaração',
				controller : 'SituacaoDeclaracaoOficiosAlunosPageCtrl',
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 05/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos.situacao.documentos.oficios.diploma', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('alunos.situacao.documentos.oficios.diploma', {
				parent: 'alunos',
				url : '/diploma',
				templateUrl : 'app/pages/alunos/situacao/documentos/oficios/diploma/diploma.html',
				title : 'Diploma',
				controller : 'SituacaoDiplomaOficiosAlunosPageCtrl',
			});
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 03/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos.situacao.documentos.oficios.membrosAluno', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {

		$stateProvider
			.state('alunos.situacao.documentos.oficios.consultaMembrosAluno', {
				parent: 'alunos',
				url : '/membrosAluno/consulta',
				templateUrl : 'app/pages/alunos/situacao/documentos/oficios/membrosAluno/consulta.html',
				title : 'Consulta',
				controller : 'SituacaoConsultaMembrosAlunoOficiosAlunosPageCtrl',
			})
			.state('alunos.situacao.documentos.oficios.membrosAluno', {
				parent: 'alunos',
				url : '/membrosAluno?membrosAluno',
				templateUrl : 'app/pages/alunos/situacao/documentos/oficios/membrosAluno/membrosAluno.html',
				title : 'Membros e Aluno',
				controller : 'SituacaoMembrosAlunoOficiosAlunosPageCtrl',
			});
	}

})();

'use strict';

angular.module('BlurAdmin', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ui.mask',
  'ngTouch',
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',

  'BlurAdmin.theme',
  'BlurAdmin.pages',
])
// .constant('REST_END_POINT', 'http://fmusp/api/')
.constant('REST_END_POINT', 'http://spg.fm.usp.br/spg/fmusp-backend/public/api/')
//.constant('REST_END_POINT', 'http://sp.gtcon.com.br:9994/index.php/api/')
.constant('VERSION', { 
	V1: 'v1' 
});
/**
 * @author Yury Tinos Pinheiro created on 02/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages')
		.service('AreasService', AreasService);

	/** @ngInject */
	function AreasService(REST_END_POINT, VERSION, $http, $q) {
				
		return {
			listarAreas : function(_filtros) {
				
				var filtros = {
					'areas': (_filtros && _filtros.areas? _filtros.areas : null)
				};
				
				return $http.get(REST_END_POINT + VERSION.V1 + '/areas?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {

					if(response.data && response.data.status == 200) {
						return response.data.areas;
					}
					else {
						return $q.reject(response.data.messages);
					}
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					
					return $q.reject(response.data.messages);
				});
			},
			listarAreasCod : function(filtros) {
				
				filtros = {
					
				};
				
				return $http.get(REST_END_POINT + VERSION.V1 + '/areas/cod?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {

					if(response.data && response.data.status == 200) {
						return response.data.areas;
					}
					else {
						return $q.reject(response.data.messages);
					}
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					
					return $q.reject(response.data.messages);
				});
			}
		};
	}

})();
/**
 * A collection of filters for Brazilian standards
 * @version v1.1.0 - 2014-09-29
 * @author Igor Costa
 * @link https://github.com/igorcosta/ng-filters-br
 * @license Apache License 2.0
**/
(function() {
  'use strict';
  /** @ngInject */
  angular.module('filters.filters', []);
  // Source: dist/.temp/brasil/filters/cep.js
  angular.module('filters.filters').filter('cep', function () {
    return function (input) {
      var str = input + '';
      str = str.replace(/\D/g, '');
      str = str.replace(/^(\d{2})(\d{3})(\d)/, '$1.$2-$3');
      return str;
    };
  });
  // Source: dist/.temp/filters/filters/cnpj.js
  angular.module('filters.filters').filter('cnpj', function () {
    return function (input) {
      // regex créditos Matheus Biagini de Lima Dias
      var str = input + '';
      str = str.replace(/\D/g, '');
      str = str.replace(/^(\d{2})(\d)/, '$1.$2');
      str = str.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
      str = str.replace(/\.(\d{3})(\d)/, '.$1/$2');
      str = str.replace(/(\d{4})(\d)/, '$1-$2');
      return str;
    };
  });
  // Source: dist/.temp/filters/filters/cpf.js
  angular.module('filters.filters', []).filter('cpf', function () {
    return function (input) {
      var str = input + '';
      str = str.replace(/\D/g, '');
      str = str.replace(/(\d{3})(\d)/, '$1.$2');
      str = str.replace(/(\d{3})(\d)/, '$1.$2');
      str = str.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      return str;
    };
  });
  // Source: dist/.temp/filters/filters/realfilterseiro.js
  function formatReal(int) {
    var tmp = int.toString().indexOf('.') !== -1 ? int + '' : int + '.00';
    var res = tmp.replace('.', '');
    tmp = res.replace(',', '');
    var neg = false;
    if (tmp.indexOf('-') === 0) {
      neg = true;
      tmp = tmp.replace('-', '');
    }
    if (tmp.length === 1) {
      tmp = '0' + tmp;
    }
    tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
    if (tmp.length > 6) {
      tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');
    }
    if (tmp.length > 9) {
      tmp = tmp.replace(/([0-9]{3}).([0-9]{3}),([0-9]{2}$)/g, '.$1.$2,$3');
    }
    if (tmp.length > 12) {
      tmp = tmp.replace(/([0-9]{3}).([0-9]{3}).([0-9]{3}),([0-9]{2}$)/g, '.$1.$2.$3,$4');
    }
    if (tmp.indexOf('.') === 0) {
      tmp = tmp.replace('.', '');
    }
    if (tmp.indexOf(',') === 0) {
      tmp = tmp.replace(',', '0,');
    }
    return neg ? '-' + tmp : tmp;
  }
  angular.module('filters.filters').filter('realbr', function () {
    return function (input) {
      return 'R$ ' + formatReal(input);
    };
  });
  // Source: dist/.temp/filters/filters/tel.js
  angular.module('filters.filters').filter('tel', function () {
    return function (input) {
      var str = input + '';
      str = str.replace(/\D/g, '');
      if (str.length === 11) {
        str = str.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        str = str.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }
      return str;
    };
  });

})();
/**
 * @author Yury Tinos Pinheiro created on 02/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages')
		.service('LogService', LogService);

	/** @ngInject */
	function LogService(REST_END_POINT, VERSION, $http, $q) {
				
		return {
			cadastraLog : function(filtros) {

				return $http.post(REST_END_POINT + VERSION.V1 + '/log', filtros).then(
				// Sucesso		
				function(response) {
					if(response.data && response.data.status == 200)
						return response.data.log;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					if(response.status == -1) 
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			}
		};
	}

})();
/**
 * @author Yury Tinos Pinheiro created on 02/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages')
		.service('PdfService', PdfService);

	/** @ngInject */
	function PdfService(REST_END_POINT, VERSION, $http, $q) {
				
		return {
			getPdf : function(_content, Orientation) {
				var cabecalho = "data:image/png;base64,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"
				, rodape = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAzsAAACFCAYAAAB8B+a3AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAChaSURBVHhe7d0LeNTVue/xV7mDEO4ETZBLuJnEouAN3aJUW2F3F2xtxdoetN1HahVtrVTtVk8V2+Kl9mht+8DTVq1tRbtbsFawRzeCLSgKFARqkKsE5CYhCbcgt/P/vTMrDuMEEkhgJvl+eOaZmf/M/G8TkvWbtdY7Jz049ZmDD//l95ZK7665lp/bwwpye9mgXv38Oqtlq/ijAAAAAJC+Dht2Usnt2MUKc3tGIainXdjvTOudnWuds9rFHwUAAACA9FDjsJNKp6y2UQDKs4E9+1pBt14ehhSKAAAAAOBEqZWwk4qGu4Xhb+oFKoguGhYHAAAAAMdDnYWdVJo2aWrn9OznvT8F8blABd16xh8FAAAAgNpzXMNOVQZp+FtunuV36+G9Pxf2PTP+CAAAAAAcnbQIO6nkd+tphTm9LK9rjg+FG9SznzVr0jT+KAAAAAAcXtqGnVRCKWxVgFMlOEphAwAAAKhKRoWdVFT1TeFHleDCdwFRChsAAABAxoedVEIluMF9CymFDQAAADRQ9TLspBIqwYVS2OoNohIcAAAAUH81mLBTFVV+U+9PXvZp3hukMAQAAAAg8zX4sJOKSmHnZXfznh9dKIUNAAAAZB7CTjWpFHbv7JzK3h9KYQMAAADpjbBzDFT0QMUPNAdIpbA1D4hKcAAAAEB6IOzUsk5ZbaMAlOelsKkEBwAAAJw4hJ3jILEUtr4YtUDV4KJrAAAAAHWHsHOChFLY6v0pyO3hYYhS2AAAAEDtIeykGVWCK8jNs/xusQBEKWwAAADg6BB2MoAqwRXmxHp+dKESHAAAAHBkhJ0MpTk/+bk9vAKcKsGpF0hzgwAAAADEEHbqEVV9U/hRJTgNf1MAohQ2AAAAGirCTj2nUth9srt5JThKYQMAAKAh2FhRYQtLywg7DVGoBKfeH30hqnqDqAQHAACATBSCzZtbS2zu1m1+e+OeCn+MsINKF/Y903t/VAo7LwpAVIIDAABAOindu9fDzMzNWz4RbFIh7OCwQinsvK453vujQAQAAADUtcRgs6isLLpdamt27o4/Wj2EHdSYSmH3zo7CT/x7gCiFDQAAgGNRsX+/vVmy7ZiCTSqEHdQKFT1Q8QPNAaIUNgAAAKoSgo3m2HiwKSmzoh3b44/WLsIO6owqwRXm5lWWwlYhBCrBAQAANCwzt3x4XIJNKoQdHFfq7VGvj0ph64tRC1QNLroGAABA5lOwWbit1BaVxoaiLSwrjz9yYhB2cMKFUtihEpzCEKWwAQAA0lu6BZtUCDtIW6r8pqFv+d1iAYhS2AAAACeGhqGpMtqisijUlJb7/UxA2EFGUSW4wpxYz48uVIIDAACoXZkabFIh7CDjac5Pfnz4m3p/qAQHAABQPQo1GoK2qKzch6RpaFp9QthBvZRYCjsEoM5Z7eKPAgAANDz1PdikQthBg6FS2H2yu3klOBVDUBiiFDYAAKiPirZvjwJNmRcPeLOkpEEEm1QIO2jQQiU49f6oF4hS2AAAINMkBxt9Yae+uBOEHSAlVYILpbDzsnOpBAcAANLCmp27fCiahqTN2vIhweYICDtANQ3q2TcKP3mW1zXHK8EpEAEAANSV5GCjeTal+/bFH0V1EHaAYxBKYSsAqfeHUtgAAOBobKyo8FCjMs8Em9pD2AFqmeb89M7O8TlAF/Y7k1LYAADgEInBZu7WbX57456K+KOoTYQd4DhQJbjC3Dwb2LOv9wD1zs6lEhwAAA1A6d69HmZmbt5CsDkBCDvACaLeHvX6hFLY6g2iEhwAAJkrMdgsKot9p82anbvjj+JEIOwAaSSxFHZeFH4UhlQMAQAApBdVQFMlNIJNeiPsABlAld809C2/Ww8PQJTCBgDg+AnBRnNsPNiUlFnRju3xR5HOCDtAhgqV4NTzQylsAABqz0x9fw3Bpl4g7AD1iOb85Od+3PtDJTgAAA5PwUZlnheVxoaiLSwrjz+C+oCwA9RzqvpWmNvTS2GHANQ5q138UQAAGg6CTcND2AEaoMRS2KoEpzBEKWwAQH2iYWiqjLaoLAo1peV+Hw0PYQeAC6Ww1fujXqCC6EIpbABAJiDYoCqEHQCHpcIH6v0pyO1hedm5VIIDAJxQCjUagraorNyHpGloGlAVwg6AGhuk4W+5eV4KW70/VIIDANQFgg2OFWEHQK0IpbDzuuZ478+gnv2sWZOm8UcBADi8ou3bo0BT5sUD3iwpIdigVhB2ANQZ9fr0zs7xOUAX9jvT5wRRChsAkBxs9IWd+uJOoLYRdgAcV6r61js71yvBUQobAOq/NTt3+VA0DUmbteVDgg2OK8IOgBMuVIIb3LfQiyGoN4hKcACQeZKDjebZlO7bF38UOP4IOwDSUtMmTe2cnv289ycvCj8KQwXdesYfBQCcaBsrKjzUqMzz3K3bouutBBukHcIOgIwSSmHnZZ/mAYhS2ABQ95KDjW5v3FMRfxRIX4QdABlPpbDzsrt5z48ulMIGgKNXunevh5mZm7cQbJDxCDsA6iXN+cnP7VHZ+6NrKsEBwKESg82isth32qzZuTv+KJD5CDsAGgxVgivM7VlZCltV4agEB6ChUAU0VULzoWglJQQbNAiEHQANWqestlEAyvNS2JoLpDCkUAQAmSwx2HiPTUmZFe3YHn8UaDgIOwCQJJTC1vA39QIVRBdKYQNIZzP1/TUEG+ATCDsAUA2hFLZ6fwric4EohQ3gRFCw0ffXLCqNzbFZWFYefwRAMsIOABwDVYIryM2z/G49vPeHSnAAapN6a7zHhmADHJWMCTuaRKzJxLOXvRNfUn369DWrxSnxe2bzVhXZnr0fxe/VjNa1Z+9eW76hOL7k2E0ac6cf38iH7ogvialqeU2o4bWkeKWV7drp98PwnGBz+TY/lmZNmkaNto+/r6Rs9w5bsnZV/N6RJb5+7dZNVvzhJr99vOg4O7Vpa1Pffj2+pOYSz83yjcW2uWyb35a7v3h9dL/EJr36QnwJULX86PdEYU4vy+ua40Ph9H9D/0cA4HAUalQZbVFZFGpKy/0+gGOTMWFHjc1bhn3JLrxnTI2DxtWDL7Offf02m77wTSvftcOuGHCBPfCnJ+3pWdPiz6i+JT/5vTfmh//otviSYzfynItjweY/h8eXxFS1vLqGDTjfHv7aWBt45/WV4U6h4Kmb7rGl62JBZsbiefb49D/6hOw54yfa/NXLfLmCzt2TJ/rtI1EAnHzreJvz3mJbG4UcvU9Hu89Hy382+p1pV//0nviSmlFj9Nlvj7eXF77hwVDnTudN9B6URT83Cjq1GXLRsIRS2PrQRj+rlMIGGjaCDXB8NLp81Bd+MGfZ4vjd9PXjr9xoq7dssOZNmpr2Vw1sNRqyWsUaCwO69/HbiZ/GB0uLV9m4z19rj0973hTsyqPGrMKTGq/9c0739RRHAUYN3g+2fRh/1Sfp8bPjn9JOnvOqr0eNlUE9+0exUT0Dp/j+9T+tu53arqOvS+Fiz76PbGf8y7hipW+jRk7CvnZonWWjLrzM903Um6PjadWsuf3HoIsql+uT4fN751u3aB3qkdl/YL8vr8oPrxlj0//5hhV98L61at7C90EVpzq2ybKrfvJ9mzz7VZu74l/+3D7RORgYHdewKMRp+Ywl8315dShQbSjdat/45Q/t9XcXRu9NL5v61ix/LLxP4Ryowafzk3i+w/HqOXps647yyvdFx5l4W8cczkOX6HV6ve6fFP37f++85ec0bFPb0G0tS3XeE/3qxu/bO++vsG/96mE/9sLoGHTuZEO0jRUb1/m2wvsYttG8aVMrifZX9F7rvSnfvcN7/1L9bITXo+HRz0nR+vf995f+jz0+/Xn/PaKft9WbP/Cf/1bNWvj/VQD1i0LNyxs32dPvF9uDRe/Z9W8vsF+vft9e2rDR5m0rtXW7Kf8M1JWT49dpTQ1VNR5fixoFwwZc4MsG9uhnU8ZNsKH5A72x/Pj13/Hb1TFj6XxviPbumuPr03qmff9Rm3jD4YeLXVow0Ca9MtU/+Q/bahM1YrXtybfe7z0jl0bLb7h8pK9v6vcetPFX32DT73rUn6uG/tTbJ9i4Edf6shsuG+HLE6nhrsce+upNdsuwL8eXxmg/FYq0/ue+Mz6+NDWds8F9Cr33SuvTfonWr4t6jRKrS2mZqBcscXl1DM0/23uIgtFP3O/XCphPf+seG3bWBTZ7/CR/n7RPOg6dG/UwhePVedJ9nTcfunfOEH9e8u3w/NGXDLe7r7reQ2vzJk38fD0waoxvN/E91faTz/voIZ/sdVLwml308RDJsb+JvWda/2PR+6tjmHHvE759vW8PffVmG9y30N93Uc+h1q/90LGKfjb0M6V90M9Gfg6T2XEoDfecsWSef6ChXsn8275ieWOv8qGrD73wO5sWBe7jPSQUwLFRsHlqzfv2nUWL7dKZf7eT/jjFznplhgec//veCi8uAOD4yYiwoyFFCigKO/pEXQ15NeI1pKhi70fR9Tp/3sQazqfQPJ7Qa6IQE4YtVUWN6Nei/dBwreFnx0KXGiL6dFZhrOC719pz0e2nZ8aGx6nxcs9zk3x/RfurbaghoyF16j1IpmNVo37o/WP9tYF6DdQgv/2ZJ+yW3/zEQ4PuV2XMZSN9/kqqXgw16q+56PKoUT7RQ480bdzEz/HwswfbtCgQaFhYMu2DwlCiEED0PiRTqJj46lQfDqfhgwpcYejgU6+95OdLQUnnZ+j9N9uYSQ/6Y5I4xDDxts6PQqrCyMMv/N63ofCZOFcn+T1NPu+aQ5EovD9VHYOG+ekYNBRQ513hafvunTYpOrbRv4iFTu2P1j/qsXv9nGid+tnQz8uW7dss98aRfhs4Ev08a26ifo71wcHZd1xnp31zhP98afjtlLdm1Wg+HYC6U7R9u01eu87uemepB5sWf/4LwQZIMxkRdtQA1/Ag9azIlfEGuhq4ekyNfgWQ6hYd6NIm9o3pic/fUl4av5WaGq+63BCFCPUKqdGbON6+vGKnN1ISpdqfh792s1/0+lQUHBRQkl+bl53jjWctD9vRc1PRcoWYxWtXekDRfTXQda0wpkaUgpga/qH3SA1xNaTUuNJzxib1Ksktw79kj0T7nijVvoq2pUa/woJ6cYpLNh8SvML51n6lCmRVCcesni31pIS5R6mEbeg1mndT1Xmvavvaf73HHhzjxyAa/qhemuWP/7Gyl0g/g9qn733+Wr+fqCbHB6TyUfR/TAHosWnP2w0TJ9il991knb4xzAPQ3ZMn2VMzX7J5K4vizwZQF1IFm/4vv2rXzH3bJix7z4ONvsgTQHpJ+7CjxmZelxz/A69GuhriQwsH+WPq6RnYo68P7fqf+DCq6gzB6hUFBzXQVXErmRrG4ZP+RBq2pk/yw6etel4YGlZd6pXQkKxxzzxx2E/5NfwpmSqBab+03dDgF50fNcoTadmKTes8CCoQ6L62retEGv6VKizoeakCjHov1OOUbHHxKruo38fldhUAtG6FMgUDNch0SXXMKmiQvF9HovWGdepyJDr2/JweVZ53/1nYUPyJYwhBTnMrEo+hWXRs6inSz4Gep/dFw9qe/ccr9lC8Vwk4HhSAJr4yxX+2h/3oOx6Ahv3w2zb2149Gy6ceVfVKAGZrdu6yqes/sB8sfZdgA2S4tA87akyq+llo6Kuhq0/nNZxNJaTVIFUvhnopFHQSh2YFeq544//z1/rcDg1N0rrCY6qSJBq+pfkViRQmrjxvSPT8HX5fYUTbvfK8Syy3Q2fvdWrTXHOAYkFLvTAS1i26rf1XCNCcj7OjkKbQpYZ+4vPVmNZz1AuhEBeWz1i6wHt2xkSvveeL1/ttHb+OZf6EJ/15gZ+ThDCg+zpeXev4fS7Nzff6eQxD7nSetVxzT3T+1MBPptenqkam4WR6jea3aD261jlSMNV9hUIdj44jnCOdb50P9ciJXpPYK6JhbwoaWhbm4ij0qlqalut90rq1Xq0nvAf6OQnnPWwjPJ583hM9HIUUHUNY7wOjbvDl+rnSHCkdg86N9l/7o/dB69U50UXr+3QUwkfFh/mFnj/97OiSKkADdWHeqmU2ec4rPvRS//8VgC657yb73xN/7D1DCkCpPswAGqrkYNNuyovWY9rf7Mo5c+2+fxURbIAMl/bV2C4+4yxbs3mDVz4r2VFmBbk9vZrRno8+8gpZavTPenehLXp/uVe60nP+umB29Md8b3wN5g1VVWRTo1Q9CY+8+Ad7cf4/DnksVHkr3rrZ3l3/vi8LenQ51Zo1VlCJPUdVvVRZSesr2bnd2rZq7fuyb/8+vz6v9xk2P2pw6DVL1q3yfddt7ZfCgqot/fKVP1vjkxvZkmg7Oqbw/LdW/Mufl9tB85KmeyWwls1a+PEpPPQ77XQPXd/73RN+vFuifRiqwglHmK+0YPWyWKO8hRrg7X3Iy22/fcxWR+dW2p/Sxk5t3zHav3U2Llq3qqpV15otG+y/575mp7br4JXlnp75kh+PqkypR2pAjz42d/lSP3fn5Z3h50jnUsek86jj7R0FEM0luvLcIX4s2tei9Ws8UCio6ThF69XwRQXEU6LzqHOkCm152bm+Xp1rPRbeU21jSfHqlOc9sTKaKtbpGPpH51eV03760nNezU0/Jzsrdsers71pC9cstxXROcqLQk/jRo1swgvP+L4qFHVu087fv/Bp+ubyUj+vquKm/dL6gBNB/39UCU7/r1UJ7tG/Tva5hnOin1X/AOMk9fQ2pRIc6r2NFRX2jw+32u+8KtpyG7tgoT24LPr7WrzeZkWhZs2uXVZx4ED82QDqg4z5nh2kpl4INfLrw3AVDTdTj5PmE6UabgagbnXKamuFuXleol4l5AtzYwVhgEykYKPKaPr+mrlbt/ntjZT/Bxocwg7ShoaZqVdFvW/qxQJw4mk4pr4AVaXWNYxTPdFhOCqQLkr37vUwM3PzFoINgEMQdgAANdK0SVM7p2c/7/0pyO3hYSjMlQPqWmKwWVRWFt0utTU7+VJOAKkRdgAAtWKQhr/l5ll+t1gASv5OK6CmVBjgzZJtsaFoJSUEGwA1RtgBANSZ/G49rTAn1vOji76TSoVHgGSJwcZ7bErKrGjH9vijAHB0CDsAgONKc35UGr53dq5d2O9M7wVKLgeP+k8lnQk2AOoaYQcAcMKp6pvCjyrBafibAlDyFyYjcynYLNxWaotKY3NsFpaVxx8BgLpF2AEApCWVwu6T3c0rwVEKO3Oot8Z7bAg2ANIAYQcAkDFCJTj1/uSrDHZ2LpXgTiCFGlVGW1QWhZrScr8PAOmEsAMAyHgX9j3Te39UCjsvCkBUgqt9BBsAmYiwAwCol0Ip7LyuOd77o0CE6lGo0RC0RWXlPtdGc24AVN+teb3s1t69/Huhvj5vgf+fyhTPnn+OZTdvbk+tXmNPv18cX5q5CDsAgAZDpbB7Z0fhJ/49QJTCJtgAta1tkyZWMuLf7YUPNtpTa9bY3zZt8dLqmWJA2yxbcNmldt+/ivyS6TIi7OiP0aUFA/321Ldft+Ubir1M6Q2XjbS1H26y5tEfqqdnTfPHj2Tc56+N3zLbXLbNpi98w69rav6EJ32ibOf/HB5fUnP6pHHYgAvi98yWrF1pc95bbGW7dsaXHB2Vdb37i9fbDRMn2CNfu9muHnyZjf3No/bcnFfjzzg8nVu9JqvlKTY5ek1xdI4TjR4y3GYsnV+5XOfhynMu9gaDzueStat8uWjZLcO+ZI9P/6Pt2ftRfGmMtnNFdPw65uRt6HWjhwzzfUhe57AB5/twFZ2v6Qvf9GWq2jQq2me9Tj8f+jkBgOrQ7zAVP9AcoPpeCrto+/Yo0JR58YA3S0r8e20yqREGZILzO7S3OZdebNe/PT8je0a6t2ppq4Z9pt6EnZPj12lLjdinbrrHA4kavmo4y8hzhvj9L5w3pEbVedQYVuCZt7LIhhYOstnjJ/mymrrlyZ/Gbx09HVO3aN8VHtRwH/OZK23GvU8c1f4kymrRKgqATfy2Qk5ykDiSZ789PvqD/ynfjznjJ1ZO/tUf/6dvvtcejgJUtw6xc67nTL19gr8HaiRo/xW2AgUQBbrkoKPAMm/CU3ZR9BqF1WTPfWe8jTx3iL9uyu0P+vNF790Do8b4bQU6nTtR8NU+6GfiZ1+/zS7Nj4VjADgS/Y6c9s83TB/8jXzoDssbe5Wdcds1dvVP77GHXvidzVgyr8a/R9OBgs3ktevsrneW2qUz/24t/vwX6//yq3bN3LdtwrL3vAeHoIP64rVL/q3yIj8uzPeLhOWjT8/1S7ivHoxLOnX02+qNSX4s3P7pgEJr3qiR3x5xavYhj322S2ffRqJfnPUpv76jXx9/rehaz/8/Z/SzX549wD743BU2ZfD5vv3p/zbYw4W2X5U7+vb212uImeha97U86Ne6ta/rwFUjPWxpXyW8VtdPnjPQt63X65gPp3urVr4+PV/7rHMg4Vi0fq1Px5HO0j7sjDznYlu6bpX33Ex8dapNWzDHl099e1YUFkrsfxbP89uBwpEaxLqk+mROn/rLa0vne8+HQoG2IWo4K0yFcd1q5Gs9uq9LuJ2KGvh6XK+v7ieCCjvqmVKDXj0Ud0+e6A323l1zKren+7Fellbew6Vl2t/w/RMKG9pvLQ+BQL1gCnPJAaM6tA1dbvnNT+yBPz1p81cvszFRkJCxw75cef4CbWPgndfbuGee8PMp+Tk9/Fq0b3rfdDwhBOm8Thpzpz9fYSx5nTrmwX0K7WfTnvceIb33CoIS1qdGiR7TcYv2Vfugc7h8wzoPXgBwtLaUlXrI0e8ahZ6z77jOQ5DCkALQlLdmfeJ314m0Zucum7r+A/vB0nc92LSb8iLBBg3K5LXFNqRjB5u5eYvfH9Ozu92a19Mb6HrsvHZtbdaHW/3yqaw2/hz9vxnd/XR/nRru4bGXN2z0x4rKt/tjL6zfYOe3b+e3r+vevfIx0fDPZE+vWevXGsYWbuu67ymtfL80bFTb0jZ/VHCG71/Fgf1REOrvz01F68pq3Dg6jlj777HlK31/+rWJHYv8cuAA21ixx1pG//+X7dgZhbK2vlyv1bY1h2jq+vV21+KlNqJrtoexw9FrHix6z3untN96jehYtO1nzzvHn6PjSWdpH3bUcFXDN3yaH4YtKQC0aXmKfbpwkH/yr0a/LtPvetQf1+1p0W1dH4l6FhQg1AhXg3zKuAmVvRnqmdB3PIh6D8LtRAoeM+79mf/hU0NdPSM1oX1UGBiaP9DXoWMWbW/yrffbNRdd7kPbxg7/si/XuQiNfA31Gn72BR5uwjlSb1F4vKY0jEOfYIahdLqtYxIFiuoMF9xSHvuh1znUazWkTOf07B59ffm4z3/VFhevssJ4mAzBrSoKVLntO3vg03OXFq/25eu2bvb74fXa1g2XjfD7L//zDV8GALVFvxdnL3vHA5A+rBl89w122jdHeAC6e/Ikmzz7lUOG3NaVVMGmx7S/2ZVz5vqQEwWb0n374s8GGgY1yBXoFW7U87KxosJvK6Q0P7mRzd1W6v93dFHj//QWLbx4gBrtCh6XdI710Ki3Y+KqNf7Yc8Wx9ph8KivL1Fs6pFMHf0wT+Keu+8C3k2xRWawYQVF5eWVhAl1X7D/g83e0/okrY22ZiatW+77PLSn14WNV0bbLEv5fp6qGqGNS+NDx3/evd6P1xoKWXqttKwB5AIu2p/3RsR/O3zZt9t8nYSjb+R3b+3U4pheiUDj4tdfTfqhb2ocd9cDoj4jCiObJKOTIpFdf8Mb37c88UdkIVihSg1ef+OuPkYLL0Pyz/fnJ1MhWA1w9K+oZUoNcPQPqaVCPS35OT/+jVVyy2Z+vP3Dlu3b47WTaN71G69B+qWckcSiXaMhVVQFE+z9uxLXec7Jg9TJfFran9ekPqYx+4n4/LgWOsP5uHbOtdYtWti7az9G/iIWsybOrNzdHvSva90QhOByNe6JjnLeqyPdd1COkeULJPUx5XU7zazUc1AMz5fYJh4RSnUut5+GvjfUhaQqceq7CbSrhtRpap6Fven3Fvpr3agFATX0U/X7T77yJr0zxvx+X3neTdfrGMP+9Pe63T9hTM1/yD6OOlhpSL2/c5MFm2OtzCDZAFRR0FGg0X2ZIx45RUFnv/3+GdOoYBZlOlT0+MnPzZg8WGkKmHhU9poa/LmrIK8xImNOmoKN1qDdFYci3EYWeWR+mVzEPBRwFHQ1hm3bRBYcdprbn4EEPbNUReoXbJnUgKEBlgrQPO6LGfcF3r/WGsxrUouFimh8S5vBIaKircR0a2FU1kOcsW2w//NNTNvT+sd6Q1hwPrU/zUarTG5RI80SCivh2O7c5NDSo1yaxGEEiNc71h1HHqPChxn0Q1qdApHksU7/34CFDtHRutu/eabPHT6w8N9Wh9WnYm3rGEin8HQ0NL1OxgTGTHvT7Wr+ORT1VYeifAprOrc7X1Ldm+b4/9tLzvlyTgwO9d1c+fKevS8FtxaZ1ftF5Ohw1OIb/6Dbbsn1bZS8XAJwI+n301KyX/EO0YT/6jgegS6IgNPbXj0bBaKo/nvxBUHKw6fqX6db1xek27O9zPNi8vGkTwQY4DA0/0zC0kTmn2qwtH3qPjYZyaZnuB+pdkTG9eniPinowPPx07uy3AzXyY70+ney89m09QKlnSMPB9Fjo4UgX6rE59a8v240LFnqQ+cN5h7bxkoVQV10h9GSatA87iXNo/jx3VmUQUS/I49NjczqC0BjWc8Lzqmog6w9N4h+bb35mpM1fXeR/mJJ7cI4UfrSN8Bw18mXt1kNDw5WP3GHDfnxb/F7VKqIfvGYpkrh6rXRRKJpdFOs5EQ0N06eJmjejwBaGnB2JAp5eo9cm0vworSOsRz1cR/pUUr1tep90jImTePXeeI9bfOifQo3mSGke0KBeh45LLYsCWyK9L3p/8rJzomPsZ5qLo2Vaf1hffm4PP/fJE4f1XrRpXj8rKQHIXEvXrrLJc17x32f6XZ7zzRHWZ9x11v+B263LIw9Yt6d/bcNnzKwMNhv3fHJ4DICqKaioN0Pzc9Qro/Dz2S6drG3TJt4LGuiDBQUVzUFRL4+GhKnhf3UUkv628dA2xcsbNnnQ0VwYPeeFDRu8KEEITBKKDtQmhRVN/A9FBkRhQ8ciqYa8he/H0TC5xNAWaM6P6BxpuFuYb6TXqBBB4rYkbEs9WZLuc3Oq0ujyUV/4gXo50tVXL77CRpx7sZ3arqPd9rlRXgr59XcX2rCzLrDC03v5kLEenbta40aN7Tevvei9Huf3zrfPfOpc21K+zYd9JfreiK/6dyzI0uJVUQM6lmqHnHGWnZt3hvXP6W79TutuHdtk2X+/+ZoNjNY/avDlXjWsa7QPp7RoYdP/+YaNvuTf/TFVUXtxwWzvjenZ5TQbdeHl3muUPJRM29l/4NBErDkt10Xrye3QxecN/fgrN0bH0cjuevaXNqB7H7s6Wlfzps1s/qoiK9+9y+fwqFdEvUT6hvAFq5bZmCikDeje20ulqjdp0qtT7ZbhX47uaxjeSj/Wkede4ut5bcm8yuOVnSn+kCo8KKB8feh/+HnU62/77WP+XM2H0VA8vRdav0JZ8dbN9tc7H/H9CoUSNGdoyluv+3kIFy1/fNrz0bEssxUbi+3Okf/L+kTh56rzh3r4+fWMF+N7EKOAO/nb9/txXfPYvZWBRvt315WjfXvf+uwX7a4//MKKPnjfe+RuuuKLNvaKL1n/0063H/zxV74cANJZxe6dtqt0ix38sNiar3/PWq5e6NdNSjZao52ldlL0d+Ngo6Z2sPHhqyYBUIjZ470uK3bstJ+vXGWb9nzkk/AVTBLn34ga+JdFoeW2d5Z4iNFE/4I2rW3swsW27+DB+LOi9tuBA/bdPr3tuXXroyC02ZqffLJd1/10e2z5isqwMGXweTYoClg/X7naKqLnP3nuQOvesmW0zta+Lyt37vRKaJ+LwlVOi+bRsh2+3tHdu3nFM/UYXZHdxYegKdDMjsLXhVHAGF/Q30466ST707oPfDt5UUDR867OPc2+0b27D8HTsiXRfmgbDxcW2EWdOtr57dtHwaWr/XzFKl+X6LxkR9vW8v/q39fnM31rwUI/Z5/u3NGXhW0p5Oj5CkVX5ebYf0XncN3uqB0YPV/nRuHukmg72c2bWePoNWEb6Sojvmcn9OyU7d5ROflTn94r6KgHRb0pzRs39XkeYbnofvIwgbAuSX48vG5TFJI0/0OPi5ZvjpZpSFlYrmFX2paWa6iW9kENc1GPRHUoVPSOQkuQeHzqWQnlnZcUr/SemPD85VFY0LWOXb1QydsNx6h9kzCkLtX5qEpYR9i2KJxltfh4yJ72V8UUwnkLwjlJpPVpv0NPWzg+7U84z4l0rAo0yesR9RDpmBK3k3gudV6Se3sAIJMdaNbC9p/Szva262r72nSw/a2jS4vW8UcBBLHAcMA0KV/UK6GeHA0/S6Sw06/1KZU9Puop0bJUE//VsC/avsPXE4oeJM7tUclnCdvU84M1u2JFEbRfYQ6NlpV+tNeXiXqhFI4UHrTOMDxO+66qb2E7omUKXHqO9levCfum9Yd1Ju6fqLT1+7t3243zNcStWeV+Bdrn8JpwjNovXUvYhiQeS+L+pquMCDsAAOBQB09uZPvadbF9WZ1tXxR+dNl/SqzULAAkCmFHFRwbmrQfxgYAAD7ppIMHrdHu7dZk20Zrtmm1tVi71FqumB/d32CNt2+1Rnt2mR04YAeYwwg0aPriT/XcqPdIEos1NAT07AAAUM/ta6ven462v1Vb29emve1tf2r8EQCo3wg7AAA0QPvaROFHw99aZcXCUNsuPjQOAOoTwg4AAHCa87O/Zbt4709X7w062KRm3z0HAOmEsAMAAKqkSnAKPbHen84+FI5KcAAyBWEHAADUyMEmzbwEdmUp7JZRAKISHIA0RNgBAADHLLEU9n7NA1JvUBSEAOBEIuwAAIA6s7fDqd7zo3lAYTgcABwvhB0AAHBcVVaC04VS2ADqEGEHAACccJrz4+FHl/j3AlEJDsCxIuwAAIC0dKBF69jQNw2BiwcgVYcDgOoi7AAAgIxxSClsVYJrHV0ohQ2gCoQdAACQ0UIpbFWCC0PhKIUNQAg7AACgXlIlOA8+rdvbvlbtqAQHNECEHQAA0GCEuT+aB7S/VVsqwQH1HGEHAAA0aJWlsPVlqApDbbv4l6QCyHyEHQAAgCSa87O/ZTvvAdrbvqv3BlEKG8g8hB0AAIBq8FLYrdrGe39iw+EohQ2kN8IOAADAUQqV4Pa26+rX+1u2pRIckEYIOwAAALVI8332tevipbD3ax6QF0ToEH8UwPFE2AEAADgOKkthhwBEKWygzhF2AAAAThAFnv36DiBVg/NiCJTCBmoTYQcAACCNaM6Phx9d4oUQqAQHHB3CDgAAQJrzSnA+9ydWClu9QVSCA46MsAMAAJCBFHbC3B+vBKf5QFEoAvAxwg4AAEA9EUphqxJcGApHKWw0ZIQdAACAeqyyFLaCT+v28eFwlMJGw0DYAQAAaIBC8QPNA9rfqi2V4FAvEXYAAADg9rXp6HN/9um7gBSG2nbxniEgUxF2AAAAUKVQCjvW+9PVe4MohY1MQdgBAABAjXgp7Cj8xHp/YsPhKIWNdETYAQAAwDELleD2tuvq15TCRjog7AAAAKBOVFaCi5fC1lA4KsHheCLsAAAA4Lja2+HUePjJ8iFwGgoH1AXCDgAAAE44BZ79rdp5CFI5bEphozYQdgAAAJCWvBS29/5EAYhS2DgKhB0AAABkDK8EF/8yVJXCVm8QleCQmtn/B0ZvKHI59htgAAAAAElFTkSuQmCC";

				var _orientation = Orientation?Orientation:'portrait';
				var docDefinition = {
					header: {
						image: cabecalho,
						width: (_orientation=='portrait'?596:600),
						height: (_orientation=='portrait'?108:120),
						margin: [0]
					},
					footer: {
						image: rodape,
						width: (_orientation=='portrait'?596:840),
						height: (_orientation=='portrait'?108:140),
						margin: [-1, 0, 0, 0]
					},

					pageSize: 'A4',
					pageOrientation: _orientation,
					pageMargins: [ 40, (_orientation=='portrait'?108:140) ],
					content: _content,
					styles: {
						header: {
						   fontSize: 16,
						   bold: true,
						   alignment: 'center',
						   color: '#333',
						    margin: [0, 20, 0, 0]
						},
						alignRight: {
							color: '#333',
						    alignment: 'right',
						    margin: [0, 20, 0, 0]
						},
						paragraph: {
							color: '#333',
							margin: [0,20,0,0],
							leadingIndent: 40
						},
						center: {
							color: '#333',
							margin: [0,50,0,0],
							alignment: 'center'
						},
						centerAta: {
							color: '#333',
							margin: [0,15,0,0],
							alignment: 'center'
						},
						signature: {
							color: '#333',
							margin: [0,50,0,0],
							bold: true,
							alignment: 'center'
						},
						textInicial: {
							color: '#333',
							margin: [0,40,0,0]
						},
						newRowAta: {
							color: '#333',
							margin: [0,20,0,0]
						},
						newRow: {
							color: '#333',
							margin: [0,30,0,0]
						},
						hr: {
							color: '#333',
							margin: [0,15,0,0]
						},
						default: {
						    color: '#333'
						},
						variable: {
						    bold: true,
						    color: '#333'
						},
					}
				};
				var win = window.open('', '_blank');
				var pdfDocGenerator = pdfMake.createPdf(docDefinition);
				pdfDocGenerator.getBase64(function(data) {
					win.document.write('<embed type="application/pdf" width="100%" height="100%" src="data:application/pdf;base64,'+data+'"/>');
					//win.location.href = 'data:application/pdf;base64,'+data; //IE
				});
			},
			getAssinatura : function() {
				return $http.get(REST_END_POINT + VERSION.V1 + '/assinatura').then(
					// Sucesso		
					function(response) {
						if(response.data && response.data.status == 200)
							return response.data.assinatura;
						return $q.reject(response.data.messages);
					}, 
					// Erro
					function(response) {
						if(response.status == -1) 
							return $q.reject({'erro' : 'Erro de conexão!'});
						return $q.reject(response.data.messages);
					});
			},
			getChefe : function() {
				return $http.get(REST_END_POINT + VERSION.V1 + '/chefe').then(
					// Sucesso		
					function(response) {
						if(response.data && response.data.status == 200)
							return response.data.chefe;
						return $q.reject(response.data.messages);
					}, 
					// Erro
					function(response) {
						if(response.status == -1) 
							return $q.reject({'erro' : 'Erro de conexão!'});
						return $q.reject(response.data.messages);
					});
			}
		};
	}

})();
/**
 * @author Yury Tinos Pinheiro created on 02/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages')
		.service('SituacoesService', SituacoesService);

	/** @ngInject */
	function SituacoesService(REST_END_POINT, VERSION, $http, $q) {
				
		return {
			listarSituacoes : function(filtros) {
				
				return 
					/*[{id:'' ,value: 'Selecione a situação do aluno'},
					{id:'MA' ,value: 'Matricula Ativa'},
					{id:'TA' ,value: 'Transferência'},
					{id:'CO' ,value: 'Titulado'},
					{id:'DE' ,value: 'Desligamento'},
					{id:'PR' ,value: 'Prorrogado'},
					{id:'TR' ,value: 'Trancado'}]*/
					[{ id: 'ativo', value: 'Ativo'},{ id: 'trancado', value: 'Trancado'},{ id: 'desligado', value: 'Desligado'}];
			}
		};
	}

})();
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      //preloader.loadAmCharts(),
      $timeout(1000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 1000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.administrador')
		.service('AuthService',AuthService)
		.service('Session', Session);

	/** @ngInject */
	function AuthService(REST_END_POINT, VERSION, $rootScope, $http, $q, Session, jwtHelper, $localStorage) { //localStorage
		var authService = {};
		/*Session.create(20, 3);*/
		authService.menu = function(){
			var menu = [], submenu=[];
			menu[1] = ['proficiencias','agendamento','comissao','diploma'];
			submenu[1] = ['proficiencias.consulta','agendamento.preAgendamento'];
			menu[2] = menu[1].concat(['alunos','downloads']);
			submenu[2] = submenu[1].concat(['alunos.consultaDadosBasicos','alunos.relatorios'
				,'agendamento.relatorios','agendamento.consultaFeriado','agendamento.consultaAnfiteatro','agendamento.consultaAlunos'
				,'downloads.ata','downloads.ordem','downloads.formularios','downloads.documentos']);
			//3 admin 
			menu[4] = ['proficiencias','parecer','comissao','diploma'];
			submenu[4] = ['proficiencias.consulta'];

			//publics
			menu['undefined'] = ['proficiencias','comissao','diploma'];
			submenu['undefined'] = ['proficiencias.consulta'];
			return {'menu': menu[this.getRole()],'submenu': submenu[this.getRole()]};
		},
		authService.validateStorage = function(){
			if($localStorage.access_token){
				if(typeof($localStorage.timeOut) !== 'undefined' && $localStorage.timeOut >= moment().valueOf() ){
					var user = jwtHelper.decodeToken($localStorage.access_token);
					Session.create(user.sub, user.profile, user.name, user.enroll);
					//renew timeout
					$localStorage.timeOut = moment().add(30,'minutes').valueOf();
					return true;
				}else{
					this.logout();
				}
			}
			return false;
		},
		authService.setStorage = function(access_token){
			$localStorage.timeOut = moment().add(30,'minutes').valueOf();
			$localStorage.access_token = access_token;
			var user = jwtHelper.decodeToken($localStorage.access_token);
			
			Session.create(user.sub, user.profile, user.name, user.enroll);
			window.location.reload();
			return access_token;
		},
		
		authService.login = function(credenciais) {
			var self = this;
			if( self.validateStorage() ){
				var deferred = $q.defer();
				deferred.resolve('Já Logado');
				return deferred.promise;
			}
			$http.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
			
			/*var credenciais = {
				usuario: credenciais.usuario,
				senha: credenciais.senha,
			};*/
			
			return $http.post(REST_END_POINT + VERSION.V1 + '/login', $.param(credenciais)).then(
			// Sucesso		
			function(response) {

				if(response.data && response.data.access_token) {
					return self.setStorage(response.data.access_token);
					//return response.data.session.user;
				}
				else {
					return $q.reject(response.data.erro);
				}
			}, 
			// Erro
			function(response) {
				if(response.data && response.data.erro){
					return $q.reject(response.data);
				}
				return $q.reject({'erro' : 'Erro de conexão!'});
			});
		};
		authService.getActiveUser = function(){
			return this.validateStorage();
		};
		authService.register = function(data) {
			var self = this;
			$http.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

			return $http.post(REST_END_POINT + VERSION.V1 + '/register', $.param(data)).then(
			// Sucesso		
			function(response) {
				
				if(response.data) {
					//Session.create(response.data.session.id, response.data.session.user.role);
					//return response.data.session.user;
					if(response.data.sucesso){
						return $q.resolve({'sucesso':response.data.sucesso});
						// return self.setStorage(response.data.access_token);
						//return $q.reject({'sucesso':response.data.sucesso});
					} else if(response.data.erro){
						return $q.reject({'erro':response.data.erro});
					} else {
						return $q.reject({'aviso':response.data.info});
					}
				} else {
					return $q.reject({'erro' : 'Erro ao tentar cadastrar o usuário!'});
				}
			}, 
			// Erro
			function(erro) {
				if(erro.data){
					if(erro.data.messages.erro){
						return $q.reject({'erro':erro.data.messages.erro});
					} else if(erro.data.messages.info){
						return $q.reject({'aviso':rerro.data.messages.info});
					}
				}
				return $q.reject({'erro' : 'Erro de conexão!'});
			});

		};

		authService.isAuthenticated = function() {
			this.validateStorage();
			return !!Session.userId;
		};

		authService.isAuthorized = function(authorizedRoles) {
			if (!angular.isArray(authorizedRoles)) {
				authorizedRoles = [ authorizedRoles ];
			}
			return (authService.isAuthenticated() && authorizedRoles.indexOf(Session.userRole) !== -1);
		};
		authService.getRole = function() {
			this.validateStorage();
			return Session.userRole;
		};
		authService.getUserName = function() {
			this.validateStorage();
			return Session.userName;
		};
		authService.getMatricula = function() {
			this.validateStorage();
			return Session.matricula;
		};
		authService.getUser = function() {
			this.validateStorage();
			return Session.userId || 0;
		};
		
		authService.isAuthorizedToAccess = function(authorizedRoles) {
			if (!angular.isArray(authorizedRoles)) {
				authorizedRoles = [ authorizedRoles ];
			}
			return (authService.isAuthenticated() && authorizedRoles.indexOf(Session.userRole) !== -1);
		};

		authService.logout  = function() {
			Session.destroy();
			delete $localStorage.access_token;
			window.location.reload();
			return;
		};
		$rootScope.isAuthenticated = authService.isAuthenticated();
		$rootScope.user = {};
		$rootScope.user.name = authService.getUserName();
		return authService;
	}
	
	/** @ngInject */
	function Session() {
		
		this.create = function(userId, userRole, userName, enroll) {
			this.userId = (userId);
			this.userRole = (userRole);
			this.userName = (userName);
			this.matricula = (enroll);
		};
		
		this.destroy = function() {
			this.userId = null;
			this.userRole = null;
			this.userName = null;
			this.matricula = null;
		};
	}
	
})();
/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos')
		.service('AlunosService', AlunosService);

	/** @ngInject */
	function AlunosService(REST_END_POINT, VERSION, $filter, $http, $q, $uibModal, AuthService) {
		
		var aluno = null;
				
		return {
			/**
			 * Listar alunos para Dados Básicos
			 */
			listarAlunos : function(filtros) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
					
					filtros = {
						sub: AuthService.getUser(),
						matricula: filtros.matricula,
						cpf: filtros.cpf,
						nome: filtros.nome,
						area: filtros.area.id,
						orientador: filtros.orientador.id,
					};
				}catch(erro){
					modalInstance.close();
				}
				
				return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/dadosBasicos/consulta?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					modalInstance.close();
					if(response.data && response.data.status == 200) {
						return response.data.alunos;
					}
					else {
						return $q.reject(response.data.messages);
					}
				}, 
				// Erro
				function(response) {
					modalInstance.close();
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					
					return $q.reject(response.data.messages);
				});
			},
			/**
			 * Buscar informação de Dados basicos
			 */
			buscarDadosBasicos : function(filtros) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
					
					filtros = {
						sub: AuthService.getUser(),
						matricula: filtros.matricula,
						nivel: filtros.nivel,
						area: filtros.areaId,
					};
				}catch(erro){
					modalInstance.close();
				}
				
				return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/dadosBasicos?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					modalInstance.close();
					if(response.data && response.data.status == 200) {
						return response.data.aluno;
					}
					else {
						return $q.reject(response.data.messages);
					}
				}, 
				// Erro
				function(response) {
					modalInstance.close();
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					
					return $q.reject(response.data.messages);
				});
			},
			
			/**
			 * Listar alunos para Situacao
			 */
			listarAlunosSituacao : function(filtros) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
					
					filtros = {
						sub: AuthService.getUser(),
						matricula: filtros.matricula,
						cpf: filtros.cpf,
						nome: filtros.nome,
						area: filtros.area.id,
						orientador: filtros.orientador.id,
					};
				}catch(erro){
					modalInstance.close();
				}
				
				return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/situacao/consulta?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					modalInstance.close();
					if(response.data && response.data.status == 200) {
						return response.data.alunos;
					}
					else {
						return $q.reject(response.data.messages);
					}
				}, 
				// Erro
				function(response) {
					modalInstance.close();
					//console.log(response);

					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					
					return $q.reject(response.data.messages);
				});
			},
			
			/**
			 * Buscar informação de Situacao
			 */
			buscarSituacao : function(filtros) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
					
					filtros = {
						sub: AuthService.getUser(),
						matricula: filtros.matricula,
						nivel: filtros.nivel,
						area: filtros.areaId,
					};
					
				}catch(erro){
					modalInstance.close();
				}
				return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/situacao?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					modalInstance.close();
					if(response.data && response.data.status == 200) {
						return response.data.aluno;
					}
					else {
						return $q.reject(response.data.messages);
					}
				}, 
				// Erro
				function(response) {
					modalInstance.close();
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					
					return $q.reject(response.data.messages);
				});
			},
			
			/**
			 * Buscar informação de Banca de defesa
			 */
			buscarBancaDefesa : function(filtros) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
					
					filtros = {
						sub: AuthService.getUser(),
						matricula: filtros.matricula,
						nivel: filtros.nivel,
						area: filtros.areaId,
					};
				}catch(erro){
					modalInstance.close();
				}
				
				return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/situacao/bancaDefesa?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					modalInstance.close();
					if(response.data && response.data.status == 200) {
						return response.data.bancaDefesa;
					}
					else {
						return $q.reject(response.data.messages);
					}
				}, 
				// Erro
				function(response) {
					modalInstance.close();
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					
					return $q.reject(response.data.messages);
				});
			},
			
			/**
			 * Buscar informação de Ata de Exame de Qualificação
			 */
			buscarAtaExqua : function(filtros) {
				filtros = {
					sub: AuthService.getUser(),
					matricula: filtros.matricula,
					nivel: filtros.nivel,
					area: filtros.areaId,
				};
				
				
				return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/situacao/ataExqua?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					if(response.data && response.data.status == 200)
						return response.data.ataExqua;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					if(response.status == -1) 
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			
			/**
			 * Buscar informação de Ata de Exame de Qualificação
			 */
			buscarMembrosAluno : function(filtros) {
				filtros = {
					sub: AuthService.getUser(),
					matricula: filtros.matricula,
					nivel: filtros.nivel,
					area: filtros.areaId,
				};
				
				return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/situacao/oficios/membrosAluno?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.membrosAluno;
					}
					else {
						return $q.reject(response.data.messages);
					}
				}, 
				// Erro
				function(response) {
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					
					return $q.reject(response.data.messages);
				});
			},
			
			/**
			 * Buscar informação de Declaração
			 */
			buscarDeclaracao : function(filtros) {
				
				filtros = {
					sub: AuthService.getUser(),
					matricula: filtros.matricula,
					nivel: filtros.nivel,
					area: filtros.areaId,
				};
				
				return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/situacao/oficios/declaracao?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.declaracao;
					}
					else {
						return $q.reject(response.data.messages);
					}
				}, 
				// Erro
				function(response) {
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					
					return $q.reject(response.data.messages);
				});
			},
			
			/**
			 * Buscar informação de Declaração
			 */
			buscarDiploma : function(filtros) {
				filtros = {
					sub: AuthService.getUser(),
					matricula: filtros.matricula,
					nivel: filtros.nivel,
					area: filtros.areaId,
				};
				
				return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/situacao/oficios/diploma?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.diploma;
					}
					else {
						return $q.reject(response.data.messages);
					}
				}, 
				// Erro
				function(response) {
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					
					return $q.reject(response.data.messages);
				});
			},

			/**
			 * Buscar informação de Recibo
			 */
			buscarRecibo : function(filtros) {
				filtros = {
					sub: AuthService.getUser(),
					matricula: filtros.matricula,
					nivel: filtros.nivel,
					area: filtros.areaId,
				};
				
				return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/situacao/oficios/recibo?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.recibo;
					}
					else {
						return $q.reject(response.data.messages);
					}
				}, 
				// Erro
				function(response) {
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					
					return $q.reject(response.data.messages);
				});
			},
			
			/**
			 * Buscar informação de Aviso
			 */
			buscarAviso : function(filtros) {
				filtros = {
					sub: AuthService.getUser(),
					matricula: filtros.matricula,
					nivel: filtros.nivel,
					area: filtros.areaId,
				};
				
				return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/situacao/oficios/aviso?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.aviso;
					}
					else {
						return $q.reject(response.data.messages);
					}
				}, 
				// Erro
				function(response) {
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					
					return $q.reject(response.data.messages);
				});
			},
			
			/**
			 * Buscar informação de Ata
			 */
			buscarAta : function(filtros) {
				filtros = {
					sub: AuthService.getUser(),
					matricula: filtros.matricula,
					nivel: filtros.nivel,
					area: filtros.areaId,
				};
				
				return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/situacao/oficios/ata?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.ata;
					}
					else {
						return $q.reject(response.data.messages);
					}
				}, 
				// Erro
				function(response) {
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					
					return $q.reject(response.data.messages);
				});
			},
			
			/**
			 * Buscar informação de Certificado
			 */
			buscarCertificado : function(filtros) {
				filtros = {
					sub: AuthService.getUser(),
					matricula: filtros.matricula,
					nivel: filtros.nivel,
					area: filtros.areaId,
				};
				
				return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/situacao/oficios/certificado?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.certificado;
					}
					else {
						return $q.reject(response.data.messages);
					}
				}, 
				// Erro
				function(response) {
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					
					return $q.reject(response.data.messages);
				});
			},
			salvarPlanoPesquisa : function(aluno) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
					
					//var data = aluno.pesquisa || {matricula:0,nivel:'ME',areaid:1,titulo:'',dataEntrega:''};
					//aluno.pesquisa !== null?aluno.pesquisa.titulo:''
					var data = {
						sub: AuthService.getUser(),
						matricula: aluno.matricula,
						nivel: aluno.nivel,
						area: aluno.codare,
						titulo: aluno.pesquisa !== null?aluno.pesquisa.titulo:'',
						dataEntrega: aluno.pesquisa !== null?$filter('date')(aluno.pesquisa.dataEntrega, 'yyyy-MM-dd'):''
					};
				}catch(erro){
					modalInstance.close();
				}
				
				return $http.post(REST_END_POINT + VERSION.V1 + '/alunos/plano-pesquisa', data).then(
						// Sucesso		
						function(response) {
							modalInstance.close();
							if(response.data && response.data.status == 200) {
								return response.data.aluno;
							}
							else {
								return $q.reject(response.data.messages);
							}
						}, 
						// Erro
						function(response) {
							modalInstance.close();
							if(response.status == -1) {						
								return $q.reject({'erro' : 'Erro de conexão!'});
							}
							
							return $q.reject(response.data.messages);
						});
			},
			salvarPortaria : function(portaria, aluno) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
					
					var data = {
						sub: AuthService.getUser(),
						matricula: aluno.matricula,
						nivel: aluno.nivel,
						area: aluno.codare,
						idPortaria: portaria.id ? portaria.id : null,
					};
				}catch(erro){
					modalInstance.close();
				}
				
				return $http.post(REST_END_POINT + VERSION.V1 + '/alunos/portaria', data).then(
						// Sucesso		
						function(response) {
							modalInstance.close();
							if(response.data && response.data.status == 200) {
								return response.data.aluno;
							}
							else {
								return $q.reject(response.data.messages);
							}
						}, 
						// Erro
						function(response) {
							modalInstance.close();
							if(response.status == -1) {						
								return $q.reject({'erro' : 'Erro de conexão!'});
							}
							
							return $q.reject(response.data.messages);
						});
			},
			salvarDatasDiploma : function(aluno) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
					
					//var data = aluno.pesquisa || {matricula:0,nivel:'ME',areaid:1,titulo:'',dataEntrega:''};
					//aluno.pesquisa !== null?aluno.pesquisa.titulo:''
					var data = {
						sub: AuthService.getUser(),
						matricula: aluno.matricula,
						nivel: aluno.nivel,
						area: aluno.codare,
						dtpedido: aluno.diploma.dtpedido !== null?$filter('date')(aluno.diploma.dtpedido, 'yyyy-MM-dd'):null,
						dtpronto: aluno.diploma.dtpronto !== null?$filter('date')(aluno.diploma.dtpronto, 'yyyy-MM-dd'):null,
						dtretirada: aluno.diploma.dtretirada !== null?$filter('date')(aluno.diploma.dtretirada, 'yyyy-MM-dd'):null
					};
				}catch(erro){
					modalInstance.close();
				}
				
				return $http.post(REST_END_POINT + VERSION.V1 + '/alunos/data-diploma', data).then(
						// Sucesso		
						function(response) {
							modalInstance.close();
							if(response.data && response.data.status == 200) {
								return response.data.aluno;
							}
							else {
								return $q.reject(response.data.messages);
							}
						}, 
						// Erro
						function(response) {
							modalInstance.close();
							if(response.status == -1) {						
								return $q.reject({'erro' : 'Erro de conexão!'});
							}
							
							return $q.reject(response.data.messages);
						});
			},
			/*salvarDiploma : function(aluno) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
					var data = {
						matricula: aluno.matricula,
						nivel: aluno.nivel,
						area: aluno.codare,
						dtpronto: aluno.diploma.dtpronto !== null?$filter('date')(aluno.diploma.dtpronto, 'yyyy-MM-dd'):'',
						dtretirada: aluno.diploma.dtretirada !== null?$filter('date')(aluno.diploma.dtretirada, 'yyyy-MM-dd'):'',
						obs: aluno.diploma.obs !== null?aluno.diploma.obs:''
					};
					
				}catch(erro){
					modalInstance.close();
				}
				
				return $http.post(REST_END_POINT + VERSION.V1 + '/alunos/salvar-diploma', data).then(
						// Sucesso		
						function(response) {
							modalInstance.close();
							if(response.data && response.data.status == 200) {
								return response.data.aluno;
							}
							else {
								return $q.reject(response.data.messages);
							}
						}, 
						// Erro
						function(response) {
							modalInstance.close();
							if(response.status == -1) {						
								return $q.reject({'erro' : 'Erro de conexão!'});
							}
							
							return $q.reject(response.data.messages);
						});
			},*/
			
			// GETTER's e SETTER's
			getAluno: function() {
				return aluno;
			},
			setAluno: function(obj) {
				aluno = obj;
			}
		};
	}

})();
/**
 * @author Yury Tinos Pinheiro created on 02/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos')
		.service('OrientadoresService', OrientadoresService);

	/** @ngInject */
	function OrientadoresService(REST_END_POINT, VERSION, $http, $q) {
				
		return {
			listarOrientadores : function(filtros) {
				
				var _filtros = {

				};
				if(filtros && filtros.id){
					_filtros = { area : filtros.id };
				}
				
					
				
				
				return $http.get(REST_END_POINT + VERSION.V1 + '/orientadores?' + $.param(_filtros)).then(
				// Sucesso		
				function(response) {

					if(response.data && response.data.status == 200) {
						return response.data.orientadores;
					}
					else {
						return $q.reject(response.data.messages);
					}
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					
					return $q.reject(response.data.messages);
				});
			}
		};
	}

})();
/**
 * @author Yury Tinos Pinheiro created on 02/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.alunos')
		.service('alunos.RelatoriosService', RelatoriosService);

	/** @ngInject */
	function RelatoriosService(REST_END_POINT, VERSION, $filter, $http, $q, $uibModal, AuthService) {
				
		var relatorio = null;
		
		var RelatoriosService = {
				
			listarRelatorios : function() {
				var relatorios = {
						listagens : {
							'relatorio.listagens.porOrientador' : { label: 'Alunos por Orientador', func: RelatoriosService.listagens.AlunosPorOrientador },
							//'relatorio.listagens.semPlanoPesquisa' : { label: 'Alunos sem Plano de Pesquisa', func: RelatoriosService.listagens.AlunosSemPlanoPesquisa },
							'relatorio.listagens.porArea' : { label: 'Alunos por Área', func: RelatoriosService.listagens.AlunosPorArea },
							'relatorio.listagens.aptosQualificacao' : { label: 'Alunos Aptos para Qualificação', func: RelatoriosService.listagens.AlunosAptosQualificacao },
							'relatorio.listagens.numeroGeralAlunosPorArea' : { label: 'Nº Geral de Alunos por Área', func: RelatoriosService.listagens.NumeroGeralAlunosPorArea },
							'relatorio.listagens.numeroAlunosRegularmenteMatriculadosPorArea' : { label: 'Nº de Alunos Regularmente Matriculados por Área', func: RelatoriosService.listagens.NumeroAlunosRegularmenteMatriculadosPorArea },
						},
						periodo : {
							'relatorio.periodo.comPrazoFinal' : { label: 'Alunos com Prazo Final', func: RelatoriosService.periodo.AlunosComPrazoFinal },
							'relatorio.periodo.comPrazoFinalTrancamento' : { label: 'Alunos com Prazo Final do Trancamento', func: RelatoriosService.periodo.AlunosComPrazoFinalTrancamento },
							'relatorio.periodo.comExameQualificacao' : { label: 'Exame de Qualificação (Prazo Final)', func: RelatoriosService.periodo.AlunosComExameQualificacao },
							'relatorio.periodo.numeroGeralAlunosPorArea' : { label: 'Nº Geral de Alunos por Área', func: RelatoriosService.periodo.NumeroGeralAlunosPorArea },
							'relatorio.periodo.semExameQualificacao' : { label: 'Alunos sem Exame de Qualificação', func: RelatoriosService.periodo.AlunosSemExameQualificacao },
						},
					};
				
				return relatorios;
			},

			listagens : {

				AlunosPorOrientador : function(filtros) {
					if(filtros.matricula == null){
						filtros.matricula = {'de':null,'ate':null};
					}

					filtros = {
						area :  filtros.area.id || 0,	
						orientador :  filtros.orientador.id || 0,
						de :  $filter('date')(filtros.matricula.de, 'yyyy-MM-dd') || null,
						ate :  $filter('date')(filtros.matricula.ate, 'yyyy-MM-dd') || null,
						situacao :  filtros.situacao.id || null,
						sub: AuthService.getUser()
					};
					
					return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/relatorios/listagens/porOrientador?' + $.param(filtros));
				},
				
				/*AlunosSemPlanoPesquisa : function(filtros) {
					
					filtros = {
						area :  filtros.area.id,	
						orientador :  filtros.orientador.id,
					};
					
					return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/relatorios/listagens/semPlanoPesquisa?' + $.param(filtros));
				},*/

				AlunosPorArea : function(filtros) {
					if(filtros.matricula == null){
						filtros.matricula = {'de':null,'ate':null};
					}

					filtros = {
						area :  filtros.area.id || 0,	
						orientador :  filtros.orientador.id || 0,
						de :  $filter('date')(filtros.matricula.de, 'yyyy-MM-dd') || null,
						ate :  $filter('date')(filtros.matricula.ate, 'yyyy-MM-dd') || null,
						situacao :  filtros.situacao.id || null,
						sub: AuthService.getUser()
					};
					
					return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/relatorios/listagens/porArea?' + $.param(filtros));
				},
				
				AlunosAptosQualificacao : function(filtros) {
					if(filtros.matricula == null){
						filtros.matricula = {'de':null,'ate':null};
					}

					filtros = {
						area :  filtros.area.id || 0,	
						orientador :  filtros.orientador.id || 0,
						de :  $filter('date')(filtros.matricula.de, 'yyyy-MM-dd') || null,
						ate :  $filter('date')(filtros.matricula.ate, 'yyyy-MM-dd') || null,
						situacao :  filtros.situacao.id || null,
						sub: AuthService.getUser()
					};
					
					return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/relatorios/listagens/aptosQualificacao?' + $.param(filtros));
				},
				
				NumeroGeralAlunosPorArea : function(filtros) {
					if(filtros.matricula == null){
						filtros.matricula = {'de':null,'ate':null};
					}

					filtros = {
						area :  filtros.area.id || 0,	
						orientador :  filtros.orientador.id || 0,
						de :  $filter('date')(filtros.matricula.de, 'yyyy-MM-dd') || null,
						ate :  $filter('date')(filtros.matricula.ate, 'yyyy-MM-dd') || null,
						situacao :  filtros.situacao.id || null,
						sub: AuthService.getUser()
					};
					
					return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/relatorios/listagens/numeroGeralAlunosPorArea?' + $.param(filtros));
				},

				NumeroAlunosRegularmenteMatriculadosPorArea : function(filtros) {
					if(filtros.matricula == null){
						filtros.matricula = {'de':null,'ate':null};
					}

					filtros = {
						area :  filtros.area.id || 0,	
						orientador :  filtros.orientador.id || 0,
						de :  $filter('date')(filtros.matricula.de, 'yyyy-MM-dd') || null,
						ate :  $filter('date')(filtros.matricula.ate, 'yyyy-MM-dd') || null,
						situacao :  filtros.situacao.id || null,
						sub: AuthService.getUser()
					};
					
					return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/relatorios/listagens/numeroAlunosRegularmenteMatriculadosPorArea?' + $.param(filtros));
				},
			},
			
			periodo : {

				AlunosComPrazoFinal : function(filtros) {
					
					filtros = {
						area :  filtros.area.id,	
						periodo_de : $filter('date')(filtros.periodo.de, 'yyyy-MM-dd'),
						periodo_ate : $filter('date')(filtros.periodo.ate, 'yyyy-MM-dd'),
						sub: AuthService.getUser()
					};
				
					return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/relatorios/periodo/comPrazoFinal?' + $.param(filtros));
				},

				AlunosComPrazoFinalTrancamento : function(filtros) {
					
					filtros = {
						area :  filtros.area.id,	
						periodo_de : $filter('date')(filtros.periodo.de, 'yyyy-MM-dd'),
						periodo_ate : $filter('date')(filtros.periodo.ate, 'yyyy-MM-dd'),
						sub: AuthService.getUser()
					};
					
					return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/relatorios/periodo/comPrazoFinalTrancamento?' + $.param(filtros));
				},

				AlunosComExameQualificacao : function(filtros) {
					
					filtros = {
						area :  filtros.area.id,	
						periodo_de : $filter('date')(filtros.periodo.de, 'yyyy-MM-dd'),
						periodo_ate : $filter('date')(filtros.periodo.ate, 'yyyy-MM-dd'),
						sub: AuthService.getUser()
					};
					
					return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/relatorios/periodo/comExameQualificacao?' + $.param(filtros));
				},
				
				NumeroGeralAlunosPorArea : function(filtros) {
					
					filtros = {
						area :  filtros.area.id,	
						periodo_de : $filter('date')(filtros.periodo.de, 'yyyy-MM-dd'),
						periodo_ate : $filter('date')(filtros.periodo.ate, 'yyyy-MM-dd'),
						sub: AuthService.getUser()
					};
					
					return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/relatorios/periodo/numeroGeralAlunosPorArea?' + $.param(filtros));
				},

				AlunosSemExameQualificacao : function(filtros) {
					
					filtros = {
							area :  filtros.area.id,
							sub: AuthService.getUser()	
							//periodo_de : $filter('date')(filtros.periodo.de, 'yyyy-MM-dd'),
							//periodo_ate : $filter('date')(filtros.periodo.ate, 'yyyy-MM-dd'),
					};
					
					return $http.get(REST_END_POINT + VERSION.V1 + '/alunos/relatorios/periodo/semExameQualificacao?' + $.param(filtros));
				},
			},

			gerarRelatorio : function(filtros) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
					
					var opcao = filtros.opcao,
						relatorios = (RelatoriosService.listarRelatorios());
				}catch(erro){
					modalInstance.close();
				}
				
				if(relatorios.listagens[opcao])
					return relatorios.listagens[opcao].func(filtros).then(
					// Sucesso		
					function(response) {
						modalInstance.close();
						if(response.data && response.data.status == 200) {
							return response.data.relatorios.listagens;
						}
						else {
							return $q.reject(response.data.messages);
						}
					}, 
					// Erro
					function(response) {
						modalInstance.close();
						if(response.status == -1) {						
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						
						return $q.reject(response.data.messages);
					});
				
				if(relatorios.periodo[opcao])
					return relatorios.periodo[opcao].func(filtros).then(	
					// Sucesso		
					function(response) {
						modalInstance.close();
						if(response.data && response.data.status == 200) {
							return response.data.relatorios.periodo;
						}
						else {
							return $q.reject(response.data.messages);
						}
					}, 
					// Erro
					function(response) {
						modalInstance.close();
						if(response.status == -1) {						
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						
						return $q.reject(response.data.messages);
					});
				
			},
			getSituacoes : function(){
				return [
					{id:'' ,value: 'Selecione a situação do aluno'},
					{id:'MA' ,value: 'Matricula Ativa'},
					{id:'TA' ,value: 'Transferência'},
					{id:'CO' ,value: 'Titulado'},
					{id:'DE' ,value: 'Desligamento'},
					{id:'PR' ,value: 'Prorrogado'},
					{id:'TR' ,value: 'Trancado'},
				];
			},
			
			// GETTER's e SETTER's
			getRelatorio: function() {
				return relatorio;
			},
			setRelatorio: function(obj) {
				relatorio = obj;
			}
		};
		
		return RelatoriosService;
	}

})();
/**
 * @author Yury Tinos Pinheiro created on 26/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.agendamento')
		.service('AgendamentoService', AgendamentoService);

	/** @ngInject */
	function AgendamentoService(REST_END_POINT, VERSION, $filter, $http, $q, $uibModal, AuthService) {

		var aluno = null;
		var feriado = null;
		var anfiteatro = null;

		return {
			listarAlunos : function(filtros) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});

					filtros = {
						nome: filtros.nome,
						matricula: filtros.matricula,
					};
				}catch(erro){
					modalInstance.close();
				}

				return $http.get(REST_END_POINT + VERSION.V1 + '/agendamento/alunos/consulta?' + $.param(filtros)).then(
				// Sucesso
				function(response) {
					modalInstance.close();
					if(response.data && response.data.status == 200) {
						return response.data.alunos;
					}
					else {
						return $q.reject(response.data.messages);
					}
				},
				// Erro
				function(response) {
					modalInstance.close();
					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},

			listarFeriados : function(filtros) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});

					filtros = {
						ano: $filter('date')(filtros.ano, 'yyyy')
					};
				}catch(erro){
					modalInstance.close();
				}

				return $http.get(REST_END_POINT + VERSION.V1 + '/agendamento/feriado/consulta?' + $.param(filtros)).then(
				// Sucesso
				function(response) {
					modalInstance.close();
					if(response.data && response.data.status == 200) {

						var feriados = response.data.feriados;

						angular.forEach(feriados, function(value, key) {
							value.dataInicio = Date.parse(value.dataInicio);
							value.dataFim = value.dataFim == null ? null : Date.parse(value.dataFim);
						});

						return response.data.feriados;
					}
					else {
						return $q.reject(response.data.messages);
					}
				},
				// Erro
				function(response) {
					modalInstance.close();
					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},

			inserirFeriado : function(feriado) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});

					var dataIni = $filter('date')(feriado.dataInicio, 'yyyy-MM-dd');
					var dataFim = $filter('date')(feriado.dataFim, 'yyyy-MM-dd') || null;
					if(feriado.fixo){
						if(dataFim == null){
							dataFim = moment(dataIni).hour(23).minute(59).second(59).format("YYYY-MM-DD HH:mm:ss");
						}else{
							dataFim = moment(dataFim).hour(23).minute(59).second(59).format("YYYY-MM-DD HH:mm:ss");
						}
						dataIni = moment(dataIni).hour(0).minute(0).second(0).format("YYYY-MM-DD HH:mm:ss");
					}else{
						dataFim = moment(dataIni).hour(feriado.periodo.value == '08:00:00'? 13 : 18).minute(59).second(59).format("YYYY-MM-DD HH:mm:ss");
						dataIni = moment(dataIni).hour(feriado.periodo.value == '08:00:00'? 8 : 14).minute(0).second(0).format("YYYY-MM-DD HH:mm:ss");
					}

					var data = {
						id : null,
						data_inicio : dataIni,
						data_fim : dataFim,
						descricao : feriado.descricao,
						fixo : feriado.fixo ? 1 : 0,
					};
				}catch(erro){
					modalInstance.close();
				}

				return $http.post(REST_END_POINT + VERSION.V1 + '/agendamento/feriado', data, {'Content-Type': 'application/x-www-form-urlencoded'}).then(
						// Sucesso
						function(response) {
							modalInstance.close();
							if(response.data && response.data.status == 200) {
								return response.data.feriado.id;
							}
							else {
								return $q.reject(response.data.messages);
							}
						},
						// Erro
						function(response) {
							modalInstance.close();
							if(response.status == -1) {
								return $q.reject({'erro' : 'Erro de conexão!'});
							}

							return $q.reject(response.data.messages);
						});
			},

			alterarFeriado : function(feriado) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});

					var dataIni = $filter('date')(feriado.dataInicio, 'yyyy-MM-dd');
					var dataFim = $filter('date')(feriado.dataFim, 'yyyy-MM-dd') || null;
					if(feriado.fixo){
						if(dataFim == null){
							dataFim = moment(dataIni).hour(23).minute(59).second(59).format("YYYY-MM-DD HH:mm:ss");
						}else{
							dataFim = moment(dataFim).hour(23).minute(59).second(59).format("YYYY-MM-DD HH:mm:ss");
						}
						dataIni = moment(dataIni).hour(0).minute(0).second(0).format("YYYY-MM-DD HH:mm:ss");
					}else{
						dataFim = moment(dataIni).hour(feriado.periodo.value == '08:00:00'? 13 : 18).minute(59).second(59).format("YYYY-MM-DD HH:mm:ss");
						dataIni = moment(dataIni).hour(feriado.periodo.value == '08:00:00'? 8 : 14).minute(0).second(0).format("YYYY-MM-DD HH:mm:ss");
					}

					var data = {
						id : feriado.id,
						data_inicio : dataIni,
						data_fim : dataFim,
						descricao : feriado.descricao,
						fixo: feriado.fixo ? 1 : 0,
					};
				}catch(erro){
					modalInstance.close();
				}

				return $http.put(REST_END_POINT + VERSION.V1 + '/agendamento/feriado', data, {'Content-Type': 'application/x-www-form-urlencoded'}).then(
						// Sucesso
						function(response) {
							modalInstance.close();
							if(response.data && response.data.status == 200) {
								return 'ok';
							}
							else {
								return $q.reject(response.data.messages);
							}
						},
						// Erro
						function(response) {
							modalInstance.close();
							if(response.status == -1) {
								return $q.reject({'erro' : 'Erro de conexão!'});
							}

							return $q.reject(response.data.messages);
						});
			},

			excluirFeriado : function(feriado) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
					var data = {
						id : feriado.id,
					};

				}catch(erro){
					modalInstance.close();
				}

				return $http.delete(REST_END_POINT + VERSION.V1 + '/agendamento/feriado/' + feriado.id+ '/' +AuthService.getUser()).then(
						// Sucesso
						function(response) {
							modalInstance.close();
							if(response.data && response.data.status == 200) {
								return 'ok';
							}
							else {
								return $q.reject(response.data.messages);
							}
						},
						// Erro
						function(response) {
							modalInstance.close();
							if(response.status == -1) {
								return $q.reject({'erro' : 'Erro de conexão!'});
							}

							return $q.reject(response.data.messages);
						});
			},
			periodos : function(){
				//return [{nome:'Manhã', value:'08:00:00'},{nome:'Tarde', value:'13:30:00'},{nome:'Tarde', value:'14:00:00'}];
				return [{nome:'Manhã', value:'08:00:00'},{nome:'Tarde', value:'13:30:00'}];
			},
			listarAnfiteatros : function(filtros) {
				filtros = {
					nome : filtros.nome,
					endereco : filtros.endereco,
				};


				return $http.get(REST_END_POINT + VERSION.V1 + '/agendamento/anfiteatro/consulta?' + $.param(filtros)).then(
				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.anfiteatros;
					}
					else {
						return $q.reject(response.data.messages);
					}
				},
				// Erro
				function(response) {
					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},

			inserirAnfiteatro : function(anfiteatro) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
					var data = {
						id : null,
						nome : anfiteatro.nome,
						endereco : anfiteatro.endereco,
					};

				}catch(erro){
					modalInstance.close();
				}

				return $http.post(REST_END_POINT + VERSION.V1 + '/agendamento/anfiteatro', data, {'Content-Type': 'application/x-www-form-urlencoded'}).then(
						// Sucesso
						function(response) {
							modalInstance.close();
							if(response.data && response.data.status == 200) {
								return response.data.anfiteatro.id;
							}
							else {
								return $q.reject(response.data.messages);
							}
						},
						// Erro
						function(response) {
							modalInstance.close();
							if(response.status == -1) {
								return $q.reject({'erro' : 'Erro de conexão!'});
							}

							return $q.reject(response.data.messages);
						});
			},

			alterarAnfiteatro : function(anfiteatro) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});

					var data = {
						id : anfiteatro.id,
						nome : anfiteatro.nome,
						endereco : anfiteatro.endereco,
					};
				}catch(erro){
					modalInstance.close();
				}

				return $http.put(REST_END_POINT + VERSION.V1 + '/agendamento/anfiteatro', data, {'Content-Type': 'application/x-www-form-urlencoded'}).then(
						// Sucesso
						function(response) {
							modalInstance.close();
							if(response.data && response.data.status == 200) {
								return 'ok';
							}
							else {
								return $q.reject(response.data.messages);
							}
						},
						// Erro
						function(response) {
							modalInstance.close();
							if(response.status == -1) {
								return $q.reject({'erro' : 'Erro de conexão!'});
							}

							return $q.reject(response.data.messages);
						});
			},

			excluirAnfiteatro : function(anfiteatro) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});

					var data = {
						id : anfiteatro.id,
					};
				}catch(erro){
					modalInstance.close();
				}

				return $http.delete(REST_END_POINT + VERSION.V1 + '/agendamento/anfiteatro/' + anfiteatro.id + '/'+ AuthService.getUser()).then(
						// Sucesso
						function(response) {
							modalInstance.close();
							if(response.data && response.data.status == 200) {
								return 'ok';
							}
							else {
								return $q.reject(response.data.messages);
							}
						},
						// Erro
						function(response) {
							modalInstance.close();
							if(response.status == -1) {
								return $q.reject({'erro' : 'Erro de conexão!'});
							}

							return $q.reject(response.data.messages);
						});
			},

			listarEventosAluno : function(aluno) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});

					var filtros = {
						matricula : aluno.matricula,
						area : aluno.areaId,
						nivel : aluno.nivel,
					};
				}catch(erro){
					modalInstance.close();
				}

				return $http.get(REST_END_POINT + VERSION.V1 + '/agendamento/eventos?' + $.param(filtros)).then(
				// Sucesso
				function(response) {
					modalInstance.close();
					if(response.data && response.data.status == 200) {
						return response.data.eventos;
					}
					else {
						return $q.reject(response.data.messages);
					}
				},
				// Erro
				function(response) {
					modalInstance.close();
					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},
			listarEventosAdmin : function(aluno, _filtros) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});

					var removeEmpty = function(obj) {
					  Object.keys(obj).forEach(function(key) {
					    if (obj[key] && typeof obj[key] === 'object') removeEmpty(obj[key])
					    else if (obj[key] === null || obj[key] === "") delete obj[key]
					  });
					  return obj;
					};
					var filtros = {
						sub : aluno.idUsuario
					};

					if(_filtros != void 0){
						var data = {
							area : (_filtros.area.id == 0 || _filtros.area.id == '' ? null : _filtros.area.id),
							data_inicio : $filter('date')(_filtros.periodo.de, 'yyyy-MM-dd'),
							data_fim : $filter('date')(_filtros.periodo.ate, 'yyyy-MM-dd'),
							nome : _filtros.nome,
							matricula: (_filtros.matricula== '' ? null : _filtros.matricula),
						};
						filtros = Object.assign(filtros, removeEmpty(data));
					}
				}catch(erro){
					modalInstance.close();
				}

				return $http.get(REST_END_POINT + VERSION.V1 + '/agendamento/admin/eventos?' + $.param(filtros)).then(
				// Sucesso
				function(response) {
					modalInstance.close();
					if(response.data && response.data.status == 200) {
						return response.data.eventos;
					}
					else {
						return $q.reject(response.data.messages);
					}
				},
				// Erro
				function(response) {
					modalInstance.close();
					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},

			inserirAgenda : function(dados) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});

				}catch(erro){
					modalInstance.close();
				}
				return $http.post(REST_END_POINT + VERSION.V1 + '/agendamento/agenda', dados, {'Content-Type': 'application/x-www-form-urlencoded'}).then(
				// Sucesso
				function(response) {
					modalInstance.close();
					if(response.data && response.data.status == 200) {
						return response.data.agendamento;
					}
					else {
						return $q.reject(response.data.messages);
					}
				},
				// Erro
				function(response) {
					modalInstance.close();
					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},

			alterarAgenda : function(dados) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});

				}catch(erro){
					modalInstance.close();
				}
				return $http.put(REST_END_POINT + VERSION.V1 + '/agendamento/agenda', dados, {'Content-Type': 'application/x-www-form-urlencoded'}).then(
				// Sucesso
				function(response) {
					modalInstance.close();
					if(response.data && response.data.status == 200)
						return response.data.agendamento;
					return $q.reject(response.data.messages);
				},
				// Erro
				function(response) {
					modalInstance.close();
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},

			excluirAgenda : function(data) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
				}catch(erro){
					modalInstance.close();
					return $q.reject({'erro' : 'Erro de conexão!'});
				}

				return $http.delete(REST_END_POINT + VERSION.V1 + '/agendamento/agenda/' + data.id+'/'+AuthService.getUser()).then(
					// Sucesso
					function(response) {
						modalInstance.close();
						if(response.data && response.data.status == 200)
							return 'ok';
						return $q.reject(response.data.messages);
					},
					// Erro
					function(response) {
						modalInstance.close();
						if(response.status == -1)
							return $q.reject({'erro' : 'Erro de conexão!'});
						return $q.reject(response.data.messages);
					});
			},

			// GETTER's e SETTER's
			getAluno: function(aluno) {
				return $http.get( REST_END_POINT + VERSION.V1 + '/agendamento/aluno?sub='+aluno).then(
					// Sucesso
					function(response) {
						if(response.data && response.data.status == 200)
							return response.data.aluno;
						return $q.reject(response.data.messages);
					},
					// Erro
					function(response) {
						if(response.status == -1)
							return $q.reject({'erro' : 'Erro de conexão!'});
						return $q.reject(response.data.messages);
					}
				);
			},
			listaAlunos: function(aluno, matricula) {
				var search = {};
				search.nome = aluno;
				if( aluno == null || matricula != null ){
					search.matricula = matricula;
					delete search.nome;
				}
				return $http.get( REST_END_POINT + VERSION.V1 + '/agendamento/alunos?'+ $.param(search)).then(

				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.alunos;
					}
					else {
						return $q.reject(response.data.messages);
					}
				},
				// Erro
				function(response) {

					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},
			selecionaAluno: function(nivel, matricula, area) {
				if(nivel === null || matricula === null || area === null){
					return;
				}
				var search = {
					nivel: nivel,
					matricula: matricula,
					area: area
				};
				return $http.get( REST_END_POINT + VERSION.V1 + '/agendamento/selecionaAluno?'+ $.param(search)).then(

				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.alunos;
					}
					else {
						return $q.reject(response.data.messages);
					}
				},
				// Erro
				function(response) {

					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},
			listaNiveis: function(matricula) {
				if(matricula === null){
					return;
				}
				var search = {
					matricula: matricula
				};
				return $http.get( REST_END_POINT + VERSION.V1 + '/agendamento/listaNiveis?'+ $.param(search)).then(

				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.alunos;
					}
					else {
						return $q.reject(response.data.messages);
					}
				},
				// Erro
				function(response) {

					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},
			listaAreas: function(matricula) {
				if(matricula === null){
					return;
				}
				var search = {
					matricula: matricula
				};
				return $http.get( REST_END_POINT + VERSION.V1 + '/agendamento/listaAreas?'+ $.param(search)).then(

				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.alunos;
					}
					else {
						return $q.reject(response.data.messages);
					}
				},
				// Erro
				function(response) {

					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},
			getEvento: function(evento) {
				var data = {
					id : evento.id,
				};

				return $http.get( REST_END_POINT + VERSION.V1 + '/agendamento/evento?' + $.param(data)).then(
				// Sucesso
				function(response) {

					if(response.data && response.data.status == 200) {
						return response.data.evento;
					}
					else {
						return $q.reject(response.data.messages);
					}
				},
				// Erro
				function(response) {

					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},
			_getAluno: function(){
				return this.aluno;
			},

			setAluno: function(obj) {
				this.aluno = obj;
			},

			getFeriado: function() {
				return this.feriado;
			},
			setFeriado: function(obj) {
				this.feriado = obj;
			},

			getAnfiteatro: function() {
				return this.anfiteatro;
			},
			setAnfiteatro: function(obj) {
				this.anfiteatro = obj;
			},
		};
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 02/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.agendamento')
		.service('agendamento.RelatoriosService', RelatoriosService);

	/** @ngInject */
	function RelatoriosService(REST_END_POINT, VERSION, $filter, $http, $q, $uibModal, AgendamentoService, AuthService) {
				
		var relatorio = null;
		var consulta = null;
		
		var RelatoriosService = {
				
			listarRelatorios : function(opcao) {
				var relatorios = {
					agendamentos: {
						'relatorio.agendamentos.relacaoAgendamentoDefesa' : { label: 'Relação de Agendamento de Defesa', func: RelatoriosService.RelacaoAgendamentoDefesa },
						'relatorio.agendamentos.resumoTotal' : { label: 'Resumo Total', func: RelatoriosService.ResumoTotal },
						'relatorio.agendamentos.relacaoBancas' : { label: 'Relação de Participação em Bancas', func: RelatoriosService.RelacaoBancas },
						'relatorio.agendamentos.relacaoDissertacaoTese' : { label: 'Relação Descritiva de Dissertações e Teses Defendidas', func: RelatoriosService.RelacaoDissertacaoTese },
						'relatorio.agendamentos.numeroTeses' : { label: 'Número de Teses e Dissertações Defendidas', func: RelatoriosService.NumeroTeses },
						'relatorio.agendamentos.relacaoDissertacaoTeseComOrientador' : { label: 'Relação de Dissertações e Teses com Orientador', func: RelatoriosService.RelacaoDissertacaoTeseComOrientador },
						'relatorio.agendamentos.relacaoDissertacaoTesePorData' : { label: 'Relação de Dissertações e Teses por Data com Orientador', func: RelatoriosService.RelacaoDissertacaoTesePorData },
					},
					consulta: {
						'consulta' : { label: 'Consulta', func: RelatoriosService.ConsultaAluno }
					}
				};
				
				return relatorios;
			},

			RelacaoAgendamentoDefesa : function(filtros) {
			
				filtros = {
					area :  filtros.area.id,
					periodo_de : filtros.periodo.de ? $filter('date')(filtros.periodo.de, 'yyyy-MM-dd') : null,
					periodo_ate : filtros.periodo.ate ? $filter('date')(filtros.periodo.ate, 'yyyy-MM-dd') : null,
					orientador :  filtros.orientador.value,
					sub: AuthService.getUser()
				};
			
				return $http.get(REST_END_POINT + VERSION.V1 + '/agendamento/relatorios/agendamentos/agendamentoDefesa?' + $.param(filtros));

			},
			ResumoTotal : function(filtros) {
			
				filtros = {
					sub: AuthService.getUser()
				};
			
				return $http.get(REST_END_POINT + VERSION.V1 + '/agendamento/relatorios/agendamentos/resumoTotal?' + $.param(filtros));

			},
			RelacaoBancas : function(filtros) {
			
				filtros = {
					orientador :  filtros.orientador.value,
					periodo_de : filtros.periodo.de ? $filter('date')(filtros.periodo.de, 'yyyy-MM-dd') : null,
					periodo_ate : filtros.periodo.ate ? $filter('date')(filtros.periodo.ate, 'yyyy-MM-dd') : null,
					sub: AuthService.getUser()
				};
			
				return $http.get(REST_END_POINT + VERSION.V1 + '/agendamento/relatorios/agendamentos/relacaoBancas?' + $.param(filtros));

			},
			RelacaoDissertacaoTese : function(filtros) { //**
			
				filtros = {
					area :  filtros.area.id,
					periodo_de : filtros.periodo.de ? $filter('date')(filtros.periodo.de, 'yyyy-MM-dd') : null,
					periodo_ate : filtros.periodo.ate ? $filter('date')(filtros.periodo.ate, 'yyyy-MM-dd') : null,
					orientador :  filtros.orientador.value,
					sub: AuthService.getUser()
				};
			
				return $http.get(REST_END_POINT + VERSION.V1 + '/agendamento/relatorios/agendamentos/dissertacaoTese?' + $.param(filtros));

			},
			NumeroTeses : function(filtros) {
			
				filtros = {
					area :  filtros.area.id,
					periodo_de : filtros.periodo.de ? $filter('date')(filtros.periodo.de, 'yyyy-MM-dd') : null,
					periodo_ate : filtros.periodo.ate ? $filter('date')(filtros.periodo.ate, 'yyyy-MM-dd') : null,
					orientador :  filtros.orientador.value,
					sub: AuthService.getUser()
				};
			
				return $http.get(REST_END_POINT + VERSION.V1 + '/agendamento/relatorios/agendamentos/numeroTeses?' + $.param(filtros));

			},
			RelacaoDissertacaoTesePorData : function(filtros) {
			
				filtros = {
					area :  filtros.area.id,
					periodo_de : filtros.periodo.de ? $filter('date')(filtros.periodo.de, 'yyyy-MM-dd') : null,
					periodo_ate : filtros.periodo.ate ? $filter('date')(filtros.periodo.ate, 'yyyy-MM-dd') : null,
					orientador :  filtros.orientador.value,
					sub: AuthService.getUser()
				};
			
				return $http.get(REST_END_POINT + VERSION.V1 + '/agendamento/relatorios/agendamentos/relacaoDissertacaoTesePorData?' + $.param(filtros));

			},
			RelacaoDissertacaoTeseComOrientador : function(filtros) {
			
				filtros = {
					area :  filtros.area.id,
					periodo_de : filtros.periodo.de ? $filter('date')(filtros.periodo.de, 'yyyy-MM-dd') : null,
					periodo_ate : filtros.periodo.ate ? $filter('date')(filtros.periodo.ate, 'yyyy-MM-dd') : null,
					orientador :  filtros.orientador.value,
					sub: AuthService.getUser()
				};
			
				return $http.get(REST_END_POINT + VERSION.V1 + '/agendamento/relatorios/agendamentos/relacaoDissertacaoTeseComOrientador?' + $.param(filtros));

			},

			ConsultaAluno : function(filtros) {

				filtros = {
					nome :  filtros.nome,	
					matricula : filtros.matricula,
					sub: AuthService.getUser()
				};
				return $http.get(REST_END_POINT + VERSION.V1 + '/agendamento/alunos/consulta?' + $.param(filtros));
			},


			gerarRelatorio : function(filtros) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
				
					var opcao = filtros.opcao,
						relatorios = RelatoriosService.listarRelatorios();
					

					if( Object.keys(relatorios.agendamentos).indexOf(opcao) !== -1 ){
						return relatorios.agendamentos[opcao].func(filtros).then(	
						// Sucesso		
						function(response) {
							modalInstance.close();
							if(response.data && response.data.status == 200) {
								return response.data.relatorios.agendamentos;
							}
							else {
								return $q.reject(response.data.messages);
							}
						}, 
						// Erro
						function(response) {
							modalInstance.close();
							if(response.status == -1) {						
								return $q.reject({'erro' : 'Erro de conexão!'});
							}
							
							return $q.reject(response.data.messages);
						});
					}
					if( Object.keys(relatorios.consulta).indexOf(opcao) !== -1 ){
						return relatorios.consulta[opcao].func(filtros).then(	
						// Sucesso		
						function(response) {
							modalInstance.close();
							if(response.data && response.data.status == 200) {
								return response.data.alunos;
							}
							else {
								return $q.reject(response.data.messages);
							}
						}, 
						// Erro
						function(response) {
							modalInstance.close();
							if(response.status == -1) {						
								return $q.reject({'erro' : 'Erro de conexão!'});
							}
							
							return $q.reject(response.data.messages);
						});
					}
				}catch(erro){
					//modalInstance.close();
				}finally{
					modalInstance.close();
				}
			},
			
			// GETTER's e SETTER's
			getRelatorio: function() {
				return relatorio;
			},
			setRelatorio: function(obj) {
				relatorio = obj;
			}
		};
		
		return RelatoriosService;
	}

})();
/**
 * @author
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.comissao')
		.service('ComissaoService', ComissaoService);

	/** @ngInject */
	function ComissaoService(REST_END_POINT, VERSION, $http, $q, AuthService) {
				
		return {
			listaComissao : function() {
				return $http.get(REST_END_POINT + VERSION.V1 + '/comissao/lista?sub='+AuthService.getUser()).then(
				// Sucesso		
				function(response) {
					if(response.data && response.data.status == 200)
						return response.data.comissao;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
		};
	}

})();
/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.comissao')
  		.controller('ComissaoPageCtrl', ComissaoPageCtrl);

	/** @ngInject */
	function ComissaoPageCtrl($scope, $state, ComissaoService) {
		$scope.listComissao = {};
		ComissaoService.listaComissao().then(function(comissao){
			$scope.listComissao = comissao;
		});
	}

})();

/**
 * @author
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.diploma')
		.service('DiplomaService', DiplomaService);

	/** @ngInject */
	function DiplomaService(REST_END_POINT, VERSION, $http, $q, $uibModal, AuthService) {
				
		return {
			listaDiploma : function(_filtros) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
					var filtros = $.extend(_filtros,{
						'sub': AuthService.getUser()
					});
					
				}catch(erro){
					modalInstance.close();
				}
				return $http.get(REST_END_POINT + VERSION.V1 + '/diploma/lista?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					modalInstance.close();
					if(response.data && response.data.status == 200)
						return response.data.diploma;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					modalInstance.close();
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
		};
	}

})();
/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.diploma')
  		.controller('DiplomaPageCtrl', DiplomaPageCtrl);

	/** @ngInject */
	function DiplomaPageCtrl($scope, $state, DiplomaService) {
		$scope.diplomas = [];
		$scope.outros = [];
		DiplomaService.listaDiploma().then(function(diploma){
			$scope.outros = diploma;
			$scope.diplomas = $scope.outros;
		});

		$scope.busca = {};
		$scope.limpar =  function(){
			$scope.busca = {};
		}

		$scope.pesquisar = function(){
			$scope.mensagem = null;
			DiplomaService.listaDiploma($scope.busca).then(function(diploma){
				$scope.outros = diploma;
				$scope.diplomas = $scope.outros;
			}).catch(function(erro){
				$scope.mensagem = erro;
				$scope.outros = [];
				$scope.diplomas = $scope.outros;
			});
		}
	}

})();

angular.module('BlurAdmin.pages.directives', [])
.directive('numbers', function() {
  return {
    require: 'ngModel',
    link: function (scope, element, attr, ngModelCtrl) {
    
      function parserNumerico(textoOriginal) {
      
        // Troque tudo o que não for um dígito válido por uma string vazia
        var inputSemNumeros = textoOriginal.replace(/[^0-9]/g, ''); 
        if(inputSemNumeros !== textoOriginal) {
            // reverta o valor para a versão sem números.
            ngModelCtrl.$setViewValue(inputSemNumeros);
            ngModelCtrl.$render();
        }
        return Number(inputSemNumeros);
      }
      
      ngModelCtrl.$parsers.push(parserNumerico);
    }
  }; 
});
angular.module('BlurAdmin.pages.directives', [])
.directive('phone', [ '$filter', '$browser', function($filter, $browser) {
    return {
        require: 'ngModel',
        link: function($scope, $element, $attrs, ngModelCtrl) {
            var listener = function() {
                var value = $element.val().replace(/[^0-9\(\)\-\s\,]/g, '');
                $element.val($filter('tel')(value, false));
            };

            // This runs when we update the text field
            ngModelCtrl.$parsers.push(function(viewValue) {
                return $filter('tel')(viewValue.replace(/[^0-9\(\)\-\s\,]/g, '').slice(0,15),false);
            });

            // This runs when the model gets updated on the scope directly and keeps our view in sync
            ngModelCtrl.$render = function() {
                $element.val($filter('tel')(ngModelCtrl.$viewValue, false));
            };

            $element.bind('change', listener);
            $element.bind('keydown', function(event) {
                var key = event.keyCode;
                // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
                // This lets us support copy and paste too
                if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)){
                    return;
                }
                $browser.defer(listener); // Have to do this or changes don't get picked up properly
            });

            $element.bind('paste cut', function() {
                $browser.defer(listener);
            });
        }
    };
}]);
/**
 * @author Edmilson Silva 24/07/17
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.downloads')
		.service('DocService', DocService);

	/** @ngInject */
	function DocService(REST_END_POINT, VERSION, $http, $q, $filter, AuthService) {
		return {
			getTiposDoc: function(){
				return $http.get(REST_END_POINT + VERSION.V1 + '/tipoDoc?sub='+AuthService.getUser()).then(
					// Sucesso		
					function(response) {
						
						if(response.data){
							if(response.data.status == 200) {
								return response.data.tiposDoc;
							} else {
								return $q.reject(response.data.messages);
							}
						} else {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
					}, 
					// Erro
					function(response) {
						if(response.status == -1) {						
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			getDocs: function(filtros){
				filtros = {
					tipo : filtros.tipo,
					filtro: filtros.filtro,
					sub: AuthService.getUser()
				};
				return $http.get(REST_END_POINT + VERSION.V1 + '/docs?'+$.param(filtros)).then(
					// Sucesso		
					function(response) {
						
						if(response.data){
							if(response.data.status == 200) {
								return response.data.docs;
							} else {
								return $q.reject(response.data.messages);
							}
						} else {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
					}, 
					// Erro
					function(response) {
						if(response.status == -1) {						
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			excluirDoc: function(filtros){
				return $http.delete(REST_END_POINT + VERSION.V1 + '/docs/'+filtros.idDownload+'/'+AuthService.getUser()).then(
					// Sucesso		
					function(response) {
						
						if(response.data){
							if(response.data.status == 200) {
								return response.data.docs;
							} else {
								return $q.reject(response.data.messages);
							}
						} else {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
					}, 
					// Erro
					function(response) {
						if(response.status == -1) {						
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			enviaCarga : function(carga){
				var fd = new FormData();
	        	fd.append('file', carga.arquivo);
	        	fd.append('title', carga.titulo);
	        	fd.append('type', $.param(carga.tipo));
	        	fd.append('desc', carga.descricao?carga.descricao:'');
	        	fd.append('date', $filter('date')(carga.data, 'yyyy-MM-dd'));
	        	fd.append('sub', AuthService.getUser());


				return $http.post(REST_END_POINT + VERSION.V1 + '/docs/carga',fd,{
					withCredentials : false,
					transformRequest : angular.identity,
		            headers: {'Content-Type' : undefined}
		        }).then(
			        //Success
			        function (response) {
			        	if(response.data){
							if(response.data.status == 200) {
								return response.data;
							} else {
								return $q.reject(response.data.messages);
							}
						} else {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
			        },
			        //Error
			        function (response, status) {
			        	if(response.status == -1) {						
			        		return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
		        	}
		        );
	        },
	        updateCarga : function(carga){
				var fd = new FormData();
				fd.append('idDownload', carga.idDownload);
	        	fd.append('file', carga.namefile);
	        	fd.append('title', carga.titulo);
	        	fd.append('type', $.param(carga.tipo?carga.tipo:{id:carga.idTipo,value:''}));
	        	fd.append('desc', carga.descricao?carga.descricao:'');
	        	fd.append('date', $filter('date')(carga.data, 'yyyy-MM-dd'));
	        	fd.append('sub', AuthService.getUser());

				return $http.post(REST_END_POINT + VERSION.V1 + '/docs/update',fd,{
					withCredentials : false,
					transformRequest : angular.identity,
		            headers: {'Content-Type' : undefined}
		        }).then(
			        //Success
			        function (response) {
			        	if(response.data){
							if(response.data.status == 200) {
								return response.data.messages;
							} else {
								return $q.reject(response.data.messages);
							}
						} else {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
			        },
			        //Error
			        function (response, status) {
			        	if(response.status == -1) {						
			        		return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
		        	}
		        );
	        },
		};
	}

})();
/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.manutencao')
		.service('ManutencaoService', ManutencaoService);

	/** @ngInject */
	function ManutencaoService(REST_END_POINT, VERSION, $filter, $http, $q, AuthService) {

		var aluno = null;

		return {
			getTipos : function() {
				var filtros = {};
				return $http.get(REST_END_POINT + VERSION.V1 + '/log/tipos').then(
				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.log;
					}
					return $q.reject(response.data);
				},
				// Erro
				function(response) {

					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},
			getCategorias : function() {
				var filtros = {};
				return $http.get(REST_END_POINT + VERSION.V1 + '/log/categorias').then(
				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.log;
					}
					return $q.reject(response.data);
				},
				// Erro
				function(response) {

					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},
			getUsuarios : function() {
				var filtros = {};
				return $http.get(REST_END_POINT + VERSION.V1 + '/log/usuarios').then(
				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.log;
					}
					return $q.reject(response.data);
				},
				// Erro
				function(response) {

					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},
			listaProgramasAreas : function(_filtros) {

				var filtros = {
					'areas': (_filtros && _filtros.areas? _filtros.areas : null)
				};

				return $http.get(REST_END_POINT + VERSION.V1 + '/programas/areas?' + $.param(filtros)).then(
				// Sucesso
				function(response) {

					if(response.data && response.data.status == 200) {
						return response.data.areas;
					}
					else {
						return $q.reject(response.data.messages);
					}
				},
				// Erro
				function(response) {

					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},
			listarProgramas : function(_filtros) {
				var filtros = $.extend(_filtros,{
					sub: AuthService.getUser()
				});

				return $http.get(REST_END_POINT + VERSION.V1 + '/programas?' + $.param(filtros)).then(
				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.programas;
					}
					return $q.reject(response.data.messages);
				},
				// Erro
				function(response) {

					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},
			adicionaProgramas : function(_filtros) {
				var filtros = $.extend(_filtros,{
					sub: AuthService.getUser()
				});

				return $http.post(REST_END_POINT + VERSION.V1 + '/programas', filtros).then(
				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.programas;
					}
					return $q.reject(response.data.messages);
				},
				// Erro
				function(response) {

					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},
			editaProgramas : function(_filtros) {
				var filtros = $.extend(_filtros,{
					sub: AuthService.getUser()
				});

				return $http.put(REST_END_POINT + VERSION.V1 + '/programas', filtros).then(
				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.programas;
					}
					return $q.reject(response.data.messages);
				},
				// Erro
				function(response) {

					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},
			excluiProgramas : function(filtros) {
				return $http.delete(REST_END_POINT + VERSION.V1 + '/programas/'+filtros.id+'/'+AuthService.getUser()).then(
				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.programas;
					}
					return $q.reject(response.data.messages);
				},
				// Erro
				function(response) {

					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},
			/**
			 * Listar alunos para Dados Básicos
			 */
			listarUsuarios : function(user_id) {
				var filtros = {
					id: user_id,
					sub: AuthService.getUser()
				};
				return $http.get(REST_END_POINT + VERSION.V1 + '/usuarios?' + $.param(filtros)).then(
				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.usuarios;
					}
					return $q.reject(response.data);
				},
				// Erro
				function(response) {

					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}

					return $q.reject(response.data.messages);
				});
			},
			/**
			 * Listar log
			 */
			listarLog : function(dados) {
				var filtros = {
					sub: AuthService.getUser(),
					de: typeof (dados.de) != 'undefined' ? $filter('date')(dados.de, 'yyyy-MM-dd') : null,
					ate: typeof (dados.ate) != 'undefined' ? $filter('date')(dados.ate, 'yyyy-MM-dd') : null,
					categoria: dados && typeof(dados.categoria) != 'undefined' ? dados.categoria : null,
					tipo: dados && typeof(dados.tipo) != 'undefined' ? dados.tipo : null,
					usuario: dados && typeof(dados.usuario) != 'undefined' ? dados.usuario : null,
					id: dados && typeof(dados.id) != 'undefined' ? dados.id : null,
					ip: dados && typeof(dados.ip) != 'undefined' ? dados.ip : null,
					//de: dados && typeof(dados.de) != 'undefined' ? $filter('date')(dados.de, 'yyyy-MM-dd') : null,
					//ate: dados && typeof(dados.ate) != 'undefined' ? $filter('date')(dados.ate, 'yyyy-MM-dd') : null,
					//tipo: dados && typeof(dados.tipo) != 'undefined' ? dados.tipo.idTipo : null,
					//categoria: dados && typeof(dados.categoria) != 'undefined' ? dados.categoria.idCagetoria : null,
					//usuario: dados && typeof(dados.usuario) != 'undefined' ? dados.usuario.idUsuario : null,

					//de: typeof (dados.de) != 'undefined' ? $filter('date')(dados.de, 'yyyy-MM-dd') : null,
					//ate: typeof (dados.ate) != 'undefined' ? $filter('date')(dados.ate, 'yyyy-MM-dd') : null,
					//categoria: dados.categoria,
					//tipo: dados.tipo,
					//usuario: dados.usuario,
					//id: dados.id,
				};
				// filtros = jQuery.extend(filtros,dados);
				return $http.get(REST_END_POINT + VERSION.V1 + '/log?' + $.param(filtros)).then(
				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200)
						return response.data.log;
					return $q.reject({'aviso': response.data.message});
				},
				// Erro
				function(response) {
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			salvaPerfil: function(usuario){
				var filtros = {
					id: usuario.id,
					perfil: usuario.perfilUser,
					sub: AuthService.getUser()
				};
				return $http.post(REST_END_POINT + VERSION.V1 + '/usuarios/salvarPerfil',filtros).then(
					// Sucesso
					function(response) {
						if(response.data && response.data.status == 200) {
							return response.data.usuarios;
						}
						return $q.reject(response.data);
					},
					// Erro
					function(response) {
						if(response.status == -1) {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					});
			},
			reprovarUsuario: function(usuario){
				var filtros = {
					id: usuario.id,
					sub: AuthService.getUser()
				};
				return $http.post(REST_END_POINT + VERSION.V1 + '/usuarios/bloquear', filtros).then(
					// Sucesso
					function(response) {
						if(response.data && response.data.status == 200) {
							return response.data.usuarios;
						}
						return $q.reject(response.data);
					},
					// Erro
					function(response) {
						if(response.status == -1) {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					});
			},
			listarPerfis : function(filtros) {
				filtros = {};
				return $http.get(REST_END_POINT + VERSION.V1 + '/usuarios/perfis',filtros).then(
				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.perfis;
					}
					return $q.reject(response.data);
				},
				// Erro
				function(response) {
					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					return $q.reject(response.data.messages);
				});
			},
			listarStatus : function(filtros) {
				filtros = {};
				return $http.get(REST_END_POINT + VERSION.V1 + '/usuarios/status',filtros).then(
				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.status_data;
					}
					return $q.reject(response.data);
				},
				// Erro
				function(response) {
					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					return $q.reject(response.data.messages);
				});
			},
			listarAreas : function(user_id) {
				var filtros = {id:user_id};
				return $http.get(REST_END_POINT + VERSION.V1 + '/usuarios/areas?'+ $.param(filtros)).then(
				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.areas;
					}
					return $q.reject(response.data);
				},
				// Erro
				function(response) {
					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					return $q.reject(response.data.messages);
				});
			},
			listarComissao : function(dados) {
				var filtros = {
					sub: AuthService.getUser(),
					cargo: dados.cargo || null,
					nome: dados.nome || null,
				};
				return $http.get(REST_END_POINT + VERSION.V1 + '/comissao?'+ $.param(filtros)).then(
					// Sucesso
					function(response) {
						if(response.data && response.data.status == 200) {
							return response.data.comissao;
						}
						return $q.reject(response.data.message);
					},
					// Erro
					function(response) {
						if(response.status == -1) {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.message);
					}
				);
			},
			listarEquipe : function(dados) {
				var filtros = {
					sub: AuthService.getUser(),
					nome: dados.nome || null,
					funcao: dados.funcao || null,
				};
				return $http.get(REST_END_POINT + VERSION.V1 + '/equipe?'+ $.param(filtros))
				.then(
					// Sucesso
					function(response) {
						if(response.data && response.data.status == 200) {
							return response.data.equipe;
						}
						return $q.reject(response.data.message);
					},
					// Erro
					function(response) {
						if(response.status == -1) {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.message);
					}
				);
			},
			listarPortaria : function(dados) {
				var filtros = {
					sub: AuthService.getUser(),
					lei: dados.lei || null,
					descricao: dados.descricao || null,
				};
				return $http.get(REST_END_POINT + VERSION.V1 + '/portaria?'+ $.param(filtros))
				.then(
					// Sucesso
					function(response) {
						if(response.data && response.data.status == 200) {
							return response.data.portaria;
						}
						return $q.reject(response.data.message);
					},
					// Erro
					function(response) {
						if(response.status == -1) {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.message);
					}
				);
			},
			listarCargos : function() {
				var filtros = {
					sub: AuthService.getUser(),
				};
				return $http.get(REST_END_POINT + VERSION.V1 + '/comissao/cargos?'+ $.param(filtros)).then(
					// Sucesso
					function(response) {
						if(response.data && response.data.status == 200) {
							return response.data.cargo;
						}
						return $q.reject(response.data);
					},
					// Erro
					function(response) {
						if(response.status == -1) {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			listarCargosDefault : function() {
				var filtros = {
					sub: AuthService.getUser(),
				};
				return $http.get(REST_END_POINT + VERSION.V1 + '/comissao/cargos?p=default&'+ $.param(filtros)).then(
					// Sucesso
					function(response) {
						if(response.data && response.data.status == 200) {
							return response.data.cargo;
						}
						return $q.reject(response.data);
					},
					// Erro
					function(response) {
						if(response.status == -1) {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			adicionarComissao : function(dados) {
				var filtros = {
					cargo: dados.cargo.id,
					titular: dados.titular,
					suplente: dados.suplente,
					sub: AuthService.getUser(),
				};
				return $http.post(REST_END_POINT + VERSION.V1 + '/comissao', filtros).then(
					// Sucesso
					function(response) {
						if(response.data && response.data.status == 200) {
							return response.data.comissao;
						}
						return $q.reject(response.data.messages);
					},
					// Erro
					function(response) {
						if(response.status == -1) {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			editarComissao : function(dados) {
				var filtros = {
					id: dados.idComissao,
					cargo: dados.cargo.id,
					titular: dados.titular,
					suplente: dados.suplente,
					sub: AuthService.getUser(),
				};
				return $http.put(REST_END_POINT + VERSION.V1 + '/comissao', filtros).then(
					// Sucesso
					function(response) {
						if(response.data && response.data.status == 200) {
							return response.data.comissao;
						}
						return $q.reject(response.data.messages);
					},
					// Erro
					function(response) {
						if(response.status == -1) {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			excluirComissao : function(dados) {
				var filtros = {
					id: dados.idComissao,
					sub: AuthService.getUser(),
				};
				return $http.delete(REST_END_POINT + VERSION.V1 + '/comissao/'+filtros.id+'/'+filtros.sub).then(
					// Sucesso
					function(response) {
						if(response.data && response.data.status == 200) {
							return response.data.comissao;
						}
						return $q.reject(response.data);
					},
					// Erro
					function(response) {
						if(response.status == -1) {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			adicionarEquipe : function(dados) {
				var filtros = {
					cargo: dados.cargo,
					nome: dados.nome,
					fone: dados.fone,
					email: dados.email,
					assinatura: dados.assinatura || null,
					sub: AuthService.getUser(),
				};
				return $http.post(REST_END_POINT + VERSION.V1 + '/equipe', filtros)
				.then(
					// Sucesso
					function(response) {
						if(response.data && response.data.status == 200) {
							return response.data.equipe;
						}
						return $q.reject(response.data.messages);
					},
					// Erro
					function(response) {
						if(response.status == -1) {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			editarEquipe : function(dados) {
				var filtros = {
					id: dados.id,
					cargo: dados.cargo,
					nome: dados.nome,
					fone: dados.fone,
					email: dados.email,
					assinatura: dados.assinatura || null,
					sub: AuthService.getUser(),
				};
				return $http.put(REST_END_POINT + VERSION.V1 + '/equipe', filtros).then(
					// Sucesso
					function(response) {
						if(response.data && response.data.status == 200) {
							return response.data.equipe;
						}
						return $q.reject(response.data.messages);
					},
					// Erro
					function(response) {
						if(response.status == -1) {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			excluirEquipe : function(dados) {
				var filtros = {
					id: dados.id,
					sub: AuthService.getUser(),
				};
				return $http.delete(REST_END_POINT + VERSION.V1 + '/equipe/'+filtros.id+'/'+filtros.sub).then(
					// Sucesso
					function(response) {
						if(response.data && response.data.status == 200) {
							return response.data.equipe;
						}
						return $q.reject(response.data.messages);
					},
					// Erro
					function(response) {
						if(response.status == -1) {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			adicionarPortaria: function (dados) {
				var filtros = {
					lei: dados.lei,
					descricao: dados.descricao,
					data: typeof (dados.data) != 'undefined' ? $filter('date')(dados.data, 'yyyy-MM-dd') : null,
					publicacao: dados.publicacao,
					periodo: dados.periodo,
					sub: AuthService.getUser(),
				};
				return $http.post(REST_END_POINT + VERSION.V1 + '/portaria', filtros)
					.then(
						// Sucesso
						function (response) {
							if (response.data && response.data.status == 200) {
								return response.data.portaria;
							}
							return $q.reject(response.data.messages);
						},
						// Erro
						function (response) {
							if (response.status == -1) {
								return $q.reject({ 'erro': 'Erro de conexão!' });
							}
							return $q.reject(response.data.messages);
						}
					);
			},
			editarPortaria: function (dados) {
				var filtros = {
					id: dados.id,
					lei: dados.lei,
					descricao: dados.descricao,
					data: typeof (dados.data) != 'undefined' ? $filter('date')(dados.data, 'yyyy-MM-dd') : null,
					publicacao: dados.publicacao,
					periodo: dados.periodo,
					sub: AuthService.getUser(),
				};
				return $http.put(REST_END_POINT + VERSION.V1 + '/portaria', filtros).then(
					// Sucesso
					function (response) {
						if (response.data && response.data.status == 200) {
							return response.data.portaria;
						}
						return $q.reject(response.data.messages);
					},
					// Erro
					function (response) {
						if (response.status == -1) {
							return $q.reject({ 'erro': 'Erro de conexão!' });
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			excluirPortaria: function (dados) {
				var filtros = {
					id: dados.id,
					sub: AuthService.getUser(),
				};
				return $http.delete(REST_END_POINT + VERSION.V1 + '/portaria/' + filtros.id + '/' + filtros.sub).then(
					// Sucesso
					function (response) {
						if (response.data && response.data.status == 200) {
							return response.data.portaria;
						}
						return $q.reject(response.data.messages);
					},
					// Erro
					function (response) {
						if (response.status == -1) {
							return $q.reject({ 'erro': 'Erro de conexão!' });
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			salvar : function(usuario) {
				usuario.sub = AuthService.getUser();
				return $http.post(REST_END_POINT + VERSION.V1 + '/usuarios/salvar',usuario).then(
				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.usuario;
					}
					return $q.reject(response.data.messages);
				},
				// Erro
				function(response) {
					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					return $q.reject(response.data.messages);
				});
			},
			adicionar : function(usuario) {
				usuario.sub = AuthService.getUser();
				return $http.post(REST_END_POINT + VERSION.V1 + '/usuarios/adicionar',usuario).then(
				// Sucesso
				function(response) {
					if(response.data && response.data.status == 200) {
						return response.data.usuario;
					}
					return $q.reject(response.data);
				},
				// Erro
				function(response) {
					if(response.status == -1) {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					return $q.reject(response.data.messages);
				});
			}
		};
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 02/05/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.proficiencias')
		.service('EscolasService', EscolasService);

	/** @ngInject */
	function EscolasService(REST_END_POINT, VERSION, $http, $q) {
				
		return {
			getEscolas : function(filtros) {
				
				var _filtros = {

				};
				/*if(filtros && filtros.id){
					_filtros = { area : filtros.id };
				}*/
				
				return $http.post(REST_END_POINT + VERSION.V1 + '/escolas?' + $.param(_filtros)).then(
				// Sucesso		
				function(response) {

					if(response.data && response.data.status == 200) {
						return response.data.escolas;
					}
					else {
						return $q.reject(response.data.messages);
					}
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					
					return $q.reject(response.data.messages);
				});
			}
		};
	}

})();
/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.proficiencias')
		.service('ProficienciasService', ProficienciasService);

	/** @ngInject */
	function ProficienciasService(REST_END_POINT, VERSION, $filter, $http, $q, AuthService) {
		
		var proficiencia = null;
		var buscaProficiencia = null;
				
		return {
			listarProficiencias : function(filtros) {
				
				this.setBuscaProficiencia(filtros);
				filtros = {
					periodo_de: $filter('date')(filtros.periodo.de, 'yyyy-MM-dd'),
					periodo_ate: $filter('date')(filtros.periodo.ate, 'yyyy-MM-dd'),
					nome: filtros.nome,
					cpf: filtros.cpf,
					conceito: filtros.conceito.value ? filtros.conceito.value : null,
					sub: AuthService.getUser() || 0
				};
				
				return $http.get(REST_END_POINT + VERSION.V1 + '/proficiencias?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					
					if(response.data){
						if(response.data.status == 200) {
							return response.data.proficiencias;
						} else {
							return $q.reject(response.data.messages);
						}
					} else {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
				}, 
				// Erro
				function(response) {
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					return $q.reject(response.data.messages);
				});
			},

			inserirProficiencia : function(filtros) {
				
				filtros = {
					cpf: filtros.cpf,
					dataExame: $filter('date')(filtros.dataExame, 'yyyy-MM-dd'),
					nomeAluno: filtros.nomeAluno,
					idEscola: filtros.escola.id,
					notaExame: filtros.notaExame,
					sub: AuthService.getUser() || 0
				};
				
				return $http.post(REST_END_POINT + VERSION.V1 + '/proficiencias', filtros).then(
				// Sucesso		
				function(response) {
					
					if(response.data){
						if(response.data.status == 200) {
							return response.data.proficiencias;
						} else {
							return $q.reject(response.data.messages);
						}
					} else {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
				}, 
				// Erro
				function(response) {
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					return $q.reject(response.data.messages);
				});
			},
			editarProficiencia : function(filtros) {
				filtros = {
					id: filtros.id,
					cpf: filtros.cpf,
					dataExame: $filter('date')(filtros.dataExame, 'yyyy-MM-dd'),
					nomeAluno: filtros.nomeAluno,
					idEscola: filtros.escola.id,
					notaExame: filtros.notaExame,
					sub: AuthService.getUser() || 0
				};
				
				return $http.put(REST_END_POINT + VERSION.V1 + '/proficiencias', filtros).then(
				// Sucesso		
				function(response) {
					
					if(response.data){
						if(response.data.status == 200) {
							return response.data.proficiencias;
						} else {
							return $q.reject(response.data.messages);
						}
					} else {
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
				}, 
				// Erro
				function(response) {
					if(response.status == -1) {						
						return $q.reject({'erro' : 'Erro de conexão!'});
					}
					return $q.reject(response.data.messages);
				});
			},
			// GETTER's e SETTER's
			getProficiencia: function() {
				return proficiencia;
			},
			setProficiencia: function(obj) {
				proficiencia = obj;
			},
			getBuscaProficiencia: function() {
				return buscaProficiencia;
			},
			setBuscaProficiencia: function(obj) {
				buscaProficiencia = obj;
			}
		};
	}

})();
/**
 * @author Edmilson Silva 24/07/17
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.parecer')
		.service('ParecerService', ParecerService);

	/** @ngInject */
	function ParecerService(REST_END_POINT, VERSION, $http, $q, $filter, AuthService) {
		var parecer = null;
		return {
			getDtTipos: function(){
				return [
					{id:1, value:'Data Entrada'},
					{id:2, value:'Data Encaminhamento'},
					{id:3, value:'Data Retorno'}
				];
			},
			getStatus: function(){
				return [
					{id:1, value:'Novo'},
					{id:2, value:'Encaminhado'},
					{id:3, value:'Encerrado'}
				];
			},
			getResultados: function($id){
				return $http.get(REST_END_POINT + VERSION.V1 + '/parecer/resultados').then(
					// Sucesso		
					function(response) {
						
						if(response.data){
							if(response.data.status == 200) {
								return response.data.parecer;
							} else {
								return $q.reject(response.data.messages);
							}
						} else {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
					}, 
					// Erro
					function(response) {
						if(response.status == -1) {						
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			getParecerData: function($id){
				return $http.get(REST_END_POINT + VERSION.V1 + '/parecer/'+$id).then(
					// Sucesso		
					function(response) {
						
						if(response.data){
							if(response.data.status == 200) {
								return response.data.parecer;
							} else {
								return $q.reject(response.data.messages);
							}
						} else {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
					}, 
					// Erro
					function(response) {
						if(response.status == -1) {						
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			getTipos: function(){
				return $http.get(REST_END_POINT + VERSION.V1 + '/parecer/tipos').then(
					// Sucesso		
					function(response) {
						
						if(response.data){
							if(response.data.status == 200) {
								return response.data.parecer;
							} else {
								return $q.reject(response.data.messages);
							}
						} else {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
					}, 
					// Erro
					function(response) {
						if(response.status == -1) {						
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			getPareceristas: function(){
				return $http.get(REST_END_POINT + VERSION.V1 + '/parecer/pareceristas').then(
					// Sucesso		
					function(response) {
						
						if(response.data){
							if(response.data.status == 200) {
								return response.data.parecer;
							} else {
								return $q.reject(response.data.messages);
							}
						} else {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
					}, 
					// Erro
					function(response) {
						if(response.status == -1) {						
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			editarParecer: function(_filtros) {

				var filtros = $.extend(_filtros,{
					dt_pedido: _filtros.dt_pedido?$filter('date')(this.getPhpDate(_filtros.dt_pedido),'yyyy-MM-dd'):null,
					dt_encam: _filtros.dt_encam?$filter('date')(this.getPhpDate(_filtros.dt_encam),'yyyy-MM-dd'):null,
					dt_retorno: _filtros.dt_retorno?$filter('date')(this.getPhpDate(_filtros.dt_retorno),'yyyy-MM-dd'):null,
					'sub': AuthService.getUser()
				});
				return $http.put(REST_END_POINT + VERSION.V1 + '/parecer',filtros).then(
					// Sucesso		
					function(response) {
						
						if(response.data){
							if(response.data.status == 200) {
								return response.data.parecer;
							} else {
								return $q.reject(response.data.messages);
							}
						} else {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
					}, 
					// Erro
					function(response) {
						if(response.status == -1) {						
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			adicionarParecer: function(_filtros) {
				
				var filtros = $.extend(_filtros,{
					dt_pedido: _filtros.dt_pedido?$filter('date')(this.getPhpDate(_filtros.dt_pedido),'yyyy-MM-dd'):null,
					dt_encam: _filtros.dt_encam?$filter('date')(this.getPhpDate(_filtros.dt_encam),'yyyy-MM-dd'):null,
					dt_retorno: _filtros.dt_retorno?$filter('date')(this.getPhpDate(_filtros.dt_retorno),'yyyy-MM-dd'):null,
					'sub': AuthService.getUser()
				});
				return $http.post(REST_END_POINT + VERSION.V1 + '/parecer',filtros).then(
					// Sucesso		
					function(response) {
						
						if(response.data){
							if(response.data.status == 200) {
								return response.data.parecer;
							} else {
								return $q.reject(response.data.messages);
							}
						} else {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
					}, 
					// Erro
					function(response) {
						if(response.status == -1) {						
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			getPhpDate: function(date){
				if( /\d{1,2}\/\d{1,2}\/\d{4}/.test(date) ){
					return date.split('/').reverse().join('-');
				}
				return date;
			},
			getParecerList: function(_filtros,isAdmin){
				var userId = AuthService.getUser();
				var name = AuthService.getUserName();
				var filtros = {
					idUsuarioRelator: !isAdmin? userId: null, 
					cod: _filtros && _filtros.cod? _filtros.cod : null,
					interessado: _filtros && _filtros.interessado? _filtros.interessado : null,
					dt_tipo: _filtros && _filtros.dt_tipo && _filtros.dt_tipo.id? _filtros.dt_tipo.id : null, 
					dt_ini: _filtros && _filtros.dt_inicial? $filter('date')(_filtros.dt_inicial,'yyyy-MM-dd'):null, 
					dt_fim: _filtros && _filtros.dt_final?$filter('date')(_filtros.dt_final,'yyyy-MM-dd'):null,
					idTipo: _filtros && _filtros.tipo && _filtros.tipo.id?_filtros.tipo.id :null, 
					nomeRelator: !isAdmin?name:(!_filtros || !_filtros.parecerista?null:_filtros.parecerista),
					status: _filtros && _filtros.status && _filtros.status.id?_filtros.status.id : null,
					sub: userId
				};
				return $http.get(REST_END_POINT + VERSION.V1 + '/parecer/lista?'+$.param(filtros)).then(
					// Sucesso		
					function(response) {
						
						if(response.data){
							if(response.data.status == 200) {
								return response.data.parecer;
							} else {
								return $q.reject(response.data.messages);
							}
						} else {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
					}, 
					// Erro
					function(response) {
						if(response.status == -1) {						
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
					}
				);
			},
			getParecer: function(){
				return parecer;
			},
			setParecer: function(obj){
				parecer = obj;
			}
		};
	}

})();
/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance, AuthService) {
        
    if(!AuthService.isAuthenticated()){
        $scope.mensagem = {'erro':'Usuário não logado!'};
        $state.go('administrador.login');
        return;
    }
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);

  /** @ngInject */
  function ProfilePageCtrl($scope, fileReader, $filter, $uibModal, AuthService) {
        
    if(!AuthService.isAuthenticated()){
        $scope.mensagem = {'erro':'Usuário não logado!'};
        $state.go('administrador.login');
        return;
    }

    $scope.picture = $filter('profilePicture')('Nasta');

    $scope.removePicture = function () {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $scope.noPicture = true;
    };

    $scope.uploadPicture = function () {
      var fileInput = document.getElementById('uploadFile');
      fileInput.click();

    };

    $scope.socialProfiles = [
      {
        name: 'Facebook',
        href: 'https://www.facebook.com/akveo/',
        icon: 'socicon-facebook'
      },
      {
        name: 'Twitter',
        href: 'https://twitter.com/akveo_inc',
        icon: 'socicon-twitter'
      },
      {
        name: 'Google',
        icon: 'socicon-google'
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/akveo',
        icon: 'socicon-linkedin'
      },
      {
        name: 'GitHub',
        href: 'https://github.com/akveo',
        icon: 'socicon-github'
      },
      {
        name: 'StackOverflow',
        icon: 'socicon-stackoverflow'
      },
      {
        name: 'Dribbble',
        icon: 'socicon-dribble'
      },
      {
        name: 'Behance',
        icon: 'socicon-behace'
      }
    ];

    $scope.unconnect = function (item) {
      item.href = undefined;
    };

    $scope.showModal = function (item) {
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      }).result.then(function (link) {
          item.href = link;
        });
    };

    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope)
          .then(function (result) {
            $scope.picture = result;
          });
    };

    $scope.switches = [true, true, false, true, true, false];
  }

})();

/**
 * 
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.rotinas')
		.service('RotinasService', RotinasService);

	/** @ngInject */
	function RotinasService(REST_END_POINT, VERSION, AuthService, $http, $q, $uibModal) {
		
		var protocolo = null;

		return {
			listaDestinos : function($_filtros) {
				
				var filtros = $.extend($_filtros || {},{
					'sub': AuthService.getUser()
				});

				return $http.get(REST_END_POINT + VERSION.V1 + '/rotinas/destinos?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			listaAssuntos : function($_filtros) {
				
				var filtros = $.extend($_filtros || {},{
					'sub': AuthService.getUser()
				});

				return $http.get(REST_END_POINT + VERSION.V1 + '/rotinas/assuntos?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			listaOficios : function(_filtros) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
					
					var filtros = $.extend(_filtros,{
						'sub': AuthService.getUser()
					});
				}catch(erro){
					modalInstance.close();
				}

				return $http.get(REST_END_POINT + VERSION.V1 + '/rotinas/oficios?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					modalInstance.close();
					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					modalInstance.close();
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			atualizaOficio : function(_filtros) {
				
				var filtros = $.extend(_filtros,{
					'sub': AuthService.getUser()
				});

				return $http.put(REST_END_POINT + VERSION.V1 + '/rotinas/oficios',filtros).then(
				// Sucesso		
				function(response) {

					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			removeOficio : function(filtros) {
				return $http.delete(REST_END_POINT + VERSION.V1 + '/rotinas/oficios/'+filtros.id+'/'+AuthService.getUser()).then(
				// Sucesso		
				function(response) {

					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			adicionaOficio : function(_filtros) {
				
				var filtros = $.extend(_filtros,{
					'sub': AuthService.getUser()
				});

				return $http.post(REST_END_POINT + VERSION.V1 + '/rotinas/oficios',filtros).then(
				// Sucesso		
				function(response) {

					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			listaTitulos : function(_filtros) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
					
					var filtros = $.extend(_filtros,{
						'sub': AuthService.getUser()
					});
				}catch(erro){
					modalInstance.close();
				}

				return $http.get(REST_END_POINT + VERSION.V1 + '/rotinas/titulos?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					modalInstance.close();
					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					modalInstance.close();
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			atualizaTitulos : function(_filtros) {
				
				var filtros = $.extend(_filtros,{
					'sub': AuthService.getUser()
				});

				return $http.put(REST_END_POINT + VERSION.V1 + '/rotinas/titulos',filtros).then(
				// Sucesso		
				function(response) {

					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			adicionaTitulos : function(_filtros) {
				
				var filtros = $.extend(_filtros,{
					'sub': AuthService.getUser()
				});

				return $http.post(REST_END_POINT + VERSION.V1 + '/rotinas/titulos',filtros).then(
				// Sucesso		
				function(response) {

					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			listarProgramas: function(){
				return $http.get(REST_END_POINT + VERSION.V1 + '/rotinas/programas').then(
					// Sucesso		
					function(response) {
						if(response.data && response.data.status == 200)
							return response.data.areas;
						return $q.reject(response.data.messages);
					}, 
					// Erro
					function(response) {
						if(response.status == -1)
							return $q.reject({'erro' : 'Erro de conexão!'});
						return $q.reject(response.data.messages);
					});
			},
			listaMaxProtocolo : function() {
				return $http.get(REST_END_POINT + VERSION.V1 + '/rotinas/max-cod-protocolo').then(
				// Sucesso		
				function(response) {
					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			getProtocolos : function(id) {
				return $http.get(REST_END_POINT + VERSION.V1 + '/rotinas/get-protocolo/'+id).then(
				// Sucesso		
				function(response) {
					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			listaProtocolo : function(_filtros) {
				try{
					var modalInstance = $uibModal.open({
						keyboard: false,
						backdrop: false,
						animation : true,
						templateUrl: 'app/pages/loading.html',
						size : 'md',
					});
					
					var filtros = $.extend(_filtros,{
						'sub': AuthService.getUser()
					});
				}catch(erro){
					modalInstance.close();
				}

				return $http.get(REST_END_POINT + VERSION.V1 + '/rotinas/protocolo?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {
					modalInstance.close();
					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					modalInstance.close();
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			atualizaProtocolo : function(_filtros) {
				
				var filtros = $.extend(_filtros,{
					'sub': AuthService.getUser()
				});
				return $http.put(REST_END_POINT + VERSION.V1 + '/rotinas/protocolo',filtros).then(
				// Sucesso		
				function(response) {

					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			adicionaProtocolo : function(_filtros) {
				
				var filtros = $.extend(_filtros,{
					'sub': AuthService.getUser()
				});

				return $http.post(REST_END_POINT + VERSION.V1 + '/rotinas/protocolo',filtros).then(
				// Sucesso		
				function(response) {

					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.erro);
				});
			},
			listaProtoExpediente : function(_filtros) {
				
				var filtros = $.extend(_filtros,{
					'sub': AuthService.getUser()
				});

				return $http.get(REST_END_POINT + VERSION.V1 + '/rotinas/proto-expediente?' + $.param(filtros)).then(
				// Sucesso		
				function(response) {

					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			atualizaProtoExpediente : function(_filtros) {
				
				var filtros = $.extend(_filtros,{
					'sub': AuthService.getUser()
				});

				return $http.put(REST_END_POINT + VERSION.V1 + '/rotinas/proto-expediente',filtros).then(
				// Sucesso		
				function(response) {

					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			adicionaProtoExpediente : function(_filtros) {
				
				var filtros = $.extend(_filtros,{
					'sub': AuthService.getUser()
				});

				return $http.post(REST_END_POINT + VERSION.V1 + '/rotinas/proto-expediente',filtros).then(
				// Sucesso		
				function(response) {

					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			listaMaxExpediente : function() {
				return $http.get(REST_END_POINT + VERSION.V1 + '/rotinas/max-cod-expediente').then(
				// Sucesso		
				function(response) {
					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			getExpedientes : function(id) {
				return $http.get(REST_END_POINT + VERSION.V1 + '/rotinas/get-expediente/'+id).then(
				// Sucesso		
				function(response) {
					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			atualizaExpediente : function(_filtros) {
				
				var filtros = $.extend(_filtros,{
					'sub': AuthService.getUser()
				});

				return $http.put(REST_END_POINT + VERSION.V1 + '/rotinas/expediente',filtros).then(
				// Sucesso		
				function(response) {

					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			adicionaExpediente : function(_filtros) {
				
				var filtros = $.extend(_filtros,{
					'sub': AuthService.getUser()
				});

				return $http.post(REST_END_POINT + VERSION.V1 + '/rotinas/expediente',filtros).then(
				// Sucesso		
				function(response) {

					if(response.data && response.data.status == 200)
						return response.data.rotinas;
					return $q.reject(response.data.messages);
				}, 
				// Erro
				function(response) {
					
					if(response.status == -1)
						return $q.reject({'erro' : 'Erro de conexão!'});
					return $q.reject(response.data.messages);
				});
			},
			setProtocolo : function (obj){
				protocolo = obj;
			},
			getProtocolo : function (){
				return protocolo;
			}
		};
	}

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables')
      .controller('TablesPageCtrl', TablesPageCtrl);

  /** @ngInject */
  function TablesPageCtrl($scope, $filter, editableOptions, editableThemes) {

    $scope.smartTablePageSize = 10;

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30'
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21'
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43'
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13'
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22'
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33'
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38'
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48'
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48'
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40'
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32'
      },
      {
        "id": 16,
        "firstName": "Francisca",
        "lastName": "Brady",
        "username": "@Gibson",
        "email": "franciscagibson@comtours.com",
        "age": 11
      },
      {
        "id": 17,
        "firstName": "Tillman",
        "lastName": "Figueroa",
        "username": "@Snow",
        "email": "tillmansnow@comtours.com",
        "age": 34
      },
      {
        "id": 18,
        "firstName": "Jimenez",
        "lastName": "Morris",
        "username": "@Bryant",
        "email": "jimenezbryant@comtours.com",
        "age": 45
      },
      {
        "id": 19,
        "firstName": "Sandoval",
        "lastName": "Jacobson",
        "username": "@Mcbride",
        "email": "sandovalmcbride@comtours.com",
        "age": 32
      },
      {
        "id": 20,
        "firstName": "Griffin",
        "lastName": "Torres",
        "username": "@Charles",
        "email": "griffincharles@comtours.com",
        "age": 19
      },
      {
        "id": 21,
        "firstName": "Cora",
        "lastName": "Parker",
        "username": "@Caldwell",
        "email": "coracaldwell@comtours.com",
        "age": 27
      },
      {
        "id": 22,
        "firstName": "Cindy",
        "lastName": "Bond",
        "username": "@Velez",
        "email": "cindyvelez@comtours.com",
        "age": 24
      },
      {
        "id": 23,
        "firstName": "Frieda",
        "lastName": "Tyson",
        "username": "@Craig",
        "email": "friedacraig@comtours.com",
        "age": 45
      },
      {
        "id": 24,
        "firstName": "Cote",
        "lastName": "Holcomb",
        "username": "@Rowe",
        "email": "coterowe@comtours.com",
        "age": 20
      },
      {
        "id": 25,
        "firstName": "Trujillo",
        "lastName": "Mejia",
        "username": "@Valenzuela",
        "email": "trujillovalenzuela@comtours.com",
        "age": 16
      },
      {
        "id": 26,
        "firstName": "Pruitt",
        "lastName": "Shepard",
        "username": "@Sloan",
        "email": "pruittsloan@comtours.com",
        "age": 44
      },
      {
        "id": 27,
        "firstName": "Sutton",
        "lastName": "Ortega",
        "username": "@Black",
        "email": "suttonblack@comtours.com",
        "age": 42
      },
      {
        "id": 28,
        "firstName": "Marion",
        "lastName": "Heath",
        "username": "@Espinoza",
        "email": "marionespinoza@comtours.com",
        "age": 47
      },
      {
        "id": 29,
        "firstName": "Newman",
        "lastName": "Hicks",
        "username": "@Keith",
        "email": "newmankeith@comtours.com",
        "age": 15
      },
      {
        "id": 30,
        "firstName": "Boyle",
        "lastName": "Larson",
        "username": "@Summers",
        "email": "boylesummers@comtours.com",
        "age": 32
      },
      {
        "id": 31,
        "firstName": "Haynes",
        "lastName": "Vinson",
        "username": "@Mckenzie",
        "email": "haynesmckenzie@comtours.com",
        "age": 15
      },
      {
        "id": 32,
        "firstName": "Miller",
        "lastName": "Acosta",
        "username": "@Young",
        "email": "milleryoung@comtours.com",
        "age": 55
      },
      {
        "id": 33,
        "firstName": "Johnston",
        "lastName": "Brown",
        "username": "@Knight",
        "email": "johnstonknight@comtours.com",
        "age": 29
      },
      {
        "id": 34,
        "firstName": "Lena",
        "lastName": "Pitts",
        "username": "@Forbes",
        "email": "lenaforbes@comtours.com",
        "age": 25
      },
      {
        "id": 35,
        "firstName": "Terrie",
        "lastName": "Kennedy",
        "username": "@Branch",
        "email": "terriebranch@comtours.com",
        "age": 37
      },
      {
        "id": 36,
        "firstName": "Louise",
        "lastName": "Aguirre",
        "username": "@Kirby",
        "email": "louisekirby@comtours.com",
        "age": 44
      },
      {
        "id": 37,
        "firstName": "David",
        "lastName": "Patton",
        "username": "@Sanders",
        "email": "davidsanders@comtours.com",
        "age": 26
      },
      {
        "id": 38,
        "firstName": "Holden",
        "lastName": "Barlow",
        "username": "@Mckinney",
        "email": "holdenmckinney@comtours.com",
        "age": 11
      },
      {
        "id": 39,
        "firstName": "Baker",
        "lastName": "Rivera",
        "username": "@Montoya",
        "email": "bakermontoya@comtours.com",
        "age": 47
      },
      {
        "id": 40,
        "firstName": "Belinda",
        "lastName": "Lloyd",
        "username": "@Calderon",
        "email": "belindacalderon@comtours.com",
        "age": 21
      },
      {
        "id": 41,
        "firstName": "Pearson",
        "lastName": "Patrick",
        "username": "@Clements",
        "email": "pearsonclements@comtours.com",
        "age": 42
      },
      {
        "id": 42,
        "firstName": "Alyce",
        "lastName": "Mckee",
        "username": "@Daugherty",
        "email": "alycedaugherty@comtours.com",
        "age": 55
      },
      {
        "id": 43,
        "firstName": "Valencia",
        "lastName": "Spence",
        "username": "@Olsen",
        "email": "valenciaolsen@comtours.com",
        "age": 20
      },
      {
        "id": 44,
        "firstName": "Leach",
        "lastName": "Holcomb",
        "username": "@Humphrey",
        "email": "leachhumphrey@comtours.com",
        "age": 28
      },
      {
        "id": 45,
        "firstName": "Moss",
        "lastName": "Baxter",
        "username": "@Fitzpatrick",
        "email": "mossfitzpatrick@comtours.com",
        "age": 51
      },
      {
        "id": 46,
        "firstName": "Jeanne",
        "lastName": "Cooke",
        "username": "@Ward",
        "email": "jeanneward@comtours.com",
        "age": 59
      },
      {
        "id": 47,
        "firstName": "Wilma",
        "lastName": "Briggs",
        "username": "@Kidd",
        "email": "wilmakidd@comtours.com",
        "age": 53
      },
      {
        "id": 48,
        "firstName": "Beatrice",
        "lastName": "Perry",
        "username": "@Gilbert",
        "email": "beatricegilbert@comtours.com",
        "age": 39
      },
      {
        "id": 49,
        "firstName": "Whitaker",
        "lastName": "Hyde",
        "username": "@Mcdonald",
        "email": "whitakermcdonald@comtours.com",
        "age": 35
      },
      {
        "id": 50,
        "firstName": "Rebekah",
        "lastName": "Duran",
        "username": "@Gross",
        "email": "rebekahgross@comtours.com",
        "age": 40
      },
      {
        "id": 51,
        "firstName": "Earline",
        "lastName": "Mayer",
        "username": "@Woodward",
        "email": "earlinewoodward@comtours.com",
        "age": 52
      },
      {
        "id": 52,
        "firstName": "Moran",
        "lastName": "Baxter",
        "username": "@Johns",
        "email": "moranjohns@comtours.com",
        "age": 20
      },
      {
        "id": 53,
        "firstName": "Nanette",
        "lastName": "Hubbard",
        "username": "@Cooke",
        "email": "nanettecooke@comtours.com",
        "age": 55
      },
      {
        "id": 54,
        "firstName": "Dalton",
        "lastName": "Walker",
        "username": "@Hendricks",
        "email": "daltonhendricks@comtours.com",
        "age": 25
      },
      {
        "id": 55,
        "firstName": "Bennett",
        "lastName": "Blake",
        "username": "@Pena",
        "email": "bennettpena@comtours.com",
        "age": 13
      },
      {
        "id": 56,
        "firstName": "Kellie",
        "lastName": "Horton",
        "username": "@Weiss",
        "email": "kellieweiss@comtours.com",
        "age": 48
      },
      {
        "id": 57,
        "firstName": "Hobbs",
        "lastName": "Talley",
        "username": "@Sanford",
        "email": "hobbssanford@comtours.com",
        "age": 28
      },
      {
        "id": 58,
        "firstName": "Mcguire",
        "lastName": "Donaldson",
        "username": "@Roman",
        "email": "mcguireroman@comtours.com",
        "age": 38
      },
      {
        "id": 59,
        "firstName": "Rodriquez",
        "lastName": "Saunders",
        "username": "@Harper",
        "email": "rodriquezharper@comtours.com",
        "age": 20
      },
      {
        "id": 60,
        "firstName": "Lou",
        "lastName": "Conner",
        "username": "@Sanchez",
        "email": "lousanchez@comtours.com",
        "age": 16
      }
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile($scope.file);
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    // Read a file as a text
    var readAsText = function(file, encoding, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsText(file, encoding);

      return deferred.promise;
    };

    // Read a file as a binary data
    var readAsBinaryString = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsBinaryString(file);

      return deferred.promise;
    };

    return {
      readAsDataURL: readAsDataURL,
      readAsBinaryString: readAsBinaryString,
      readAsText: readAsText
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author Yury Tinos Pinheiro
 * created on 14/03/2017
 */

(function () {
	'use strict';

	angular.module('BlurAdmin.pages.administrador.login.forgot')
		.controller('ForgotPageCtrl', ForgotPageCtrl);

	/** @ngInject */
	function ForgotPageCtrl($scope, $state, $rootScope, AUTH_EVENTS, AuthService) {
		if(AuthService.isAuthenticated()){
			$scope.mensagem = {'info':'Usuário já logado!'};
			$state.go('proficiencias.consulta');
		}

		$scope.forgot = function (dados) {
			
			
		};
	}

})();



/**
 * @author Yury Tinos Pinheiro
 * created on 14/03/2017
 */

(function () {
	'use strict';

	angular.module('BlurAdmin.pages.administrador.login')
		.controller('LoginPageCtrl', LoginPageCtrl);

	/** @ngInject */
	function LoginPageCtrl($scope, $state, $rootScope, $location, AUTH_EVENTS, AuthService, $uibModal) {
		AuthService.getActiveUser();
		if(AuthService.isAuthenticated()){
			$scope.mensagem = {'sucesso':'Usuário já logado!'};
			$state.go('proficiencias.consulta');
		}
		// Variáveis padrão
		$scope.credenciais = {
		    usuario : '',
		    senha : ''
		};
		$scope.mensagem = null;
		$scope.login = function (credenciais) {
			
			AuthService.login(credenciais).then(function(token) {
				$rootScope.$broadcast(AUTH_EVENTS.loginSuccess);
				//$scope.setCurrentUser(token);
				$scope.mensagem = null;
				$state.go('proficiencias.consulta');
			}, function(mensagem) {
				$rootScope.$broadcast(AUTH_EVENTS.loginFailed);
				$scope.mensagem = mensagem;
			});
		};
		$scope.registerForm = function(){
			$location.path('/administrador/register');
			//$state.go('BlurAdmin.pages.administrador.register');
		}
		$scope.forgotPass = function(){
			var modal = $uibModal.open({
				keyboard: false,
				backdrop: false,
				animation : true,
            	size: 'sm',
            	template: '<div class="modal-content">\
	            				<div class="modal-header">\
		                            <button type="button" class="close" ng-click="$dismiss()" aria-label="Close">\
										<em class="ion-ios-close-empty sn-link-close"></em>\
									</button>\
									<em class="ion-ios-information-outline pull-left" style="font-size:23px;color:#7d7d7d"></em>\
									<h4 class="modal-title text-center"> Mensagem</h4>\
		                        </div>\
		                        <div class="modal-body text-center">Por favor, procure a área de NTI para mais informações</div>\
		                        <div class="modal-footer">\
		                            <button class="btn btn-primary" ng-click="$dismiss()">OK</button>\
		                        </div>\
		                    </div>'
        	});
			//$location.path('/administrador/login/forgot');
			//$state.go('BlurAdmin.pages.administrador.register');
		}
	}

})();



/**
 * @author Yury Tinos Pinheiro
 * created on 14/03/2017
 */

(function () {
	'use strict';

	angular.module('BlurAdmin.pages.administrador.logout')
		.controller('LogoutPageCtrl', LogoutPageCtrl);

	/** @ngInject */
	function LogoutPageCtrl($scope, $state, AuthService, AUTH_EVENTS) {
		if(!AuthService.isAuthenticated()){
			$scope.mensagem = {'sucesso':'Usuário não logado!'};
			$state.go('administrador.login');
		}else{
			AuthService.logout();
			$state.go('administrador.login');
		}

	}

})();



/**
 * @author Yury Tinos Pinheiro
 * created on 14/03/2017
 */

(function () {
	'use strict';

	angular.module('BlurAdmin.pages.administrador.register')
		.controller('RegisterPageCtrl', RegisterPageCtrl);

	RegisterPageCtrl.$inject = ['$scope','$state', '$rootScope','AuthService','AUTH_EVENTS'];
	/** @ngInject */
	function RegisterPageCtrl($scope, $state, $rootScope, AuthService, AUTH_EVENTS) {
		if(AuthService.isAuthenticated()){
			$scope.mensagem = {'info':'Usuário já logado!'};
			$state.go('proficiencias.consulta');
		}
		$scope.register = function (data) {
			AuthService.register(data).then(function(mensagem) {
				$scope.mensagem = mensagem;
				$rootScope.$broadcast(AUTH_EVENTS.loginSuccess);
				//$scope.setCurrentUser(user);
			}, function(mensagem) {
				$scope.mensagem = mensagem;
				$rootScope.$broadcast(AUTH_EVENTS.loginFailed);
			});
		};
	}

})();



(function(){
    'use strict';
    
    /** @ngInject */
    angular.module('BlurAdmin.pages.administrador.register.validador-cpf',[])
    .directive('validadorCpf', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ctrl) {
                
                function customValidator(ngModelValue) {
                    function getFirstDigit(v) {
                        var matriz = [10, 9, 8, 7, 6, 5, 4, 3, 2];
                        var total = 0,
                            verifc;
                        for (var i = 0; i < 9; i++) {
                            total += v[i] * matriz[i];
                        }
                        verifc = ((total % 11) < 2) ? 0 : (11 - (total % 11));
                        return verifc;
                    }
                    
                    function getSecondDigit(v) {
                        var matriz = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];
                        var total = 0,
                            verifc;
                        for (var i = 0; i < 10; i++) {
                            total += v[i] * matriz[i];
                        }
                        verifc = ((total % 11) < 2) ? 0 : (11 - (total % 11));
                        return verifc;
                    }
                    
                    if (ngModelValue.length >= 11) {
                        ctrl.$setValidity('cpfValid',null);
                        ctrl.$setValidity('cpfInvalid',null);
                        var digits = ngModelValue.replace(/\D+/g, '');
                        var dig1 = getFirstDigit(digits.substr(0, 9));                    
                        var dig2 = getSecondDigit(digits.substr(0, 10));
                        var final = digits.substr(9,2);
                        var val = ""+dig1+dig2;

                        if (final === val) {
                            ctrl.$setValidity('cpfValid',true);
                        }
                        else
                        {
                            ctrl.$setValidity('cpfInvalid',false);
                        }
                    } else {
                        ctrl.$setValidity('cpfInvalid',false);
                    }
                    return ngModelValue;
                }
                ctrl.$parsers.push(customValidator);
            }
        };
    });
})();
/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.alunos.dadosBasicos')
  		.controller('DadosBasicosAlunoPageCtrl', DadosBasicosAlunoPageCtrl);

	/** @ngInject */
	function DadosBasicosAlunoPageCtrl($scope, $state, AlunosService, toastr, AuthService) {
		
		if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		//$scope.mensagem = null;
		// Tela de Dados Basicos
		var aluno = AlunosService.getAluno();
		$scope.isAdmin = false;
		if( AuthService.isAuthorizedToAccess([3]) ){
			$scope.isAdmin = true;
		}
		
		if(aluno == null) {
			
			$state.go('alunos.consultaDadosBasicos');
		}
		else {
			
			AlunosService.buscarDadosBasicos(aluno).then(function(data) {
				$scope.aluno = data;
			})
			.catch(function(erros) {
				$scope.erros = erros;
			});
		}

		$scope.setPortaria = function (portaria, aluno) {
			AlunosService.salvarPortaria(portaria, aluno).then(function (data) {
				if (data.resultado == 200) {
					toastr.success(data.mensagem, 'Sucesso', {});
				} else {
					toastr.error(data.mensagem, 'Erro!', {});
				}
			})
			.catch(function (erros) {
				toastr.error(error.Message, 'Erro!', {});
			});
		}
		$scope.salvarPlanoPesquisa = function(aluno) {
			AlunosService.salvarPlanoPesquisa(aluno).then(function(data) {
				if(data.resultado == 200){
					toastr.success(data.mensagem, 'Sucesso', {});
					//$scope.mensagem = {'sucesso':data.mensagem};
				}else{
					toastr.error(data.mensagem, 'Erro!', {});
					//$scope.mensagem = {'erro':data.mensagem};
				}
			})
			.catch(function(erros) {
				toastr.error(error.Message, 'Erro!', {});
				//$scope.mensagem = erros;
			});
		};
		$scope.salvarDatasDiploma = function(aluno) {
			AlunosService.salvarDatasDiploma(aluno).then(function(data) {
				if(data.resultado == 200){
					toastr.success(data.mensagem, 'Sucesso', {});
					//$scope.mensagem = {'sucesso':data.mensagem};
				}else{
					toastr.error(data.mensagem, 'Erro!', {});
					//$scope.mensagem = {'erro':data.mensagem};
				}
			})
			.catch(function(erros) {
				toastr.error(error.Message, 'Erro!', {});
				//$scope.mensagem = erros;
			});
		};
		$scope.salvarDiploma = function(diploma) {
			AlunosService.salvarDiploma(diploma).then(function(data) {
				if(data.resultado == 200){
					toastr.success(data.mensagem, 'Sucesso', {});
					//$scope.mensagem = {'sucesso':data.mensagem};
				}else{
					toastr.error(data.mensagem, 'Erro!', {});
					//$scope.mensagem = {'erro':data.mensagem};
				}
			})
			.catch(function(erros) {
				toastr.error(error.Message, 'Erro!', {});
				//$scope.mensagem = erros;
			});;
		};
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.alunos.dadosBasicos')
  		.controller('DadosBasicosConsultaAlunosPageCtrl', DadosBasicosConsultaAlunosPageCtrl);

	/** @ngInject */
	function DadosBasicosConsultaAlunosPageCtrl($scope, $state, AreasService, OrientadoresService, AlunosService,AuthService) {

		if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
			$scope.mensagem = {'erro':'Usuário não logado!'};
			$state.go('administrador.login');
			return;
		}
		//var expToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiYWRtaW4iOnRydWV9.TJVA95OrM7E2cBab30RMHrHDcEfxjoYZgeFONFh7HgQ';  
    	//var tokenPayload = jwtHelper.decodeToken(expToken);
    	//console.log(tokenPayload);

		// Combobox de Área e Orientadores
		$scope.areas = [{ id: '', value: ''}];
		$scope.orientadores = [{ id: '', value: ''}];
		$scope.aluno = {};

		AreasService.listarAreas().then(function(areas) {
			$scope.areas = areas;
			
			OrientadoresService.listarOrientadores().then(function(orientadores) {
				$scope.orientadores = orientadores;
				
				$scope.limpar();
			})
			.catch(function(mensagem) {		
				$scope.mensagem = mensagem;
			});
		})
		.catch(function(mensagem) {	
			$scope.mensagem = mensagem;
		});

		$scope.getOrientadores = function(item) {
			OrientadoresService.listarOrientadores(item).then(function(orientadores) {
				$scope.orientadores = orientadores;
			})
			.catch(function(mensagem) {		
				$scope.mensagem = mensagem;
			});
		};
		

		$scope.pesquisar = function() {
			
			$scope.alunos = null;
			$scope.mensagem = null;
			AlunosService.listarAlunos($scope.aluno).then(function(alunos) {
				$scope.alunos = alunos;
			})
			.catch(function(mensagem) {		
				$scope.mensagem = mensagem;
			});
		};
		
		$scope.limpar = function() {
			// Reset dos parametros de busca
			$scope.aluno = {
				cpf : '',
				matricula : '',
				nome : '',
				area : $scope.areas[0],
				orientador : $scope.orientadores[0],
			};
			
			$scope.alunos = null;
			AlunosService.setAluno(null);
		};

		$scope.consultarDadosBasicos = function(aluno) {
			
			AlunosService.setAluno(aluno);
			
			$state.go('alunos.dadosBasicos');
		};

	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.alunos.relatorios')
  		.controller('RelatoriosAlunosPageCtrl', RelatoriosAlunosPageCtrl);
  	
  	RelatoriosAlunosPageCtrl.$inject = ['$scope', '$state', 'AreasService', 'OrientadoresService', 'alunos.RelatoriosService','AuthService'];

	/** @ngInject */
	function RelatoriosAlunosPageCtrl($scope, $state, AreasService, OrientadoresService, RelatoriosService, AuthService) {
        
        if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
            $scope.mensagem = {'erro':'Usuário não autorizado!'};
            $state.go('administrador.login');
            return;
        }
        $scope.current = 0;
        $scope.select = function( index ){
        	$scope.current = index;
        	
        };

		$scope.mensagem = [null,null];
		$scope.relatorios = RelatoriosService.listarRelatorios();
		
		// Combobox de Área e Orientadores
		$scope.areas = [{ id: '', value: ''}];
		$scope.orientadores = [{ id: '', value: ''}];
		$scope.situacoes = RelatoriosService.getSituacoes();


		AreasService.listarAreas().then(function(areas) {
			$scope.areas = areas;
			
			OrientadoresService.listarOrientadores().then(function(orientadores) {
				$scope.orientadores = orientadores;
				$scope.limpar();
			})
			.catch(function(mensagem) {		
				$scope.mensagem[$scope.current] = mensagem;
			});
		})
		.catch(function(mensagem) {	
			$scope.mensagem[$scope.current] = mensagem;
		});
		
		$scope.getOrientadores = function(item) {
			OrientadoresService.listarOrientadores(item).then(function(orientadores) {
				$scope.orientadores = orientadores;
			})
			.catch(function(mensagem) {		
				$scope.mensagem[$scope.current] = mensagem;
			});
		};
		

		$scope.pesquisarListagens = function() {		
			
			$scope.mensagem[0] = null;
			RelatoriosService.gerarRelatorio($scope.relatorio.listagens).then(function(relatorio) {
				RelatoriosService.setRelatorio(relatorio);
				$state.go('alunos.relatorios.' + $scope.relatorio.listagens.opcao);
			})
			.catch(function(mensagem) {		
				$scope.mensagem[0] = mensagem;
			});
		};

		$scope.pesquisarPeriodo = function() {	
			
			$scope.mensagem[1] = null;
			
			RelatoriosService.gerarRelatorio($scope.relatorio.periodo).then(function(relatorio) {
				RelatoriosService.setRelatorio(relatorio);
				$state.go('alunos.relatorios.' + $scope.relatorio.periodo.opcao);
			})
			.catch(function(mensagem) {		
				$scope.mensagem[1] = mensagem;
			});					
		};

		$scope.limpar = function() {
			
			var anoPassado = new Date().setFullYear((new Date()).getFullYear() - 1);
			$scope.mensagem[$scope.current] = null;
			// Reset dos parametros de busca
			$scope.relatorio = {
				listagens : {
					opcao : Object.keys($scope.relatorios.listagens)[0],	
					area : $scope.areas[0],
					orientador : $scope.orientadores[0],
					situacao : $scope.situacoes[0]
				},
				periodo : {
					opcao : Object.keys($scope.relatorios.periodo)[0],
					area : $scope.areas[0],
					periodo: {
						de: anoPassado,
						ate: Date.now(),
					}
				},
			};
			
			RelatoriosService.setRelatorio(null);
		};

	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.alunos.situacao')
  		.controller('SituacaoAlunosPageCtrl', SituacaoAlunosPageCtrl);

	/** @ngInject */
	function SituacaoAlunosPageCtrl($scope, $state, AlunosService, AuthService) {
        
        if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
            $scope.mensagem = {'erro':'Usuário não autorizado!'};
            $state.go('administrador.login');
            return;
        }
		
		// Tela de Dados Basicos
		var aluno = AlunosService.getAluno();
		$scope.clear = function(item){
			$(item).val("");
		}
		if(aluno == null) {
			$state.go('alunos.situacao');
		}
		else {
			AlunosService.buscarSituacao(aluno).then(function(data) {
				$scope.aluno = data;
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
		}
		$scope.vaParaBancaDefesa = function() {
			$state.go('alunos.situacao.documentos.bancaDefesa');
		}
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.alunos.situacao')
  		.controller('SituacaoConsultaAlunosPageCtrl', SituacaoConsultaAlunosPageCtrl);

	/** @ngInject */
	function SituacaoConsultaAlunosPageCtrl($scope, $state, AreasService, OrientadoresService, AlunosService, AuthService) {

		if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		// Combobox de Área
		$scope.areas = [{ id: '', value: ''}];
		$scope.orientadores = [{ id: '', value: ''}];

		AreasService.listarAreas().then(function(areas) {
			$scope.areas = areas;
			
			OrientadoresService.listarOrientadores().then(function(orientadores) {
				$scope.orientadores = orientadores;

				$scope.limpar();
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
		})
		.catch(function(mensagem) {
			$scope.mensagem = mensagem;
		});
		
		

		$scope.pesquisar = function() {
			
			$scope.alunos = null;
			$scope.mensagem = null;
			
			AlunosService.listarAlunosSituacao($scope.aluno).then(function(alunos) {
				$scope.alunos = alunos;
			})
			.catch(function(mensagem) {		
				$scope.mensagem = mensagem;
			});
		};
		
		$scope.limpar = function() {
			// Reset dos parametros de busca
			$scope.aluno = {
				cpf : '',
				matricula : '',
				nome : '',
				area : $scope.areas[0],
				orientador : $scope.orientadores[0],
			};
			
			$scope.alunos = null;
			AlunosService.setAluno(null);
		};
		
		$scope.consultarSituacao = function(aluno) {
			
			AlunosService.setAluno(aluno);
			
			$state.go('alunos.situacao');
		};
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.agendamento.anfiteatro')
  		.controller('AnfiteatroAgendamentoPageCtrl', AnfiteatroAgendamentoPageCtrl);

	/** @ngInject */
	function AnfiteatroAgendamentoPageCtrl($scope, $filter, AgendamentoService, AuthService) {
		
		if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}

		var anfiteatro = AgendamentoService.getAnfiteatro();
		
		$scope.inserirAnfiteatro = function(anfiteatro) {
			
			AgendamentoService.inserirAnfiteatro(anfiteatro).then(function(id) {
				$scope.anfiteatro.id = id;
				$scope.mensagem = { sucesso: "Anfiteatro incluído com sucesso" }; 
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});	
		};
		
		$scope.alterarAnfiteatro = function(anfiteatro) {
			
			AgendamentoService.alterarAnfiteatro(anfiteatro).then(function() {				
				$scope.mensagem = { sucesso: "Anfiteatro alterado com sucesso" };
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
			
		};

		$scope.limpar = function() {
			$scope.anfiteatro = {
				id: anfiteatro == null ? null : anfiteatro.id,	
				nome: null,
				endereco: null
			};
		};
		
		// Inicializa tela
		if(anfiteatro == null) {
			$scope.acao = "Incluir";
			$scope.limpar();
		}
		else {
			$scope.acao = "Alterar";
			$scope.anfiteatro = anfiteatro;
		}
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.agendamento.anfiteatro')
  		.controller('ConsultaAnfiteatroAgendamentoPageCtrl', ConsultaAnfiteatroAgendamentoPageCtrl);

	/** @ngInject */
	function ConsultaAnfiteatroAgendamentoPageCtrl($scope, $state, AgendamentoService, AuthService) {
		
		if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		
		$scope.pesquisar = function() {
			
			$scope.anfiteatros = null;
			
			AgendamentoService.listarAnfiteatros($scope.anfiteatro).then(function(data) {
				$scope.mensagem = null;
				$scope.anfiteatros = data;
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
		};

		$scope.inserirAnfiteatro = function() {
			
			AgendamentoService.setAnfiteatro(null);
			
			$state.go('agendamento.anfiteatro');
		};
		
		$scope.editarAnfiteatro = function(anfiteatro) {
			
			AgendamentoService.setAnfiteatro(anfiteatro);
			
			$state.go('agendamento.anfiteatro');
		};
		
		$scope.excluirAnfiteatro = function(anfiteatro) {
			
			AgendamentoService.excluirAnfiteatro(anfiteatro).then(function() {				
				AgendamentoService.setAnfiteatro(null);
				$scope.pesquisar();
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
			
		};
		
		$scope.limpar = function() {
			// Reset dos parametros de busca
			$scope.anfiteatro = {
				nome : null,
				endereco: null,
			};
			
			$scope.anfiteatros = null;
			$scope.mensagem = null;
		};

		
		$scope.limpar();
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.agendamento.preAgendamento')
			.controller('PreAgendamentoPageCtrl', PreAgendamentoPageCtrl);

	/** @ngInject */
	function PreAgendamentoPageCtrl($scope, $state, $filter, $uibModal, toastr, AgendamentoService, AuthService, AreasService, ManutencaoService) {

		if( !AuthService.isAuthorizedToAccess([1,2,3]) ){ //aluno,secretaria,admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		var resp = ['backdrop click','escape key press'];
		$scope.filtrosPesquisa = AuthService.isAuthorizedToAccess([2,3]);

		// Combobox de Área e Orientadores
		$scope.areas = [{ id: '', value: ''}];
		var usuario = {areas:[]};
		var id = AuthService.getUser();
		if(!AuthService.isAuthorizedToAccess([2,3]) ){
			ManutencaoService.listarAreas(id).then(function(result){
				usuario.areas = [].concat( result.map(function(e,i){return e.arecod;}) );
				AreasService.listarAreas(usuario).then(function(areas) {
					$scope.areas = areas;
					$scope.limpar();
					if($scope.areas.length == 1){
						$scope.agendamento.area = $scope.areas[0];
					}
				})
				.catch(function(mensagem) {
					$scope.mensagem = mensagem;
				});
			});
		}else{
			AreasService.listarAreas().then(function(areas) {
				$scope.areas = areas;
				$scope.limpar();
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
		}


		$scope.agendamento={};
		$scope.limpar = function(){
			$scope.agendamento.nome = "";
			$scope.agendamento.matricula = "";
			$scope.agendamento.periodo = {
				de:new Date(),
				ate:new Date(new Date().setMonth(new Date().getMonth()+1))};
			$scope.agendamento.area = {};
		};
		$scope.limpar();
		var aluno = {idUsuario: id };
		$scope.pesquisar = function(dados){
			var aluno = {idUsuario: id };
			AgendamentoService.listarEventosAdmin(aluno, dados).then(function(agendamentos) {
				$('#calendar').fullCalendar('destroy');
				criarCalendario(agendamentos);
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
		};


		if( AuthService.isAuthorizedToAccess([2,3]) ){
			AgendamentoService.listarEventosAdmin(aluno,$scope.agendamento).then(function(agendamentos) {
				criarCalendario(agendamentos);
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
		}else{
			AgendamentoService.getAluno(aluno.idUsuario).then(function(resultado) {
				aluno = {
					idUsuario: id,
					areaId: parseInt(resultado.codarea),
					matricula: resultado.codpes,
					nivel: resultado.nivpgm,
					nome: resultado.nompes,
					nomeArea: resultado.nomearea,
				};

				AgendamentoService.listarEventosAluno(aluno).then(function(agendamentos) {
					criarCalendario(agendamentos);
				})
				.catch(function(mensagem) {
					$scope.mensagem = mensagem;
				});
			}).catch(function(mensagem){
				$scope.mensagem = mensagem;
			});
		}



		var criarCalendario = function(agendamentos)
		{
			if( ( agendamentos.resultado != void 0 && agendamentos.resultado === 0 )) {
				return;
			}
			var eventos = agendamentos;
			if(!angular.isArray(eventos)){
				eventos = [eventos];
			}
			var i =1;
			agendamentos.dias = {};
			agendamentos.dias.vigencia = eventos.filter(function(e,i,a){return e.tipo == 'V';})[0];
			agendamentos.dias.total = eventos.filter(function(e,i,a){return e.tipo == 'T';})[0];
			if(agendamentos.dias.vigencia == void 0 ){

				var periodoIni = $scope.agendamento.periodo && $scope.agendamento.periodo.de ? moment($scope.agendamento.periodo.de)._d : moment()._d;
				var periodoFim = $scope.agendamento.periodo && $scope.agendamento.periodo.ate ? moment($scope.agendamento.periodo.ate).hour(23).minute(0).second(0)._d : moment().add(1,'months')._d;
				agendamentos.dias.vigencia = {
					'start': $filter('date')(periodoIni, 'yyyy-MM-dd'),
					'end': $filter('date')(periodoFim, 'yyyy-MM-dd'),
				};
			}
			if(agendamentos.dias.total == void 0 ){
				agendamentos.dias.total = agendamentos.dias.vigencia;
			}
			agendamentos.dias.feriados = eventos.map(function(e){
				if(e.tipo=='F'){
					if(e.end == null){
						e.end = moment(e.start).hour(20).minute(59).second(59);
					}else{
						e.end = moment(e.end).hour(20).minute(59).second(59);
					}
					return e;
				}
			}).filter(function(e,i){ return typeof(e) !== "undefined";});
			agendamentos.eventos = eventos.filter(function(e,i,a){return e.tipo == 'E' || e.tipo == 'P';});
			var b1 = eventos.map(function(e){
				if(e.start || e.start != null){
					return e.start;
				}
			}).filter(function(e,i){ return typeof(e) !== "undefined";});
			var b2 = eventos.map(function(e){
				if(e.end || e.end != null){
					return e.end;
				}
			}).filter(function(e,i){ return typeof(e) !== "undefined";});
			var b3 = b1.concat(b2);
			agendamentos.bloqueios = b3.sort().filter(function(v, i, a){return a.indexOf(v) === i;});

			//var agendamentos.dias = {};
			var rendenizaDia = function(dia, celula) {
				agendamentos.dias.feriados.forEach(function(feriado, index) {
					if(dia.isBetween(moment(feriado.start).subtract(1, 'days'), feriado.end ) )
					{
						$(celula).removeClass();
						$(celula).addClass('fc-day fc-widget-content fc-disabled-day fc-holiday align-center');
						$(celula).text(feriado.title);
						return;
					}
				});
			};

			var rendenizaEvento = function(evento, elemento) {
				var inicio = moment(evento.start).format('HH:mm'),
					fim = moment(evento.end);
				if( inicio == '08:00'){
					inicio = "Manhã - ";
					fim = "";
				}else if( inicio == '13:30'){
					inicio = "Tarde - ";
					fim = "";
				}else if( inicio == '14:00'){
					inicio = "Tarde - ";
					fim = "";
				}
				var texto = [inicio];
			 	var titulo = 'Reservado';
			 	if(evento.tipo == 'P'){
					elemento.addClass('fc-partial-holiday');
				}

				if( AuthService.isAuthorizedToAccess([2,3]) || evento.tipo != 'E'){
					titulo = evento.title ;
				}
				if( fim != "" && fim.isValid() ){
					texto[texto.length] = ' - ' + fim.format('HH:mm');
				}
				texto[texto.length] = titulo;

		    	elemento.text(texto.join(" "));

		    };

		    var cliqueDia = function(dia, jsEvent, view) {

		    	var estaBloqueado = false;
				agendamentos.dias.feriados.forEach(function(feriado, index) {
					if(dia.isBetween(moment(feriado.start).subtract(1, 'days'), moment(feriado.end).subtract(1, 'days').hour(23))) {
						estaBloqueado = true;
					}
				});

				if(estaBloqueado) {
					return;
				}
				if(!AuthService.isAuthorizedToAccess([2,3])){
					//$scope.aluno.nome=aluno.nome;
					agendamentos.eventos.forEach(function(evento, index) {
						if(estaBloqueado)
							return;
						if(evento.tipo == 'E') {
							var modalInstance = $uibModal.open({
								animation : true,
								template : '<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-information-circled modal-icon"></i><span>Dia ' + dia.format('D/M/YYYY') + '</span></div><div class="modal-body text-center">Não é permitido realizar mais de um Agendamento de Defesa!</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button></div></div>',
								size : 'md',
							});
							estaBloqueado = true;
							return;
						}
					});

					if(estaBloqueado) {
						return;
					}
				}

				// Por algum motivo, essa @#$# de moment.js passa a data de ontem
				//dia = dia.add(1, 'days');

				var modalInstance = $uibModal.open({
					animation : true,
					templateUrl : 'app/pages/agendamento/preAgendamento/cadastro/cadastro.html',
					size : 'md',
					controller : 'CadastroAgendamentoPageCtrl',
					resolve : {
						dataAgendamento : function() {
							return dia.clone();
						},
						evento : function() {
							return null;
						},
						agendamentos : function() {
							return agendamentos;
						},
						aluno: function(){
							return aluno;
						}
					}

				});

				modalInstance.result.then(function(eventoAgendado) {
					$('#calendar').fullCalendar('renderEvent', eventoAgendado, true);
					$('#calendar').fullCalendar('unselect');
					$('#calendar').fullCalendar( 'rerenderEvents' );

					//$uibModalInstance.dismiss("Agendamento realizado");
					toastr.success("Agendamento realizado", 'Sucesso', {});
			    }, function (mensagem) {
					if (typeof mensagem != 'undefined' && resp.indexOf(mensagem) == -1 && typeof mensagem !== 'object') {
						toastr.error(mensagem, 'Erro', {});
					  } else if (typeof mensagem == 'object') {
						  var tipo = Object.keys(mensagem)[0];
						toastr.error(mensagem[tipo],tipo.substring(0,1).toUpperCase()+tipo.substring(1),{});
					  }
			      //console.log('Modal dismissed at: ' + new Date());
			      //Nada feito
			    });
			}

			var calendarOptions = {
				locale: 'pt-br',
				height: 'auto',
				weekends: false,
				header : {
					left : 'prev,next',
					center : 'title',
					right : 'month,agendaWeek,agendaDay'
				},
				validRange : {
			        start: moment(agendamentos.dias.total.start).format('YYYY-MM-DD'),
			        end: moment(agendamentos.dias.total.end).add(1,'days').hour(0).minute(0).second(0).format('YYYY-MM-DD'),
			    },
			    dayRender : rendenizaDia,
			    eventRender : rendenizaEvento,
				dayClick : function(dia, jsEvent, view) {
					var d = dia.clone();
					d.hour(moment().hour()).minute(moment().minute());
					var startDate = moment(agendamentos.dias.vigencia.start).hour(0).minute(0);
					var endDate = moment(agendamentos.dias.vigencia.end).hour(23).minute(59).second(59);

					if( parseFloat(d.format('YYYYMMDDHHmmssSSSS')) >= parseFloat(startDate.format('YYYYMMDDHHmmssSSSS'))
						&& parseFloat(d.format('YYYYMMDDHHmmssSSSS')) <= parseFloat(endDate.format('YYYYMMDDHHmmssSSSS')) ){
						cliqueDia(dia, jsEvent, view);
					}else{
						var modalInstance = $uibModal.open({
							animation : true,
							template : '<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-information-circled modal-icon"></i><span>Erro</span></div><div class="modal-body text-center">Esta data não esta em seu período de agendamento que inicia em '+moment(agendamentos.dias.vigencia.start).format('DD/MM/YYYY')+'</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button></div></div>',
							size : 'md',
						});
					}
				},
				eventClick : function(evento, jsEvent, view) {
					var startDate = moment(agendamentos.dias.vigencia.start).hour(0).minute(0);
					var endDate = moment(agendamentos.dias.vigencia.end).hour(23).minute(59).second(59);
					if(evento.tipo == 'E' &&
						parseFloat(evento.start.format('YYYYMMDDHHmmssSSSS')) >= parseFloat(startDate.format('YYYYMMDDHHmmssSSSS'))
						&& parseFloat(evento.start.format('YYYYMMDDHHmmssSSSS')) <= parseFloat(endDate.format('YYYYMMDDHHmmssSSSS')) ) {
						var modalInstance = $uibModal.open({
							animation : true,
							templateUrl : 'app/pages/agendamento/preAgendamento/edicao/editar.html',
							size : 'md',
							controller : 'EditarAgendamentoPageCtrl',
							resolve : {
								dataAgendamento : function() {
									return evento.start;
								},
								evento : function() {
									return evento;
								},
								agendamentos : function() {
									return agendamentos;
								},
								aluno: function(){
									return aluno;
								}
							}

						});

						modalInstance.result.then(function(eventoAgendado) {
							$('#calendar').fullCalendar('removeEvents', [ evento.id ]);
							if( eventoAgendado != null ){
								$('#calendar').fullCalendar('renderEvent', eventoAgendado, true);
							}
							$('#calendar').fullCalendar('unselect');
							//$uibModalInstance.dismiss("Agendamento editado");
							toastr.success("Agendamento editado", 'Sucesso', {});
					    }, function (mensagem) {
			    			if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1 ){
					    		toastr.error(mensagem, 'Erro', {});
					    	}
					      //console.log('Modal dismissed at: ' + new Date());
					      //Nada feito
					    });
					}else{
						var modalInstance = $uibModal.open({
							animation : true,
							template : '<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-information-circled modal-icon"></i><span>Erro</span></div><div class="modal-body text-center">Não é possivel editar este agendamento</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button></div></div>',
							size : 'md',
						});
					}
			    },
				eventLimit : 4, // allow "more" link when too many events
				eventLimitClick : "popover",
				events : agendamentos.eventos,
			};

			var calendar = $('#calendar').fullCalendar(calendarOptions);
			if($('.fc-prev-button').hasClass('fc-state-disabled')){
				if(moment(agendamentos.dias.vigencia.end)._d.getMonth() !== moment(agendamentos.dias.vigencia.start)._d.getMonth()){
					$('.fc-prev-button').removeClass('fc-state-disabled');
					$('.fc-prev-button').removeAttr('disabled');
				}else{
					$('.fc-prev-button').addClass('fc-state-disabled');
					$('.fc-prev-button').attr('disabled');
				}
			}
		}
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.agendamento.calendarioFeriado')
  		.controller('CalendarioFeriadoAgendamentoPageCtrl', CalendarioFeriadoAgendamentoPageCtrl);

	/** @ngInject */
	function CalendarioFeriadoAgendamentoPageCtrl($scope, $filter, AgendamentoService, AuthService) {
		
		if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}

		var feriado = AgendamentoService.getFeriado() || {};

		$scope.periodos = AgendamentoService.periodos();
		feriado.periodo = $scope.periodos[0];
		
		$scope.inserirFeriado = function(feriado) {
			AgendamentoService.inserirFeriado(feriado).then(function(id) {
				$scope.feriado.id = id;
				$scope.mensagem = { sucesso: "Feriado incluído com sucesso" }; 
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});	
		};
		
		$scope.alterarFeriado = function(feriado) {
			
			AgendamentoService.alterarFeriado(feriado).then(function() {				
				$scope.mensagem = { sucesso: "Feriado alterado com sucesso" };
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
			
		};

		$scope.limpar = function() {
			$scope.feriado = {
				id: feriado == null ? null : feriado.id,	
				dataInicio: null,
				dataFim: null,
				descricao: null,
				fixo: true,
			};
		};
		
		// Inicializa tela
		if(feriado == null) {
			$scope.acao = "Incluir";
			$scope.limpar();
		}
		else {
			if(feriado.fixo == "1" || feriado.fixo == "S"){
				feriado.fixo = true;
			}else{
				feriado.fixo = false;
			}
			$scope.acao = "Alterar";
			$scope.feriado = feriado;
		}
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.agendamento.calendarioFeriado')
  		.controller('ConsultaCalendarioFeriadoAgendamentoPageCtrl', ConsultaCalendarioFeriadoAgendamentoPageCtrl);

	/** @ngInject */
	function ConsultaCalendarioFeriadoAgendamentoPageCtrl($scope, $state, AgendamentoService, AuthService) {
		
		if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}

		$scope.opcoesAnoReferenciaApenas = {
			datepickerMode: "year",
		    minMode: "year",
		    showWeeks: "false",
		};

		
		$scope.pesquisar = function() {
			
			$scope.feriados = null;
			
			AgendamentoService.listarFeriados($scope.calendario).then(function(data) {
				$scope.mensagem = null;
				$scope.feriados = data;
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
		};

		$scope.inserirFeriado = function() {
			
			AgendamentoService.setFeriado(null);
			
			$state.go('agendamento.feriado');
		};
		
		$scope.editarFeriado = function(feriado) {
			
			AgendamentoService.setFeriado(feriado);
			
			$state.go('agendamento.feriado');
		};
		
		$scope.excluirFeriado = function(feriado) {
			
			AgendamentoService.excluirFeriado(feriado).then(function() {				
				AgendamentoService.setFeriado(null);
				$scope.pesquisar();
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
			
		};
		
		$scope.limpar = function() {
			// Reset dos parametros de busca
			$scope.calendario = {
				ano : null,
			};
			
			$scope.feriados = null;
			$scope.mensagem = null;
		};

		
		$scope.limpar();
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.agendamento.relatorios')
  		.controller('RelatoriosAgendamentoPageCtrl', RelatoriosAgendamentoPageCtrl);
  	
  	RelatoriosAgendamentoPageCtrl.$inject = ['$scope', '$state', 'AreasService', 'agendamento.RelatoriosService', 'AgendamentoService', 'SituacoesService','AuthService','OrientadoresService'];

	/** @ngInject */
	function RelatoriosAgendamentoPageCtrl($scope, $state, AreasService, RelatoriosService, AgendamentoService, SituacoesService, AuthService, OrientadoresService) {

		$scope.mensagem = [];
		$scope.current = 0;
        $scope.select = function( index ){
        	$scope.current = index;
        };
        $scope.principal = {};

		if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
			$scope.mensagem[$scope.current] = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}


		$scope.relatorios = RelatoriosService.listarRelatorios();
		
		// Combobox de Área e Orientadores
		$scope.areas = [{ id: '', value: ''}];
		
		AreasService.listarAreas().then(function(areas) {
			$scope.areas = areas;

			$scope.limparAgendamentos();
		})
		.catch(function(mensagem) {	
			$scope.mensagem[$scope.current] = mensagem;
		});

		$scope.orientadores = [{ id: '', value: ''}];
		$scope.getOrientadores = function() {
			OrientadoresService.listarOrientadores().then(function(orientadores) {
				$scope.orientadores = orientadores;
			})
			.catch(function(mensagem) {		
				$scope.mensagem[$scope.current] = mensagem;
			});
		};
		$scope.getOrientadores();

		$scope.pesquisarAgendamentos = function() {	
			$scope.mensagem[$scope.current] = null;
			
			RelatoriosService.gerarRelatorio($scope.relatorio).then(function(relatorio) {
				
				RelatoriosService.setRelatorio(relatorio);
				
				$state.go('agendamento.relatorios.' + $scope.relatorio.opcao);
			})
			.catch(function(mensagem) {		
				$scope.mensagem[$scope.current] = mensagem;
			});					
		};
		$scope.pesquisarConsulta = function( consulta ){
			$scope.principal.consulta = consulta;
			consulta.opcao = 'consulta';
			$scope.mensagem[$scope.current] = null;
			
			RelatoriosService.gerarRelatorio(consulta).then(function(aluno) {
				$scope.alunos = aluno;
			})
			.catch(function(mensagem) {		
				$scope.mensagem[$scope.current] = mensagem;
			});
		}

		$scope.mostrarAgendamento = function(aluno) {
			AgendamentoService.setAluno(aluno);
			$state.go('agendamento.relatorios.aluno');
		};
		
		$scope.limparAgendamentos = function() {
			
			var anoPassado = new Date().setFullYear((new Date()).getFullYear() - 1);
			
			// Reset dos parametros de busca
			$scope.relatorio = {
				opcao : Object.keys($scope.relatorios.agendamentos)[0],
				area : $scope.areas[0],
				situacao : $scope.situacao,
				orientador : $scope.orientadores[0],
				periodo: {
					de: anoPassado,
					ate: Date.now(),
				},
			};
			
			RelatoriosService.setRelatorio(null);
		};
		$scope.limparConsulta = function() {
			$scope.consulta = {
				nome : '',
				matricula: '',
			};
			
			$scope.alunos = null;
			$scope.mensagem[$scope.current] = null;
		};
	}

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist')
    .controller('chartistCtrl', chartistCtrl);

  /** @ngInject */
  function chartistCtrl($scope, $timeout, baConfig) {

    $scope.simpleLineOptions = {
      color: baConfig.colors.defaultText,
      fullWidth: true,
      height: "300px",
      chartPadding: {
        right: 40
      }
    };

    $scope.simpleLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      series: [
        [20, 20, 12, 45, 50],
        [10, 45, 30, 14, 12],
        [34, 12, 12, 40, 50],
        [10, 43, 25, 22, 16],
        [3, 6, 30, 33, 43]
      ]
    };

    $scope.areaLineData = {
      labels: [1, 2, 3, 4, 5, 6, 7, 8],
      series: [
        [5, 9, 7, 8, 5, 3, 5, 4]
      ]
    };

    $scope.areaLineOptions = {
      fullWidth: true,
      height: "300px",
      low: 0,
      showArea: true
    };

    $scope.biLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      series: [
        [1, 2, 3, 1, -2, 0, 1],
        [-2, -1, -2, -1, -2.5, -1, -2],
        [0, 0, 0, 1, 2, 2.5, 2],
        [2.5, 2, 1, 0.5, 1, 0.5, -1]
      ]
    };

    $scope.biLineOptions = {
      height: "300px",
      high: 3,
      low: -3,
      showArea: true,
      showLine: false,
      showPoint: false,
      fullWidth: true,
      axisX: {
        showGrid: false
      }
    };

    $scope.simpleBarData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      series: [
        [15, 24, 43, 27, 5, 10, 23, 44, 68, 50, 26, 8],
        [13, 22, 49, 22, 4, 6, 24, 46, 57, 48, 22, 4]
      ]
    };

    $scope.simpleBarOptions = {
      fullWidth: true,
      height: "300px"
    };

    $scope.multiBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [5, 4, 3, 7],
        [3, 2, 9, 5],
        [1, 5, 8, 4],
        [2, 3, 4, 6],
        [4, 1, 2, 1]
      ]
    };

    $scope.multiBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value.split(/\s+/).map(function (word) {
            return word[0];
          }).join('');
        }
      },
      axisY: {
        offset: 20
      }
    };

    $scope.multiBarResponsive = [
      ['screen and (min-width: 400px)', {
        reverseData: true,
        horizontalBars: true,
        axisX: {
          labelInterpolationFnc: Chartist.noop
        },
        axisY: {
          offset: 60
        }
      }],
      ['screen and (min-width: 700px)', {
        stackBars: false,
        reverseData: false,
        horizontalBars: false,
        seriesBarDistance: 15
      }]
    ];

    $scope.stackedBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [800000, 1200000, 1400000, 1300000],
        [200000, 400000, 500000, 300000],
        [100000, 200000, 400000, 600000]
      ]
    };

    $scope.stackedBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisY: {
        labelInterpolationFnc: function (value) {
          return (value / 1000) + 'k';
        }
      }
    };

    $scope.simplePieData = {
      series: [5, 3, 4]
    };

    $scope.simplePieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelInterpolationFnc: function (value) {
        return Math.round(value / 12 * 100) + '%';
      }
    };

    $scope.labelsPieData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.labelsPieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.simpleDonutData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.simpleDonutOptions = {
      fullWidth: true,
      donut: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.donutResponsive = getResponsive(5, 40);

    $scope.pieResponsive = getResponsive(20, 80);

    function getResponsive(padding, offset){
      return [
        ['screen and (min-width: 1550px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 1200px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 600px)', {
          chartPadding: 0,
          labelOffset: 0,
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }]
      ];
    }

    $timeout(function(){
      new Chartist.Line('#line-chart', $scope.simpleLineData, $scope.simpleLineOptions);
      new Chartist.Line('#area-chart', $scope.areaLineData, $scope.areaLineOptions);
      new Chartist.Line('#bi-chart', $scope.biLineData, $scope.biLineOptions);

      new Chartist.Bar('#simple-bar', $scope.simpleBarData, $scope.simpleBarOptions);
      new Chartist.Bar('#multi-bar', $scope.multiBarData, $scope.multiBarOptions, $scope.multiBarResponsive);
      new Chartist.Bar('#stacked-bar', $scope.stackedBarData, $scope.stackedBarOptions);

      new Chartist.Pie('#simple-pie', $scope.simplePieData, $scope.simplePieOptions, $scope.pieResponsive);
      new Chartist.Pie('#label-pie', $scope.labelsPieData, $scope.labelsPieOptions);
      new Chartist.Pie('#donut', $scope.simpleDonutData, $scope.simpleDonutOptions, $scope.donutResponsive);
    });
  }
})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs1DCtrl', chartJs1DCtrl);

  /** @ngInject */
  function chartJs1DCtrl($scope, baConfig) {
    var layoutColors = baConfig.colors;

    $scope.labels =["Sleeping", "Designing", "Coding", "Cycling"];
    $scope.data = [20, 40, 5, 35];
    $scope.options = {
      elements: {
        arc: {
          borderWidth: 0
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontColor: layoutColors.defaultText
        }
      }
    };

    $scope.changeData = function () {
      $scope.data = shuffle($scope.data);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs2DCtrl', chartJs2DCtrl);

  /** @ngInject */
  function chartJs2DCtrl($scope) {
    $scope.labels =["May", "Jun", "Jul", "Aug", "Sep"];
    $scope.data = [
      [65, 59, 90, 81, 56],
      [28, 48, 40, 19, 88]
    ];
    $scope.series = ['Product A', 'Product B'];


    $scope.changeData = function () {
      $scope.data[0] = shuffle($scope.data[0]);
      $scope.data[1] = shuffle($scope.data[1]);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJsWaveCtrl', chartJsWaveCtrl);

  /** @ngInject */
  function chartJsWaveCtrl($scope, $interval, stopableInterval) {
    $scope.labels =["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    $scope.data = [1, 9, 3, 4, 5, 6, 7, 8, 2].map(function(e){
      return Math.sin(e) * 25 +25;
    });

    stopableInterval.start($interval, function(){
      var tempArray = [];
      var lastElement = $scope.data[$scope.data.length-1];
      for(var i = $scope.data.length-1; i > 0; i--){
       tempArray[i] = $scope.data[i-1];
      }
      tempArray[0] = lastElement;
      $scope.data = tempArray;
    }, 400)
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris')
    .controller('morrisCtrl', morrisCtrl);

  /** @ngInject */
  function morrisCtrl($scope, $window, baConfig) {
    var layoutColors = baConfig.colors;
    $scope.colors = [layoutColors.primary, layoutColors.warning, layoutColors.danger, layoutColors.info, layoutColors.success, layoutColors.primaryDark];
    $scope.lineData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.areaData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.barData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.donutData = [
      {label: "Download Sales", value: 12},
      {label: "In-Store Sales", value: 30},
      {label: "Mail-Order Sales", value: 20}
    ];

    angular.element($window).bind('resize', function () {
      //$window.Morris.Grid.prototype.redraw();
    });
  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .service('mailMessages', mailMessages);

  /** @ngInject */
  function mailMessages($sce) {
    var messages = [
      {
        "id": "4563faass",
        "name": "Nasta Linnie",
        "subject": "Great text",
        "date": "2015-08-28T07:57:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Check out this cool text.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "attachment": "poem.txt",
        "position": "Great Employee",
        "tag": "friend",
        "labels": ['inbox']
      },
      {
        "id": "4563fdfvd",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-11-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ex mauris, ultrices vel lectus quis, scelerisque hendrerit ipsum. Suspendisse ullamcorper turpis neque, eget dapibus magna placerat ac. Suspendisse rhoncus ligula ac mi tempus varius ut sed lacus. Sed et commodo nulla, et placerat leo. Nam rhoncus vulputate sem non pharetra. Praesent fringilla massa in laoreet convallis. Aliquam lobortis dui a congue facilisis. Aenean dapibus semper semper. Quisque aliquam, nibh dapibus interdum condimentum, ex velit tempor tortor, at vestibulum magna leo quis leo. Morbi pulvinar varius erat ac rutrum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In hac habitasse platea dictumst.</p>" +
          "<br><p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "4563zxcss",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-10-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey Nasta, </p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "work",
        "labels": ['sent', 'important']
      },
      {
        "id": "8955sddf",
        "name": "Nick Cat",
        "subject": "New Design",
        "date": "2015-05-05T12:59:45",
        "body": $sce.trustAsHtml("<p>Hey John, Consectetur adipiscing elit</p><br>" +
          "<p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "attachment": "design.psd",
        "tag": "work",
        "labels": ['inbox']
      },
      {
        "id": "8955sdfcc",
        "name": "Nick Cat",
        "subject": "Gift card",
        "date": "2015-07-18T10:19:01",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Consectetur adipiscing elit, Lorem ipsum dolor sit amet</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "8955asewf",
        "name": "Nick Cat",
        "subject": "Some news",
        "date": "2015-09-23T03:04:10",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "work",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334uudsa",
        "name": "Kostya Danovsky",
        "subject": "Street Art",
        "date": "2015-11-22T10:05:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Aliquam eu facilisis eros, quis varius est.</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Lorem ipsum dolor sit amet! Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed." +
          "Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "attachment": "file.doc",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334aefvv",
        "name": "Kostya Danovsky",
        "subject": "New product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Aliquam eu facilisis eros, quis varius est. Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Nulla facilisi. Nulla congue, arcu eget blandit lacinia, leo ante ullamcorper lectus, vel pulvinar justo ipsum vitae justo." +
          "Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334cvdss",
        "name": "Kostya Danovsky",
        "subject": "Old product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<br>"+
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "study",
        "labels": ['trash']
      },
      {
        "id": "8223xzxfn",
        "name": "Andrey Hrabouski",
        "subject": "Skype moji",
        "date": "2015-07-16T06:47:53",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Lorem ipsum dolor I find moji in skype sit amet!.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['trash']
      },
      {
        "id": "8223sdffn",
        "name": "Andrey Hrabouski",
        "subject": "My App",
        "date": "2015-06-20T07:05:02",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur My Falasson App elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['spam']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "Cool",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['draft']
      },
      {
        "id": "8223xsdaa",
        "name": "Andrey Hrabouski",
        "subject": "Car rent",
        "date": "2015-02-25T10:58:58",
        "body": $sce.trustAsHtml("<p>Hey Andrey. </p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": "family",
        "labels": ['draft']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "What next",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Esse esse labore tempor ullamco ullamco. Id veniam laborum c.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['sent']
      }
    ].sort(function (a, b) {
        if (a.date > b.date) return 1;
        if (a.date < b.date) return -1;
      }).reverse();
    var tabs = [{
      label: 'inbox',
      name: 'Inbox',
      newMails: 7
    }, {
      label: 'sent',
      name: 'Sent Mail'
    }, {
      label: 'important',
      name: 'Important'
    }, {
      label: 'draft',
      name: 'Draft',
      newMails: 2
    }, {
      label: 'spam',
      name: 'Spam'
    }, {
      label: 'trash',
      name: 'Trash'
    }];

    return{
      getTabs : function(){
        return tabs
      },
      getMessagesByLabel : function(label){
        return messages.filter(function(m){
          return m.labels.indexOf(label) != -1;
        });
      },
      getMessageById : function(id){
        return messages.filter(function(m){
          return m.id == id;
        })[0];
      }
    }

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
      .controller('MailTabCtrl', MailTabCtrl);

  /** @ngInject */
  function MailTabCtrl(composeModal, mailMessages) {

    var vm = this;
    vm.navigationCollapsed = true;
    vm.showCompose = function(subject, to , text){
      composeModal.open({
        subject : subject,
        to: to,
        text: text
      })
    };

    vm.tabs = mailMessages.getTabs();
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline')
      .controller('TimelineCtrl', TimelineCtrl);

  /** @ngInject */
  function TimelineCtrl() {
    var timelineBlocks = $('.cd-timeline-block'),
        offset = 0.8;

    //hide timeline blocks which are outside the viewport
    hideBlocks(timelineBlocks, offset);

    //on scolling, show/animate timeline blocks when enter the viewport
    $(window).on('scroll', function () {
      if (!window.requestAnimationFrame) {
        setTimeout(function () {
          showBlocks(timelineBlocks, offset);
        }, 100);
      } else {
        window.requestAnimationFrame(function () {
          showBlocks(timelineBlocks, offset);
        });
      }
    });

    function hideBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top > $(window).scrollTop() + $(window).height() * offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
      });
    }

    function showBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
      });
    }
  }
})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree')
    .controller('treeCtrl', treeCtrl);

  /** @ngInject */
  function treeCtrl($scope, $timeout) {

    $scope.ignoreChanges = false;
    var newId = 0;
    $scope.ignoreChanges = false;
    $scope.newNode = {};

    $scope.basicConfig = {
      core: {
        multiple: false,
        check_callback: true,
        worker: true
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      'plugins': ['types'],
      'version': 1
    };

    $scope.dragConfig = {
      'core': {
        'check_callback': true,
        'themes': {
          'responsive': false
        }
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      "plugins": ["dnd", 'types']
    };

    $scope.addNewNode = function () {
      $scope.ignoreChanges = true;
      var selected = this.basicTree.jstree(true).get_selected()[0];
      if (selected)
        $scope.treeData.push({
          id: (newId++).toString(),
          parent: selected,
          text: "New node " + newId,
          state: {opened: true}
        });
      $scope.basicConfig.version++;
    };


    $scope.refresh = function () {
      $scope.ignoreChanges = true;
      newId = 0;
      $scope.treeData = getDefaultData();
      $scope.basicConfig.version++;
    };

    $scope.expand = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = true;
      });
      $scope.basicConfig.version++;
    };

    $scope.collapse = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = false;
      });
      $scope.basicConfig.version++;
    };

    $scope.readyCB = function() {
      $timeout(function() {
        $scope.ignoreChanges = false;
      });
    };


    $scope.applyModelChanges = function() {
      return !$scope.ignoreChanges;
    };

    $scope.treeData = getDefaultData();
    $scope.dragData = [
      {
        "id": "nd1",
        "parent": "#",
        "type": "folder",
        "text": "Node 1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd2",
        "parent": "#",
        "type": "folder",
        "text": "Node 2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd3",
        "parent": "#",
        "type": "folder",
        "text": "Node 3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd4",
        "parent": "#",
        "type": "folder",
        "text": "Node 4",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd5",
        "parent": "nd1",
        "text": "Node 1.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd6",
        "parent": "nd1",
        "text": "Node 1.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd7",
        "parent": "nd1",
        "text": "Node 1.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd8",
        "parent": "nd2",
        "text": "Node 2.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd9",
        "parent": "nd2",
        "text": "Node 2.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd10",
        "parent": "nd2",
        "text": "Node 2.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd11",
        "parent": "nd3",
        "text": "Node 3.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd12",
        "parent": "nd3",
        "text": "Node 3.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd13",
        "parent": "nd3",
        "text": "Node 3.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd14",
        "parent": "nd4",
        "text": "Node 4.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd15",
        "parent": "nd4",
        "text": "Node 4.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd16",
        "parent": "nd4",
        "text": "Node 4.3",
        "state": {
          "opened": true
        }
      }
    ];

    function getDefaultData() {
      return [
        {
          "id": "n1",
          "parent": "#",
          "type": "folder",
          "text": "Node 1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n2",
          "parent": "#",
          "type": "folder",
          "text": "Node 2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n3",
          "parent": "#",
          "type": "folder",
          "text": "Node 3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n5",
          "parent": "n1",
          "text": "Node 1.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n6",
          "parent": "n1",
          "text": "Node 1.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n7",
          "parent": "n1",
          "text": "Node 1.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n8",
          "parent": "n1",
          "text": "Node 1.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n9",
          "parent": "n2",
          "text": "Node 2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n10",
          "parent": "n2",
          "text": "Node 2.2 (Custom icon)",
          "icon": "ion-help-buoy",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n12",
          "parent": "n3",
          "text": "Node 3.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n13",
          "parent": "n3",
          "type": "folder",
          "text": "Node 3.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n14",
          "parent": "n13",
          "text": "Node 3.2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n15",
          "parent": "n13",
          "text": "Node 3.2.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n16",
          "parent": "n3",
          "text": "Node 3.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n17",
          "parent": "n3",
          "text": "Node 3.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n18",
          "parent": "n3",
          "text": "Node 3.5",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n19",
          "parent": "n3",
          "text": "Node 3.6",
          "state": {
            "opened": true
          }
        }
      ]
    }


  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/pages/dashboard/blurFeed/blurFeed.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('BlurFeedCtrl', BlurFeedCtrl);

  /** @ngInject */
  function BlurFeedCtrl($scope) {
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl',
      templateUrl: 'app/pages/dashboard/dashboardCalendar/dashboardCalendar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

  /** @ngInject */
  function DashboardCalendarCtrl(baConfig) {
    var dashboardColors = baConfig.colors.dashboard;
    var $element = $('#calendar').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      defaultDate: '2016-03-08',
      selectable: true,
      selectHelper: true,
      select: function (start, end) {
        var title = prompt('Event Title:');
        var eventData;
        if (title) {
          eventData = {
            title: title,
            start: start,
            end: end
          };
          $element.fullCalendar('renderEvent', eventData, true); // stick? = true
        }
        $element.fullCalendar('unselect');
      },
      editable: true,
      eventLimit: true, // allow "more" link when too many events
      events: [
        {
          title: 'All Day Event',
          start: '2016-03-01',
          color: dashboardColors.silverTree
        },
        {
          title: 'Long Event',
          start: '2016-03-07',
          end: '2016-03-10',
          color: dashboardColors.blueStone
        },
        {
          title: 'Dinner',
          start: '2016-03-14T20:00:00',
          color: dashboardColors.surfieGreen
        },
        {
          title: 'Birthday Party',
          start: '2016-04-01T07:00:00',
          color: dashboardColors.gossipDark
        }
      ]
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardLineChart', dashboardLineChart);

  /** @ngInject */
  function dashboardLineChart() {
    return {
      restrict: 'E',
      controller: 'DashboardLineChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardLineChart/dashboardLineChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardLineChartCtrl', DashboardLineChartCtrl);

  /** @ngInject */
  function DashboardLineChartCtrl(baConfig, layoutPaths, baUtil) {
    var layoutColors = baConfig.colors;
    var graphColor = baConfig.theme.blur ? '#000000' : layoutColors.primary;
    var chartData = [
      { date: new Date(2012, 11), value: 0, value0: 0 },
      { date: new Date(2013, 0), value: 15000, value0: 19000},
      { date: new Date(2013, 1), value: 30000, value0: 20000},

      { date: new Date(2013, 2), value: 25000, value0: 22000},
      { date: new Date(2013, 3), value: 21000, value0: 25000},
      { date: new Date(2013, 4), value: 24000, value0: 29000},
      { date: new Date(2013, 5), value: 31000, value0: 26000},
      { date: new Date(2013, 6), value: 40000, value0: 25000},
      { date: new Date(2013, 7), value: 37000, value0: 20000},
      { date: new Date(2013, 8), value: 18000, value0: 22000},
      { date: new Date(2013, 9), value: 5000, value0: 26000},
      { date: new Date(2013, 10), value: 40000, value0: 30000},
      { date: new Date(2013, 11), value: 20000, value0: 25000},
      { date: new Date(2014, 0), value: 5000, value0: 13000},

      { date: new Date(2014, 1), value: 3000, value0: 13000},
      { date: new Date(2014, 2), value: 1800, value0: 13000},
      { date: new Date(2014, 3), value: 10400, value0: 13000},
      { date: new Date(2014, 4), value: 25500, value0: 13000},
      { date: new Date(2014, 5), value: 2100, value0: 13000},
      { date: new Date(2014, 6), value: 6500, value0: 13000},
      { date: new Date(2014, 7), value: 1100, value0: 13000},
      { date: new Date(2014, 8), value: 17200, value0: 13000},
      { date: new Date(2014, 9), value: 26900, value0: 13000},
      { date: new Date(2014, 10), value: 14100, value0: 13000},
      { date: new Date(2014, 11), value: 35300, value0: 13000},
      { date: new Date(2015, 0), value: 54800, value0: 13000},
      { date: new Date(2015, 1), value: 49800, value0: 13000}
    ];

    var chart = AmCharts.makeChart('amchart', {
      type: 'serial',
      theme: 'blur',
      marginTop: 15,
      marginRight: 15,
      dataProvider: chartData,
      categoryField: 'date',
      categoryAxis: {
        parseDates: true,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText
      },
      valueAxes: [
        {
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }
      ],
      graphs: [
        {
          id: 'g0',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.3),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value0',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        },
        {
          id: 'g1',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.5),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        }
      ],
      chartCursor: {
        categoryBalloonDateFormat: 'MM YYYY',
        categoryBalloonColor: '#4285F4',
        categoryBalloonAlpha: 0.7,
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5
      },
      dataDateFormat: 'MM YYYY',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      zoomOutButton: {
        backgroundColor: '#fff',
        backgroundAlpha: 0
      },
      zoomOutText: '',
      pathToImages: layoutPaths.images.amChart
    });

    function zoomChart() {
      chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    }

    chart.addListener('rendered', zoomChart);
    zoomChart();
    if (chart.zoomChart) {
      chart.zoomChart();
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/pages/dashboard/dashboardMap/dashboardMap.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl(baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var map = AmCharts.makeChart('amChartMap', {
      type: 'map',
      theme: 'blur',
      zoomControl: { zoomControlEnabled: false, panControlEnabled: false },

      dataProvider: {
        map: 'worldLow',
        zoomLevel: 3.5,
        zoomLongitude: 10,
        zoomLatitude: 52,
        areas: [
          { title: 'Austria', id: 'AT', color: layoutColors.primary, customData: '1 244', groupId: '1'},
          { title: 'Ireland', id: 'IE', color: layoutColors.primary, customData: '1 342', groupId: '1'},
          { title: 'Denmark', id: 'DK', color: layoutColors.primary, customData: '1 973', groupId: '1'},
          { title: 'Finland', id: 'FI', color: layoutColors.primary, customData: '1 573', groupId: '1'},
          { title: 'Sweden', id: 'SE', color: layoutColors.primary, customData: '1 084', groupId: '1'},
          { title: 'Great Britain', id: 'GB', color: layoutColors.primary, customData: '1 452', groupId: '1'},
          { title: 'Italy', id: 'IT', color: layoutColors.primary, customData: '1 321', groupId: '1'},
          { title: 'France', id: 'FR', color: layoutColors.primary, customData: '1 112', groupId: '1'},
          { title: 'Spain', id: 'ES', color: layoutColors.primary, customData: '1 865', groupId: '1'},
          { title: 'Greece', id: 'GR', color: layoutColors.primary, customData: '1 453', groupId: '1'},
          { title: 'Germany', id: 'DE', color: layoutColors.primary, customData: '1 957', groupId: '1'},
          { title: 'Belgium', id: 'BE', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Luxembourg', id: 'LU', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Netherlands', id: 'NL', color: layoutColors.primary, customData: '1 213', groupId: '1'},
          { title: 'Portugal', id: 'PT', color: layoutColors.primary, customData: '1 291', groupId: '1'},
          { title: 'Lithuania', id: 'LT', color: layoutColors.successLight, customData: '567', groupId: '2'},
          { title: 'Latvia', id: 'LV', color: layoutColors.successLight, customData: '589', groupId: '2'},
          { title: 'Czech Republic ', id: 'CZ', color: layoutColors.successLight, customData: '785', groupId: '2'},
          { title: 'Slovakia', id: 'SK', color: layoutColors.successLight, customData: '965', groupId: '2'},
          { title: 'Estonia', id: 'EE', color: layoutColors.successLight, customData: '685', groupId: '2'},
          { title: 'Hungary', id: 'HU', color: layoutColors.successLight, customData: '854', groupId: '2'},
          { title: 'Cyprus', id: 'CY', color: layoutColors.successLight, customData: '754', groupId: '2'},
          { title: 'Malta', id: 'MT', color: layoutColors.successLight, customData: '867', groupId: '2'},
          { title: 'Poland', id: 'PL', color: layoutColors.successLight, customData: '759', groupId: '2'},
          { title: 'Romania', id: 'RO', color: layoutColors.success, customData: '302', groupId: '3'},
          { title: 'Bulgaria', id: 'BG', color: layoutColors.success, customData: '102', groupId: '3'},
          { title: 'Slovenia', id: 'SI', color: layoutColors.danger, customData: '23', groupId: '4'},
          { title: 'Croatia', id: 'HR', color: layoutColors.danger, customData: '96', groupId: '4'}
        ]
      },

      areasSettings: {
        rollOverOutlineColor: layoutColors.border,
        rollOverColor: layoutColors.primaryDark,
        alpha: 0.8,
        unlistedAreasAlpha: 0.2,
        unlistedAreasColor: layoutColors.defaultText,
        balloonText: '[[title]]: [[customData]] users'
      },


      legend: {
        width: '100%',
        marginRight: 27,
        marginLeft: 27,
        equalWidths: false,
        backgroundAlpha: 0.3,
        backgroundColor: layoutColors.border,
        borderColor: layoutColors.border,
        borderAlpha: 1,
        top: 362,
        left: 0,
        horizontalGap: 10,
        data: [
          {
            title: 'over 1 000 users',
            color: layoutColors.primary
          },
          {
            title: '500 - 1 000 users',
            color: layoutColors.successLight
          },
          {
            title: '100 - 500 users',
            color: layoutColors.success
          },
          {
            title: '0 - 100 users',
            color: layoutColors.danger
          }
        ]
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

  /** @ngInject */
  function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil) {
    var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    $scope.charts = [{
      color: pieColor,
      description: 'New Visits',
      stats: '57,820',
      icon: 'person',
    }, {
      color: pieColor,
      description: 'Purchases',
      stats: '$ 89,745',
      icon: 'money',
    }, {
      color: pieColor,
      description: 'Active Users',
      stats: '178,391',
      icon: 'face',
    }, {
      color: pieColor,
      description: 'Returned',
      stats: '32,592',
      icon: 'refresh',
    }
    ];

    function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }

    function loadPieCharts() {
      $('.chart').each(function () {
        var chart = $(this);
        chart.easyPieChart({
          easing: 'easeOutBounce',
          onStep: function (from, to, percent) {
            $(this.el).find('.percent').text(Math.round(percent));
          },
          barColor: chart.attr('rel'),
          trackColor: 'rgba(0,0,0,0)',
          size: 84,
          scaleLength: 0,
          animation: 2000,
          lineWidth: 9,
          lineCap: 'round',
        });
      });

      $('.refresh-data').on('click', function () {
        updatePieCharts();
      });
    }

    function updatePieCharts() {
      $('.pie-charts .chart').each(function(index, chart) {
        $(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
      });
    }

    $timeout(function () {
      loadPieCharts();
      updatePieCharts();
    }, 1000);
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardTodo', dashboardTodo);

  /** @ngInject */
  function dashboardTodo() {
    return {
      restrict: 'EA',
      controller: 'DashboardTodoCtrl',
      templateUrl: 'app/pages/dashboard/dashboardTodo/dashboardTodo.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardTodoCtrl', DashboardTodoCtrl);

  /** @ngInject */
  function DashboardTodoCtrl($scope, baConfig) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    var colors = [];
    for (var key in dashboardColors) {
      colors.push(dashboardColors[key]);
    }

    function getRandomColor() {
      var i = Math.floor(Math.random() * (colors.length - 1));
      return colors[i];
    }

    $scope.todoList = [
      { text: 'Check me out' },
      { text: 'Lorem ipsum dolor sit amet, possit denique oportere at his, etiam corpora deseruisse te pro' },
      { text: 'Ex has semper alterum, expetenda dignissim' },
      { text: 'Vim an eius ocurreret abhorreant, id nam aeque persius ornatus.' },
      { text: 'Simul erroribus ad usu' },
      { text: 'Ei cum solet appareat, ex est graeci mediocritatem' },
      { text: 'Get in touch with akveo team' },
      { text: 'Write email to business cat' },
      { text: 'Have fun with blur admin' },
      { text: 'What do you think?' },
    ];

    $scope.todoList.forEach(function(item) {
      item.color = getRandomColor();
    });

    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if (clickPlus || event.which === 13) {
        $scope.todoList.unshift({
          text: $scope.newTodoText,
          color: getRandomColor(),
        });
        $scope.newTodoText = '';
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('popularApp', popularApp);

  /** @ngInject */
  function popularApp() {
    return {
      restrict: 'E',
      templateUrl: 'app/pages/dashboard/popularApp/popularApp.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/dashboard/trafficChart/trafficChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper) {

      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      $scope.doughnutData = {
          labels: [
              'Other',
              'Search engines',
              'Referral Traffic',
              'Direct Traffic',
              'Ad Campaigns'
          ],
          datasets: [
              {
                  data: [2000, 1500, 1000, 1200, 400],
                  backgroundColor: [
                      dashboardColors.white,
                      dashboardColors.blueStone,
                      dashboardColors.surfieGreen,
                      dashboardColors.silverTree,
                      dashboardColors.gossip

                  ],
                  hoverBackgroundColor: [
                      colorHelper.shade(dashboardColors.white, 15),
                      colorHelper.shade(dashboardColors.blueStone, 15),
                      colorHelper.shade(dashboardColors.surfieGreen, 15),
                      colorHelper.shade(dashboardColors.silverTree, 15),
                      colorHelper.shade(dashboardColors.gossip, 15)
                  ],
                  percentage: [87, 22, 70, 38, 17]
              }]
      };

      var ctx = document.getElementById('chart-area').getContext('2d');
      window.myDoughnut = new Chart(ctx, {
          type: 'doughnut',
          data: $scope.doughnutData,
          options: {
              cutoutPercentage: 64,
              responsive: true,
              elements: {
                  arc: {
                      borderWidth: 0
                  }
              }
          }
      });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/pages/dashboard/weather/weather.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();
/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.downloads.ata')
  		.controller('AtaPageCtrl', AtaPageCtrl);

	/** @ngInject */
	function AtaPageCtrl(REST_END_POINT, $scope, $state, AuthService, $uibModal, toastr, DocService, $filter ) {

		if( !AuthService.isAuthorizedToAccess([2,3,4]) ){ //secretaria,admin,docente
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		$scope.ata = {
			de: null,
			ate: null
		};
		$scope.base = REST_END_POINT+'../../../docs/spg/';
		$scope.docs =[];
		$scope.outros = [];
		DocService.getDocs({'tipo':'ata'}).then(function(data) {
			$scope.docs = data;
			$scope.outros = data;
		});
		var resp = ['backdrop click','escape key press'];
		$scope.isAdmin = false;
		if( AuthService.isAuthorizedToAccess([3]) ){
			$scope.isAdmin = true;
		}
		
		$scope.pesquisar = function( ){
			$scope.docs = null;
			var de = $scope.ata.de !== null ? $filter('date')($scope.ata.de, 'yyyy-MM-dd'): '';
			var ate = $scope.ata.ate !== null ? $filter('date')($scope.ata.ate, 'yyyy-MM-dd'): '';
			DocService.getDocs({'tipo':'ata', 'filtro': {de: de, ate: ate}})
			.then(function(data) {
				$scope.mensagem = null;
				$scope.docs = data;
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
		}
		$scope.limpar = function( ){
			$scope.ata.de = null;
			$scope.ata.ate = null;
		}
		$scope.addAta = function(){
			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/downloads/widget/cadastro.html',
				size : 'md',
				controller : 'CadastroDownloadPageCtrl',
			});
			
			modalInstance.result.then(function(docAdicionado) {
		        $scope.outros.push(docAdicionado);
		    }, function (mensagem) {
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1 ){
		    		toastr.error(mensagem, 'Erro', {});
		    		modalInstance.dismiss();
		    	}
		    });
		}

		$scope.editar = function( doc ){

			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/downloads/widget/editar.html',
				size : 'md',
				controller : 'EditarDownloadPageCtrl',
				resolve : {
							doc : function() {
								return doc;
							}
						}
			});
			
			modalInstance.result.then(function(docAdicionado) {
				var index = $scope.outros.indexOf(docAdicionado);
		        if (index !== -1) {
		            $scope.outros[index] = docAdicionado;
		        }
		    }, function (mensagem) {
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1 ){
		    		toastr.error(mensagem, 'Erro', {});
		    		error.dismiss();
		    	}
		    });
		}
		$scope.excluir = function( doc ){
			DocService.excluirDoc(doc).then(function(data) {
				toastr.success("Documento excluido com sucesso", 'Sucesso', {});

		        var index = $scope.outros.indexOf(doc);
		        if (index !== -1) {
		            $scope.outros.splice(index, 1);
		        }
			})
			.catch(function(erro) {
				toastr.error(erro, 'Erro', {});
			});
		}
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.downloads.documentos')
  		.controller('DocumentosPageCtrl', DocumentosPageCtrl);

	/** @ngInject */
	function DocumentosPageCtrl(REST_END_POINT, $scope, $state, AuthService, $uibModal, toastr, DocService) {

		if( !AuthService.isAuthorizedToAccess([2,3,4]) ){ //secretaria,admin,docente
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		$scope.base = REST_END_POINT+'../../../docs/spg/';
		$scope.docs =[];
		$scope.form = {};
		DocService.getDocs({'tipo':'docs'}).then(function(data) {
			$scope.docs = data;
		});
		var resp = ['backdrop click','escape key press'];
		$scope.isAdmin = false;
		if( AuthService.isAuthorizedToAccess([3]) ){
			$scope.isAdmin = true;
		}
		$scope.addDocumento = function(){
			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/downloads/widget/cadastro.html',
				size : 'md',
				controller : 'CadastroDownloadPageCtrl',
			});
			
			modalInstance.result.then(function(docAdicionado) {
		        $scope.outros.push(docAdicionado);
		    }, function (mensagem) {
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1){
		    		toastr.error(mensagem, 'Erro', {});
		    		modalInstance.dismiss();
		    	}
		    });
		}
		$scope.limpar = function( ){
			$scope.form.titulo = null;
		}
		$scope.pesquisar = function( ){
			$scope.docs = null;
			
			DocService.getDocs({'tipo':'docs', 'filtro': $scope.form.titulo})
			.then(function(data) {
				$scope.mensagem = null;
				$scope.docs = data;
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
		}

		$scope.editar = function( doc ){

			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/downloads/widget/editar.html',
				size : 'md',
				controller : 'EditarDownloadPageCtrl',
				resolve : {
							doc : function() {
								return doc;
							}
						}
			});
			
			modalInstance.result.then(function(docAdicionado) {
				var index = $scope.outros.indexOf(doc);
		        if (index !== -1) {
		            $scope.outros[index] = docAdicionado;
		        }
		    }, function (mensagem) {
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1){
		    		toastr.error(mensagem, 'Erro', {});
		    		modalInstance.dismiss();
		    	}
		    });
		}
		$scope.excluir = function( doc ){
			DocService.excluirDoc(doc).then(function(data) {
				toastr.success("Documento excluido com sucesso", 'Sucesso', {});

		        var index = $scope.outros.indexOf(doc);
		        if (index !== -1) {
		            $scope.outros.splice(index, 1);
		        }
			})
			.catch(function(erro) {
				toastr.error(erro, 'Erro', {});
			});
		}
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.downloads.formularios')
  		.controller('FormulariosPageCtrl', FormulariosPageCtrl);

	/** @ngInject */
	function FormulariosPageCtrl(REST_END_POINT, $scope, $state, AuthService, $uibModal, toastr, DocService) {

		if( !AuthService.isAuthorizedToAccess([2,3,4]) ){ //secretaria,admin,docente
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		$scope.base = REST_END_POINT+'../../../docs/spg/';
		$scope.docs =[];
		$scope.outros =[];
		$scope.form = {};
		DocService.getDocs({'tipo':'forms'})
		.then(function(data) {
			$scope.outros = data;
			$scope.docs = $scope.outros;
		});
		var resp = ['backdrop click','escape key press'];
		$scope.isAdmin = false;
		if( AuthService.isAuthorizedToAccess([3]) ){
			$scope.isAdmin = true;
		}
		$scope.addFormulario = function(){
			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/downloads/widget/cadastro.html',
				size : 'md',
				controller : 'CadastroDownloadPageCtrl',
			});
			
			modalInstance.result.then(function(docAdicionado) {
		        $scope.outros.push(docAdicionado);
				$scope.docs = $scope.outros;
		    }, function (mensagem) {
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1 ){
		    		toastr.error(mensagem, 'Erro', {});
		    		modalInstance.dismiss();
		    	}
		    });
		}
		$scope.pesquisar = function( ){
			$scope.docs = null;
			
			DocService.getDocs({'tipo':'forms', 'filtro': $scope.form.titulo})
			.then(function(data) {
				$scope.mensagem = null;
				$scope.docs = data;
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
		}
		$scope.limpar = function( ){
			$scope.form.titulo = null;
		}
		$scope.editar = function( doc ){

			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/downloads/widget/editar.html',
				size : 'md',
				controller : 'EditarDownloadPageCtrl',
				resolve : {
							doc : function() {
								return doc;
							}
						}
			});
			
			modalInstance.result.then(function(docAdicionado) {
				var index = $scope.outros.indexOf(doc);
		        if (index !== -1) {
		            $scope.outros[index] = docAdicionado;
		        }
		        $scope.docs = $scope.outros;
		    }, function (mensagem) {
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1 ){
		    		toastr.error(mensagem, 'Erro', {});
		    		error.dismiss();
		    	}
		    });
		}
		$scope.excluir = function( doc ){
			DocService.excluirDoc(doc).then(function(data) {
				toastr.success("Documento excluido com sucesso", 'Sucesso', {});

		        var index = $scope.outros.indexOf(doc);
		        if (index !== -1) {
		            $scope.outros.splice(index, 1);
		        }
		        $scope.docs = $scope.outros;
			})
			.catch(function(erro) {
				toastr.error(erro, 'Erro', {});
			});
		}
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.downloads.ordem')
  		.controller('OrdemPageCtrl', OrdemPageCtrl);

	/** @ngInject */
	function OrdemPageCtrl(REST_END_POINT, $scope, $state, AuthService, $uibModal, toastr, DocService, $filter) {

		if( !AuthService.isAuthorizedToAccess([2,3,4]) ){ //secretaria,admin,docente
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		$scope.ordem = {
			de: null,
			ate: null
		};
		$scope.base = REST_END_POINT+'../../../docs/spg/';
		$scope.docs =[];
		DocService.getDocs({'tipo':'ordem'}).then(function(data) {
			$scope.docs = data;
		});
		var resp = ['backdrop click','escape key press'];
		$scope.isAdmin = false;
		if( AuthService.isAuthorizedToAccess([3]) ){
			$scope.isAdmin = true;
		}
		$scope.addOrdem = function(){
			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/downloads/widget/cadastro.html',
				size : 'md',
				controller : 'CadastroDownloadPageCtrl',
			});
			
			modalInstance.result.then(function(docAdicionado) {
		        $scope.outros.push(docAdicionado);
		    }, function (mensagem) {
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1 ){
		    		toastr.error(mensagem, 'Erro', {});
		    		modalInstance.dismiss();
		    	}
		    });
		}
		$scope.pesquisar = function( ){
			$scope.docs = null;
			var de = $scope.ordem.de !== null ? $filter('date')($scope.ordem.de, 'yyyy-MM'): '';
			var ate = $scope.ordem.ate !== null ? $filter('date')($scope.ordem.ate, 'yyyy-MM'): '';
			DocService.getDocs({'tipo':'ordem', 'filtro': {de: de, ate: ate}})
			.then(function(data) {
				$scope.mensagem = null;
				$scope.docs = data;
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
		}
		$scope.limpar = function( ){
			$scope.ordem.de = null;
			$scope.ordem.ate = null;
		}
		$scope.editar = function( doc ){

			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/downloads/widget/editar.html',
				size : 'md',
				controller : 'EditarDownloadPageCtrl',
				resolve : {
							doc : function() {
								return doc;
							}
						}
			});
			
			modalInstance.result.then(function(docAdicionado) {
				var index = $scope.outros.indexOf(doc);
		        if (index !== -1) {
		            $scope.outros[index] = docAdicionado;
		        }
		    }, function (mensagem) {
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1 ){
		    		toastr.error(mensagem, 'Erro', {});
		    		error.dismiss();
		    	}
		    });
		}
		$scope.excluir = function( doc ){
			DocService.excluirDoc(doc).then(function(data) {
				toastr.success("Documento excluido com sucesso", 'Sucesso', {});

		        var index = $scope.outros.indexOf(doc);
		        if (index !== -1) {
		            $scope.outros.splice(index, 1);
		        }
			})
			.catch(function(erro) {
				toastr.error(erro, 'Erro', {});
			});
		}
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.downloads.documentos')
  		.controller('CadastroDownloadPageCtrl', CadastroDownloadPageCtrl);

	/** @ngInject */
	function CadastroDownloadPageCtrl($scope, fileReader, $state, AuthService, DocService, $uibModalInstance, toastr) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}

		$scope.doc = {};
		$scope.doc.arquivo = null;

		$scope.mensagem = null;
		$scope.noFile = true;
		$scope.fileName = '';
		$scope.items = [];

		$scope.opcoesAnoReferenciaApenas = {
			datepickerMode: "month",
		    minMode: "month",
		    showWeeks: "false",
		};

		DocService.getTiposDoc().then(function(data) {
			$scope.items = data;
			$scope.doc.tipo = data[0];
		});

		$scope.removeFile = function () {
			$scope.doc.arquivo = null
			$scope.noFile = true;
			$scope.fileName = '';
			document.getElementById('uploadFile').value = '';
			$scope.progress = 0;
		};

		$scope.uploadFile = function () {
			var f = document.getElementById('uploadFile');
			f.click();
		};


		$scope.getFile = function (f) {
	        $scope.progress = 0;
	        if(f) {
	        	var types = 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/pdf,application/zip,application/x-zip-compressed';
	        	var validType = types.split(',');
	        	if(!validType.indexOf(f.type) === -1){
	        		$scope.mensagem = {'erro':'O arquivo deve ser: .xlsx, .xls, .doc, .docx, .ppt, .pptx, .zip ou .pdf'};
					return;
	        	}
	        	if(f.size > 10485760){
	        		$scope.mensagem = {'erro':'O arquivo de possuir no máximo 10MB'};
					return;
				}
		        fileReader.readAsDataURL(f,$scope).then(function (resp) {
			        // Do stuff
			        //var byteLength = parseInt((resp).replace(/=/g,"").length * 0.75);
			        //if(byteLength > f.max_size){}

			        $scope.doc.arquivo = resp;
			        $scope.noFile = false;
			    }, function (err) {
			        // Do stuff
			        $scope.removeFile();
			        $scope.noFile = true;
			    });
			    if(f.name){
			    	$scope.fileName = f.name;
			    }
			    
	        }
	    };
	 
	    $scope.$on("fileProgress", function(e, progress) {
	        $scope.progress = progress.loaded / progress.total;
	    });

		$scope.enviar = function(resp) {
			$scope.mensagem = null;
			if(typeof(resp) == 'undefined' || !resp.arquivo || !$scope.cadastroForm.$valid){
				$scope.mensagem = {'erro':'Preencha os dados obrigatórios de maneira correta!'};
				return;
			}
			var _dataName = $scope.fileName.split('.');
			var ext = _dataName[_dataName.length-1];
			if(['xlsx','xls','doc','docx','ppt','pptx','zip','pdf'].indexOf(ext) === -1){
				$scope.mensagem = {'erro':'O arquivo deve ser: .xlsx, .xls, .doc, .docx, .ppt, .pptx, .zip ou .pdf'};
				return;
			}
			resp.fileName = $scope.fileName;
			
			DocService.enviaCarga(resp).then(function(data) {
				if(data.obj){
					$uibModalInstance.close(data.obj);
				}else{
					$uibModalInstance.close(data.messages);
				}
				toastr.success("Documento incluido com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				//toastr.error(erro, 'Erro', {});
			});

		};
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.downloads.documentos')
  		.controller('EditarDownloadPageCtrl', EditarDownloadPageCtrl);

	/** @ngInject */
	function EditarDownloadPageCtrl(REST_END_POINT, $scope, fileReader, $state, AuthService, DocService, $uibModalInstance, doc, $filter, toastr) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		$scope.base = REST_END_POINT+'../../../docs/spg/';
		$scope.doc = doc;
		$scope.doc.data = moment(doc.referencia).toDate();
		
		$scope.fileName = doc.namefile;
		//$scope.base = REST_END_POINT+'../../../docs/spg/';
		

		$scope.mensagem = null;
		$scope.noFile = false;
		$scope.opcoesAnoReferenciaApenas = {
			datepickerMode: "month",
		    minMode: "month",
		    showWeeks: "false",
		};
		$scope.items = [];
		DocService.getTiposDoc().then(function(data) {
			$scope.items = data;
			for(var i in data){
				if(data[i].id == doc.idTipo){
					$scope.doc.tipo = data[i];
					break;
				}
			}
		});

		$scope.enviar = function(resp) {
			$scope.mensagem = null;
			if(typeof(resp) == 'undefined' || !$scope.cadastroForm.$valid){
				$scope.mensagem = {'erro':'Preencha os dados obrigatórios de maneira correta!'};
				return;
			}
			var _dataName = $scope.fileName.split('.');
			var ext = _dataName[_dataName.length-1];
			if(['xlsx','xls','doc','docx','ppt','pptx','zip','pdf'].indexOf(ext) === -1){
				$scope.mensagem = {'erro':'O arquivo deve ser: .xlsx, .xls, .doc, .docx, .ppt, .pptx, .zip ou .pdf'};
				return;
			}
			resp.fileName = $scope.fileName;
			
			DocService.updateCarga(resp).then(function(msg) {
				$uibModalInstance.close(resp);
				toastr.success("Documento editado com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				//toastr.error(erro, 'Erro', {});
			});

		};
	}

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('WizardCtrl', WizardCtrl);

  /** @ngInject */
  function WizardCtrl($scope) {
   var vm = this;

    vm.personalInfo = {};
    vm.productInfo = {};
    vm.shipment = {};

    vm.arePersonalInfoPasswordsEqual = function () {
      return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
    };
  }

})();


/**
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.adicionar')
  		.controller('AdicionarPageCtrl', AdicionarPageCtrl);

	/** @ngInject */
	function AdicionarPageCtrl($scope, $state, AuthService, AreasService, $timeout, ManutencaoService, toastr ) {
		
		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		$scope.usuarios = {};
		var obj = null;
		$scope.perfis = [{id:1,text:'Aluno'},{id:2,text:'Secretaria'},{id:3,text:'Administrador'},{id:4,text:'Docente'}];
	    ManutencaoService.listarPerfis().then(function(result){
			$scope.perfis = [].concat(result);
		});
		$scope.areas = [
			{id:5146,value:'Alergia e Imunopatologia',nomae_area:'5146 - Alergia e Imunopatologia'},
			{id:5152,value:'Anestesiologia',nomae_area:'5152 - Anestesiologia'},
			{id:5131,value:'Cardiologia',nomae_area:'5131 - Cardiologia'},
			{id:5170,value:'Cieências da Reabilitação',nomae_area:'5170 - Cieências da Reabilitação'}
		];
		AreasService.listarAreasCod().then(function(result){
			$scope.areas = [].concat(result);
		});
		$scope.statusList = [{id:1,text:'Pendente'},{id:2,text:'Aprovado'},{id:3,text:'Reprovado'}];
		ManutencaoService.listarStatus().then(function(result){
			$scope.statusList = [].concat(result);
			$scope.usuarios.status = $scope.statusList[0];
		});
		function removeAcento (text)
		{       
		    text = text.replace(new RegExp('[ÁÀÂÃ]','gi'), 'A');
		    text = text.replace(new RegExp('[ÉÈÊ]','gi'), 'E');
		    text = text.replace(new RegExp('[ÍÌÎ]','gi'), 'I');
		    text = text.replace(new RegExp('[ÓÒÔÕ]','gi'), 'O');
		    text = text.replace(new RegExp('[ÚÙÛ]','gi'), 'U');
		    text = text.replace(new RegExp('[Ç]','gi'), 'C');
		    text = text.replace(new RegExp('[áàâã]','gi'), 'a');
		    text = text.replace(new RegExp('[éèê]','gi'), 'e');
		    text = text.replace(new RegExp('[íìî]','gi'), 'i');
		    text = text.replace(new RegExp('[óòôõ]','gi'), 'o');
		    text = text.replace(new RegExp('[úùû]','gi'), 'u');
		    text = text.replace(new RegExp('[ç]','gi'), 'c');
		    text = text.replace(new RegExp('[^a-z ]+','gi'), '');
		    return text.trim();                 
		}

		$scope.adicionar = (function(user){
	    	if(!user.perfil || user.perfil == null || user.perfil == ''){
	    		toastr.error('É necessário escolher um perfil', 'Erro', {});
	    		return false;
	    	}
	    	var nome = user.firstName.split(' ');
	    	if(user.matricula){
	    		user.login = removeAcento(nome[0]).substring(0, 4) +'.'+ user.matricula.substring(0, 4);
	    	}else if(user.cpf){
	    		user.login = removeAcento(nome[0]).substring(0, 4) +'.'+ user.cpf.substring(0, 4);
	    	}
	    	ManutencaoService.adicionar(user).then(function(data){
	    		toastr.success(data.mensagem, 'Sucesso', {});
	    		$scope.mensagem = {sucesso: data.mensagem};
	    		$scope.usuarios = angular.copy({});
	    	}).catch(function(data){
	    		if(!data){data={erro:"Erro"};}
	    		toastr.error(data.erro, 'Erro', {});
	    		$scope.mensagem = {erro: data.erro};
	    	});
	    });
	    $scope.reset = (function(){
	    	$scope.usuarios = null;
	    	jQuery('#select-areas').selectpicker('refrash');
	    });
	    $timeout(function(){
		    jQuery('#select-areas').selectpicker('destroy');
	      	jQuery('#select-areas').selectpicker('create');
        },1750);
	}

})();

/**
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.comissao')
  		.controller('ManutencaoComissaoPageCtrl', ManutencaoComissaoPageCtrl);

	/** @ngInject */
	function ManutencaoComissaoPageCtrl($scope, $state, AuthService, ManutencaoService, toastr, $uibModal) {
		if( !AuthService.isAuthorizedToAccess([3]) ){ //secretaria,admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		var resp = ['backdrop click','escape key press'];
		$scope.busca = {};
		var dados = {cargo:null,nome:null};
		$scope.mensagem = null;
		ManutencaoService.listarComissao(dados).then(function(result){
			$scope.outros = result;
			$scope.comissao = $scope.outros;
		}).catch(function(error){
			$scope.mensagem = error;
		});
		
		var defaultC = null;
		$scope.cargos = null;
		ManutencaoService.listarCargos().then(function(result){
			$scope.cargos = result;
			defaultC = result[0];
			$scope.busca.cargo = defaultC;
		}).catch(function(error){
			$scope.mensagem = error;
		});
		
		$scope.pesquisar = function(){
			$scope.mensagem = null;
			var filtros = {
				cargo: $scope.busca.cargo.id,
				nome: $scope.busca.nome
			}
			ManutencaoService.listarComissao(filtros).then(function(result){
				$scope.outros = result;
				$scope.comissao = $scope.outros;
			}).catch(function(error){
				$scope.mensagem = error;
				$scope.outros = [];
			});
		};

		$scope.limpar = function(){
			$scope.busca.cargo = defaultC;
			$scope.busca.nome = "";
		};

		$scope.adicionar =function(){
			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/manutencao/widget/cadastroComissao.html',
				size : 'md',
				controller : 'CadastroComissaoPageCtrl',
			});
			
			modalInstance.result.then(function(comissao) {
		        $scope.outros.push(comissao);
		        $scope.comissao = $scope.outros;
		    }, function (mensagem) {
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1){
		    		toastr.error(mensagem, 'Erro', {});
		    		modalInstance.dismiss();
		    	}
		    });
		};

		$scope.editar = function( comissao ){

			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/manutencao/widget/editarComissao.html',
				size : 'md',
				controller : 'EditarComissaoPageCtrl',
				resolve : {
							comissao : function() {
								return comissao;
							}
						}
			});
			
			modalInstance.result.then(function(comissao) {
				var excluir = true;
				if(isNaN(comissao)){
					excluir = false;
				}
		        for(var item in $scope.outros){
		        	if(excluir && $scope.outros[item].idComissao == comissao){
		        		$scope.outros.splice(item,1);
		        	}else{
			        	if($scope.outros[item].idComissao == comissao.id){
			        		$scope.outros.splice(item,1);
			        		$scope.outros[item] = comissao;
			        	}
		        	}
		        }
		        $scope.comissao = $scope.outros;
		    }, function (mensagem) {
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1 ){
		    		toastr.error(mensagem, 'Erro', {});
		    		error.dismiss();
		    	}
		    });
		};
	}

})();

/**
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.editar')
  		.controller('EditarPageCtrl', EditarPageCtrl);

	/** @ngInject */
	function EditarPageCtrl($scope, $state, $stateParams, $filter, $timeout, toastr, AuthService, ManutencaoService, AreasService) {
		
		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		if(!$stateParams.user || $stateParams.user == null){
			$scope.mensagem = {'erro':'Necessário informações do usuário!'};
			$state.go('manutencao.usuario');
			return;
		}
	    $scope.usuario = JSON.parse(atob($stateParams.user));
	    $scope.usuario.editarMatricula = true;
	    if(!$scope.usuario.matricula){
	    	$scope.usuario.editarMatricula = false;
	    }
	    $scope.usuario.editarCpf = true;
	    if(!$scope.usuario.cpf){
	    	$scope.usuario.editarCpf = false;
	    }
	    $scope.master = angular.copy($scope.usuario);
	    $scope.usuario.flag_ad = 0;
	    ManutencaoService.listarUsuarios($scope.usuario.id).then(function(result){
	    	$scope.usuario.flag_ad = parseInt(result[0].flag_ad);
	    	$scope.master.flag_ad = parseInt(result[0].flag_ad);
	    	if($scope.usuario.flag_ad == 1){
	    		if(!$scope.usuario.matricula){
			    	$scope.usuario.editarMatricula = false;
			    }
			    if(!$scope.usuario.cpf){
	    			$scope.usuario.editarCpf = false;
			    }
	    	}
	    });

	    $scope.usuario.areas = [];
	    ManutencaoService.listarAreas($scope.usuario.id).then(function(result){
			$scope.usuario.areas = [].concat( result.map(function(e,i){return e.id;}) );
			$scope.master.areas = [].concat( result.map(function(e,i){return e.id;}) );
		});

	    $scope.perfis = [{id:1,text:'Aluno'},{id:2,text:'Secretaria'},{id:3,text:'Administrador'},{id:4,text:'Docente'}];
	    ManutencaoService.listarPerfis().then(function(result){
			$scope.perfis = [].concat(result);
		});
		$scope.areas = [
			{id:5146,value:'Alergia e Imunopatologia',nomae_area:'5146 - Alergia e Imunopatologia'},
			{id:5152,value:'Anestesiologia',nomae_area:'5152 - Anestesiologia'},
			{id:5131,value:'Cardiologia',nomae_area:'5131 - Cardiologia'},
			{id:5170,value:'Cieências da Reabilitação',nomae_area:'5170 - Cieências da Reabilitação'}
		];
	    AreasService.listarAreasCod().then(function(result){
			$scope.areas = [].concat(result);
		});

		$scope.statusList = [{id:1,text:'Pendente'},{id:2,text:'Aprovado'}];
		ManutencaoService.listarStatus().then(function(result){
			$scope.statusList = [].concat(result);//[{id:1,text:'Pendente'},{id:2,text:'Aprovado'}];
		});

	    $scope.showProfiles = (function(user) {
	      if(user.perfil && $scope.perfis.length) {
	        var selected = $filter('filter')($scope.perfis, {id: user.perfil});
	        return selected.length ? selected[0].text : 'Não Configurado';
	      } else return 'Não Configurado'
	    });
	    $scope.usuario.perfilName = $scope.usuario.perfil;
	    //$scope.perfilName = $scope.showProfiles($scope.usuario);

	    $scope.salvar = (function(user){
	    	if(!user.perfil || user.perfil == null || user.perfil == ''){
	    		toastr.error('É necessário escolher um perfil', 'Erro', {});
	    		return false;
	    	}
	    	ManutencaoService.salvar(user).then(function(data){
	    		toastr.success(data.mensagem, 'Sucesso', {});
	    		$timeout(function(){
	    			$state.go('manutencao.usuario');
	    		},3000);
	    	}).catch(function(error){
	    		if(!error){error={erro:"Erro"};}
	    		toastr.error(error.erro, 'Erro', {});
	    		$scope.mensagem = error;
	    	});
	    });
	    $scope.cancelar = (function(){
	    	$scope.usuario = angular.copy($scope.master);
	    	$state.go('manutencao.usuario');
	    });
		$timeout(function(){
		    jQuery('#select-areas').selectpicker('destroy');
	      	jQuery('#select-areas').selectpicker('create');
        },1750);
	}

})();

/**
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.equipe')
  		.controller('ManutencaoEquipePageCtrl', ManutencaoEquipePageCtrl);

	/** @ngInject */
	function ManutencaoEquipePageCtrl($scope, $state, AuthService, ManutencaoService, $filter, editableOptions, editableThemes, toastr, $timeout, $uibModal) {
		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		$scope.busca = {};
		var dados = {nome:null,funcao:null};
		$scope.mensagem = null;

		ManutencaoService.listarEquipe(dados)
		.then(function(result) {
			$scope.outros = result;
			$scope.equipe = $scope.outros;
		}).catch(function(error){ return $scope.mensagem = error });

		var resp = ['backdrop click','escape key press'];
		
		$scope.pesquisar = function(){
			$scope.mensagem = null;
			var filtros = {
				nome: $scope.busca.nome,
				funcao: $scope.busca.funcao
			}
			ManutencaoService.listarEquipe(filtros).then(function(result){
				$scope.outros = result;
				$scope.equipe = $scope.outros;
			}).catch(function(error){
				$scope.mensagem = error;
				$scope.outros = [];
			});
		};

		$scope.limpar = function(){
			$scope.busca.nome = "";
			$scope.busca.funcao = "";
		};

		$scope.adicionar = function(){
			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/manutencao/widget/cadastroEquipe.html',
				size : 'md',
				controller : 'CadastroEquipePageCtrl',
			});
			
			modalInstance.result
			.then(function(equipe) {
		        $scope.outros.push(equipe);
		        $scope.equipe = $scope.outros;
		    }, function (mensagem) {
				if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1){
		    		toastr.error(mensagem, 'Erro', {});
		    		modalInstance.dismiss();
		    	}
		    });
		};

		$scope.editar = function( equipe ){
			var resetAll = angular.copy($scope.outros);
			// var reset = angular.copy(equipe);

			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/manutencao/widget/editarEquipe.html',
				size : 'md',
				controller : 'EditarEquipePageCtrl',
				resolve :{
					equipe : function() {
						return equipe;
					}
				}
			});
			
			modalInstance.result
			.then(function(equipe) {
				var remover = !isNaN(equipe);
				var atualizar = !(equipe instanceof Array) && Object(equipe).hasOwnProperty('id');
				if(remover || atualizar){  
					for(var item in $scope.outros){
						var excluir = remover && $scope.outros[item].id == equipe;
						var editar = atualizar  && $scope.outros[item].id == equipe.id;
						if( excluir ){
							$scope.outros.splice(item,1);
							break;
						}else if( editar ){
							$scope.outros[item] = equipe;
							break;
						}
					}
				}else{
					$scope.outros = resetAll;
				}
		        $scope.equipe = $scope.outros;
		    }, function (mensagem) {
				$scope.outros = resetAll;
				$scope.equipe = resetAll;
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1 ){
		    		toastr.error(mensagem, 'Erro', {});
		    		error.dismiss();
		    	}
		    });
		};
	}

})();

/**
 */

(function () {
	'use strict';

	angular.module('BlurAdmin.pages.manutencao.log')
		.controller('LogPageCtrl', LogPageCtrl);

	/** @ngInject */
	function LogPageCtrl($scope, $state, AuthService, ManutencaoService) { //, $filter, editableOptions, editableThemes, toastr, $timeout

		if (!AuthService.isAuthorizedToAccess([3])) { //secretaria,admin
			$scope.mensagem = { 'erro': 'Usuário não autorizado!' };
			$state.go('administrador.login');
			return;
		}
		$scope.smartTablePageSize = 100;
		//$scope.editableTableData = $scope.smartTableData.slice(0, 36);

		$scope.mensagem = null;
		$scope.outros = null;
		$scope.busca = {};

		// ManutencaoService.listarLog().then(function(result){
		// 	$scope.log = result;
		// 	$scope.outros = result;
		// }).catch(function(error){
		// 	$scope.mensagem = error;
		// });
		//busca.item_tipo
		//busca.item_categoria
		//busca.item_usuario
		$scope.tipos = [];
		$scope.categorias = [];
		$scope.usuarios = [];

		ManutencaoService.getTipos().then(function (result) {
			$scope.tipos = result;
			$scope.busca.tipo = result[0];
		});
		ManutencaoService.getCategorias().then(function (result) {
			$scope.categorias = result;
			$scope.busca.categoria = result[0];
		});
		ManutencaoService.getUsuarios().then(function (result) {
			$scope.usuarios = result;
			$scope.busca.usuario = result[0];
		});


		$scope.pesquisar = function () {
			$scope.mensagem = null;
			$scope.outros = null;
			$scope.log = null;

			ManutencaoService.listarLog($scope.busca).then(function (result) {
				$scope.log = result;
				$scope.outros = result;
			}).catch(function (error) {
				$scope.mensagem = error;
			});
		}
		$scope.limpar = function () {
			$scope.busca = {
				id: '',
				de: '',
				ate: '',
				tipo: { idTipo: 0, descricao: 'Todos os Tipos' },
				categoria: { idCategoria: 0, descricao: 'Todos as Categorias' },
				usuario: { idUsuario: 0, nome: 'Todos os Usuários' },
				ip: '',
			}
		}
	    /*
	    editableOptions.theme = 'bs3';
	    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
	    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
		*/

	}

})();

/**
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.portaria')
  		.controller('ManutencaoPortariaPageCtrl', ManutencaoPortariaPageCtrl);

	/** @ngInject */
	function ManutencaoPortariaPageCtrl($scope, $state, AuthService, ManutencaoService, toastr, $uibModal) {
		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}

		$scope.busca = {};
		var dados = {lei:null,descricao:null};
		$scope.mensagem = null;

		ManutencaoService.listarPortaria(dados)
		.then(function(result) {
			$scope.outros = result;
			$scope.portaria = $scope.outros;
		}).catch(function(error){ return $scope.mensagem = error });

		var resp = ['backdrop click','escape key press'];
		
		$scope.pesquisar = function(){
			$scope.mensagem = null;
			var filtros = {
				lei: $scope.busca.lei,
				descricao: $scope.busca.descricao
			}
			ManutencaoService.listarPortaria(filtros).then(function(result){
				$scope.outros = result;
				$scope.portaria = $scope.outros;
			}).catch(function(error){
				$scope.mensagem = error;
				$scope.outros = [];
			});
		};

		$scope.limpar = function(){
			$scope.busca.lei = "";
			$scope.busca.descricao = "";
		};

		$scope.adicionar =function(){
			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/manutencao/widget/cadastroPortaria.html',
				size : 'md',
				controller : 'CadastroPortariaPageCtrl',
			});
			
			modalInstance.result.then(function(portaria) {
		        $scope.outros.push(portaria);
		        $scope.portaria = $scope.outros;
		    }, function (mensagem) {
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1){
		    		toastr.error(mensagem, 'Erro', {});
		    		modalInstance.dismiss();
		    	}
		    });
		};

		$scope.editar = function( portaria ){
			var resetAll = angular.copy($scope.outros);
			// var reset = angular.copy(portaria);

			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/manutencao/widget/editarPortaria.html',
				size : 'md',
				controller : 'EditarPortariaPageCtrl',
				resolve : {
						portaria : function() {
							return portaria;
						}
					}
			});
			
			modalInstance.result
			.then(function(portaria) {
				var remover = !isNaN(portaria);
				var atualizar = !(portaria instanceof Array) && Object(portaria).hasOwnProperty('id');
				console.log(portaria,remover,atualizar);
				if (remover || atualizar) {
					for (var item in $scope.outros) {
						var excluir = remover && $scope.outros[item].id == portaria;
						var editar = atualizar && $scope.outros[item].id == portaria.id;
						if (excluir) {
							$scope.outros.splice(item, 1);
							break;
						} else if (editar) {
							$scope.outros[item] = portaria;
							break;
						}
					}
				} else {
					$scope.outros = resetAll;
				}
		        $scope.portaria = $scope.outros;
		    }, function (mensagem) {
				$scope.outros = resetAll;
				$scope.portaria = resetAll;
				if (typeof (mensagem) != 'undefined' && resp.indexOf(mensagem) == -1) {
					toastr.error(mensagem, 'Erro', {});
					error.dismiss();
				}
		    });
		};
	}

})();

/**
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.programas')
  		.controller('ProgramasPageCtrl', ProgramasPageCtrl);

	/** @ngInject */
	function ProgramasPageCtrl($scope, $state, AuthService, ManutencaoService, $filter, editableOptions, editableThemes, toastr, $uibModal ) {
		if( !AuthService.isAuthorizedToAccess([3]) ){ //secretaria,admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		var resp = ['backdrop click','escape key press'];
		$scope.busca = {};
		var dados = {codigo:null,programa:null};
		ManutencaoService.listarProgramas(dados).then(function(result){
			$scope.outros = result;
			$scope.programas = $scope.outros;
		}).catch(function(error){
			$scope.mensagem = {'aviso':"Nenhum Programa para exibir"};
			$scope.outros = [];
			$scope.programas = $scope.outros;
		});
		
				
		$scope.pesquisar = function(){
			$scope.mensagem = null;
			var filtros = {
				codigo: $scope.busca.codigo,
				programa: $scope.busca.programa
			}
			ManutencaoService.listarProgramas(filtros).then(function(result){
				$scope.outros = result;
				$scope.programas = $scope.outros;
			}).catch(function(error){
				$scope.mensagem = {'aviso':"Nenhum Programa para exibir!"};
				$scope.outros = [];
				$scope.programas = $scope.outros;
			});
		};

		$scope.limpar = function(){
			$scope.busca.codigo = "";
			$scope.busca.programa = "";
		};

		$scope.adicionar = function(){
			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/manutencao/widget/cadastroProgramas.html',
				size : 'md',
				controller : 'CadastroProgramasPageCtrl',
			});
			
			modalInstance.result.then(function(programas) {
		        $scope.outros.push(programas);
		        $scope.programas = $scope.outros;
		    }, function (mensagem) {
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1){
		    		toastr.error(mensagem, 'Erro', {});
		    		modalInstance.dismiss();
		    	}
		    });
		};

		$scope.editar = function( programas ){

			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/manutencao/widget/editarProgramas.html',
				size : 'md',
				controller : 'EditarProgramasPageCtrl',
				resolve : {
							programas : function() {
								programas.arg_cod = parseInt(programas.arg_cod);
								return programas;
							}
						}
			});
			
			modalInstance.result.then(function(programa) {
				var excluir = true;
				if(isNaN(programa)){
					excluir = false;
				}
		        for(var item in $scope.outros){
		        	if(excluir && $scope.outros[item].id == programa){
		        		$scope.outros.splice(item,1);
		        	}else{
			        	if($scope.outros[item].id == programa.id){
			        		$scope.outros[item] = programa;
			        	}
		        	}
		        }
		        $scope.programas = $scope.outros;
		        
		    }, function (mensagem) {
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1 ){
		    		toastr.error(mensagem, 'Erro', {});
		    		error.dismiss();
		    	}
		    });
		};
	}

})();

/**
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.usuario')
  		.controller('UsuarioPageCtrl', UsuarioPageCtrl);

	/** @ngInject */
	function UsuarioPageCtrl($scope, $state, AuthService, ManutencaoService, $filter, editableOptions, editableThemes, toastr, $timeout) {
		
		if( !AuthService.isAuthorizedToAccess([3]) ){ //secretaria,admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
	    //$scope.smartTablePageSize = 10;
	    //$scope.editableTableData = $scope.smartTableData.slice(0, 36);

		$scope.mensagem = null;
		$scope.outros = null;
		$scope.perfil = [{id:"1",text:'Aluno'},{id:"2",text:'Secretaria'},{id:"3",text:'Administrador'},{id:"4",text:'Docente'}];
	    ManutencaoService.listarPerfis().then(function(result){
			$scope.perfil = [].concat(result);
		});
		$scope.statusList = [{id:"1",text:'Pendente'},{id:"2",text:'Aprovado'}];;
		ManutencaoService.listarStatus().then(function(result){
			$scope.statusList = [].concat(result);//[{id:1,text:'Pendente'},{id:2,text:'Aprovado'}];
		});

		ManutencaoService.listarUsuarios().then(function(result){
			$scope.usuarios = [].concat(result);
			$scope.outros = [].concat(result);
			//console.log($scope.usuarios,$scope.outros);
		}).catch(function(error){
			$scope.mensagem = error;
		});

		$scope.showProfiles = (function(user) {
			if(user.perfil && $scope.perfil.length) {
				var selected = $filter('filter')($scope.perfil, {id: user.perfil});
				return selected.length ? selected[0].text : 'Não Configurado';
			} else 
				return 'Não Configurado'
	    });

	    $scope.aprovar = (function(item){
	    	$scope.mensagem = null;
	    	toastr.clear();
	    	if(!item.perfilUser){
	    		var msg = 'Defina o Perfil do usuário primeiro';
	    		toastr.error(msg, 'Erro', {});
	    		$scope.mensagem = {'erro':msg};
	    		return;
	    	}
	    	ManutencaoService.salvaPerfil(item).then(function(data){
	    		toastr.success(data.mensagem, 'Sucesso', {});
	    		ManutencaoService.listarUsuarios().then(function(result){
					$scope.usuarios = [].concat(result);
					$scope.outros = [].concat(result);
				});
	    	}).catch(function(error){
	    		$scope.mensagem = error;
	    	});
	    });
	    $scope.reprovar = (function(item){
	    	$scope.mensagem = null;
	    	toastr.clear();
	    	ManutencaoService.reprovarUsuario(item).then(function(data){
	    		toastr.success(data.mensagem, 'Sucesso', {});
	    		ManutencaoService.listarUsuarios().then(function(result){
					$scope.usuarios = [].concat(result);
					$scope.outros = [].concat(result);
				});
	    	}).catch(function(error){
	    		$scope.mensagem = error;
	    	});
	    });

	    $scope.addUsuarios = (function() {
	      $state.go('manutencao.adicionar');
	    });
	    $scope.editar = (function(item) {
	    	$state.transitionTo('manutencao.editar',{user:btoa(JSON.stringify(item))});
	    });
	    /*$scope.clearFilter = function () {
            $scope.filterName = '';
            $scope.filterLastName = '';
            $scope.filterMatricula = '';
            $scope.filterCPF = '';
            $scope.filterLogin = '';
            $scope.filterEmail = '';
            $scope.filterStatus = '';
            $scope.filterPerfil = '';

        }*/

	    editableOptions.theme = 'bs3';
	    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
	    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.comissao')
  		.controller('CadastroComissaoPageCtrl', CadastroComissaoPageCtrl);

	/** @ngInject */
	function CadastroComissaoPageCtrl($scope, fileReader, $state, AuthService, DocService, $uibModalInstance, toastr, ManutencaoService) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}

		$scope.comissao = {};
		$scope.cargos = null;
		ManutencaoService.listarCargosDefault().then(function(result){
			$scope.cargos = result;
			$scope.comissao.cargo = result[0];
		}).catch(function(error){
			$scope.mensagem = error;
		});

		$scope.adicionar = function(resp) {
			$scope.mensagem = null;
			
			ManutencaoService.adicionarComissao(resp).then(function(data) {
				if(data.comissao){
					$uibModalInstance.close(data.comissao);
				}else{
					$uibModalInstance.close(data.messages);
				}
				toastr.success("Comissão incluido com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				//toastr.error(erro, 'Erro', {});
			});
		};
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.equipe')
  		.controller('CadastroEquipePageCtrl', CadastroEquipePageCtrl);

	/** @ngInject */
	function CadastroEquipePageCtrl($scope, fileReader, $state, AuthService, $uibModalInstance, toastr, ManutencaoService, BOSS_JOB) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		$scope.cargo_chefe = BOSS_JOB;
		$scope.equipe = {};
		$scope.noFile = true;
		$scope.fileName = '';
		$scope.equipe.assinatura = null

		$scope.removeFile = function () {
			$scope.equipe.assinatura = null
			$scope.noFile = true;
			$scope.fileName = '';
			document.getElementById('uploadFile').value = '';
			$scope.progress = 0;
		};

		$scope.uploadFile = function () {
			$scope.progress = 0;
			var f = document.getElementById('uploadFile');
			f.click();
		};


		$scope.getFile = function (f) {
			$scope.progress = 0;
	        if(f) {
				fileReader.readAsDataURL(f,$scope)
				.then(function (resp) {
			        // Do stuff
			        $scope.equipe.assinatura = resp;
			        $scope.noFile = false;
			    }, function (err) {
			        // Do stuff
			        $scope.removeFile();
			        $scope.noFile = true;
			    });
			    if(f.name){
			    	$scope.fileName = f.name;
			    }
	        }
	    };
	 
	    $scope.$on("fileProgress", function(e, progress) {
	        $scope.progress = progress.loaded / progress.total;
		});
		
		$scope.adicionar = function(equipe) {
			$scope.mensagem = null;
			var isEmpty = Object.keys(equipe).length === 0 && equipe.constructor === Object;
			if( isEmpty || !equipe.cargo){
				$scope.mensagem = {'info':'Preencha ao menos o cargo'};
				return;
			}

			// if(!equipe.assinatura && BOSS_JOB || !$scope.cadastroForm.$valid ){
			// 	$scope.mensagem = {'erro':'Faça o upload do arquivo de assinatura'};
			// 	return;
			// }
			if ( equipe.assinatura ){
				var _dataName = $scope.fileName.split('.');
				var ext = _dataName[_dataName.length-1];
				
				if(['png','jpeg','jpg','svg'].indexOf(ext.toLowerCase()) === -1){
					$scope.mensagem = {'erro':'O arquivo deve ser uma imagem png,jpeg,jpg ou svg'};
					return;
				}
			}
			
			ManutencaoService.adicionarEquipe(equipe)
			.then(function(data) {
				if(data.messages){
					$uibModalInstance.close(data.messages);
				}else{
					$uibModalInstance.close(data);
				}
				toastr.success("Colaborador de equipe incluido com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				toastr.error(erro, 'Erro', {});
			});
		};
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.portaria')
  		.controller('CadastroPortariaPageCtrl', CadastroPortariaPageCtrl);

	/** @ngInject */
	function CadastroPortariaPageCtrl($scope, fileReader, $state, AuthService, DocService, $uibModalInstance, toastr, ManutencaoService) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}

		$scope.portaria = {};

		$scope.adicionar = function(resp) {
			$scope.mensagem = null;
			
			ManutencaoService.adicionarPortaria(resp).then(function(data) {
				if (data.messages) {
					$uibModalInstance.close(data.messages);
				} else {
					$uibModalInstance.close(data);
				}
				toastr.success("Portaria incluido com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				toastr.error(erro, 'Erro', {});
			});
		};
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.programas')
  		.controller('CadastroProgramasPageCtrl', CadastroProgramasPageCtrl);

	/** @ngInject */
	function CadastroProgramasPageCtrl($scope, $state, AuthService, $uibModalInstance, toastr, ManutencaoService) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		$scope.setProgram = function(codigo){
			$scope.programas.nome = "";
			ManutencaoService.listaProgramasAreas({areas:codigo})
			.then(function(areas) {
				if(areas.length === 1){
					$scope.programas.nome = areas[0].value;
				}
			})
			.catch(function() {	
				//
			});
		}
		$scope.adicionar = function(resp) {
			$scope.mensagem = null;
			
			ManutencaoService.adicionaProgramas(resp).then(function(data) {
				$uibModalInstance.close(data);
				toastr.success("Programa incluido com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				toastr.error(erro, 'Erro', {});
			});
		};
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.comissao')
  		.controller('EditarComissaoPageCtrl', EditarComissaoPageCtrl);

	/** @ngInject */
	function EditarComissaoPageCtrl($scope, fileReader, $state, AuthService, DocService, $uibModalInstance, toastr, comissao, ManutencaoService) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		$scope.comissao = comissao;

		$scope.cargos = null;
		ManutencaoService.listarCargosDefault().then(function(result){
			$scope.cargos = result;
			for(var i in $scope.cargos){
				if($scope.cargos[i].nome == $scope.comissao.nome){
					$scope.comissao.cargo = $scope.cargos[i];
					break;
				}
			}
			//$scope.busca.cargo = $scope.comissao.cargos[0];
		}).catch(function(error){
			$scope.mensagem = error;
		});

		$scope.enviar = function(resp) {
			$scope.mensagem = null;
			
			ManutencaoService.editarComissao(resp).then(function(comissao) {
				$uibModalInstance.close(comissao);
				toastr.success("Comissão atualizada com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				$uibModalInstance.close();
				toastr.error(erro, 'Erro', {});
			});
		};

		$scope.excluir = function(resp) {
			$scope.mensagem = null;
			
			ManutencaoService.excluirComissao(resp).then(function(comissao) {
				$uibModalInstance.close(comissao);
				toastr.success("Comissão incluido com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				$uibModalInstance.close();
				toastr.error(erro, 'Erro', {});
			});
		};
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.equipe')
  		.controller('EditarEquipePageCtrl', EditarEquipePageCtrl);

	/** @ngInject */
	function EditarEquipePageCtrl($scope, fileReader, $state, AuthService, $uibModal, $uibModalInstance, toastr, equipe, ManutencaoService, BOSS_JOB) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		$scope.cargo_chefe = BOSS_JOB;
		$scope.equipe = equipe;
		$scope.noFile = true;
		$scope.fileName = '';
		$scope.equipe.assinatura = null

		$scope.removeFile = function () {
			$scope.equipe.assinatura = null
			$scope.noFile = true;
			$scope.fileName = '';
			document.getElementById('uploadFile').value = '';
			$scope.progress = 0;
		};

		$scope.uploadFile = function () {
			$scope.progress = 0;
			var f = document.getElementById('uploadFile');
			f.click();
		};


		$scope.getFile = function (f) {
			$scope.progress = 0;
	        if(f) {
				fileReader.readAsDataURL(f,$scope)
				.then(function (resp) {
			        // Do stuff
			        $scope.equipe.assinatura = resp;
			        $scope.noFile = false;
			    }, function (err) {
			        // Do stuff
			        $scope.removeFile();
			        $scope.noFile = true;
			    });
			    if(f.name){
			    	$scope.fileName = f.name;
			    }
	        }
	    };
	 
	    $scope.$on("fileProgress", function(e, progress) {
	        $scope.progress = progress.loaded / progress.total;
		});

		$scope.enviar = function(resp) {
			$scope.mensagem = null;
			// if ((!resp.assinatura && BOSS_JOB) || !$scope.cadastroForm.$valid){
			// 	$scope.mensagem = {'erro':'Faça o upload do arquivo de assinatura'};
			// 	return;
			// }
			if ( resp.assinatura ){
				var _dataName = $scope.fileName.split('.');
				var ext = _dataName[_dataName.length-1];
	
				if(['png','jpeg','jpg','svg'].indexOf(ext.toLowerCase()) === -1){
					$scope.mensagem = {'erro':'O arquivo deve ser uma imagem png,jpeg,jpg ou svg'};
					return;
				}
			}
			
			ManutencaoService.editarEquipe(resp)
			.then(function(equipe)  {
				toastr.success("Colaborador de equipe atualizado com sucesso", 'Sucesso', {});
				$uibModalInstance.close(equipe);
			})
			.catch(function(erro) {
				toastr.error(erro, 'Erro', {});
				$uibModalInstance.close($scope.reset);
			});
		};

		$scope.excluir = function(resp) {
			$scope.mensagem = null;
			var isEmpty = Object.keys(equipe).length === 0 && equipe.constructor === Object;
			if( isEmpty || equipe.cargo == ''){
				$scope.mensagem = {'info':'Preencha ao menos o cargo'};
				return;
			}
			$uibModal.open({
				size: 'sm',
				template: '<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Excluir</span></div><div class="modal-body text-center">Tem certeza que deseja excluir este colaborador de equipe?</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$close()">Sim</button><button class="btn btn-default" ng-click="$dismiss()">Não</button></div></div>',
				animation : true,
			}).result.then(function(){
				ManutencaoService.excluirEquipe(resp)
				.then(function(equipe) {
					toastr.success("Colaborador de equipe excluido com sucesso", 'Sucesso', {});
					$uibModalInstance.close(equipe);
				})
				.catch(function(erro) {
					toastr.error(erro, 'Erro', {});
					$uibModalInstance.close($scope.reset);
				});
			}).catch(function(){
				$uibModalInstance.close($scope.reset);
				//console.log('Nao confirmado');
			});
			
		};
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.portaria')
  		.controller('EditarPortariaPageCtrl', EditarPortariaPageCtrl);

	/** @ngInject */
	function EditarPortariaPageCtrl($scope, $state, AuthService, $uibModal, $uibModalInstance, toastr, portaria, ManutencaoService) {
		
		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		portaria.data = portaria.data ? moment(portaria.data).toDate():null;
		$scope.portaria = portaria;

		$scope.enviar = function(resp) {
			$scope.mensagem = null;
			
			ManutencaoService.editarPortaria(resp)
			.then(function(portaria) {
				toastr.success("editarPortaria atualizada com sucesso", 'Sucesso', {});
				$uibModalInstance.close(portaria);
			})
			.catch(function(erro) {
				toastr.error(erro, 'Erro', {});
				$uibModalInstance.close($scope.reset);
			});
		};

		$scope.excluir = function(resp) {
			$scope.mensagem = null;
			$uibModal.open({
				size: 'sm',
				template: '<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Excluir</span></div><div class="modal-body text-center">Tem certeza que deseja excluir esta portaria?</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$close()">Sim</button><button class="btn btn-default" ng-click="$dismiss()">Não</button></div></div>',
				animation : true,
			}).result.then(function(){
				ManutencaoService.excluirPortaria(resp).then(function(portaria) {
					$uibModalInstance.close(portaria);
					toastr.success("editarPortaria excluida com sucesso", 'Sucesso', {});
				})
				.catch(function(erro) {
					toastr.error(erro, 'Erro', {});
					$uibModalInstance.close($scope.reset);
				});
			}).catch(function(){
				$uibModalInstance.close($scope.reset);
				//console.log('Nao confirmado');
			});

		};
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.programas')
  		.controller('EditarProgramasPageCtrl', EditarProgramasPageCtrl);

	/** @ngInject */
	function EditarProgramasPageCtrl($scope, $state, AuthService, $uibModalInstance, toastr, programas, ManutencaoService) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}

		var _programa = {
			id: programas.id,
			codigo: programas.arg_cod,
			nome: programas.arg_desc.trim(),
			coordenador: programas.arl_coord.trim(),
			secretaria: programas.arl_secret,
			local: programas.arl_local,
			endereco: programas.arl_end,
			telefone: programas.arl_tel,
			email: programas.arl_email,
		}
		$scope.programas = _programa;

		$scope.setProgram = function(codigo){
			$scope.programas.nome = "";
			ManutencaoService.listaProgramasAreas({areas:codigo})
			.then(function(areas) {
				if(areas.length === 1){
					$scope.programas.nome = areas[0].value;
				}
			})
			.catch(function() {	
				//
			});
		}

		
		$scope.enviar = function(resp) {
			$scope.mensagem = null;
			ManutencaoService.editaProgramas(resp).then(function(programa) {
				$uibModalInstance.close(programa[0]);
				toastr.success("Programa atualizado com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				$uibModalInstance.close();
				toastr.error(erro, 'Erro', {});
			});
		};

		$scope.excluir = function(resp) {
			$scope.mensagem = null;
			
			ManutencaoService.excluiProgramas(resp).then(function(programa) {
				$uibModalInstance.close(programa);
				toastr.success("Programa excluido com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				$uibModalInstance.close();
				toastr.error(erro, 'Erro', {});
			});
		};
	}

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('GmapPageCtrl', GmapPageCtrl);

  /** @ngInject */
  function GmapPageCtrl($timeout) {
    function initialize() {
      var mapCanvas = document.getElementById('google-maps');
      var mapOptions = {
        center: new google.maps.LatLng(44.5403, -78.5463),
        zoom: 8,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
      var map = new google.maps.Map(mapCanvas, mapOptions);
    }

    $timeout(function(){
      initialize();
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('LeafletPageCtrl', LeafletPageCtrl);

  /** @ngInject */
  function LeafletPageCtrl($timeout) {
    function initialize() {
      L.Icon.Default.imagePath = 'assets/img/theme/vendor/leaflet/dist/images';
      var map = L.map(document.getElementById('leaflet-map')).setView([51.505, -0.09], 13);
      L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      L.marker([51.5, -0.09]).addTo(map)
          .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
          .openPopup();
    }

    $timeout(function(){
      initialize();
    }, 100);

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('MapBubblePageCtrl', MapBubblePageCtrl);

  /** @ngInject */
  function MapBubblePageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    var latlong = {};
    latlong['AD'] = {'latitude': 42.5, 'longitude': 1.5};
    latlong['AE'] = {'latitude': 24, 'longitude': 54};
    latlong['AF'] = {'latitude': 33, 'longitude': 65};
    latlong['AG'] = {'latitude': 17.05, 'longitude': -61.8};
    latlong['AI'] = {'latitude': 18.25, 'longitude': -63.1667};
    latlong['AL'] = {'latitude': 41, 'longitude': 20};
    latlong['AM'] = {'latitude': 40, 'longitude': 45};
    latlong['AN'] = {'latitude': 12.25, 'longitude': -68.75};
    latlong['AO'] = {'latitude': -12.5, 'longitude': 18.5};
    latlong['AP'] = {'latitude': 35, 'longitude': 105};
    latlong['AQ'] = {'latitude': -90, 'longitude': 0};
    latlong['AR'] = {'latitude': -34, 'longitude': -64};
    latlong['AS'] = {'latitude': -14.3333, 'longitude': -170};
    latlong['AT'] = {'latitude': 47.3333, 'longitude': 13.3333};
    latlong['AU'] = {'latitude': -27, 'longitude': 133};
    latlong['AW'] = {'latitude': 12.5, 'longitude': -69.9667};
    latlong['AZ'] = {'latitude': 40.5, 'longitude': 47.5};
    latlong['BA'] = {'latitude': 44, 'longitude': 18};
    latlong['BB'] = {'latitude': 13.1667, 'longitude': -59.5333};
    latlong['BD'] = {'latitude': 24, 'longitude': 90};
    latlong['BE'] = {'latitude': 50.8333, 'longitude': 4};
    latlong['BF'] = {'latitude': 13, 'longitude': -2};
    latlong['BG'] = {'latitude': 43, 'longitude': 25};
    latlong['BH'] = {'latitude': 26, 'longitude': 50.55};
    latlong['BI'] = {'latitude': -3.5, 'longitude': 30};
    latlong['BJ'] = {'latitude': 9.5, 'longitude': 2.25};
    latlong['BM'] = {'latitude': 32.3333, 'longitude': -64.75};
    latlong['BN'] = {'latitude': 4.5, 'longitude': 114.6667};
    latlong['BO'] = {'latitude': -17, 'longitude': -65};
    latlong['BR'] = {'latitude': -10, 'longitude': -55};
    latlong['BS'] = {'latitude': 24.25, 'longitude': -76};
    latlong['BT'] = {'latitude': 27.5, 'longitude': 90.5};
    latlong['BV'] = {'latitude': -54.4333, 'longitude': 3.4};
    latlong['BW'] = {'latitude': -22, 'longitude': 24};
    latlong['BY'] = {'latitude': 53, 'longitude': 28};
    latlong['BZ'] = {'latitude': 17.25, 'longitude': -88.75};
    latlong['CA'] = {'latitude': 54, 'longitude': -100};
    latlong['CC'] = {'latitude': -12.5, 'longitude': 96.8333};
    latlong['CD'] = {'latitude': 0, 'longitude': 25};
    latlong['CF'] = {'latitude': 7, 'longitude': 21};
    latlong['CG'] = {'latitude': -1, 'longitude': 15};
    latlong['CH'] = {'latitude': 47, 'longitude': 8};
    latlong['CI'] = {'latitude': 8, 'longitude': -5};
    latlong['CK'] = {'latitude': -21.2333, 'longitude': -159.7667};
    latlong['CL'] = {'latitude': -30, 'longitude': -71};
    latlong['CM'] = {'latitude': 6, 'longitude': 12};
    latlong['CN'] = {'latitude': 35, 'longitude': 105};
    latlong['CO'] = {'latitude': 4, 'longitude': -72};
    latlong['CR'] = {'latitude': 10, 'longitude': -84};
    latlong['CU'] = {'latitude': 21.5, 'longitude': -80};
    latlong['CV'] = {'latitude': 16, 'longitude': -24};
    latlong['CX'] = {'latitude': -10.5, 'longitude': 105.6667};
    latlong['CY'] = {'latitude': 35, 'longitude': 33};
    latlong['CZ'] = {'latitude': 49.75, 'longitude': 15.5};
    latlong['DE'] = {'latitude': 51, 'longitude': 9};
    latlong['DJ'] = {'latitude': 11.5, 'longitude': 43};
    latlong['DK'] = {'latitude': 56, 'longitude': 10};
    latlong['DM'] = {'latitude': 15.4167, 'longitude': -61.3333};
    latlong['DO'] = {'latitude': 19, 'longitude': -70.6667};
    latlong['DZ'] = {'latitude': 28, 'longitude': 3};
    latlong['EC'] = {'latitude': -2, 'longitude': -77.5};
    latlong['EE'] = {'latitude': 59, 'longitude': 26};
    latlong['EG'] = {'latitude': 27, 'longitude': 30};
    latlong['EH'] = {'latitude': 24.5, 'longitude': -13};
    latlong['ER'] = {'latitude': 15, 'longitude': 39};
    latlong['ES'] = {'latitude': 40, 'longitude': -4};
    latlong['ET'] = {'latitude': 8, 'longitude': 38};
    latlong['EU'] = {'latitude': 47, 'longitude': 8};
    latlong['FI'] = {'latitude': 62, 'longitude': 26};
    latlong['FJ'] = {'latitude': -18, 'longitude': 175};
    latlong['FK'] = {'latitude': -51.75, 'longitude': -59};
    latlong['FM'] = {'latitude': 6.9167, 'longitude': 158.25};
    latlong['FO'] = {'latitude': 62, 'longitude': -7};
    latlong['FR'] = {'latitude': 46, 'longitude': 2};
    latlong['GA'] = {'latitude': -1, 'longitude': 11.75};
    latlong['GB'] = {'latitude': 54, 'longitude': -2};
    latlong['GD'] = {'latitude': 12.1167, 'longitude': -61.6667};
    latlong['GE'] = {'latitude': 42, 'longitude': 43.5};
    latlong['GF'] = {'latitude': 4, 'longitude': -53};
    latlong['GH'] = {'latitude': 8, 'longitude': -2};
    latlong['GI'] = {'latitude': 36.1833, 'longitude': -5.3667};
    latlong['GL'] = {'latitude': 72, 'longitude': -40};
    latlong['GM'] = {'latitude': 13.4667, 'longitude': -16.5667};
    latlong['GN'] = {'latitude': 11, 'longitude': -10};
    latlong['GP'] = {'latitude': 16.25, 'longitude': -61.5833};
    latlong['GQ'] = {'latitude': 2, 'longitude': 10};
    latlong['GR'] = {'latitude': 39, 'longitude': 22};
    latlong['GS'] = {'latitude': -54.5, 'longitude': -37};
    latlong['GT'] = {'latitude': 15.5, 'longitude': -90.25};
    latlong['GU'] = {'latitude': 13.4667, 'longitude': 144.7833};
    latlong['GW'] = {'latitude': 12, 'longitude': -15};
    latlong['GY'] = {'latitude': 5, 'longitude': -59};
    latlong['HK'] = {'latitude': 22.25, 'longitude': 114.1667};
    latlong['HM'] = {'latitude': -53.1, 'longitude': 72.5167};
    latlong['HN'] = {'latitude': 15, 'longitude': -86.5};
    latlong['HR'] = {'latitude': 45.1667, 'longitude': 15.5};
    latlong['HT'] = {'latitude': 19, 'longitude': -72.4167};
    latlong['HU'] = {'latitude': 47, 'longitude': 20};
    latlong['ID'] = {'latitude': -5, 'longitude': 120};
    latlong['IE'] = {'latitude': 53, 'longitude': -8};
    latlong['IL'] = {'latitude': 31.5, 'longitude': 34.75};
    latlong['IN'] = {'latitude': 20, 'longitude': 77};
    latlong['IO'] = {'latitude': -6, 'longitude': 71.5};
    latlong['IQ'] = {'latitude': 33, 'longitude': 44};
    latlong['IR'] = {'latitude': 32, 'longitude': 53};
    latlong['IS'] = {'latitude': 65, 'longitude': -18};
    latlong['IT'] = {'latitude': 42.8333, 'longitude': 12.8333};
    latlong['JM'] = {'latitude': 18.25, 'longitude': -77.5};
    latlong['JO'] = {'latitude': 31, 'longitude': 36};
    latlong['JP'] = {'latitude': 36, 'longitude': 138};
    latlong['KE'] = {'latitude': 1, 'longitude': 38};
    latlong['KG'] = {'latitude': 41, 'longitude': 75};
    latlong['KH'] = {'latitude': 13, 'longitude': 105};
    latlong['KI'] = {'latitude': 1.4167, 'longitude': 173};
    latlong['KM'] = {'latitude': -12.1667, 'longitude': 44.25};
    latlong['KN'] = {'latitude': 17.3333, 'longitude': -62.75};
    latlong['KP'] = {'latitude': 40, 'longitude': 127};
    latlong['KR'] = {'latitude': 37, 'longitude': 127.5};
    latlong['KW'] = {'latitude': 29.3375, 'longitude': 47.6581};
    latlong['KY'] = {'latitude': 19.5, 'longitude': -80.5};
    latlong['KZ'] = {'latitude': 48, 'longitude': 68};
    latlong['LA'] = {'latitude': 18, 'longitude': 105};
    latlong['LB'] = {'latitude': 33.8333, 'longitude': 35.8333};
    latlong['LC'] = {'latitude': 13.8833, 'longitude': -61.1333};
    latlong['LI'] = {'latitude': 47.1667, 'longitude': 9.5333};
    latlong['LK'] = {'latitude': 7, 'longitude': 81};
    latlong['LR'] = {'latitude': 6.5, 'longitude': -9.5};
    latlong['LS'] = {'latitude': -29.5, 'longitude': 28.5};
    latlong['LT'] = {'latitude': 55, 'longitude': 24};
    latlong['LU'] = {'latitude': 49.75, 'longitude': 6};
    latlong['LV'] = {'latitude': 57, 'longitude': 25};
    latlong['LY'] = {'latitude': 25, 'longitude': 17};
    latlong['MA'] = {'latitude': 32, 'longitude': -5};
    latlong['MC'] = {'latitude': 43.7333, 'longitude': 7.4};
    latlong['MD'] = {'latitude': 47, 'longitude': 29};
    latlong['ME'] = {'latitude': 42.5, 'longitude': 19.4};
    latlong['MG'] = {'latitude': -20, 'longitude': 47};
    latlong['MH'] = {'latitude': 9, 'longitude': 168};
    latlong['MK'] = {'latitude': 41.8333, 'longitude': 22};
    latlong['ML'] = {'latitude': 17, 'longitude': -4};
    latlong['MM'] = {'latitude': 22, 'longitude': 98};
    latlong['MN'] = {'latitude': 46, 'longitude': 105};
    latlong['MO'] = {'latitude': 22.1667, 'longitude': 113.55};
    latlong['MP'] = {'latitude': 15.2, 'longitude': 145.75};
    latlong['MQ'] = {'latitude': 14.6667, 'longitude': -61};
    latlong['MR'] = {'latitude': 20, 'longitude': -12};
    latlong['MS'] = {'latitude': 16.75, 'longitude': -62.2};
    latlong['MT'] = {'latitude': 35.8333, 'longitude': 14.5833};
    latlong['MU'] = {'latitude': -20.2833, 'longitude': 57.55};
    latlong['MV'] = {'latitude': 3.25, 'longitude': 73};
    latlong['MW'] = {'latitude': -13.5, 'longitude': 34};
    latlong['MX'] = {'latitude': 23, 'longitude': -102};
    latlong['MY'] = {'latitude': 2.5, 'longitude': 112.5};
    latlong['MZ'] = {'latitude': -18.25, 'longitude': 35};
    latlong['NA'] = {'latitude': -22, 'longitude': 17};
    latlong['NC'] = {'latitude': -21.5, 'longitude': 165.5};
    latlong['NE'] = {'latitude': 16, 'longitude': 8};
    latlong['NF'] = {'latitude': -29.0333, 'longitude': 167.95};
    latlong['NG'] = {'latitude': 10, 'longitude': 8};
    latlong['NI'] = {'latitude': 13, 'longitude': -85};
    latlong['NL'] = {'latitude': 52.5, 'longitude': 5.75};
    latlong['NO'] = {'latitude': 62, 'longitude': 10};
    latlong['NP'] = {'latitude': 28, 'longitude': 84};
    latlong['NR'] = {'latitude': -0.5333, 'longitude': 166.9167};
    latlong['NU'] = {'latitude': -19.0333, 'longitude': -169.8667};
    latlong['NZ'] = {'latitude': -41, 'longitude': 174};
    latlong['OM'] = {'latitude': 21, 'longitude': 57};
    latlong['PA'] = {'latitude': 9, 'longitude': -80};
    latlong['PE'] = {'latitude': -10, 'longitude': -76};
    latlong['PF'] = {'latitude': -15, 'longitude': -140};
    latlong['PG'] = {'latitude': -6, 'longitude': 147};
    latlong['PH'] = {'latitude': 13, 'longitude': 122};
    latlong['PK'] = {'latitude': 30, 'longitude': 70};
    latlong['PL'] = {'latitude': 52, 'longitude': 20};
    latlong['PM'] = {'latitude': 46.8333, 'longitude': -56.3333};
    latlong['PR'] = {'latitude': 18.25, 'longitude': -66.5};
    latlong['PS'] = {'latitude': 32, 'longitude': 35.25};
    latlong['PT'] = {'latitude': 39.5, 'longitude': -8};
    latlong['PW'] = {'latitude': 7.5, 'longitude': 134.5};
    latlong['PY'] = {'latitude': -23, 'longitude': -58};
    latlong['QA'] = {'latitude': 25.5, 'longitude': 51.25};
    latlong['RE'] = {'latitude': -21.1, 'longitude': 55.6};
    latlong['RO'] = {'latitude': 46, 'longitude': 25};
    latlong['RS'] = {'latitude': 44, 'longitude': 21};
    latlong['RU'] = {'latitude': 60, 'longitude': 100};
    latlong['RW'] = {'latitude': -2, 'longitude': 30};
    latlong['SA'] = {'latitude': 25, 'longitude': 45};
    latlong['SB'] = {'latitude': -8, 'longitude': 159};
    latlong['SC'] = {'latitude': -4.5833, 'longitude': 55.6667};
    latlong['SD'] = {'latitude': 15, 'longitude': 30};
    latlong['SE'] = {'latitude': 62, 'longitude': 15};
    latlong['SG'] = {'latitude': 1.3667, 'longitude': 103.8};
    latlong['SH'] = {'latitude': -15.9333, 'longitude': -5.7};
    latlong['SI'] = {'latitude': 46, 'longitude': 15};
    latlong['SJ'] = {'latitude': 78, 'longitude': 20};
    latlong['SK'] = {'latitude': 48.6667, 'longitude': 19.5};
    latlong['SL'] = {'latitude': 8.5, 'longitude': -11.5};
    latlong['SM'] = {'latitude': 43.7667, 'longitude': 12.4167};
    latlong['SN'] = {'latitude': 14, 'longitude': -14};
    latlong['SO'] = {'latitude': 10, 'longitude': 49};
    latlong['SR'] = {'latitude': 4, 'longitude': -56};
    latlong['ST'] = {'latitude': 1, 'longitude': 7};
    latlong['SV'] = {'latitude': 13.8333, 'longitude': -88.9167};
    latlong['SY'] = {'latitude': 35, 'longitude': 38};
    latlong['SZ'] = {'latitude': -26.5, 'longitude': 31.5};
    latlong['TC'] = {'latitude': 21.75, 'longitude': -71.5833};
    latlong['TD'] = {'latitude': 15, 'longitude': 19};
    latlong['TF'] = {'latitude': -43, 'longitude': 67};
    latlong['TG'] = {'latitude': 8, 'longitude': 1.1667};
    latlong['TH'] = {'latitude': 15, 'longitude': 100};
    latlong['TJ'] = {'latitude': 39, 'longitude': 71};
    latlong['TK'] = {'latitude': -9, 'longitude': -172};
    latlong['TM'] = {'latitude': 40, 'longitude': 60};
    latlong['TN'] = {'latitude': 34, 'longitude': 9};
    latlong['TO'] = {'latitude': -20, 'longitude': -175};
    latlong['TR'] = {'latitude': 39, 'longitude': 35};
    latlong['TT'] = {'latitude': 11, 'longitude': -61};
    latlong['TV'] = {'latitude': -8, 'longitude': 178};
    latlong['TW'] = {'latitude': 23.5, 'longitude': 121};
    latlong['TZ'] = {'latitude': -6, 'longitude': 35};
    latlong['UA'] = {'latitude': 49, 'longitude': 32};
    latlong['UG'] = {'latitude': 1, 'longitude': 32};
    latlong['UM'] = {'latitude': 19.2833, 'longitude': 166.6};
    latlong['US'] = {'latitude': 38, 'longitude': -97};
    latlong['UY'] = {'latitude': -33, 'longitude': -56};
    latlong['UZ'] = {'latitude': 41, 'longitude': 64};
    latlong['VA'] = {'latitude': 41.9, 'longitude': 12.45};
    latlong['VC'] = {'latitude': 13.25, 'longitude': -61.2};
    latlong['VE'] = {'latitude': 8, 'longitude': -66};
    latlong['VG'] = {'latitude': 18.5, 'longitude': -64.5};
    latlong['VI'] = {'latitude': 18.3333, 'longitude': -64.8333};
    latlong['VN'] = {'latitude': 16, 'longitude': 106};
    latlong['VU'] = {'latitude': -16, 'longitude': 167};
    latlong['WF'] = {'latitude': -13.3, 'longitude': -176.2};
    latlong['WS'] = {'latitude': -13.5833, 'longitude': -172.3333};
    latlong['YE'] = {'latitude': 15, 'longitude': 48};
    latlong['YT'] = {'latitude': -12.8333, 'longitude': 45.1667};
    latlong['ZA'] = {'latitude': -29, 'longitude': 24};
    latlong['ZM'] = {'latitude': -15, 'longitude': 30};
    latlong['ZW'] = {'latitude': -20, 'longitude': 30};

    var mapData = [
      {'code': 'AF', 'name': 'Afghanistan', 'value': 32358260, 'color': layoutColors.primaryDark},
      {'code': 'AL', 'name': 'Albania', 'value': 3215988, 'color': layoutColors.warning},
      {'code': 'DZ', 'name': 'Algeria', 'value': 35980193, 'color': layoutColors.danger},
      {'code': 'AO', 'name': 'Angola', 'value': 19618432, 'color': layoutColors.danger},
      {'code': 'AR', 'name': 'Argentina', 'value': 40764561, 'color': layoutColors.success},
      {'code': 'AM', 'name': 'Armenia', 'value': 3100236, 'color': layoutColors.warning},
      {'code': 'AU', 'name': 'Australia', 'value': 22605732, 'color': layoutColors.warningDark},
      {'code': 'AT', 'name': 'Austria', 'value': 8413429, 'color': layoutColors.warning},
      {'code': 'AZ', 'name': 'Azerbaijan', 'value': 9306023, 'color': layoutColors.warning},
      {'code': 'BH', 'name': 'Bahrain', 'value': 1323535, 'color': layoutColors.primaryDark},
      {'code': 'BD', 'name': 'Bangladesh', 'value': 150493658, 'color': layoutColors.primaryDark},
      {'code': 'BY', 'name': 'Belarus', 'value': 9559441, 'color': layoutColors.warning},
      {'code': 'BE', 'name': 'Belgium', 'value': 10754056, 'color': layoutColors.warning},
      {'code': 'BJ', 'name': 'Benin', 'value': 9099922, 'color': layoutColors.danger},
      {'code': 'BT', 'name': 'Bhutan', 'value': 738267, 'color': layoutColors.primaryDark},
      {'code': 'BO', 'name': 'Bolivia', 'value': 10088108, 'color': layoutColors.success},
      {'code': 'BA', 'name': 'Bosnia and Herzegovina', 'value': 3752228, 'color': layoutColors.warning},
      {'code': 'BW', 'name': 'Botswana', 'value': 2030738, 'color': layoutColors.danger},
      {'code': 'BR', 'name': 'Brazil', 'value': 196655014, 'color': layoutColors.success},
      {'code': 'BN', 'name': 'Brunei', 'value': 405938, 'color': layoutColors.primaryDark},
      {'code': 'BG', 'name': 'Bulgaria', 'value': 7446135, 'color': layoutColors.warning},
      {'code': 'BF', 'name': 'Burkina Faso', 'value': 16967845, 'color': layoutColors.danger},
      {'code': 'BI', 'name': 'Burundi', 'value': 8575172, 'color': layoutColors.danger},
      {'code': 'KH', 'name': 'Cambodia', 'value': 14305183, 'color': layoutColors.primaryDark},
      {'code': 'CM', 'name': 'Cameroon', 'value': 20030362, 'color': layoutColors.danger},
      {'code': 'CA', 'name': 'Canada', 'value': 34349561, 'color': layoutColors.primary},
      {'code': 'CV', 'name': 'Cape Verde', 'value': 500585, 'color': layoutColors.danger},
      {'code': 'CF', 'name': 'Central African Rep.', 'value': 4486837, 'color': layoutColors.danger},
      {'code': 'TD', 'name': 'Chad', 'value': 11525496, 'color': layoutColors.danger},
      {'code': 'CL', 'name': 'Chile', 'value': 17269525, 'color': layoutColors.success},
      {'code': 'CN', 'name': 'China', 'value': 1347565324, 'color': layoutColors.primaryDark},
      {'code': 'CO', 'name': 'Colombia', 'value': 46927125, 'color': layoutColors.success},
      {'code': 'KM', 'name': 'Comoros', 'value': 753943, 'color': layoutColors.danger},
      {'code': 'CD', 'name': 'Congo, Dem. Rep.', 'value': 67757577, 'color': layoutColors.danger},
      {'code': 'CG', 'name': 'Congo, Rep.', 'value': 4139748, 'color': layoutColors.danger},
      {'code': 'CR', 'name': 'Costa Rica', 'value': 4726575, 'color': layoutColors.primary},
      {'code': 'CI', 'name': 'Cote d\'Ivoire', 'value': 20152894, 'color': layoutColors.danger},
      {'code': 'HR', 'name': 'Croatia', 'value': 4395560, 'color': layoutColors.warning},
      {'code': 'CU', 'name': 'Cuba', 'value': 11253665, 'color': layoutColors.primary},
      {'code': 'CY', 'name': 'Cyprus', 'value': 1116564, 'color': layoutColors.warning},
      {'code': 'CZ', 'name': 'Czech Rep.', 'value': 10534293, 'color': layoutColors.warning},
      {'code': 'DK', 'name': 'Denmark', 'value': 5572594, 'color': layoutColors.warning},
      {'code': 'DJ', 'name': 'Djibouti', 'value': 905564, 'color': layoutColors.danger},
      {'code': 'DO', 'name': 'Dominican Rep.', 'value': 10056181, 'color': layoutColors.primary},
      {'code': 'EC', 'name': 'Ecuador', 'value': 14666055, 'color': layoutColors.success},
      {'code': 'EG', 'name': 'Egypt', 'value': 82536770, 'color': layoutColors.danger},
      {'code': 'SV', 'name': 'El Salvador', 'value': 6227491, 'color': layoutColors.primary},
      {'code': 'GQ', 'name': 'Equatorial Guinea', 'value': 720213, 'color': layoutColors.danger},
      {'code': 'ER', 'name': 'Eritrea', 'value': 5415280, 'color': layoutColors.danger},
      {'code': 'EE', 'name': 'Estonia', 'value': 1340537, 'color': layoutColors.warning},
      {'code': 'ET', 'name': 'Ethiopia', 'value': 84734262, 'color': layoutColors.danger},
      {'code': 'FJ', 'name': 'Fiji', 'value': 868406, 'color': layoutColors.warningDark},
      {'code': 'FI', 'name': 'Finland', 'value': 5384770, 'color': layoutColors.warning},
      {'code': 'FR', 'name': 'France', 'value': 63125894, 'color': layoutColors.warning},
      {'code': 'GA', 'name': 'Gabon', 'value': 1534262, 'color': layoutColors.danger},
      {'code': 'GM', 'name': 'Gambia', 'value': 1776103, 'color': layoutColors.danger},
      {'code': 'GE', 'name': 'Georgia', 'value': 4329026, 'color': layoutColors.warning},
      {'code': 'DE', 'name': 'Germany', 'value': 82162512, 'color': layoutColors.warning},
      {'code': 'GH', 'name': 'Ghana', 'value': 24965816, 'color': layoutColors.danger},
      {'code': 'GR', 'name': 'Greece', 'value': 11390031, 'color': layoutColors.warning},
      {'code': 'GT', 'name': 'Guatemala', 'value': 14757316, 'color': layoutColors.primary},
      {'code': 'GN', 'name': 'Guinea', 'value': 10221808, 'color': layoutColors.danger},
      {'code': 'GW', 'name': 'Guinea-Bissau', 'value': 1547061, 'color': layoutColors.danger},
      {'code': 'GY', 'name': 'Guyana', 'value': 756040, 'color': layoutColors.success},
      {'code': 'HT', 'name': 'Haiti', 'value': 10123787, 'color': layoutColors.primary},
      {'code': 'HN', 'name': 'Honduras', 'value': 7754687, 'color': layoutColors.primary},
      {'code': 'HK', 'name': 'Hong Kong, China', 'value': 7122187, 'color': layoutColors.primaryDark},
      {'code': 'HU', 'name': 'Hungary', 'value': 9966116, 'color': layoutColors.warning},
      {'code': 'IS', 'name': 'Iceland', 'value': 324366, 'color': layoutColors.warning},
      {'code': 'IN', 'name': 'India', 'value': 1241491960, 'color': layoutColors.primaryDark},
      {'code': 'ID', 'name': 'Indonesia', 'value': 242325638, 'color': layoutColors.primaryDark},
      {'code': 'IR', 'name': 'Iran', 'value': 74798599, 'color': layoutColors.primaryDark},
      {'code': 'IQ', 'name': 'Iraq', 'value': 32664942, 'color': layoutColors.primaryDark},
      {'code': 'IE', 'name': 'Ireland', 'value': 4525802, 'color': layoutColors.warning},
      {'code': 'IL', 'name': 'Israel', 'value': 7562194, 'color': layoutColors.primaryDark},
      {'code': 'IT', 'name': 'Italy', 'value': 60788694, 'color': layoutColors.warning},
      {'code': 'JM', 'name': 'Jamaica', 'value': 2751273, 'color': layoutColors.primary},
      {'code': 'JP', 'name': 'Japan', 'value': 126497241, 'color': layoutColors.primaryDark},
      {'code': 'JO', 'name': 'Jordan', 'value': 6330169, 'color': layoutColors.primaryDark},
      {'code': 'KZ', 'name': 'Kazakhstan', 'value': 16206750, 'color': layoutColors.primaryDark},
      {'code': 'KE', 'name': 'Kenya', 'value': 41609728, 'color': layoutColors.danger},
      {'code': 'KP', 'name': 'Korea, Dem. Rep.', 'value': 24451285, 'color': layoutColors.primaryDark},
      {'code': 'KR', 'name': 'Korea, Rep.', 'value': 48391343, 'color': layoutColors.primaryDark},
      {'code': 'KW', 'name': 'Kuwait', 'value': 2818042, 'color': layoutColors.primaryDark},
      {'code': 'KG', 'name': 'Kyrgyzstan', 'value': 5392580, 'color': layoutColors.primaryDark},
      {'code': 'LA', 'name': 'Laos', 'value': 6288037, 'color': layoutColors.primaryDark},
      {'code': 'LV', 'name': 'Latvia', 'value': 2243142, 'color': layoutColors.warning},
      {'code': 'LB', 'name': 'Lebanon', 'value': 4259405, 'color': layoutColors.primaryDark},
      {'code': 'LS', 'name': 'Lesotho', 'value': 2193843, 'color': layoutColors.danger},
      {'code': 'LR', 'name': 'Liberia', 'value': 4128572, 'color': layoutColors.danger},
      {'code': 'LY', 'name': 'Libya', 'value': 6422772, 'color': layoutColors.danger},
      {'code': 'LT', 'name': 'Lithuania', 'value': 3307481, 'color': layoutColors.warning},
      {'code': 'LU', 'name': 'Luxembourg', 'value': 515941, 'color': layoutColors.warning},
      {'code': 'MK', 'name': 'Macedonia, FYR', 'value': 2063893, 'color': layoutColors.warning},
      {'code': 'MG', 'name': 'Madagascar', 'value': 21315135, 'color': layoutColors.danger},
      {'code': 'MW', 'name': 'Malawi', 'value': 15380888, 'color': layoutColors.danger},
      {'code': 'MY', 'name': 'Malaysia', 'value': 28859154, 'color': layoutColors.primaryDark},
      {'code': 'ML', 'name': 'Mali', 'value': 15839538, 'color': layoutColors.danger},
      {'code': 'MR', 'name': 'Mauritania', 'value': 3541540, 'color': layoutColors.danger},
      {'code': 'MU', 'name': 'Mauritius', 'value': 1306593, 'color': layoutColors.danger},
      {'code': 'MX', 'name': 'Mexico', 'value': 114793341, 'color': layoutColors.primary},
      {'code': 'MD', 'name': 'Moldova', 'value': 3544864, 'color': layoutColors.warning},
      {'code': 'MN', 'name': 'Mongolia', 'value': 2800114, 'color': layoutColors.primaryDark},
      {'code': 'ME', 'name': 'Montenegro', 'value': 632261, 'color': layoutColors.warning},
      {'code': 'MA', 'name': 'Morocco', 'value': 32272974, 'color': layoutColors.danger},
      {'code': 'MZ', 'name': 'Mozambique', 'value': 23929708, 'color': layoutColors.danger},
      {'code': 'MM', 'name': 'Myanmar', 'value': 48336763, 'color': layoutColors.primaryDark},
      {'code': 'NA', 'name': 'Namibia', 'value': 2324004, 'color': layoutColors.danger},
      {'code': 'NP', 'name': 'Nepal', 'value': 30485798, 'color': layoutColors.primaryDark},
      {'code': 'NL', 'name': 'Netherlands', 'value': 16664746, 'color': layoutColors.warning},
      {'code': 'NZ', 'name': 'New Zealand', 'value': 4414509, 'color': layoutColors.warningDark},
      {'code': 'NI', 'name': 'Nicaragua', 'value': 5869859, 'color': layoutColors.primary},
      {'code': 'NE', 'name': 'Niger', 'value': 16068994, 'color': layoutColors.danger},
      {'code': 'NG', 'name': 'Nigeria', 'value': 162470737, 'color': layoutColors.danger},
      {'code': 'NO', 'name': 'Norway', 'value': 4924848, 'color': layoutColors.warning},
      {'code': 'OM', 'name': 'Oman', 'value': 2846145, 'color': layoutColors.primaryDark},
      {'code': 'PK', 'name': 'Pakistan', 'value': 176745364, 'color': layoutColors.primaryDark},
      {'code': 'PA', 'name': 'Panama', 'value': 3571185, 'color': layoutColors.primary},
      {'code': 'PG', 'name': 'Papua New Guinea', 'value': 7013829, 'color': layoutColors.warningDark},
      {'code': 'PY', 'name': 'Paraguay', 'value': 6568290, 'color': layoutColors.success},
      {'code': 'PE', 'name': 'Peru', 'value': 29399817, 'color': layoutColors.success},
      {'code': 'PH', 'name': 'Philippines', 'value': 94852030, 'color': layoutColors.primaryDark},
      {'code': 'PL', 'name': 'Poland', 'value': 38298949, 'color': layoutColors.warning},
      {'code': 'PT', 'name': 'Portugal', 'value': 10689663, 'color': layoutColors.warning},
      {'code': 'PR', 'name': 'Puerto Rico', 'value': 3745526, 'color': layoutColors.primary},
      {'code': 'QA', 'name': 'Qatar', 'value': 1870041, 'color': layoutColors.primaryDark},
      {'code': 'RO', 'name': 'Romania', 'value': 21436495, 'color': layoutColors.warning},
      {'code': 'RU', 'name': 'Russia', 'value': 142835555, 'color': layoutColors.warning},
      {'code': 'RW', 'name': 'Rwanda', 'value': 10942950, 'color': layoutColors.danger},
      {'code': 'SA', 'name': 'Saudi Arabia', 'value': 28082541, 'color': layoutColors.primaryDark},
      {'code': 'SN', 'name': 'Senegal', 'value': 12767556, 'color': layoutColors.danger},
      {'code': 'RS', 'name': 'Serbia', 'value': 9853969, 'color': layoutColors.warning},
      {'code': 'SL', 'name': 'Sierra Leone', 'value': 5997486, 'color': layoutColors.danger},
      {'code': 'SG', 'name': 'Singapore', 'value': 5187933, 'color': layoutColors.primaryDark},
      {'code': 'SK', 'name': 'Slovak Republic', 'value': 5471502, 'color': layoutColors.warning},
      {'code': 'SI', 'name': 'Slovenia', 'value': 2035012, 'color': layoutColors.warning},
      {'code': 'SB', 'name': 'Solomon Islands', 'value': 552267, 'color': layoutColors.warningDark},
      {'code': 'SO', 'name': 'Somalia', 'value': 9556873, 'color': layoutColors.danger},
      {'code': 'ZA', 'name': 'South Africa', 'value': 50459978, 'color': layoutColors.danger},
      {'code': 'ES', 'name': 'Spain', 'value': 46454895, 'color': layoutColors.warning},
      {'code': 'LK', 'name': 'Sri Lanka', 'value': 21045394, 'color': layoutColors.primaryDark},
      {'code': 'SD', 'name': 'Sudan', 'value': 34735288, 'color': layoutColors.danger},
      {'code': 'SR', 'name': 'Suriname', 'value': 529419, 'color': layoutColors.success},
      {'code': 'SZ', 'name': 'Swaziland', 'value': 1203330, 'color': layoutColors.danger},
      {'code': 'SE', 'name': 'Sweden', 'value': 9440747, 'color': layoutColors.warning},
      {'code': 'CH', 'name': 'Switzerland', 'value': 7701690, 'color': layoutColors.warning},
      {'code': 'SY', 'name': 'Syria', 'value': 20766037, 'color': layoutColors.primaryDark},
      {'code': 'TW', 'name': 'Taiwan', 'value': 23072000, 'color': layoutColors.primaryDark},
      {'code': 'TJ', 'name': 'Tajikistan', 'value': 6976958, 'color': layoutColors.primaryDark},
      {'code': 'TZ', 'name': 'Tanzania', 'value': 46218486, 'color': layoutColors.danger},
      {'code': 'TH', 'name': 'Thailand', 'value': 69518555, 'color': layoutColors.primaryDark},
      {'code': 'TG', 'name': 'Togo', 'value': 6154813, 'color': layoutColors.danger},
      {'code': 'TT', 'name': 'Trinidad and Tobago', 'value': 1346350, 'color': layoutColors.primary},
      {'code': 'TN', 'name': 'Tunisia', 'value': 10594057, 'color': layoutColors.danger},
      {'code': 'TR', 'name': 'Turkey', 'value': 73639596, 'color': layoutColors.warning},
      {'code': 'TM', 'name': 'Turkmenistan', 'value': 5105301, 'color': layoutColors.primaryDark},
      {'code': 'UG', 'name': 'Uganda', 'value': 34509205, 'color': layoutColors.danger},
      {'code': 'UA', 'name': 'Ukraine', 'value': 45190180, 'color': layoutColors.warning},
      {'code': 'AE', 'name': 'United Arab Emirates', 'value': 7890924, 'color': layoutColors.primaryDark},
      {'code': 'GB', 'name': 'United Kingdom', 'value': 62417431, 'color': layoutColors.warning},
      {'code': 'US', 'name': 'United States', 'value': 313085380, 'color': layoutColors.primary},
      {'code': 'UY', 'name': 'Uruguay', 'value': 3380008, 'color': layoutColors.success},
      {'code': 'UZ', 'name': 'Uzbekistan', 'value': 27760267, 'color': layoutColors.primaryDark},
      {'code': 'VE', 'name': 'Venezuela', 'value': 29436891, 'color': layoutColors.success},
      {'code': 'PS', 'name': 'West Bank and Gaza', 'value': 4152369, 'color': layoutColors.primaryDark},
      {'code': 'VN', 'name': 'Vietnam', 'value': 88791996, 'color': layoutColors.primaryDark},
      {'code': 'YE', 'name': 'Yemen, Rep.', 'value': 24799880, 'color': layoutColors.primaryDark},
      {'code': 'ZM', 'name': 'Zambia', 'value': 13474959, 'color': layoutColors.danger},
      {'code': 'ZW', 'name': 'Zimbabwe', 'value': 12754378, 'color': layoutColors.danger}
    ];

    var map;
    var minBulletSize = 3;
    var maxBulletSize = 70;
    var min = Infinity;
    var max = -Infinity;

    // get min and max values
    for (var i = 0; i < mapData.length; i++) {
      var value = mapData[i].value;
      if (value < min) {
        min = value;
      }
      if (value > max) {
        max = value;
      }
    }

    // build map
    AmCharts.theme = AmCharts.themes.blur;
    map = new AmCharts.AmMap();

    map.addTitle('Population of the World in 2011', 14);
    map.addTitle('source: Gapminder', 11);
    map.areasSettings = {
      unlistedAreasColor: '#000000',
      unlistedAreasAlpha: 0.1
    };
    map.imagesSettings.balloonText = '<span style="font-size:14px;"><b>[[title]]</b>: [[value]]</span>';
    map.pathToImages = layoutPaths.images.amMap;

    var dataProvider = {
      mapVar: AmCharts.maps.worldLow,
      images: []
    };

    // it's better to use circle square to show difference between values, not a radius
    var maxSquare = maxBulletSize * maxBulletSize * 2 * Math.PI;
    var minSquare = minBulletSize * minBulletSize * 2 * Math.PI;

    // create circle for each country
    for (var i = 0; i < mapData.length; i++) {
      var dataItem = mapData[i];
      var value = dataItem.value;
      // calculate size of a bubble
      var square = (value - min) / (max - min) * (maxSquare - minSquare) + minSquare;
      if (square < minSquare) {
        square = minSquare;
      }
      var size = Math.sqrt(square / (Math.PI * 2));
      var id = dataItem.code;

      dataProvider.images.push({
        type: 'circle',
        width: size,
        height: size,
        color: dataItem.color,
        longitude: latlong[id].longitude,
        latitude: latlong[id].latitude,
        title: dataItem.name,
        value: value
      });
    }

    map.dataProvider = dataProvider;
    map.export = {
      enabled: true
    };

    $timeout(function() {
      map.write('map-bubbles');
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('MapLinesPageCtrl', MapLinesPageCtrl);

  /** @ngInject */
  function MapLinesPageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    // svg path for target icon
    var targetSVG = 'M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z';
// svg path for plane icon
    var planeSVG = 'M19.671,8.11l-2.777,2.777l-3.837-0.861c0.362-0.505,0.916-1.683,0.464-2.135c-0.518-0.517-1.979,0.278-2.305,0.604l-0.913,0.913L7.614,8.804l-2.021,2.021l2.232,1.061l-0.082,0.082l1.701,1.701l0.688-0.687l3.164,1.504L9.571,18.21H6.413l-1.137,1.138l3.6,0.948l1.83,1.83l0.947,3.598l1.137-1.137V21.43l3.725-3.725l1.504,3.164l-0.687,0.687l1.702,1.701l0.081-0.081l1.062,2.231l2.02-2.02l-0.604-2.689l0.912-0.912c0.326-0.326,1.121-1.789,0.604-2.306c-0.452-0.452-1.63,0.101-2.135,0.464l-0.861-3.838l2.777-2.777c0.947-0.947,3.599-4.862,2.62-5.839C24.533,4.512,20.618,7.163,19.671,8.11z';
    $timeout(function() {
      var map = AmCharts.makeChart( 'map-lines', {
        type: 'map',
        theme: 'blur',
        dataProvider: {
          map: 'worldLow',
          linkToObject: 'london',
          images: [ {
            id: 'london',
            svgPath: targetSVG,
            title: 'London',
            latitude: 51.5002,
            longitude: -0.1262,
            scale: 1.5,
            zoomLevel: 2.74,
            zoomLongitude: -20.1341,
            zoomLatitude: 49.1712,

            lines: [ {
              latitudes: [ 51.5002, 50.4422 ],
              longitudes: [ -0.1262, 30.5367 ]
            }, {
              latitudes: [ 51.5002, 46.9480 ],
              longitudes: [ -0.1262, 7.4481 ]
            }, {
              latitudes: [ 51.5002, 59.3328 ],
              longitudes: [ -0.1262, 18.0645 ]
            }, {
              latitudes: [ 51.5002, 40.4167 ],
              longitudes: [ -0.1262, -3.7033 ]
            }, {
              latitudes: [ 51.5002, 46.0514 ],
              longitudes: [ -0.1262, 14.5060 ]
            }, {
              latitudes: [ 51.5002, 48.2116 ],
              longitudes: [ -0.1262, 17.1547 ]
            }, {
              latitudes: [ 51.5002, 44.8048 ],
              longitudes: [ -0.1262, 20.4781 ]
            }, {
              latitudes: [ 51.5002, 55.7558 ],
              longitudes: [ -0.1262, 37.6176 ]
            }, {
              latitudes: [ 51.5002, 38.7072 ],
              longitudes: [ -0.1262, -9.1355 ]
            }, {
              latitudes: [ 51.5002, 54.6896 ],
              longitudes: [ -0.1262, 25.2799 ]
            }, {
              latitudes: [ 51.5002, 64.1353 ],
              longitudes: [ -0.1262, -21.8952 ]
            }, {
              latitudes: [ 51.5002, 40.4300 ],
              longitudes: [ -0.1262, -74.0000 ]
            } ],

            images: [ {
              label: 'Flights from London',
              svgPath: planeSVG,
              left: 100,
              top: 45,
              labelShiftY: 5,
              labelShiftX: 5,
              color: layoutColors.defaultText,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 20
            }, {
              label: 'show flights from Vilnius',
              left: 106,
              top: 70,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 11,
              linkToObject: 'vilnius'
            } ]
          },

            {
              id: 'vilnius',
              svgPath: targetSVG,
              title: 'Vilnius',
              latitude: 54.6896,
              longitude: 25.2799,
              scale: 1.5,
              zoomLevel: 4.92,
              zoomLongitude: 15.4492,
              zoomLatitude: 50.2631,

              lines: [ {
                latitudes: [ 54.6896, 50.8371 ],
                longitudes: [ 25.2799, 4.3676 ]
              }, {
                latitudes: [ 54.6896, 59.9138 ],
                longitudes: [ 25.2799, 10.7387 ]
              }, {
                latitudes: [ 54.6896, 40.4167 ],
                longitudes: [ 25.2799, -3.7033 ]
              }, {
                latitudes: [ 54.6896, 50.0878 ],
                longitudes: [ 25.2799, 14.4205 ]
              }, {
                latitudes: [ 54.6896, 48.2116 ],
                longitudes: [ 25.2799, 17.1547 ]
              }, {
                latitudes: [ 54.6896, 44.8048 ],
                longitudes: [ 25.2799, 20.4781 ]
              }, {
                latitudes: [ 54.6896, 55.7558 ],
                longitudes: [ 25.2799, 37.6176 ]
              }, {
                latitudes: [ 54.6896, 37.9792 ],
                longitudes: [ 25.2799, 23.7166 ]
              }, {
                latitudes: [ 54.6896, 54.6896 ],
                longitudes: [ 25.2799, 25.2799 ]
              }, {
                latitudes: [ 54.6896, 51.5002 ],
                longitudes: [ 25.2799, -0.1262 ]
              }, {
                latitudes: [ 54.6896, 53.3441 ],
                longitudes: [ 25.2799, -6.2675 ]
              } ],

              images: [ {
                label: 'Flights from Vilnius',
                svgPath: planeSVG,
                left: 100,
                top: 45,
                labelShiftY: 5,
                labelShiftX: 5,
                color: layoutColors.defaultText,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 20
              }, {
                label: 'show flights from London',
                left: 106,
                top: 70,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 11,
                linkToObject: 'london'
              } ]
            }, {
              svgPath: targetSVG,
              title: 'Brussels',
              latitude: 50.8371,
              longitude: 4.3676
            }, {
              svgPath: targetSVG,
              title: 'Prague',
              latitude: 50.0878,
              longitude: 14.4205
            }, {
              svgPath: targetSVG,
              title: 'Athens',
              latitude: 37.9792,
              longitude: 23.7166
            }, {
              svgPath: targetSVG,
              title: 'Reykjavik',
              latitude: 64.1353,
              longitude: -21.8952
            }, {
              svgPath: targetSVG,
              title: 'Dublin',
              latitude: 53.3441,
              longitude: -6.2675
            }, {
              svgPath: targetSVG,
              title: 'Oslo',
              latitude: 59.9138,
              longitude: 10.7387
            }, {
              svgPath: targetSVG,
              title: 'Lisbon',
              latitude: 38.7072,
              longitude: -9.1355
            }, {
              svgPath: targetSVG,
              title: 'Moscow',
              latitude: 55.7558,
              longitude: 37.6176
            }, {
              svgPath: targetSVG,
              title: 'Belgrade',
              latitude: 44.8048,
              longitude: 20.4781
            }, {
              svgPath: targetSVG,
              title: 'Bratislava',
              latitude: 48.2116,
              longitude: 17.1547
            }, {
              svgPath: targetSVG,
              title: 'Ljubljana',
              latitude: 46.0514,
              longitude: 14.5060
            }, {
              svgPath: targetSVG,
              title: 'Madrid',
              latitude: 40.4167,
              longitude: -3.7033
            }, {
              svgPath: targetSVG,
              title: 'Stockholm',
              latitude: 59.3328,
              longitude: 18.0645
            }, {
              svgPath: targetSVG,
              title: 'Bern',
              latitude: 46.9480,
              longitude: 7.4481
            }, {
              svgPath: targetSVG,
              title: 'Kiev',
              latitude: 50.4422,
              longitude: 30.5367
            }, {
              svgPath: targetSVG,
              title: 'Paris',
              latitude: 48.8567,
              longitude: 2.3510
            }, {
              svgPath: targetSVG,
              title: 'New York',
              latitude: 40.43,
              longitude: -74
            }
          ]
        },

        areasSettings: {
          unlistedAreasColor: layoutColors.info
        },

        imagesSettings: {
          color: layoutColors.warningLight,
          selectedColor: layoutColors.warning
        },

        linesSettings: {
          color: layoutColors.warningLight,
          alpha: 0.8
        },


        backgroundZoomsToTop: true,
        linesAboveImages: true,

        export: {
          'enabled': true
        },
        pathToImages: layoutPaths.images.amMap
      } );
    }, 100);

  }

})();

/**
 * @author Edmilson Silva 24/07/17
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.proficiencias.carga')
		.service('CargaProficienciaService', CargaProficienciaService);

	/** @ngInject */
	function CargaProficienciaService(REST_END_POINT, VERSION, $http, $q, $filter) {
				
		return {
			enviaCarga : function(carga){
				var fd = new FormData();
	        	fd.append('file', carga.arquivo);
	        	fd.append('school', $.param(carga.escola));
	        	fd.append('dtExam', $filter('date')(carga.data, 'yyyy-MM-dd'));

				return $http.post(REST_END_POINT + VERSION.V1 + '/proficiencias/carga',fd,{
					withCredentials : false,
					transformRequest : angular.identity,
		            headers: {'Content-Type' : undefined}
		        }).then(
			        //Success
			        function (response) {
			        	if(response.data){
							if(response.data.status == 200) {
								return response.data.messages;
							} else {
								return $q.reject(response.data.messages);
							}
						} else {
							return $q.reject({'erro' : 'Erro de conexão!'});
						}
			        },
			        //Error
			        function (response, status) {
			        	if(response.status == -1) {						
			        		return $q.reject({'erro' : 'Erro de conexão!'});
						}
						return $q.reject(response.data.messages);
		        	}
		        );
	        }
		};
	}

})();
/**
 * @author Edmilson Silva 24/07/17
 */
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.proficiencias.carga')
  		.controller('CargaProficienciasPageCtrl', CargaProficienciasPageCtrl);

	/** @ngInject */
	function CargaProficienciasPageCtrl(REST_END_POINT, VERSION, $scope, $state, fileReader,  EscolasService, CargaProficienciaService, AuthService) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		
		$scope.escolas = [{'id':'1','value':'Cultura Inglesa'},];
		$scope.proficiencias = {};
		$scope.proficiencias.carga = {};
		$scope.proficiencias.carga.arquivo = null;

		$scope.mensagem = null;
		$scope.noFile = true;
		$scope.fileName = '';

		$scope.removeFile = function () {
			$scope.proficiencias.carga.arquivo = null
			$scope.noFile = true;
			$scope.fileName = '';
			document.getElementById('uploadFile').value = '';
			$scope.progress = 0;
		};

		$scope.uploadFile = function () {
			var f = document.getElementById('uploadFile');
			f.click();
		};


		$scope.getFile = function (f) {
	        $scope.progress = 0;
	        if(f) {
		        fileReader.readAsDataURL(f,$scope).then(function (resp) {
			        // Do stuff
			        $scope.proficiencias.carga.arquivo = resp;
			        $scope.noFile = false;
			    }, function (err) {
			        // Do stuff
			        $scope.removeFile();
			        $scope.noFile = true;
			    });
			    if(f.name){
			    	$scope.fileName = f.name;
			    }
	        }
	    };
	 
	    $scope.$on("fileProgress", function(e, progress) {
	        $scope.progress = progress.loaded / progress.total;
	    });
		
		EscolasService.getEscolas().then(function(data) {
			$scope.escolas = data;
		})
		.catch(function(erros) {
			$scope.erros = erros;
		});

		$scope.enviar = function(resp) {
			$scope.mensagem = null;
			if(!resp.arquivo || !$scope.cargaForm.$valid){
				$scope.mensagem = {'erro':'Todos os dados são obrigatórios!'};
				return;
			}
			var _dataName = $scope.fileName.split('.');
			var ext = _dataName[_dataName.length-1];
			if(ext.toLowerCase() !== 'xlsx'){
				$scope.mensagem = {'erro':'O arquivo deve ser do Excel (.xlsx)'};
				return;
			}
			
			CargaProficienciaService.enviaCarga(resp).then(function(msg) {
				$scope.mensagem = {'sucesso':msg};
			})
			.catch(function(erro) {
				$scope.mensagem = {'erro':erro};
			});

		};
		
		$scope.limpar = function() {
			// Reset dos parametros de busca
			$scope.proficiencias.carga = {
				data : '',
				escola : $scope.escolas[0],
				arquivo : '',
			};
			
			//$scope.proficientes = null;
			$scope.mensagem = null;
		};
		$scope.limpar();

	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.proficiencias.certificado')
  		.controller('CertificadoProficienciasPageCtrl', CertificadoProficienciasPageCtrl);

	/** @ngInject */
	function CertificadoProficienciasPageCtrl($scope, $state, ProficienciasService,AuthService) {

		if( !AuthService.isAuthorizedToAccess([1,2,3]) ){ //aluno,secretaria,admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}

		/*// Variáveis padrão
		// Nota Minima
		$scope.notaMinima = 90;
		// Combobox de Conceito
		$scope.conceitos = [
			{
				value : 0,
				label : 'Todos'
			}, 
			{
				value : 1,
				label : 'Aprovado'
			}, 
			{
				value : 2,
				label : 'Reprovado'
			}, 
		];

		$scope.pesquisar = function() {
			
			$scope.proficientes = null;
			$scope.mensagem = null;
			
			ProficienciasService.listarProficiencias($scope.proficiente).then(function(data) {
				$scope.proficientes = data;
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
		};
		
		$scope.limpar = function() {
			// Reset dos parametros de busca
			$scope.proficiente = {
				periodo : {
					de : '',
					ate : ''
				},
				cpf : '',
				nome : '',
				conceito : $scope.conceitos[0]
			};
			
			$scope.proficientes = null;
			$scope.mensagem = null;
		};

		$scope.gerarDeclaracao = function(proficiencia) {
			
			ProficienciasService.setProficiencia(proficiencia);
			
			$state.go('proficiencias.declaracao');
		};
		
		$scope.limpar();*/
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.proficiencias.consulta')
  		.controller('ConsultaProficienciasPageCtrl', ConsultaProficienciasPageCtrl);

	/** @ngInject */
	function ConsultaProficienciasPageCtrl($scope, $state, ProficienciasService,AuthService) {

		$scope.isAdmin = false;
		if( AuthService.isAuthorizedToAccess([3]) ){
			$scope.isAdmin = true;
		}
		// Variáveis padrão
		// Nota Minima
		//$scope.notaMinima = 90;
		// Combobox de Conceito

		$scope.conceitos = [
			{
				value : 0,
				label : 'Todos'
			}, 
			{
				value : 1,
				label : 'Aprovado'
			}, 
			{
				value : 2,
				label : 'Reprovado'
			}, 
		];

		$scope.pesquisar = function() {
			
			$scope.proficientes = null;
			$scope.mensagem = null;
			
			ProficienciasService.listarProficiencias($scope.proficiente).then(function(data) {
				$scope.proficientes = data;
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
		};
		
		$scope.limpar = function() {
			// Reset dos parametros de busca
			$scope.proficiente = {
				periodo : {
					de : '',
					ate : ''
				},
				cpf : '',
				nome : '',
				conceito : $scope.conceitos[0]
			};
			
			$scope.proficientes = null;
			$scope.mensagem = null;
			var busca = ProficienciasService.getBuscaProficiencia();
			if(busca != null){
				$scope.proficiente = busca;
				$scope.pesquisar();
			}
		};

		$scope.editarProficiencia = function(proficiencia) {
			ProficienciasService.setProficiencia(proficiencia);
			$state.go('proficiencias.editar');
		};
		$scope.gerarDeclaracao = function(proficiencia) {
			ProficienciasService.setProficiencia(proficiencia);
			$state.go('proficiencias.declaracao');
		};
		
		$scope.limpar();
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.proficiencias.consulta')
  		.controller('EditarProficienciasPageCtrl', EditarProficienciasPageCtrl);

	/** @ngInject */
	function EditarProficienciasPageCtrl($scope, $state, $filter, ProficienciasService, EscolasService, AuthService) {
		
		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		var proficiencia = ProficienciasService.getProficiencia() || {};
		if(Object.keys(proficiencia).length == 0){
			$state.go('proficiencias.consulta');
		}
		proficiencia.notaExame = proficiencia.notaExame?parseFloat(proficiencia.notaExame):null;
		proficiencia.dataExame = proficiencia.dataExame?moment(proficiencia.dataExame).toDate():null;
		proficiencia.cpf = proficiencia.cpf?("00000000000"+proficiencia.cpf).slice(-11):null;
		
		$scope.escolas = [];

		EscolasService.getEscolas().then(function(data) {
			data = data.concat([{id:'0',value:'Outros'}]);
			$scope.escolas = data;
			$scope.proficiencia.escola = data[0];
		});
		
		$scope.inserirProficiencia = function(proficiencia) {
			ProficienciasService.inserirProficiencia(proficiencia).then(function(id) {
				$scope.proficiencia.id = id;
				$scope.mensagem = { sucesso: "Proficiencia incluída com sucesso" }; 
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});	
		};
		$scope.alterarProficiencia = function(proficiencia) {
			ProficienciasService.editarProficiencia(proficiencia).then(function(atualizado) {
				$scope.mensagem = { sucesso: "Proficiencia alterada com sucesso" }; 
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});	
		};

		$scope.limpar = function() {
			$scope.proficiencia = {
				id: !$scope.proficiencia || $scope.proficiencia.id == null ? null : $scope.proficiencia.id,	
				dataExame: moment().toDate(),
				cpf: "",
				nomeAluno: "",
				notaExame: 50.0,
				escola: $scope.escolas.length>0? $scope.escolas[0] : null
			};
		};
		
		// Inicializa tela
		if(proficiencia.id == null) {
			$scope.acao = "Incluir";
			$scope.limpar();
		}
		else {
			proficiencia.conceito = false;
			if(proficiencia.conceito == "1"){
				proficiencia.conceito = true;
			}
			$scope.acao = "Alterar";
			$scope.proficiencia = proficiencia;
		}
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

	angular.module('BlurAdmin.pages.proficiencias.declaracao')
		.controller('DeclaracaoProficienciasPageCtrl', DeclaracaoProficienciasPageCtrl);

	/** @ngInject */
	function DeclaracaoProficienciasPageCtrl($scope, $state, ProficienciasService, AuthService, PdfService, $filter, LogService) {

		// Variáveis padrão
		// Data atual
		$scope.dataAtual = moment().toDate();
		
		$scope.proficiente = null;
		
		var proficiencia = ProficienciasService.getProficiencia();
		
		if(proficiencia == null) {
			$state.go('proficiencias.consulta');
		} else {
			$scope.proficiente = proficiencia;
		}
		LogService.cadastraLog(jQuery.extend(proficiencia, {msg:'Gerar declaração do aluno',sub:AuthService.getUser()}) );

		$scope.print = function(){
			LogService.cadastraLog(jQuery.extend(proficiencia, {msg:'Imprime declaração do aluno (em pdf)',sub:AuthService.getUser()}) );

			var content = [
				{text: 'DECLARAÇÃO', style:'header'},
				{text: 
				    [
				        'Declaro que o Sr(a). ',
				        $scope.proficiente.nomeAluno,
				        ' realizou exame de proficiência em língua inglesa na ',
				        'Cultura Inglesa',
				        ', para fins de inscrição em programa de pós-graduação na Faculdade de Medicina da Universidade de São Paulo, no dia ',
				        $filter('date')($scope.proficiente.dataExame,'dd/MM/yyyy'),
				        ', obtendo ',
				        $filter('number')($scope.proficiente.notaExame,1),
				        ' pontos.'
				    ], style: 'paragraph', alignment: 'justify', margin: [0,100]
				},
				{text:  $filter('capitalize')($filter('date')($scope.dataAtual ,"'São Paulo', dd "))+'de'+ $filter('capitalize')($filter('date')($scope.dataAtual ," MMMM "))+'de'+$filter('date')($scope.dataAtual ," yyyy"), style: 'center', margin:[0,50]},
				{text: 
				    [
				        'Este documento eletrônico dispensa carimbo e assinatura. Sua autenticidade pode ser comprovada pelo Serviço de Pós-graduação da FMUSP através do e-mail: ',
				        {text: 'posfm@fm.usp.br',link: 'mailto:posfm@fm.usp.br',color:'#9090FF'}
				    ], style:'center', italics: true, margin: [0,130,0,0], fontSize: 10
				}
			];
			PdfService.getPdf(content);
		}
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.parecer')
  		.controller('ParecerPageCtrl', ParecerPageCtrl);

	/** @ngInject */
	function ParecerPageCtrl($scope, $state, ParecerService, AuthService, LogService, PdfService, $filter) {

		if( !AuthService.isAuthorizedToAccess([3,4]) ){ //admin,docente
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}

		$scope.isAdmin = false;
		if( AuthService.isAuthorizedToAccess([3]) ){
			$scope.isAdmin = true;
		}

		$scope.busca = {};
		if($scope.isAdmin){
			$scope.dt_tipos = ParecerService.getDtTipos();
			//$scope.busca.dt_tipo = $scope.dt_tipos[0];

			$scope.listStatus = ParecerService.getStatus();
			//$scope.busca.status = $scope.listStatus[0];

			$scope.tipos=[];
			ParecerService.getTipos().then(function(result){
				$scope.tipos = result;
				//$scope.busca.tipo = $scope.tipos[0];
			});


			$scope.parecer=[];
			ParecerService.getParecerList({},$scope.isAdmin).then(function(result){
				$scope.outros = result;
				$scope.parecer = $scope.outros;
			});

			// $scope.new = function(name) {
			// 	var item = {
			//         id: 0,
			//         value: name
			//     };
			//     $scope.pareceristas.push(item);
			//     $scope.busca.parecerista = item;
			// };
		}
		$scope.pesquisar = function(){
			$scope.mensagem = null;
			ParecerService.getParecerList($scope.busca,$scope.isAdmin).then(function(result){
				$scope.outros = result;
				$scope.parecer = $scope.outros;
			}).catch(function(erro){
				$scope.mensagem = erro;
			});
		};
		$scope.limpar = function(){
			$scope.busca = {};
		};
		$scope.editar = function(item){
			ParecerService.setParecer(item);
			$state.go('parecer.editar');
		};
		$scope.novo = function(){
			if($scope.isAdmin){
				ParecerService.setParecer({idParecer:0});
				$state.go('parecer.editar');
			}
		};
		
		$scope.pdf = function(){
			LogService.cadastraLog(jQuery.extend($scope.busca, {msg:'Gera Resultado de pesquisa no Parecer',sub:AuthService.getUser()}) );
			var content = [];

			var base = {
				table: {
					body: [
						[{text:'Código',style:'variable'}, {text:'Interessado',style:'variable'}, {text:'Encaminhado',style:'variable'}, {text:'Assunto',style:'variable'}, {text:'Programa',style:'variable'}, {text:'Parerista',style:'variable'}],
					]
				}
			};
			for(var item in $scope.parecer){
				base.table.body.push (
					[
						{text: $scope.parecer[item].cod,style:'default'},
						{text: $scope.parecer[item].interessado,style:'default'},
						{text: $scope.parecer[item].dt_encam?$filter('date')($scope.parecer[item].dt_encam,'dd/MM/yyyy'):"",style:'default'},
						{text: $scope.parecer[item].assunto?$scope.parecer[item].assunto:"",style:'default'},
						{text: $scope.parecer[item].area?$scope.parecer[item].area:"",style:'default'},
						{text: $scope.parecer[item].nomeRelator?$scope.parecer[item].nomeRelator:"",style:'default'}
					]
				);
			}
			content.push(base);
			content.push({text: '', style:'newRow',alignment:'center',bold:true});
			PdfService.getPdf(content,"landscape");
		};
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.parecer')
  		.controller('EditarParecerPageCtrl', EditarParecerPageCtrl);

	/** @ngInject */
	function EditarParecerPageCtrl($scope, $state, $stateParams, fileReader, AuthService, $uibModal, toastr, ParecerService, $filter, LogService, PdfService, AreasService, $timeout) {

		if( !AuthService.isAuthorizedToAccess([3,4]) ){ //admin,docente
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		$scope.isAdmin = false;
		if( AuthService.isAuthorizedToAccess([3]) ){
			$scope.isAdmin = true;
		}
		$scope.parecer = ParecerService.getParecer();

		if(!$scope.parecer){
			$state.go('parecer.consulta');
		}

		if($scope.isAdmin){
			$timeout(function(){
				$scope.parecer.dt_encam = $scope.parecer && $scope.parecer.dt_encam? moment(dateToPHP($scope.parecer.dt_encam)).toDate(): null;
				$scope.parecer.dt_pedido = $scope.parecer && $scope.parecer.dt_pedido? moment(dateToPHP($scope.parecer.dt_pedido)).toDate(): null;
				$scope.parecer.dt_retorno = $scope.parecer && $scope.parecer.dt_retorno? moment(dateToPHP($scope.parecer.dt_retorno)).toDate(): null;
			},500);
		}

		$scope.tipos=[];
		ParecerService.getTipos().then(function(result){
			$scope.tipos = result;
		});

		$scope.programas = [];
		AreasService.listarAreas().then(function(areas) {
			areas.shift();
			$scope.programas = areas;
		});
		$scope.pareceristas = [];
		ParecerService.getPareceristas().then(function(result){
			$scope.pareceristas = result;
		});
		$scope.resultados = [];
		$scope.resultados_parecer = [];
		ParecerService.getResultados().then(function(result){
			$scope.resultados = result;
			$scope.resultados_parecer = result;
		});

		$scope.novo = false;
		if($scope.parecer == null || $scope.parecer.idParecer == 0){
			//novo
			$scope.novo = true;
			$scope.dt_pedido = moment().toDate();

		}else{
			//editar
			$timeout(function(){
				ParecerService.getParecerData($scope.parecer.idParecer).then(function(result){
					$scope.parecer = validaResult(result);
					if($scope.isAdmin){
						$timeout(function(){
							$scope.parecer.dt_encam = $scope.parecer && $scope.parecer.dt_encam? moment(dateToPHP($scope.parecer.dt_encam)).toDate(): null;
							$scope.parecer.dt_pedido = $scope.parecer && $scope.parecer.dt_pedido? moment(dateToPHP($scope.parecer.dt_pedido)).toDate(): null;
							$scope.parecer.dt_retorno = $scope.parecer && $scope.parecer.dt_retorno? moment(dateToPHP($scope.parecer.dt_retorno)).toDate(): null;
						},500);
					}
				});
			},300);
		}

		$scope.new = function(name) {
			var item = {
		        id: null,
		        value: name
		    };
		    $scope.pareceristas.push(item);
		    $scope.parecer.nomeRelator = item;
		};
		$scope.salvar = function(){
			if($scope.novo){
				ParecerService.adicionarParecer($scope.parecer).then(function(result){
					$scope.parecer = validaResult(result);

					toastr.success('Parecer Salvo com sucesso','Successo', {});
					$state.go('parecer.consulta');
				}).catch(function(erro){
					toastr.error(erro, 'Erro', {});
				});
			}else{
				ParecerService.editarParecer($scope.parecer).then(function(result){
					$scope.parecer = validaResult(result);
					$state.go('parecer.consulta');
					toastr.success('Parecer Salvo com sucesso','Successo', {});

				}).catch(function(erro){
					toastr.error(erro, 'Erro', {});
				});

			}
		};

		$scope.printCapa = function(){
			LogService.cadastraLog(jQuery.extend($scope.parecer, {msg:'Imprime Aviso',sub:AuthService.getUser()}) );
			var content = [
					{text: 'Encaminhamento para Parecer do Relator\n\n', style:'header'},
					{
					    layout: 'noBorders', style:'default',
					    table: {
					        widths: [100,200,100,'*'],
							body: [
								[{text:'Código',style:'variable'}, $scope.parecer.cod, {text:'Programa',style:'variable'},($scope.parecer.programa && $scope.parecer.programa.value?$scope.parecer.programa.value:'')],
								[{text:'Interessado',style:'variable'}, {colSpan: 3, text:$scope.parecer.interessado}, '', ''],
								[{text:'Encaminhado',style:'variable'}, {colSpan: 3, text:($scope.parecer.dt_encam?moment($scope.parecer.dt_encam).format('DD/MM/YYYY'):'')}, '', ''],
								[{text:'Relator',style:'variable'}, {colSpan: 3, text: ($scope.parecer.nomeRelator && $scope.parecer.nomeRelator.value?$scope.parecer.nomeRelator.value:'')}, '', ''],
								[{text:'Referência',style:'variable'}, {colSpan: 3, text: $scope.parecer.assunto}, '', '']
							]
						}
					},
					{
						table: {
						    widths: ['*'],
							body: [
								['Parecer do Relator'],
								[
									{text: [
											{text:'\n\n\n\nSr(a). Relator(a),\n\n',style:'default'},
											{text:'Solicitamos a fineza de utiliza Sistema de Pós-Graduação - Internet, conforme segue:\n',style:'paragraph'},

											{text:'\n(caso não seja possível a emissão do parecer no prazo de 30 dias, favor devolver ao SPG)\n\n',style:'paragraph',italics: true},

											{text:"Acesse o link: http://spg.fm.usp.br/spg/#/administrador/login", link:"http://spg.fm.usp.br/spg/#/administrador/login", decoration:"underline"},
											{text:'\n\nPARECER - Lança' +
													' parecer do relator - código da capa ',style:'paragraph'},
											{text:$scope.parecer.cod,style:'variable'},
											{text:' - digitar parecer - salvar \n\n\n',style:'default'},

											{text:'Assinatura do Relator _________________________________________________ Data ___/___/____',style:'variable'},






										]}
								],
								['\n\nParecer da Comissão\n\n\n']
							]
						}
					}
				];

			PdfService.getPdf(content);
		};
		$scope.printParecer = function(){
			LogService.cadastraLog(jQuery.extend($scope.parecer, {msg:'Imprime Aviso',sub:AuthService.getUser()}) );
			var content = [
				{text: 'Impressão do Parecer do Relator', style:'header'},
				{text: ['Credenciamento / Recredenciamento / Reformulação de Disciplina(s) e Responsável(eis)\n\n'] , fontSize:8,color:'#AAA',alignment:'center'},
				{
				    layout: 'noBorders', style:'default',
				    table: {
				        widths: [200,'*'],
						body: [
							[{text:'Código',style:'variable'}, $scope.parecer.cod],
							[{text:'Programa',style:'variable'},($scope.parecer.programa && $scope.parecer.programa.value?$scope.parecer.programa.value:'')],
							[{text:'Interessado',style:'variable'}, $scope.parecer.interessado],
							[{text:'Entrada Pedido',style:'variable'}, {text:$scope.parecer.dt_pedido?moment(dateToPHP($scope.parecer.dt_pedido)).format('DD/MM/YYYY'):''}],
							[{text:'Assunto',style:'variable'},{text: $scope.parecer.assunto}]
						]
					}
				},
				'\n\n'
			];

			var base = {
				layout: 'noBorders', style:'default',
				table: {
				    widths: ['*'],
					body: [
						[{fillColor: '#CCC',text: 'Parecer do Relator', style:'variable'}]
					]
				}
			};

			if( $scope.parecer.tipo.id == 10 ){
				base.table.body.push(
					[{fillColor: '#DDD',text: 'I.(Analise o mérito e a importância da disciplina junto ao programa)', style:'variable'}],
					[{fillColor: '#EEE',text: $scope.parecer.parecer_i?$scope.parecer.parecer_i:'---'}],
					[{fillColor: '#DDD',text: 'II.(Analise se o conteúdo está ligado às linhas de pesquisa)', style:'variable'}],
					[{fillColor: '#EEE',text: $scope.parecer.parecer_ii?$scope.parecer.parecer_ii:'---'}],
					[{fillColor: '#DDD',text: 'III.(Analise a competência específica dos(s) responsável(eis), avaliada por produção científica: publicação de artigos completos em revistas de corpo editorial rigoroso, de preferência em nível internacional; livros; capítulos de livros; participação em congressos internacionais e nacionais; coordenação e participação em projetos de pesquisa financiados)', style:'variable'}],
					[{fillColor: '#EEE',text: $scope.parecer.parecer_iii?$scope.parecer.parecer_iii:'---'}],
					[{fillColor: '#DDD',text: 'IV.(Analise, no caso de recredenciamento ou reformulação de disciplina, a frequência que a disciplina foi oferecida)', style:'variable'}],
					[{fillColor: '#EEE',text: $scope.parecer.parecer_iv?$scope.parecer.parecer_iv:'---'}],
					[{fillColor: '#DDD',text: 'Parecer Final'}],
					[{fillColor: '#EEE',text: $scope.parecer.resultado_parecer && $scope.parecer.resultado_parecer.value?$scope.parecer.resultado_parecer.value:''}],
					['\n\n\n\nParecer da Comissão']
				);
			}else{
				base.table.body.push(
					[{fillColor: '#EEE',text: $scope.parecer.parecer_i? $scope.parecer.parecer_i : ''}],
					[{fillColor: '#DDD',text: 'Parecer Final'}],
					[{fillColor: '#EEE',text: $scope.parecer.resultado_parecer && $scope.parecer.resultado_parecer.value?$scope.parecer.resultado_parecer.value:''}],
					['\n\n\n\nParecer da Comissão']
				);
			}
			content.push(base);
			PdfService.getPdf(content);
		};
		function validateDate(date){
			return date ? moment(date).format('DD/MM/YYYY') : null;
		}
		function dateToPHP(date){
			if( /\d{1,2}\/\d{1,2}\/\d{4}/.test(date) ){
				return date.split('/').reverse().join('-');
			}
			return date;
		}
		function validaResult(result){
			if(!$scope.isAdmin){
				result.dt_encam = result.dt_encam?moment(result.dt_encam).format('DD/MM/YYYY'):null;
				result.dt_pedido = result.dt_pedido?moment(result.dt_pedido).format('DD/MM/YYYY'):null;
				result.dt_retorno = result.dt_retorno?moment(result.dt_retorno).format('DD/MM/YYYY'):null;
			}else{
				result.dt_encam = result.dt_encam?moment(result.dt_encam).valueOf():null;
				result.dt_pedido = result.dt_pedido?moment(result.dt_pedido).valueOf():null;
				result.dt_retorno = result.dt_retorno?moment(result.dt_retorno).valueOf():null;
			}

			var a = Object.values($scope.tipos).map(function(e,i){if(e.id==result.idTipo){return e;}}).filter(function(e){return !!e});
			if(a.length > 0){
				result.tipo = a[0];
			}
			a = Object.values($scope.programas).map(function(e,i){if(e.value==result.area || e.id==result.codarea){return e;}}).filter(function(e){return !!e});
			if(a.length > 0){
				result.programa = a[0];
			}
			a = Object.values($scope.resultados).map(function(e,i){if(e.id==result.idStatus){return e;}}).filter(function(e){return !!e});
			if(a.length > 0){
				result.resultado = a[0];
			}
			a = Object.values($scope.resultados_parecer).map(function(e,i){if(e.id==result.idStatusParecer){return e;}}).filter(function(e){return !!e});
			if(a.length > 0){
				result.resultado_parecer = a[0];
			}
			a = Object.values($scope.pareceristas).map(function(e,i){if(e.id==result.idUsuarioRelator){return e;}}).filter(function(e){return !!e});
			if(a.length > 0){
				result.nomeRelator = a[0];
			}
			return result;
		}
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.rotinas.protocolo')
  		.controller('ProtocoloPageCtrl', ProtocoloPageCtrl);

	/** @ngInject */
	function ProtocoloPageCtrl($scope, $state, AuthService, RotinasService, $filter, toastr, $uibModal) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}

		var resp = ['backdrop click','escape key press'];
		$scope.busca = {};
		$scope.protocolos = [];
		var defaultAssunto = {id:0,assunto:'Todos os Assuntos'};
		var defaultDestino = {id:0,local:'Todos os Destinos'};
		var maxCod = 1;
		RotinasService.listaMaxProtocolo().then(function(result){
			maxCod = parseInt(result.replace(/\D\-\,\./gi,''))+1;
		});

		RotinasService.listaAssuntos({'todos':true}).then(function(result){
			defaultAssunto = result[0];
			$scope.assuntos = result;
			$scope.busca.assunto = defaultAssunto;
		}).catch(function(error){
			$scope.assuntos = [];
		});

		RotinasService.listaDestinos({'todos':true}).then(function(result){
			defaultDestino = result[0];
			$scope.destinos = result;
			$scope.busca.destino = defaultDestino;
		}).catch(function(error){
			$scope.destinos = [];
		});

		var dados = {codigo:null,interessado:null,assunto:null,destino:null,dataInicial:null,dataFinal:null};
		RotinasService.listaProtocolo(dados).then(function(result){
			$scope.outros = result;
			$scope.protocolos = $scope.outros;
		}).catch(function(error){
			$scope.mensagem = {'aviso':"Nenhum Protocolo para exibir"};
			$scope.outros = [];
			$scope.protocolos = $scope.outros;
		});
		
				
		$scope.pesquisar = function(){
			$scope.mensagem = null;
			var filtros = {
				codigo: $scope.busca.codigo || null,
				interessado: $scope.busca.interessado || null,
				assunto: $scope.busca.assunto && $scope.busca.assunto.assunto?$scope.busca.assunto.assunto:null,
				destino: $scope.busca.destino && $scope.busca.destino.local?$scope.busca.destino.local:null,
				dataInicial: $scope.busca.dataInicial?$filter('date')(moment($scope.busca.dataInicial).toDate(), 'yyyy-MM-dd') : null,
				dataFinal: $scope.busca.dataFinal?$filter('date')(moment($scope.busca.dataFinal).toDate(), 'yyyy-MM-dd') : null
			}
			RotinasService.listaProtocolo(filtros).then(function(result){
				$scope.outros = result;
				$scope.protocolos = $scope.outros;
			}).catch(function(error){
				$scope.mensagem = {'aviso':"Nenhum Protocolo/Expediente para exibir"};
				$scope.outros = [];
				$scope.protocolos = $scope.outros;
			});
		};

		$scope.limpar = function(){
			$scope.busca = {codigo:"",interessado:"",dataInicial:"",dataFinal:""};
			$scope.busca.assunto = defaultAssunto;
			$scope.busca.destino = defaultDestino;
		};

		$scope.adicionarProtocolo = function(){
			RotinasService.setProtocolo(null);
			$state.go('rotinas.protocolo.editar', { 'maxCod': maxCod });
		};
		$scope.adicionarExpediente = function(){
			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/rotinas/widget/protocolo/cadastroExpediente.html',
				size : 'md',
				controller : 'CadastroRotinaExpedientePageCtrl',
				/*resolve : {
							maxCod : function() {
								return Math.max.apply(Math,$scope.protocolos.map(function(o){return o.codigo;}));
							}
						}*/
			});
			
			modalInstance.result.then(function(protocolo) {
		        $scope.outros.unshift(protocolo);
		        $scope.protocolos = $scope.outros;
		    }, function (mensagem) {
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1){
		    		toastr.error(mensagem, 'Erro', {});
		    		modalInstance.dismiss();
		    	}
		    });
		};
		$scope.editar = function(item){
			if(item.tipo == "Protocolo"){
				$scope.editarProtocolo(item);
			}else{
				$scope.editarExpediente(item);
			}
		}
		$scope.editarProtocolo = function(protocolo){
			RotinasService.setProtocolo(protocolo);
			$state.go('rotinas.protocolo.editar', { 'maxCod': maxCod });
		};
		$scope.editarExpediente = function( expediente  ){
			var reset = angular.copy(expediente);

			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/rotinas/widget/protocolo/editarExpediente.html',
				size : 'md',
				controller : 'EditarRotinaExpedientePageCtrl',
				resolve : {
							expediente : function() {
								return expediente ;
							}
						}
			});
			
			modalInstance.result.then(function(expediente) {
		        for(var item in $scope.outros){
		        	if($scope.outros[item].id == expediente.id){
		        		$scope.outros[item] = expediente;
		        	}
		        }
		        $scope.protocolos = $scope.outros;
		    }, function (mensagem) {
		    	for(var item in $scope.outros){
		    		if($scope.outros[item].id == reset.id){
		        		$scope.outros[item] = reset;
		        	}
			    }
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1 ){
		    		toastr.error(mensagem, 'Erro', {});
		    		error.dismiss();
		    	}
		    });
		};
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.rotinas.oficio')
  		.controller('OficioPageCtrl', OficioPageCtrl);

	/** @ngInject */
	function OficioPageCtrl($scope, $state, AuthService, RotinasService, $filter, toastr, $uibModal) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		var resp = ['backdrop click','escape key press'];
		$scope.busca = {};
		var dados = {codigo:null,interessado:null,dataInicial:null,dataFinal:null,assunto:null,local:null};
		RotinasService.listaOficios(dados).then(function(result){
			$scope.outros = result;
			$scope.oficio = $scope.outros;
		}).catch(function(error){
			$scope.mensagem = {'aviso':"Nenhum Ofício para exibir"};
			$scope.outros = [];
			$scope.oficio = $scope.outros;
		});
		
				
		$scope.pesquisar = function(){
			$scope.mensagem = null;
			var filtros = {
				codigo: $scope.busca.codigo || null,
				interessado: $scope.busca.interessado || null,
				dataInicial: $filter('date')($scope.busca.dataInicial, 'yyyy-MM-dd') || null,
				dataFinal: $filter('date')($scope.busca.dataFinal, 'yyyy-MM-dd') || null,
				assunto: $scope.busca.assunto || null,
				local: $scope.busca.local || null
			}
			RotinasService.listaOficios(filtros).then(function(result){
				$scope.outros = result;
				$scope.oficio = $scope.outros;
			}).catch(function(error){
				$scope.mensagem = {'aviso':"Nenhum Ofício para exibir"};
				$scope.outros = [];
				$scope.oficio = $scope.outros;
			});
		};

		$scope.limpar = function(){
			$scope.busca = {codigo:"",interessado:"",dataInicial:"",dataFinal:"",assunto:"",local:""};
		};

		$scope.adicionar = function(){
			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/rotinas/widget/oficio/cadastroOficio.html',
				size : 'md',
				controller : 'CadastroRotinaOficioPageCtrl',
			});
			
			modalInstance.result.then(function(oficio) {
		        $scope.outros.unshift(oficio);
		        $scope.oficio = $scope.outros;
		    }, function (mensagem) {
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1){
		    		toastr.error(mensagem, 'Erro', {});
		    		modalInstance.dismiss();
		    	}
		    });
		};

		$scope.editar = function( oficio ){
			var reset = angular.copy(oficio);
			
			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/rotinas/widget/oficio/editarOficio.html',
				size : 'md',
				controller : 'EditarRotinaOficioPageCtrl',
				resolve : {
							oficio : function() {
								return oficio;
							}
						}
			});
			
			modalInstance.result.then(function(oficio) {
				var excluir = true;
				if(isNaN(oficio)){
					excluir = false;
				}
		        for(var item in $scope.outros){
		        	if(excluir && $scope.outros[item].id == oficio){
		        		$scope.outros.splice(item,1);
		        	}else{
			        	if($scope.outros[item].id == oficio.id){
			        		$scope.outros[item] = oficio;
			        	}
		        	}
		        }
		        $scope.oficio = $scope.outros;
		        
		    }, function (mensagem) {
		    	for(var item in $scope.outros){
		    		if($scope.outros[item].idOficio == reset.idOficio){
		        		$scope.outros[item] = reset;
		        	}
			    }
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1 ){
		    		toastr.error(mensagem, 'Erro', {});
		    		error.dismiss();
		    	}
		    });
		};
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.rotinas.titulo')
  		.controller('TituloPageCtrl', TituloPageCtrl);

	/** @ngInject */
	function TituloPageCtrl($scope, $state, AuthService, RotinasService, $filter, toastr, $uibModal) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		var resp = ['backdrop click','escape key press'];
		$scope.busca = {};
		$scope.titulos = [];
		var dados = {codigo:null,nome:null,dataInicial:null,dataFinal:null};
		RotinasService.listaTitulos(dados).then(function(result){
			$scope.outros = result;
			$scope.titulos = $scope.outros;
		}).catch(function(error){
			$scope.mensagem = {'aviso':"Nenhum Título para exibir"};
			$scope.outros = [];
			$scope.titulos = $scope.outros;
		});
		
				
		$scope.pesquisar = function(){
			$scope.mensagem = null;
			var filtros = {
				codigo: $scope.busca.codigo || null,
				nome: $scope.busca.nome || null,
				dataInicial: $filter('date')($scope.busca.dataInicial, 'yyyy-MM-dd') || null,
				dataFinal: $filter('date')($scope.busca.dataFinal, 'yyyy-MM-dd') || null
			}
			RotinasService.listaTitulos(filtros).then(function(result){
				$scope.outros = result;
				$scope.titulos = $scope.outros;
			}).catch(function(error){
				$scope.mensagem = {'aviso':"Nenhum Titulo para exibir"};
				$scope.outros = [];
				$scope.titulos = $scope.outros;
			});
		};

		$scope.limpar = function(){
			$scope.busca = {codigo:"",nome:"",dataInicial:"",dataFinal:""};
		};

		$scope.adicionar = function(){
			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/rotinas/widget/titulos/cadastroTitulos.html',
				size : 'md',
				controller : 'CadastroRotinaTitulosPageCtrl',
				resolve : {
							maxCod : function() {
								return Math.max.apply(Math,$scope.titulos.map(function(o){return o.codigo;}));
							}
						}
			});
			
			modalInstance.result.then(function(titulo) {
		        $scope.outros.unshift(titulo);
		        $scope.titulos = $scope.outros;
		    }, function (mensagem) {
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1){
		    		toastr.error(mensagem, 'Erro', {});
		    		modalInstance.dismiss();
		    	}
		    });
		};

		$scope.editar = function( titulo ){
			titulo.dataspg = titulo.dataspg?moment(titulo.dataspg).toDate():null;
			titulo.datadef = titulo.datadef?moment(titulo.datadef).toDate():null;
			titulo.aprocpg = titulo.aprocpg?moment(titulo.aprocpg).toDate():null;
			titulo.aprogreg = titulo.aprogreg?moment(titulo.aprogreg).toDate():null;
			titulo.aprocama = titulo.aprocama?moment(titulo.aprocama).toDate():null;

			var reset = angular.copy(titulo);

			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/rotinas/widget/titulos/editarTitulos.html',
				size : 'md',
				controller : 'EditarRotinaTitulosPageCtrl',
				resolve : {
							titulo : function() {
								return titulo;
							}
						}
			});
			
			modalInstance.result.then(function(titulo) {
				var item = -1
				var a = Object.values($scope.outros).map(function(e){if(e.id==titulo.id){item=i;return e;}}).filter(function(e){return !!e});
				if(a.length>0 && item != -1){
		        	$scope.outros[item] = a;
		        }else{
		        	$scope.outros[item] = reset
		        }
		        $scope.titulos = $scope.outros;
		        
		    }, function (mensagem) {
		    	var item = -1;
				var a = Object.values($scope.outros).map(function(e,i){if(e.id==reset.idProtoExpediente){item=i;return e;}}).filter(function(e){return !!e});
		    	if(a.length > 0 && item != -1){
		    		$scope.outros[item] = reset;
		    	}
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1 ){
		    		toastr.error(mensagem, 'Erro', {});
		    		error.dismiss();
		    	}
		    });
		};
	}

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons')
      .controller('ButtonPageCtrl', ButtonPageCtrl);

  /** @ngInject */
  function ButtonPageCtrl($scope, $timeout) {
    $scope.progressFunction = function() {
      return $timeout(function() {}, 3000);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons')
      .controller('IconsPageCtrl', IconsPageCtrl);

  /** @ngInject */
  function IconsPageCtrl($scope) {
    $scope.icons = {
      kameleonIcons: [
        {
          name: 'Beach',
          img: 'Beach'
        },
        {
          name: 'Bus',
          img: 'Bus'
        },
        {
          name: 'Cheese',
          img: 'Cheese'
        },
        {
          name: 'Desert',
          img: 'Desert'
        },
        {
          name: 'Images',
          img: 'Images'
        },
        {
          name: 'Magician',
          img: 'Magician'
        },
        {
          name: 'Makeup',
          img: 'Makeup'
        },
        {
          name: 'Programming',
          img: 'Programming'
        },
        {
          name: 'Shop',
          img: 'Shop'
        },
        {
          name: 'Surfer',
          img: 'Surfer'
        },
        {
          name: 'Phone Booth',
          img: 'Phone-Booth'
        },
        {
          name: 'Ninja',
          img: 'Ninja'
        },
        {
          name: 'Apartment',
          img: 'Apartment'
        },
        {
          name: 'Batman',
          img: 'Batman'
        },
        {
          name: 'Medal',
          img: 'Medal-2'
        },
        {
          name: 'Money',
          img: 'Money-Increase'
        },
        {
          name: 'Street View',
          img: 'Street-View'
        },
        {
          name: 'Student',
          img: 'Student-3'
        },
        {
          name: 'Bell',
          img: 'Bell'
        },
        {
          name: 'Woman',
          img: 'Boss-5'
        },
        {
          name: 'Euro',
          img: 'Euro-Coin'
        },
        {
          name: 'Chessboard',
          img: 'Chessboard'
        },
        {
          name: 'Burglar',
          img: 'Burglar'
        },
        {
          name: 'Dna',
          img: 'Dna'
        },
        {
          name: 'Clipboard Plan',
          img: 'Clipboard-Plan'
        },
        {
          name: 'Boss',
          img: 'Boss-3'
        },
        {
          name: 'Key',
          img: 'Key'
        },
        {
          name: 'Surgeon',
          img: 'Surgeon'
        },
        {
          name: 'Hacker',
          img: 'Hacker'
        },
        {
          name: 'Santa',
          img: 'Santa'
        }
      ],
      kameleonRoundedIcons: [
        {
          color: 'success',
          img: 'Apartment',
          name: 'Apartment'
        },
        {
          color: 'warning',
          img: 'Bus',
          name: 'Bus'
        },
        {
          color: 'primary',
          img: 'Checklist',
          name: 'Checklist'
        },
        {
          color: 'warning',
          img: 'Desert',
          name: 'Desert'
        },
        {
          color: 'danger',
          img: 'Laptop-Signal',
          name: 'Laptop Signal'
        },
        {
          color: 'info',
          img: 'Love-Letter',
          name: 'Love Letter'
        },
        {
          color: 'success',
          img: 'Makeup',
          name: 'Makeup'
        },
        {
          color: 'primary',
          img: 'Santa',
          name: 'Santa'
        },
        {
          color: 'success',
          img: 'Surfer',
          name: 'Surfer'
        },
        {
          color: 'info',
          img: 'Vector',
          name: 'Vector'
        },
        {
          color: 'warning',
          img: 'Money-Increase',
          name: 'Money Increase'
        },
        {
          color: 'info',
          img: 'Alien',
          name: 'Alien'
        },
        {
          color: 'danger',
          img: 'Online-Shopping',
          name: 'Online Shopping'
        },
        {
          color: 'warning',
          img: 'Euro-Coin',
          name: 'Euro'
        },
        {
          color: 'info',
          img: 'Boss-3',
          name: 'Boss'
        }
      ],
      ionicons: ['ion-ionic', 'ion-arrow-right-b', 'ion-arrow-down-b', 'ion-arrow-left-b', 'ion-arrow-up-c', 'ion-arrow-right-c', 'ion-arrow-down-c', 'ion-arrow-left-c', 'ion-arrow-return-right', 'ion-arrow-return-left', 'ion-arrow-swap', 'ion-arrow-shrink', 'ion-arrow-expand', 'ion-arrow-move', 'ion-arrow-resize', 'ion-chevron-up', 'ion-chevron-right', 'ion-chevron-down', 'ion-chevron-left', 'ion-navicon-round', 'ion-navicon', 'ion-drag', 'ion-log-in', 'ion-log-out', 'ion-checkmark-round', 'ion-checkmark', 'ion-checkmark-circled', 'ion-close-round', 'ion-plus-round', 'ion-minus-round', 'ion-information', 'ion-help', 'ion-backspace-outline', 'ion-help-buoy', 'ion-asterisk', 'ion-alert', 'ion-alert-circled', 'ion-refresh', 'ion-loop', 'ion-shuffle', 'ion-home', 'ion-search', 'ion-flag', 'ion-star', 'ion-heart', 'ion-heart-broken', 'ion-gear-a', 'ion-gear-b', 'ion-toggle-filled', 'ion-toggle', 'ion-settings', 'ion-wrench', 'ion-hammer', 'ion-edit', 'ion-trash-a', 'ion-trash-b', 'ion-document', 'ion-document-text', 'ion-clipboard', 'ion-scissors', 'ion-funnel', 'ion-bookmark', 'ion-email', 'ion-email-unread', 'ion-folder', 'ion-filing', 'ion-archive', 'ion-reply', 'ion-reply-all', 'ion-forward'],
      fontAwesomeIcons: ['fa fa-adjust', 'fa fa-anchor', 'fa fa-archive', 'fa fa-area-chart', 'fa fa-arrows', 'fa fa-arrows-h', 'fa fa-arrows-v', 'fa fa-asterisk', 'fa fa-at', 'fa fa-automobile', 'fa fa-ban', 'fa fa-bank', 'fa fa-bar-chart', 'fa fa-bar-chart-o', 'fa fa-barcode', 'fa fa-bars', 'fa fa-bed', 'fa fa-beer', 'fa fa-bell', 'fa fa-bell-o', 'fa fa-bell-slash', 'fa fa-bell-slash-o', 'fa fa-bicycle', 'fa fa-binoculars', 'fa fa-birthday-cake', 'fa fa-bolt', 'fa fa-bomb', 'fa fa-book', 'fa fa-bookmark', 'fa fa-bookmark-o', 'fa fa-briefcase', 'fa fa-bug', 'fa fa-building', 'fa fa-building-o', 'fa fa-bullhorn'],
      socicon: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', ',', ';', ':', '+', '@', '=', '-', '^', '?', '$', '*', '&', '(', '#', '.', '_', ']', ')', '\'', '"', '}', '{']
    }
  }

})();

/**
 * @author a.demeshko
 * created on 18.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
    .controller('ModalsPageCtrl', ModalsPageCtrl);

  /** @ngInject */
  function ModalsPageCtrl($scope, $uibModal, baProgressModal) {
    $scope.open = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.openProgressDialog = baProgressModal.open;
  }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
      .controller('NotificationsPageCtrl', NotificationsPageCtrl);

  /** @ngInject */
  function NotificationsPageCtrl($scope, toastr, toastrConfig) {
    var defaultConfig = angular.copy(toastrConfig);
    $scope.types = ['success', 'error', 'info', 'warning'];

    $scope.quotes = [
      {
        title: 'Come to Freenode',
        message: 'We rock at <em>#angularjs</em>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Looking for bootstrap?',
        message: 'Try ui-bootstrap out!'
      },
      {
        title: 'Wants a better router?',
        message: 'We have you covered with ui-router'
      },
      {
        title: 'Angular 2',
        message: 'Is gonna rock the world'
      },
      {
        title: null,
        message: 'Titles are not always needed'
      },
      {
        title: null,
        message: 'Toastr rock!'
      },
      {
        title: 'What about nice html?',
        message: '<strong>Sure you <em>can!</em></strong>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Ionic is <em>cool</em>',
        message: 'Best mobile framework ever',
        options: {
          allowHtml: true
        }
      }
    ];

    var openedToasts = [];
    $scope.options = {
      autoDismiss: false,
      positionClass: 'toast-top-right',
      type: 'info',
      timeOut: '5000',
      extendedTimeOut: '2000',
      allowHtml: false,
      closeButton: false,
      tapToDismiss: true,
      progressBar: false,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
      title: "Some title here",
      msg: "Type your message here"
    };


    $scope.clearLastToast = function () {
      var toast = openedToasts.pop();
      toastr.clear(toast);
    };

    $scope.clearToasts = function () {
      toastr.clear();
    };

    $scope.openRandomToast = function () {
      var type = Math.floor(Math.random() * $scope.types.length);
      var quote = Math.floor(Math.random() * $scope.quotes.length);
      var toastType = $scope.types[type];
      var toastQuote = $scope.quotes[quote];
      openedToasts.push(toastr[toastType](toastQuote.message, toastQuote.title, toastQuote.options));
      $scope.optionsStr = "toastr." + toastType + "(\'" + toastQuote.message + "\', \'" + toastQuote.title + "', " + JSON.stringify(toastQuote.options || {}, null, 2) + ")";
    };

    $scope.openToast = function () {
      angular.extend(toastrConfig, $scope.options);
      openedToasts.push(toastr[$scope.options.type]($scope.options.msg, $scope.options.title));
      var strOptions = {};
      for (var o in  $scope.options) if (o != 'msg' && o != 'title')strOptions[o] = $scope.options[o];
      $scope.optionsStr = "toastr." + $scope.options.type + "(\'" + $scope.options.msg + "\', \'" + $scope.options.title + "\', " + JSON.stringify(strOptions, null, 2) + ")";
    };

    $scope.$on('$destroy', function iVeBeenDismissed() {
      angular.extend(toastrConfig, defaultConfig);
    })
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
    	  
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, $element, $attrs, $state, baSidebarService, AuthService) {
    var menuItems = baSidebarService.getMenuItems();
    var showMenus = AuthService.menu();
    if(AuthService.getRole() != 3){ //admin
      var removeMenu = [], removeSubMenu = [];
      for(var i in menuItems){
          var sub = true;
          if( showMenus.menu.indexOf(menuItems[i].name) == -1){
              removeMenu.push(i);
          sub = false;
          }
        if( sub ){
          for(var j in menuItems[i].subMenu){
            if( showMenus.submenu.indexOf(menuItems[i].subMenu[j].name) == -1 ){
              removeSubMenu.push([i,j]);
              continue;
            }
          }
        }
      }

      for(var i in removeMenu){
        delete menuItems[removeMenu[i]];
      }
      for(var j in removeSubMenu){
          delete menuItems[removeSubMenu[j][0]].subMenu[removeSubMenu[j][1]];
      }
      menuItems = menuItems.filter(function(e){return !!e});
      menuItems.map(function(e){
        if(e.subMenu){
          e.subMenu = e.subMenu.filter(function(e){return !!e});
        }
      });
    }
    $scope.menuItems = menuItems;

    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy created on 16.12.2015
 */
(function() {
	'use strict';

	angular.module('BlurAdmin.theme.components').directive('contentTop',
			contentTop);

	/** @ngInject */
	function contentTop($location, $state) {
		return {
			restrict : 'E',
			templateUrl : 'app/theme/components/contentTop/contentTop.html',
			link : function($scope) {
				$scope.$watch(function() {
					$scope.activePageTitle = $state.current.title;
					
					var breadchumbs = new Array();
					var parent = $state.$current.parent;
	
					while(parent && parent.self && parent.self.title != "") {
						breadchumbs.push(parent.self.title);
						parent = parent.parent;
					} 
					
					breadchumbs[breadchumbs.length - 1] = $state.$current.self.title;
					
					$scope.activePageBreadchumbs = breadchumbs;
				});
			}
		};
	}
	
	function toTitleCase(str)
	{
	    return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
	}

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {};
      /*0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };*/

    $scope.notifications = [];
      /*{
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];*/

    $scope.messages = [];
      /*{
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];*/

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author Yury Tinos
 * created on 11/05/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('responseMessage', responseMessage);

  /** @ngInject */
  function responseMessage() {
    return {
      restrict: 'AE',
      scope: {
    	  msg: '=',
    	  voltar: '=?',
      },
      templateUrl: 'app/theme/components/responseMessage/responseMessage.html',
      controller: 'ResponseMessageCtrl'
    };
  }

})();
/**
 * @author Yury Tinos
 * created on 11/05/2017
 */
(function () {
	'use strict';

	angular.module('BlurAdmin.theme.components')
    	.controller('ResponseMessageCtrl', ResponseMessageCtrl);

	/** @ngInject */
	function ResponseMessageCtrl($scope) {

		$scope.$watch('msg', function(value) {
			
			$scope.mensagem = null;
			
			if(value) {

				var tipo, tipos = Object.keys(value);
				tipos.length > 0 ? tipo = tipos[0] : tipo = 'erro';
				
				switch (tipo) {
				
					case 'sucesso':
						$scope.type = 'success';
						$scope.title = 'Sucesso!';
					break;
					case 'aviso':
						$scope.type = 'warning';
						$scope.title = 'Aviso!';
					break;
					case 'erro':
					default:
						$scope.type = 'danger';
						$scope.title = 'Ocorreu um Erro!';
					break;
				}
		
				$scope.mensagem = value[tipo];
			}
		});
		
		$scope.$watch('voltar', function(value) {

			$scope.voltar = true;
			
			if(value != null) {
				$scope.voltar = value;
			}
		});
		
		$scope.limparMensagem = function() {
			
			$scope.mensagem = null;
		}
	}
  
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author Yury Tinos
 * created on 09/03/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('rootImage', rootImage);

  /** @ngInject */
  function rootImage(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'jpg';
      return layoutPaths.images.root + input + '.' + ext;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '=',
        switcherOnLabel: '@',
        switcherOffLabel: '@',
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('cpfFormat', cpfFormat);

  /** @ngInject */
  function cpfFormat() {
    return function (text) {
      var str = text + '';
      str = str.replace(/\D/g, "");
      str = '0'.repeat(11) + str;
      str = str.slice(str.length - 11);
      return str.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    };
  }

  angular.module('BlurAdmin.theme')
    .filter('cnpjFormat', cnpjFormat);

  /** @ngInject */
  function cnpjFormat() {
    return function (text) {
      var str = text + '';
      str = str.replace(/\D/g, "");
      str = '0'.repeat(14) + str;
      str = str.slice(str.length - 14);
      return str.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();


(function () {
    'use strict';
    angular.module('BlurAdmin.theme')
        .filter('unique', unique);

    /** @ngInject */
    function unique() {
        return function (collection, keyname) {
            var output = [],
                keys = [];

            angular.forEach(collection, function (item) {
                var key = item[keyname];
                if (keys.indexOf(key) === -1) {
                    keys.push(key);
                    output.push(item);
                }
            });
            return output;
        };
    }


})();

/**
 * @author Yury Tinos Pinheiro
 * created on 03/05/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.alunos.situacao.documentos')
  		.controller('SituacaoAtaExquaAlunosPageCtrl', SituacaoAtaExquaAlunosPageCtrl);

	/** @ngInject */
	function SituacaoAtaExquaAlunosPageCtrl($scope, $state, AlunosService, AuthService, $filter, PdfService, LogService) {
        
        if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
            $scope.mensagem = {'erro':'Usuário não autorizado!'};
            $state.go('administrador.login');
            return;
        }
		// Tela de Dados Basicos
		var aluno = AlunosService.getAluno();
		
		if(aluno == null) {
			$state.go('alunos.situacao');
		}
		else {
			
			AlunosService.buscarAtaExqua(aluno).then(function(data) {
				$scope.ataExqua = data;
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});

			$scope.print = function(){
				LogService.cadastraLog(jQuery.extend($scope.ataExqua, {msg:'Imprime Ata Exqua',sub:AuthService.getUser()}) );
				var content = [
					{text:'ATA DE EXAME DE QUALIFICAÇÃO',style:'header', margin: [0,11], fontSize: 10},
					{text: 
					    [
					        'O(A) aluno(a) ',
					        {text: $scope.ataExqua.nomeAluno, style:'variable'},
					        ' - matrícula ',
					        {text: $scope.ataExqua.matricula, style:'variable'},
					        ' - curso de ',
					        {text: $scope.ataExqua.grauAcademico, style:'variable'},
					        ' ',
					        {text: $scope.ataExqua.areaDeclaracao, style:'default'},
					        ' ',
					        {text: $scope.ataExqua.area, style:'default'},
					        ', submeteu-se ao exame de qualificação, perante a Comissão Examinadora, atendendo ao disposto no Regimento da Pós-Graduação da Universidade de São Paulo.'
					    ], style: 'newRowAta',alignment: 'justify', fontSize: 8, margin: [0,0]
					},
					{text: 'A Comissão Examinadora, indicada pela Comissão Coordenadora do Programa, é de parecer que:', style:'newRowAta',alignment: 'justify', fontSize: 8, margin: [0,0]},
					{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 1 }],style:'hr',margin: [0,8,0,0] },
					{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 1 }],style:'hr',margin: [0,8,0,0] },
					{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 1 }],style:'hr',margin: [0,8,0,0] },
					{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 1 }],style:'hr',margin: [0,8,0,0] },
					{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 1 }],style:'hr',margin: [0,8,0,0] },
					{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 1 }],style:'hr',margin: [0,8,0,0] },
					{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 1 }],style:'hr',margin: [0,8,0,0] },
					{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 1 }],style:'hr',margin: [0,8,0,0] },
					{text: 'Membros Participantes da Comissão Examinadora', style:'centerAta', bold:true, fontSize: 8},
					{text: 'Assinale com um "X" - Aprovado (APR) ou Reprovado (REP) e assine', style:'centerAta', bold:true,margin: [0,0], fontSize: 8},
					{text: 'São Paulo,  ______ de _______________________ de 20 ______', style:'centerAta', fontSize: 8},
		        ];
		        var mapItems = [];
				$('.sub-linha').map(function(i,v){ mapItems.push($(v).val()); });
				var i=0,j=0;
		        for(var participante in $scope.ataExqua.bancada){
		        	var a = mapItems[i++];
		        	var b = mapItems[i++];
		        	var l = { canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 0.5 }],style:'hr', margin: [0, (j++==0?15:10), 0, 0] };
					content.push(l);
					content.push({text: '( '+(a == ''? ' ':a)+' ) APR ( '+(b == ''? ' ':b)+' ) REP - ' + ($scope.ataExqua.bancada[participante].nome || '')+' - '+$filter('uppercase')($scope.ataExqua.bancada[participante].titulo) || '', style:'variable',bold:true, fontSize: 9});
				}
				content.push({text: 'DATA DE HOMOLOGAÇÃO PELA CCP ______ / ______ / __________', style:'centerAta', fontSize: 8,margin:[0,15,0,0]});
				content.push({text: '________________________________________', style:'centerAta', fontSize: 8,margin:[0,10,0,0]});
				content.push({text: 'ASSINATURA COORDENADOR', style:'default',alignment:'center', fontSize: 8});

				PdfService.getPdf(content);
			}
		}
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 03/05/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.alunos.situacao.documentos')
  		.controller('SituacaoBancaDefesaAlunosPageCtrl', SituacaoBancaDefesaAlunosPageCtrl);

	/** @ngInject */
	function SituacaoBancaDefesaAlunosPageCtrl($scope, $state, AlunosService, AuthService, $filter, PdfService, LogService) {
        
        if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
            $scope.mensagem = {'erro':'Usuário não autorizado!'};
            $state.go('administrador.login');
            return;
        }

		// Tela de Dados Basicos
		var aluno = AlunosService.getAluno();
		
		if(aluno == null) {
			$state.go('alunos.situacao');
		}
		else {
			
			AlunosService.buscarBancaDefesa(aluno).then(function(data) {
				$scope.bancaDefesa = data;
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
			$scope.print = function(){
				LogService.cadastraLog(jQuery.extend($scope.bancaDefesa, {msg:'Imprime Banca de Defesa',sub:AuthService.getUser()}) );
				var content = [
					{text:'Senhor(a) Professor(a),',style:'textInicial'},
					{text:
						[
						    'Encaminho-lhe a composição da Comissão Julgadora da ',
						    {text: $scope.bancaDefesa.nivel || '', style:'variable'},
						    ' do(a) pós-graduando(a) ',
						    {text: $scope.bancaDefesa.nomeAluno || '' },
						    ' devidamente aprovada pelo Sr. Presidente da Comissão de Pós-Graduação da FMUSP. Prof. ',
							{text: $scope.bancaDefesa.nomePresidente || '', style:'variable'},
						    ' "ad referendum" em ',
						    {text: $scope.bancaDefesa.dataProvaBanca || '', style:'variable'}, 
						    ', solicitando-lhe a fineza de agendar a data, horario e local.'
						], style:'paragraph'
					},
					{ canvas: [{ type: 'line', x1: 0, y1: 10, x2: 520, y2: 10, lineWidth: 0.5 }], style:'hr' }
				];
				var base = {
					table: {
					    widths: [340, '*'],
						body: [],
						},
					layout: 'noBorders', style:'default'
				};
				for(var participante in $scope.bancaDefesa.bancada){
					base.table.body.push([{text: $scope.bancaDefesa.bancada[participante].nome || '',style:'default'},{text: $filter('uppercase')($scope.bancaDefesa.bancada[participante].titulo || ''),style:'default'}]);
				}
				content.push(base);
				content.push({canvas: [{ type: 'line', x1: 0, y1: 5, x2: 520, y2: 5, lineWidth: 0.5 }], style:'default' });
				content.push({text:
					[
					    {text:'Obs.: ', style:'variable'},
					    'Por deliberação da CPG, a defesa só pode ocorrer, no mínimo, 30(trinta) dias a contar da data do agendamento da mesma.',
					], style:'newRow'
				});
				content.push({text: 'Atenciosamente,', style:'center'});
				content.push({text: 'Para ciência:',style:'newRow'});
				content.push({text: $scope.bancaDefesa.descricaoCargo || '',style:'variable'});
				
				PdfService.getPdf(content);
			};
		}
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 03/05/2017
 */

(function () {
	'use strict';

	angular.module('BlurAdmin.pages.alunos.situacao.documentos')
	.controller('SituacaoReciboAlunosPageCtrl', SituacaoReciboAlunosPageCtrl);

	/** @ngInject */
	function SituacaoReciboAlunosPageCtrl($scope, $state, AlunosService, PdfService, $filter, LogService, AuthService) {

		$scope.mensagem = null;
		
		// Tela de Dados Basicos
		var aluno = AlunosService.getAluno();
		if(aluno == null) {
			$state.go('alunos.situacao');
		}
		else {
			
			AlunosService.buscarRecibo(aluno).then(function(data) {
				$scope.recibo = data;
				if(!$scope.recibo.nome){
					$scope.recibo.nome = aluno.nome;
				}
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
			$scope.print = function(){
				LogService.cadastraLog(jQuery.extend($scope.diploma, {msg:'Imprime Recibo',sub:AuthService.getUser()}) );
				var content = [//
						{text: ['Diploma e Histórico de Pós-Graduação\n','Comprovante de Retirada'],alignment:'center', bold:true, style:'textInicial', margin:[0,60,0,0]},
						{text:
						    [
								'O pós-graduando ', 
								{text: $scope.recibo.nome || '', style:'variable'}, 
								' retirou o diploma e o histórico escolar de ',
								{text: $scope.recibo.nivel || '', style:'variable'},
								', nesta data'
						    ]
						    ,style:'paragraph', margin:[0,69,0,0]
						},
						{text:
						    [
						        {text: 'Observações:', style:'variable'}
						    ]
						    ,style:'default', margin:[0,30,0,0]
						},
						{text:
						    [
						        '(   ) enviado para correção'
						    ]
						    ,style:'default', margin:[0,10,0,0]
						},
						{text:
						    [
						        {text: $scope.recibo.dataExtenso || '', style:'variable',alignment:'center'}
						    ]
						    ,style:'default', margin:[0,60,0,0]
						},
					];
				content.push({canvas: [{ type: 'line', x1: 150, y1: 5, x2: 350, y2: 5, lineWidth: 0.5 }], style:'default', margin:[0,60,0,0] });
				content.push({text: [{text: $scope.recibo.nome || '', style:'variable'}], style:'default',alignment:'center' });
				PdfService.getPdf(content);
			};
		}
	}

})();

/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.agendamento.preAgendamento')
			.controller('CadastroAgendamentoPageCtrl', CadastroAgendamentoPageCtrl);

	/** @ngInject */
	function CadastroAgendamentoPageCtrl(
			$scope, 
			$state, 
			$uibModal, 
			$uibModalInstance, 
			dataAgendamento, 
			evento, 
			agendamentos, 
			aluno, 
			AgendamentoService, 
			AuthService, 
			AreasService
		) {
		
		if( !AuthService.isAuthorizedToAccess([1,2,3]) ){ //aluno,secretaria,admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}

		// Combobox de Área
		// $scope.areas = null;
		// AreasService.listarAreas()
		// .then(function(areas) {
		// 	$scope.areas = areas;
		// })
		// .catch(function(mensagem) {	
		// 	$scope.mensagem = mensagem;
		// });

		$scope.agora = moment();
		$scope.termos = {};
		$scope.termos.aceite = false;
		$scope.isAdmin = false;
		if( AuthService.isAuthorizedToAccess([3]) ){
			$scope.isAdmin = true;
		}
		
		function resetData(){
			$scope.alunos = [];
			$scope.niveis = [];
		}
		resetData();
		$scope.bloquear = true;
		$scope.querySearch   = querySearch;
		$scope.aluno = {};
		$scope.aluno.nome = aluno.nome;
		$scope.aluno.nivel = aluno.nivel;
		$scope.aluno.matricula = aluno.matricula;
		$scope.horaAgendamento = AgendamentoService.periodos();
		$scope.anfiteatroSelecionado = {};
		$scope.setAnfiteatro = function(anfiteatro){
			$scope.anfiteatroSelecionado = anfiteatro;
		}

		$scope.setMatricula = function(aluno){
			if(!$scope.isAdmin){
				return;
			}
			$scope.aluno.matricula = aluno.codpes;
			$scope.error = null;
			if($scope.aluno.matricula == ''){
				$scope.error = "Aluno não esta ativo";
			}else{
				$scope.setNiveis(aluno.codpes);
				$scope.setAreas(aluno.codpes);
			}
		}
		$scope.setNiveis = function (matricula){
			$scope.niveis = [];
			AgendamentoService.listaNiveis(matricula)
			.then(function(resp){
				$scope.niveis = resp;
			}).catch(function() {
				$scope.error = "Aluno não esta ativo";
			});
		}
		$scope.setAreas = function (matricula){
			$scope.areas = [];
			AgendamentoService.listaAreas(matricula)
			.then(function(resp){
				$scope.areas = resp;
			}).catch(function() {
				$scope.error = "Aluno não esta ativo";
			});
		}
		$scope.selAluno = function (matricula){
			$scope.error = null;
			AgendamentoService.listaAlunos(null, matricula)
			.then(function(resp){
				$scope.alunos = resp;
				$scope.aluno.nome = $scope.alunos[0];
			}).catch(function() {
				$scope.error = "Aluno não esta ativo";
			});
		}

		$scope.setNome = function(matricula){
			if(!$scope.isAdmin){
				return;
			}

			$scope.selAluno(matricula)
			$scope.setNiveis(matricula);
			$scope.setAreas(matricula);
		};

		$scope.setAluno = function(nivel, matricula, area){
			if(!$scope.isAdmin){
				return;
			}
			if(nivel && area){
				if(typeof nivel == "object"){
					nivel = nivel.nivpgm;
				}
				AgendamentoService.selecionaAluno(nivel, matricula, area)
				.then(function(resp) {
					$scope.classRed = '';
					$scope.bloquear = false;
					if(resp && resp.length>0){
						var aluno = resp[0];
						$scope.error = null;
						$scope.aluno.evento.dataLimite = aluno.dt_lim;
						$scope.aluno.areaId = aluno.codare;
						$scope.aluno.nomeArea = aluno.nomare;
						$scope.aluno.nivelSelecionado = aluno.nivpgm;
						if( moment($scope.aluno.evento.dataLimite).toDate() < moment().toDate() ){
							$scope.classRed = 'color-red';
							$scope.bloquear = true;
						}
					}
				}).catch(function(){
					$scope.error = "Aluno não esta ativo";
				});
			}
		};
	    
		function querySearch (searchText) {
			AgendamentoService.listaAlunos(searchText)
			.then(function(resp) {
				$scope.error = null;
				if(resp && resp.length>0){
					$scope.alunos = resp;
				}else{
					$scope.error = "Aluno não esta ativo";
					resetData();
					$scope.aluno.nome = searchText;
				}
			}).catch(function(data){
				$scope.error = "Aluno não esta ativo";
				resetData();
			});
		}

		$scope.BotaoSalvar = "Cadastrar";
		$scope.BotaoExcluir = "Cancelar";
		
		$scope.anfiteatros = null;
		$scope.anfiteatro = {
			nome : null,
			endereco: null,
		};
			
		AgendamentoService.listarAnfiteatros($scope.anfiteatro).then(function(data) {
			$scope.mensagem = null;
			$scope.anfiteatros = data;
			if(!$scope.aluno){
				$scope.aluno = {};
			}
			if(!$scope.aluno.evento){
				$scope.aluno.evento = {};
			}
			$scope.aluno.evento.anfiteatro = $scope.anfiteatros[0];
			$scope.anfiteatro = $scope.anfiteatros[0];
			$scope.anfiteatroSelecionado = $scope.anfiteatros[0];
		})
		.catch(function(mensagem) {
			$scope.mensagem = mensagem;
		});
		
		var minDate = !$scope.isAdmin?moment(agendamentos.dias.vigencia.start).add(1,'days').hour(0).minute(0).second(0).toDate():moment('2017-01-01').toDate();
		var maxDate = !$scope.isAdmin?moment(agendamentos.dias.vigencia.end).subtract(1,'days').hour(0).minute(0).second(0).toDate():moment('2100-01-01').toDate();

		$scope.datePickerOptions = {
			dateDisabled: function(data) {
				
				var bloquear = false;
				agendamentos.dias.feriados.forEach(function(feriado, index) {
					if(!bloquear && moment(data.date).isBetween(moment(feriado.start), moment(feriado.end).add(1, 'days')))
						bloquear = true;
				});

				agendamentos.eventos.filter(function(e){ return e.tipo == 'P';}).forEach(function(feriado, index){
					if(!bloquear && parseFloat(moment(data.date).format('YYYYMMDDHHmmssSSSS')) == parseFloat(moment(feriado.start).format('YYYYMMDDHHmmssSSSS')) ){
							bloquear=true;
							return;
					}
				});

				if( [0,6].indexOf(data.date.getDay()) !== -1 ){
					bloquear = true;
				}
				
				return bloquear;
			},
	    minDate: minDate,
			maxDate: maxDate,
		};

		
		$scope.aluno.evento = {};
		$scope.aluno.evento.dataAgendamento = dataAgendamento.add(1, 'days').toDate();
		$scope.aluno.evento.horaAgendamento = $scope.horaAgendamento[0];//moment({ hour: 8, minute: 0 }).toDate();
		$scope.aluno.evento.dataLimite = moment(agendamentos.dias.vigencia.end).toDate();
		$scope.aluno.evento.dataSolicitacao = moment().toDate();
		$scope.classRed = '';
		if( moment($scope.aluno.evento.dataLimite).toDate() < moment().toDate() ){
			$scope.classRed = 'color-red';
		}


		$scope.salvar = function( ) {
			if(!$scope.isAdmin && !$scope.termos.aceite){
				var modalInstance = $uibModal.open({
					animation : true,
					template : '<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-information-circled modal-icon"></i><span>Erro</span></div><div class="modal-body text-center">É necessário aceitar os termos de agendamento</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button></div></div>',
					size : 'md',
				});
				return false;
			}
			var horaAgendamento = $scope.aluno.evento.horaAgendamento.value || $scope.aluno.evento.horaAgendamento;
			var dataHoraAgendamento = moment($scope.aluno.evento.dataAgendamento).format('YYYY-MM-DD')+' '+horaAgendamento;
			
			if( parseFloat(moment(dataHoraAgendamento).format('YYYYMMDDHHmmssSSSS')) < parseFloat(moment(agendamentos.dias.vigencia.start).format('YYYYMMDDHHmmssSSSS'))
				|| parseFloat(moment(dataHoraAgendamento).format('YYYYMMDDHHmmssSSSS')) > parseFloat(moment(agendamentos.dias.vigencia.end).format('YYYYMMDDHHmmssSSSS')) ){
				$uibModalInstance.dismiss("Não pode ser agendado nesta data e horário, pois seu periodo de agendamento inicia em " + moment(agendamentos.dias.vigencia.start).format('DD/MM/YYYY HH:mm:ss') );
				return;
			}
			
			//OK
			var dataLimite = $scope.aluno.evento.dataLimite || null;

			var campos = {
				nome: aluno.nome || $scope.aluno.nome.nompes || aluno.nome || null,
				nivel: aluno.nivel || $scope.aluno.nivelSelecionado || $scope.aluno.nivel || null,
				codArea: aluno.areaId || $scope.aluno.areaId || null,
				nomeArea: aluno.nomeArea || $scope.aluno.nomeArea || null,
				area: aluno.area || $scope.aluno.area || null,
				matricula: aluno.matricula || $scope.aluno.nome.codpes || null,
				agendamento: dataHoraAgendamento,
				dataLimite: dataLimite != null ? moment(dataLimite).format('YYYY-MM-DD HH:mm') : null,
				dataSolicitacao: moment().format('YYYY-MM-DD HH:mm'),
				anfiteatro: $scope.anfiteatroSelecionado.nome || null,
				idAnfiteatro: $scope.anfiteatroSelecionado.id || null,
				user: AuthService.getUser() || 0
			};
			var validacao = {
				nome: campos.nome, 
				nivel: campos.nivel, 
				matricula: campos.matricula,
				area: campos.area,
				data: campos.agendamento, 
				anfiteatro: campos.anfiteatro
			};
			for(var i in validacao){
				if(validacao[i] == null || validacao[i] == ""){
					var modalInstance = $uibModal.open({
						animation : true,
						template : '<div class="modal-content">\
													<div class="modal-header bg-warning">\
														<i class="ion-information-circled modal-icon"></i>\
														<span>Erro</span>\
													</div>\
													<div class="modal-body text-center">\
														O campo ' + i + ' precisa ser preenchido\
													</div>\
													<div class="modal-footer">\
														<button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button>\
													</div>\
												</div>',
						size : 'md',
					});
					return false;
				}
			}

			AgendamentoService.inserirAgenda(campos).then(function(agendamento) {
				var evento = {
					id: agendamento.id,
					title: campos.nome,
					allDay: false,
					start: moment(campos.agendamento),
					overlap: true,
					tipo: 'E',
				};
				//$uibModalInstance.dismiss("Salvo com sucesso");
				agendamentos.eventos.push(evento);
				$uibModalInstance.close(evento);	
			})
			.catch(function(mensagem) {		
				$uibModalInstance.dismiss(mensagem);
			});	
		}
		$scope.excluir = function( ) {
			$uibModalInstance.close();
			//$uibModalInstance.dismiss();
		}
	}
	
})();
/**
 * @author Yury Tinos Pinheiro created on 07/03/2017
 */

(function() {
	'use strict';

	angular.module('BlurAdmin.pages.agendamento.preAgendamento')
			.controller('EditarAgendamentoPageCtrl', EditarAgendamentoPageCtrl);

	/** @ngInject */
	function EditarAgendamentoPageCtrl($scope, $state, toastr, $uibModal, $uibModalInstance, dataAgendamento, aluno, evento, agendamentos, AgendamentoService, AuthService) {
		
		if( !AuthService.isAuthorizedToAccess([1,2,3]) ){ //secretaria,admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		if(!evento.id){
			$uibModalInstance.dismiss("Evento não pode ser carregado, tente novamente mais tarde!");
		}
		$scope.termos = {};
		$scope.termos.aceite = false;
		$scope.isAdmin = false;
		if( AuthService.isAuthorizedToAccess([3]) ){
			$scope.isAdmin = true;
		}
		$scope.BotaoSalvar = "Salvar";
		$scope.BotaoExcluir = "Excluir";
		var dadosAluno = aluno;

		var minDate = !$scope.isAdmin?moment(agendamentos.dias.vigencia.start).toDate():moment('2000-01-01').toDate();
		var maxDate = !$scope.isAdmin?moment(agendamentos.dias.vigencia.end).toDate():moment('2100-01-01').toDate();

		$scope.datePickerOptions = {
			dateDisabled: function(data) {
				
				var bloquear = false;
				agendamentos.dias.feriados.forEach(function(feriado, index) {
					if(!bloquear && moment(data.date).isBetween(moment(feriado.start), moment(feriado.end)))
						bloquear = true;
				});

				agendamentos.eventos.filter(function(e){ return e.tipo == 'P';}).forEach(function(feriado, index){
					if(!bloquear && parseFloat(moment(data.date).format('YYYYMMDDHHmmssSSSS')) == parseFloat(moment(feriado.start).format('YYYYMMDDHHmmssSSSS')) ){
							bloquear=true;
							return;
					}
				});

				if( [0,6].indexOf(data.date.getDay()) !== -1 ){
					bloquear = true;
				}
				
				return bloquear;
			},
	    	minDate: minDate,
			maxDate: maxDate,
		};
		AgendamentoService.getEvento(evento).then(function(resultado){
			$scope.dadosEvento = resultado;
			var aluno = {
				nome : resultado.nome,
				matricula : resultado.matricula,
				nivel : resultado.nivel,
				area : resultado.area,
				evento: {
					dataAgendamento: resultado.dataagdef != null ? new Date(resultado.dataagdef).getTime() : null,
					horaAgendamento: resultado.dataagdef != null ? moment(new Date(resultado.dataagdef).getTime()).format('HH:mm:ss') : null,
					dataLimite: resultado.dtalimite != null ? new Date(resultado.dtalimite).getTime() : null,
					dataSolicitacao: resultado.dtasolicitacao != null ? new Date(resultado.dtasolicitacao).getTime() : null,
					anfiteatro : {
						nome: resultado.anfiteatro
					}
				},
				anfiteatro : resultado.anfiteatro,
				idAnfiteatro : resultado.idAnfiteatro
			};
			if(aluno == null) {
				$uibModalInstance.dismiss("Aluno é obrigatório");
			}
			else {

				$scope.aluno = aluno;
				$scope.anfiteatroSelecionado = $scope.aluno.evento.anfiteatro;
				$scope.horaAgendamento = AgendamentoService.periodos();
				
				var horaSelecionada = $scope.horaAgendamento[0];
				var hora = $scope.horaAgendamento.map(function(e){ if(e.value == aluno.evento.horaAgendamento){return e;}}).filter(function(e){return e});
				if(hora.length > 0){
					horaSelecionada = hora.reduce(function(e){return e});
				}
				$scope.aluno.evento.horaAgendamento = horaSelecionada.nome;
				
				$scope.anfiteatros = null;
				$scope.anfiteatro = {
					nome : null,
					endereco: null,
				};
				
				AgendamentoService.listarAnfiteatros($scope.anfiteatro).then(function(data) {
					$scope.mensagem = null;
					$scope.anfiteatros = data;
					var anfiteatro = $scope.aluno.idAnfiteatro || null;
					$scope.aluno.evento.anfiteatro = data[0];
					if(data.map(function(e){ if(e.id == anfiteatro){return e;}}).filter(function(e){return e}).length > 0 ){
						$scope.aluno.evento.anfiteatro = data.map(function(e){ if(e.id == anfiteatro){return e;}}).filter(function(e){return e}).reduce(function(e){return e});
					}
					$scope.anfiteatroSelecionado = $scope.aluno.evento.anfiteatro;
				})
				.catch(function(mensagem) {
					$scope.mensagem = mensagem;
				});
				
				$scope.setAnfiteatro = function(anfiteatro){
					$scope.anfiteatroSelecionado = anfiteatro;
				}
				$scope.salvar = function() {
					if(!$scope.isAdmin && !$scope.termos.aceite){
						var modalInstance = $uibModal.open({
							animation : true,
							template : '<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-information-circled modal-icon"></i><span>Erro</span></div><div class="modal-body text-center">É necessário aceitar os termos de agendamento</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button></div></div>',
							size : 'md',
						});
						return false;
					}
					var horaSelecionada = $scope.horaAgendamento[0];
					var hora = $scope.horaAgendamento.map(function(e){ if(e.nome == $scope.aluno.evento.horaAgendamento){return e;}}).filter(function(e){return e});
					if(hora.length > 0){
						horaSelecionada = hora.reduce(function(e){return e});
					}
					var dataHoraAgendamento = moment($scope.aluno.evento.dataAgendamento).format('YYYY-MM-DD')+' '+horaSelecionada.value;
					if( parseFloat(moment(dataHoraAgendamento).format('YYYYMMDDHHmmssSSSS')) < parseFloat(moment(agendamentos.dias.vigencia.start).format('YYYYMMDDHHmmssSSSS'))
						|| parseFloat(moment(dataHoraAgendamento).format('YYYYMMDDHHmmssSSSS')) > parseFloat(moment(agendamentos.dias.vigencia.end).format('YYYYMMDDHHmmssSSSS')) ){
						$uibModalInstance.dismiss("Não pode ser agendado nesta data e horário, pois seu periodo de agendamento inicia em " + moment(agendamentos.dias.vigencia.start).format('DD/MM/YYYY HH:mm:ss') );
						return;
					}
					var dataLimite = $scope.aluno.evento.dataLimite || $scope.dadosEvento.dtalimite || null;
					var dataSolicitacao = $scope.aluno.evento.dataSolicitacao || $scope.dadosEvento.dataSolicitacao || null;
					var campos = {
						"id": $scope.dadosEvento.id,
						"agendamento": dataHoraAgendamento || $scope.dadosEvento.dataagdef,
						"matricula": $scope.aluno.matricula || $scope.dadosEvento.matricula,
						"nome": $scope.aluno.nome || $scope.dadosEvento.nome,
						"nivel": $scope.aluno.nivel || $scope.dadosEvento.nivel || null,
						"codArea": $scope.dadosEvento.codarea || $scope.aluno.area.codare || null,
						"nomeArea": $scope.dadosEvento.area || $scope.aluno.area.nomare || null,
						"titulotrab": $scope.dadosEvento.titulotrab || null,
						"anfiteatro": $scope.anfiteatroSelecionado.nome || null,
						"idAnfiteatro": $scope.anfiteatroSelecionado.id || null,
						"dataLimite": dataLimite != null ? moment(dataLimite).format("YYYY-MM-DD HH:mm:ss") : null,
						"dataSolicitacao": dataSolicitacao != null ? moment(dataSolicitacao).format("YYYY-MM-DD HH:mm:ss") : null,
						"user": AuthService.getUser() || 0,
					};
					if(!$scope.isAdmin){
						
						agendamentos.dias.feriados.forEach(function(feriado, index) {	
							if(moment(dataHoraAgendamento).isBetween(moment(feriado.start).hour(0), feriado.end)) {
								$uibModalInstance.dismiss("Agendamento não pode ser colocado num Feriado 1");
								return;
							}
						});

						var bloqueio = false;
						agendamentos.dias.feriados.forEach(function(feriado, index) {	
							if(!bloqueio && moment(dataHoraAgendamento).isBetween(moment(feriado.start).hour(0), feriado.end)) {
								bloqueio = true;
								$uibModalInstance.dismiss("Agendamento não pode ser colocado num Feriado 2");
								return;
							}
						});

						agendamentos.eventos.filter(function(e){ return e.tipo == 'P';}).forEach(function(feriado, index){
							if(!bloqueio && parseFloat(moment(dataHoraAgendamento).format('YYYYMMDDHHmmssSSSS')) == parseFloat(moment(feriado.start).format('YYYYMMDDHHmmssSSSS')) ){
									bloqueio = true;
									$uibModalInstance.dismiss("Agendamento não pode ser colocado durante um Evento ("+feriado.title+")");
									return;
							}
						});
						if(bloqueio){
							return;
						}

						if(!moment(campos.agendamento).isBetween(moment(agendamentos.dias.vigencia.start), moment(agendamentos.dias.vigencia.end || campos.dataLimite).add(1,'days')) ){
							$uibModalInstance.dismiss("Não se pode agendar nesta data! Verifique o limite de data");
							return;
						}
					}
					var validacao = {nome: campos.nome, matricula: campos.matricula, data: campos.agendamento, anfiteatro: campos.anfiteatro};
					for(var i in validacao){
						if(validacao[i] == null || validacao[i] == ""){
							var modalInstance = $uibModal.open({
								animation : true,
								template : '<div class="modal-content">\
															<div class="modal-header bg-warning">\
																<i class="ion-information-circled modal-icon"></i>\
																<span>Erro</span>\
															</div>\
															<div class="modal-body text-center">\
																O campo ' + i + ' precisa ser preenchido\
															</div>\
															<div class="modal-footer">\
																<button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button>\
															</div>\
														</div>',
								size : 'md',
							});
							return false;
						}
					}

					AgendamentoService.alterarAgenda(campos).then(function(agendamento) {
						var evento = {
							id: agendamento.id,
							title: campos.nome,
							allDay: false,
							start: moment(campos.agendamento),
							overlap: true,
							tipo: 'E',
						};
						
						$uibModalInstance.close(evento);	
					})
					.catch(function(mensagem) {		
						$uibModalInstance.dismiss(mensagem);
					});				
				}
				$scope.excluir = function() {
					var modal = $uibModal.open({
			            size: 'sm',
			            template: '<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Excluir</span></div><div class="modal-body text-center">Tem certeza que deseja excluir este agendamento?</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$close()">Sim</button><button class="btn btn-default" ng-click="$dismiss()">Não</button></div></div>',
			            animation : true,
		        	}).result.then(function(){
		        		if( !$scope.isAdmin ){
			        		var dataHoraAgendamento = moment($scope.aluno.evento.dataAgendamento).hour(0).minute(0).second(0).format('YYYY-MM-DD HH:mm:ss');
			        		if(parseFloat(moment(dataHoraAgendamento).format('YYYYMMDDHHmmssSSSS')) < parseFloat(moment(agendamentos.dias.vigencia.start).format('YYYYMMDDHHmmssSSSS')) ){
			        			$uibModalInstance.dismiss("Não pode  excluir agendamentos a menos de 30 dias do mesmo." );
								return;
			        		}
		        		}
		        		var campos = {
							"id": $scope.dadosEvento.id,
							"user_id": AuthService.getUser()
						};
						AgendamentoService.excluirAgenda(campos).then(function(){
							agendamentos.eventos = agendamentos.eventos.filter(function(e){
								if(e.tipo == 'E'){
									return false;
								}
								return true;
							});
							evento = null;
							$uibModalInstance.close(evento);
						}).catch(function(mensagem){
							$uibModalInstance.dismiss(mensagem);
						});
					}).catch(function(){
						//console.log('Nao confirmado');
					});
				}
			}
		}).catch(function(){
			$uibModalInstance.dismiss("Dados de evento não conseguiram ser carregados");
		});
		
	}
	
})();
/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.agendamento.relatorios.aluno')
  		.controller('AlunoAgendamentoPageCtrl', AlunoAgendamentoPageCtrl);

	/** @ngInject */
	function AlunoAgendamentoPageCtrl($scope, $state, AgendamentoService, AuthService) {
		
		if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}

		// Tela de Dados Basicos
		var aluno = AgendamentoService._getAluno();
		if(aluno == null) {
			$state.go('agendamento.relatorios');
		} else {
			$scope.aluno = aluno;
		}
	}

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('AreaChartCtrl', AreaChartCtrl);

  /** @ngInject */
  function AreaChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var areaChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          lineColor: layoutColors.info,
          date: '2012-01-01',
          duration: 408
        },
        {
          date: '2012-01-02',
          duration: 482
        },
        {
          date: '2012-01-03',
          duration: 562
        },
        {
          date: '2012-01-04',
          duration: 379
        },
        {
          lineColor: layoutColors.warning,
          date: '2012-01-05',
          duration: 501
        },
        {
          date: '2012-01-06',
          duration: 443
        },
        {
          date: '2012-01-07',
          duration: 405
        },
        {
          date: '2012-01-08',
          duration: 309,
          lineColor: layoutColors.danger
        },
        {
          date: '2012-01-09',
          duration: 287
        },
        {
          date: '2012-01-10',
          duration: 485
        },
        {
          date: '2012-01-11',
          duration: 890
        },
        {
          date: '2012-01-12',
          duration: 810
        }
      ],
      balloon: {
        cornerRadius: 6,
        horizontalPadding: 15,
        verticalPadding: 10
      },
      valueAxes: [
        {
          duration: 'mm',
          durationUnits: {
            hh: 'h ',
            mm: 'min'
          },
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          bullet: 'square',
          bulletBorderAlpha: 1,
          bulletBorderThickness: 1,
          fillAlphas: 0.5,
          fillColorsField: 'lineColor',
          legendValueText: '[[value]]',
          lineColorField: 'lineColor',
          title: 'duration',
          valueField: 'duration'
        }
      ],

      chartCursor: {
        categoryBalloonDateFormat: 'YYYY MMM DD',
        cursorAlpha: 0,
        fullWidth: true
      },
      dataDateFormat: 'YYYY-MM-DD',
      categoryField: 'date',
      categoryAxis: {
        dateFormats: [
          {
            period: 'DD',
            format: 'DD'
          },
          {
            period: 'WW',
            format: 'MMM DD'
          },
          {
            period: 'MM',
            format: 'MMM'
          },
          {
            period: 'YYYY',
            format: 'YYYY'
          }
        ],
        parseDates: true,
        autoGridCount: false,
        gridCount: 50,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      pathToImages: layoutPaths.images.amChart
    });

    areaChart.addListener('dataUpdated', zoomAreaChart);

    function zoomAreaChart() {
      areaChart.zoomToDates(new Date(2012, 0, 3), new Date(2012, 0, 11));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('BarChartCtrl', BarChartCtrl);

  /** @ngInject */
  function BarChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var barChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          country: 'USA',
          visits: 3025,
          color: layoutColors.primary
        },
        {
          country: 'China',
          visits: 1882,
          color: layoutColors.danger

        },
        {
          country: 'Japan',
          visits: 1809,
          color: layoutColors.info
        },
        {
          country: 'Germany',
          visits: 1322,
          color: layoutColors.success
        },
        {
          country: 'UK',
          visits: 1122,
          color: layoutColors.warning
        },
        {
          country: 'France',
          visits: 1114,
          color: layoutColors.primaryLight
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          title: 'Visitors from country',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      startDuration: 1,
      graphs: [
        {
          balloonText: '<b>[[category]]: [[value]]</b>',
          fillColorsField: 'color',
          fillAlphas: 0.7,
          lineAlpha: 0.2,
          type: 'column',
          valueField: 'visits'
        }
      ],
      chartCursor: {
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        zoomable: false
      },
      categoryField: 'country',
      categoryAxis: {
        gridPosition: 'start',
        labelRotation: 45,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'top-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('combinedChartCtrl', combinedChartCtrl);

  /** @ngInject */
  function combinedChartCtrl($element, baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart(id, {
      "type": "serial",
      "theme": "none",
      "color": layoutColors.defaultText,
      "dataDateFormat": "YYYY-MM-DD",
      "precision": 2,
      "valueAxes": [{
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v1",
        "title": "Sales",
        "position": "left",
        "autoGridCount": false,
        "labelFunction": function(value) {
          return "$" + Math.round(value) + "M";
        }
      }, {
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v2",
        "title": "Market Days",
        "gridAlpha": 0,
        "position": "right",
        "autoGridCount": false
      }],
      "graphs": [{
        "id": "g3",
        color: layoutColors.defaultText,
        "valueAxis": "v1",
        "lineColor": layoutColors.primaryLight,
        "fillColors": layoutColors.primaryLight,
        "fillAlphas": 0.8,
        "lineAlpha": 0.8,
        "type": "column",
        "title": "Actual Sales",
        "valueField": "sales2",
        "clustered": false,
        "columnWidth": 0.5,
        "lineColorField" : layoutColors.defaultText,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g4",
        "valueAxis": "v1",
        color: layoutColors.defaultText,
        "lineColor": layoutColors.primary,
        "fillColors": layoutColors.primary,
        "fillAlphas": 0.9,
        "lineAlpha": 0.9,
        "type": "column",
        "title": "Target Sales",
        "valueField": "sales1",
        "clustered": false,
        "columnWidth": 0.3,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g1",
        "valueAxis": "v2",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        color: layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.danger,
        "type": "smoothedLine",
        "title": "Market Days",
        "useLineColorForBulletBorder": true,
        "valueField": "market1",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }, {
        "id": "g2",
        "valueAxis": "v2",
        color: layoutColors.defaultText,
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.warning,
        "type": "smoothedLine",
        "dashLength": 5,
        "title": "Market Days ALL",
        "useLineColorForBulletBorder": true,
        "valueField": "market2",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }],
      "chartScrollbar": {
        "graph": "g1",
        "oppositeAxis": false,
        "offset": 30,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 50,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      "chartCursor": {
        "pan": true,
        "cursorColor" : layoutColors.danger,
        "valueLineEnabled": true,
        "valueLineBalloonEnabled": true,
        "cursorAlpha": 0,
        "valueLineAlpha": 0.2
      },
      "categoryField": "date",
      "categoryAxis": {
        "axisColor": layoutColors.defaultText,
        "color": layoutColors.defaultText,
        "gridColor": layoutColors.defaultText,
        "parseDates": true,
        "dashLength": 1,
        "minorGridEnabled": true
      },
      "legend": {
        "useGraphSettings": true,
        "position": "top",
        "color": layoutColors.defaultText
      },
      "balloon": {
        "borderThickness": 1,
        "shadowAlpha": 0
      },
      "export": {
        "enabled": true
      },
      "dataProvider": [{
        "date": "2013-01-16",
        "market1": 71,
        "market2": 75,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-17",
        "market1": 74,
        "market2": 78,
        "sales1": 4,
        "sales2": 6
      }, {
        "date": "2013-01-18",
        "market1": 78,
        "market2": 88,
        "sales1": 5,
        "sales2": 2
      }, {
        "date": "2013-01-19",
        "market1": 85,
        "market2": 89,
        "sales1": 8,
        "sales2": 9
      }, {
        "date": "2013-01-20",
        "market1": 82,
        "market2": 89,
        "sales1": 9,
        "sales2": 6
      }, {
        "date": "2013-01-21",
        "market1": 83,
        "market2": 85,
        "sales1": 3,
        "sales2": 5
      }, {
        "date": "2013-01-22",
        "market1": 88,
        "market2": 92,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-23",
        "market1": 85,
        "market2": 90,
        "sales1": 7,
        "sales2": 6
      }, {
        "date": "2013-01-24",
        "market1": 85,
        "market2": 91,
        "sales1": 9,
        "sales2": 5
      }, {
        "date": "2013-01-25",
        "market1": 80,
        "market2": 84,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-26",
        "market1": 87,
        "market2": 92,
        "sales1": 4,
        "sales2": 8
      }, {
        "date": "2013-01-27",
        "market1": 84,
        "market2": 87,
        "sales1": 3,
        "sales2": 4
      }, {
        "date": "2013-01-28",
        "market1": 83,
        "market2": 88,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-29",
        "market1": 84,
        "market2": 87,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-30",
        "market1": 81,
        "market2": 85,
        "sales1": 4,
        "sales2": 7
      }],
      pathToImages: layoutPaths.images.amChart
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('FunnelChartCtrl', FunnelChartCtrl);

  /** @ngInject */
  function FunnelChartCtrl($scope, $element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var funnelChart = AmCharts.makeChart(id, {
      type: 'funnel',
      theme: 'blur',
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      dataProvider: [
        {
          title: 'Website visits',
          value: 300
        },
        {
          title: 'Downloads',
          value: 123
        },
        {
          title: 'Requested prices',
          value: 98
        },
        {
          title: 'Contaced',
          value: 72
        },
        {
          title: 'Purchased',
          value: 35
        },
        {
          title: 'Asked for support',
          value: 25
        },
        {
          title: 'Purchased more',
          value: 18
        }
      ],
      titleField: 'title',
      marginRight: 160,
      marginLeft: 15,
      labelPosition: 'right',
      funnelAlpha: 0.9,
      valueField: 'value',
      startX: 0,
      alpha: 0.8,
      neckWidth: '0%',
      startAlpha: 0,
      outlineThickness: 1,
      neckHeight: '0%',
      balloonText: '[[title]]:<b>[[value]]</b>',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',
      pathToImages: layoutPaths
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('ganttChartCtrl', ganttChartCtrl);

  /** @ngInject */
  function ganttChartCtrl($element) {
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart( id, {
      "type": "gantt",
      "theme": "light",
      "marginRight": 70,
      "period": "hh",
      "dataDateFormat":"YYYY-MM-DD",
      "balloonDateFormat": "JJ:NN",
      "columnWidth": 0.5,
      "valueAxis": {
        "type": "date",
        "minimum": 7,
        "maximum": 31
      },
      "brightnessStep": 10,
      "graph": {
        "fillAlphas": 1,
        "balloonText": "<b>[[task]]</b>: [[open]] [[value]]"
      },
      "rotate": true,
      "categoryField": "category",
      "segmentsField": "segments",
      "colorField": "color",
      "startDate": "2015-01-01",
      "startField": "start",
      "endField": "end",
      "durationField": "duration",
      "dataProvider": [
        {
        "category": "John",
        "segments": [ {
          "start": 7,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Smith",
        "segments": [ {
          "start": 10,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Ben",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Mike",
        "segments": [ {
          "start": 9,
          "duration": 6,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 4,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Lenny",
        "segments": [ {
          "start": 8,
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Scott",
        "segments": [ {
          "start": 15,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Julia",
        "segments": [ {
          "start": 9,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 1,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 8,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Bob",
        "segments": [ {
          "start": 9,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 7,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kendra",
        "segments": [ {
          "start": 11,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Tom",
        "segments": [ {
          "start": 9,
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 5,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kyle",
        "segments": [ {
          "start": 6,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Anita",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Jack",
        "segments": [ {
          "start": 8,
          "duration": 10,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Kim",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 3,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Aaron",
        "segments": [ {
          "start": 18,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Alan",
        "segments": [ {
          "start": 17,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Ruth",
        "segments": [ {
          "start": 13,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Simon",
        "segments": [ {
          "start": 10,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 17,
          "duration": 4,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      } ],
      "valueScrollbar": {
        "autoGridCount":true
      },
      "chartCursor": {
        "cursorColor":"#55bb76",
        "valueBalloonsEnabled": false,
        "cursorAlpha": 0,
        "valueLineAlpha":0.5,
        "valueLineBalloonEnabled": true,
        "valueLineEnabled": true,
        "zoomable":false,
        "valueZoomable":true
      },
      "export": {
        "enabled": true
      }
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('LineChartCtrl', LineChartCtrl);

  /** @ngInject */
  function LineChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var lineChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      marginTop: 0,
      marginRight: 15,
      dataProvider: [
        {
          year: '1990',
          value: -0.17
        },
        {
          year: '1991',
          value: -0.254
        },
        {
          year: '1992',
          value: 0.019
        },
        {
          year: '1993',
          value: -0.063
        },
        {
          year: '1994',
          value: 0.005
        },
        {
          year: '1995',
          value: 0.077
        },
        {
          year: '1996',
          value: 0.12
        },
        {
          year: '1997',
          value: 0.011
        },
        {
          year: '1998',
          value: 0.177
        },
        {
          year: '1999',
          value: -0.021
        },
        {
          year: '2000',
          value: -0.037
        },
        {
          year: '2001',
          value: 0.03
        },
        {
          year: '2002',
          value: 0.179
        },
        {
          year: '2003',
          value: 0.2
        },
        {
          year: '2004',
          value: 0.180
        },
        {
          year: '2005',
          value: 0.21
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          id: 'g1',
          balloonText: '[[value]]',
          bullet: 'round',
          bulletSize: 8,
          lineColor: layoutColors.danger,
          lineThickness: 1,
          negativeLineColor: layoutColors.warning,
          type: 'smoothedLine',
          valueField: 'value'
        }
      ],
      chartScrollbar: {
        graph: 'g1',
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 55,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      chartCursor: {
        categoryBalloonDateFormat: 'YYYY',
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5,
        fullWidth: true
      },
      dataDateFormat: 'YYYY',
      categoryField: 'year',
      categoryAxis: {
        minPeriod: 'YYYY',
        parseDates: true,
        minorGridAlpha: 0.1,
        minorGridEnabled: true,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });

    lineChart.addListener('rendered', zoomChart);
    if (lineChart.zoomChart) {
      lineChart.zoomChart();
    }

    function zoomChart() {
      lineChart.zoomToIndexes(Math.round(lineChart.dataProvider.length * 0.4), Math.round(lineChart.dataProvider.length * 0.55));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('PieChartCtrl', PieChartCtrl);

  /** @ngInject */
  function PieChartCtrl($element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var pieChart = AmCharts.makeChart(id, {
      type: 'pie',
      startDuration: 0,
      theme: 'blur',
      addClassNames: true,
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      legend: {
        position: 'right',
        marginRight: 100,
        autoMargins: false,
      },
      innerRadius: '40%',
      defs: {
        filter: [
          {
            id: 'shadow',
            width: '200%',
            height: '200%',
            feOffset: {
              result: 'offOut',
              in: 'SourceAlpha',
              dx: 0,
              dy: 0
            },
            feGaussianBlur: {
              result: 'blurOut',
              in: 'offOut',
              stdDeviation: 5
            },
            feBlend: {
              in: 'SourceGraphic',
              in2: 'blurOut',
              mode: 'normal'
            }
          }
        ]
      },
      dataProvider: [
        {
          country: 'Lithuania',
          litres: 501.9
        },
        {
          country: 'Czech Republic',
          litres: 301.9
        },
        {
          country: 'Ireland',
          litres: 201.1
        },
        {
          country: 'Germany',
          litres: 165.8
        },
        {
          country: 'Australia',
          litres: 139.9
        },
        {
          country: 'Austria',
          litres: 128.3
        },
        {
          country: 'UK',
          litres: 99
        },
        {
          country: 'Belgium',
          litres: 60
        }
      ],
      valueField: 'litres',
      titleField: 'country',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',

      autoMargins: false,
      marginTop: 10,
      alpha: 0.8,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      pullOutRadius: 0,
      pathToImages: layoutPaths.images.amChart,
      responsive: {
        enabled: true,
        rules: [
          // at 900px wide, we hide legend
          {
            maxWidth: 900,
            overrides: {
              legend: {
                enabled: false
              }
            }
          },

          // at 200 px we hide value axis labels altogether
          {
            maxWidth: 200,
            overrides: {
              valueAxes: {
                labelsEnabled: false
              },
              marginTop: 30,
              marginBottom: 30,
              marginLeft: 30,
              marginRight: 30
            }
          }
        ]
      }
    });

    pieChart.addListener('init', handleInit);

    pieChart.addListener('rollOverSlice', function (e) {
      handleRollOver(e);
    });

    function handleInit() {
      pieChart.legend.addListener('rollOverItem', handleRollOver);
    }

    function handleRollOver(e) {
      var wedge = e.dataItem.wedge.node;
      wedge.parentNode.appendChild(wedge);
    }
  }

})();

/**
 * @author a.demeshko
 * created on 24/12/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('composeBoxCtrl', composeBoxCtrl);

  /** @ngInject */
  function composeBoxCtrl(subject, to, text) {
    var vm = this;
    vm.subject = subject;
    vm.to = to;
    vm.text = text;
  }
})();
/**
 * @author a.demeshko
 * created on 12/24/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .service('composeModal', composeModal);

  /** @ngInject */
  function composeModal($uibModal) {
      this.open = function(options){
        return $uibModal.open({
          animation: false,
          templateUrl: 'app/pages/components/mail/composeBox/compose.html',
          controller: 'composeBoxCtrl',
          controllerAs: 'boxCtrl',
          size: 'compose',
          resolve: {
            subject: function () {
              return options.subject;
            },
            to: function () {
              return options.to;
            },
            text: function () {
              return options.text;
            }
          }
        });
      }

  }

})();
/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('MailDetailCtrl', MailDetailCtrl);

  /** @ngInject */
  function MailDetailCtrl($stateParams, mailMessages) {
    var vm = this;
    vm.mail = mailMessages.getMessageById($stateParams.id);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('MailListCtrl', MailListCtrl);

  /** @ngInject */
  function MailListCtrl($stateParams,  mailMessages) {
    var vm = this;
    vm.messages = mailMessages.getMessagesByLabel($stateParams.label);
    vm.label = $stateParams.label;
  }

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.rotinas.oficio')
  		.controller('CadastroRotinaOficioPageCtrl', CadastroRotinaOficioPageCtrl);

	/** @ngInject */
	function CadastroRotinaOficioPageCtrl($scope, $filter, fileReader, $state, AuthService, $uibModalInstance, toastr, RotinasService) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}

		$scope.oficio = {};
		$scope.destinos = [];

		RotinasService.listaDestinos().then(function(destinos) {
			$scope.destinos = destinos;
		});

		$scope.adicionar = function(resp) {
			$scope.mensagem = null;

			resp.dataspg = resp.dataspg?moment(resp.dataspg).format('YYYY-MM-DD'):null;
			resp.datadef = resp.datadef?moment(resp.datadef).format('YYYY-MM-DD'):null;
			resp.aprocpg = resp.aprocpg?moment(resp.aprocpg).format('YYYY-MM-DD'):null;
			resp.aprogreg = resp.aprogreg?moment(resp.aprogreg).format('YYYY-MM-DD'):null;
			resp.aprocama = resp.aprocama?moment(resp.aprocama).format('YYYY-MM-DD'):null;
			
			if(!resp.locades || resp.locades.trim() == ""){
				resp.locades = resp.destino.local;
			}

			RotinasService.adicionaOficio(resp).then(function(oficio) {
				oficio.dt_insert = $filter('date')(moment(oficio.dt_insert).toDate(),'dd/MM/yyyy');
				$uibModalInstance.close(oficio);
				toastr.success("Oficio incluido com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				toastr.error(erro, 'Erro', {});
			});
		};
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.comissao')
  		.controller('EditarRotinaOficioPageCtrl', EditarRotinaOficioPageCtrl);

	/** @ngInject */
	function EditarRotinaOficioPageCtrl($scope, fileReader, $state, AuthService, $uibModalInstance, toastr, oficio, RotinasService) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		var destino = oficio.locades;
		$scope.oficio = oficio;
		$scope.destinos = [];

		RotinasService.listaDestinos().then(function(destinos) {
			$scope.destinos = destinos;
			var local = destinos.map(function(e){
				if(e.local == destino){
					return e;
				}
			}).filter(function(e){ return !!e});
			if(local.length>0){
				$scope.oficio.destino = local[0];
				$scope.oficio.locades = "";
			}else{
				$scope.oficio.locades = destino;
			}
		});

		$scope.enviar = function(resp) {
			$scope.mensagem = null;

			if(!resp.locades || resp.locades.trim() == ""){
				resp.locades = resp.destino.local;
			}

			RotinasService.atualizaOficio(resp).then(function(oficio) {
				$uibModalInstance.close(oficio);
				toastr.success("Oficio atualizado com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				toastr.error(erro, 'Erro', {});
			});
		};
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.rotinas.oficio')
  		.controller('CadastroRotinaExpedientePageCtrl', CadastroRotinaExpedientePageCtrl);

	/** @ngInject */
	function CadastroRotinaExpedientePageCtrl($scope, $filter, $state, AuthService, $uibModalInstance, toastr, RotinasService, AreasService) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		$scope.expediente = {};
		$scope.expediente.dt_cadastro = moment().toDate();
		var maxCod = 1;
		RotinasService.listaMaxExpediente().then(function(result){
			maxCod = result+1;
			$scope.expediente.nExpediente = maxCod;
		});

		$scope.destinos = [];

		RotinasService.listaDestinos().then(function(destinos) {
			destinos.push({id:0,local:'OUTROS'});
			$scope.destinos = destinos;
			$scope.expediente.destino = destinos[0];
		});
		$scope.programas = [];
		AreasService.listarAreas().then(function(areas) {
			areas.shift();
			$scope.programas = areas;
			$scope.expediente.programa = areas[0];
		});

		$scope.adicionar = function(resp) {
			//$scope.mensagem = null;
			if(!resp.programa || !resp.programa.id){
				toastr.error(erro, 'Programa precisa ser informado', {});
			}
			if(!resp.destino || !resp.destino.id){
				toastr.error(erro, 'Destino precisa ser informado', {});
			}
			var dados = $.extend(resp,{
				'destino': resp.destino.id,
				'programa': resp.programa.id,
				'dt_cadastro': resp.dt_cadastro?$filter('date')(resp.dt_cadastro,'yyyy-MM-dd'):null,
				'dt_saida': resp.dt_cadastro?$filter('date')(resp.dt_saida,'yyyy-MM-dd'):null,
			});
			RotinasService.adicionaExpediente(dados).then(function(expediente) {
				$uibModalInstance.close(expediente);
				toastr.success("Expediente incluido com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				toastr.error(erro, 'Erro', {});
			});
		};
		

	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.comissao')
  		.controller('CadastroRotinaProtoExpedientePageCtrl', CadastroRotinaProtoExpedientePageCtrl);

	/** @ngInject */
	function CadastroRotinaProtoExpedientePageCtrl($scope, fileReader, $state, AuthService, $uibModalInstance, toastr, RotinasService, protocolo, $filter) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		$scope.protoExpediente = {};
		$scope.protoExpediente.dt_saida = moment().toDate();
		RotinasService.listaDestinos().then(function(destinos) {
			destinos.push({id:0,local:'OUTROS'});
			$scope.destinos = destinos;
			$scope.protoExpediente.destino = destinos[0];
		});
		
		
		$scope.enviar = function(resp) {
			$scope.mensagem = null;
			var dados = {
				'idProtocolo': protocolo.idProtocolo, 
				'programa': protocolo.programa.id,
				'destino': resp.destino.id,
				'destinoOutro': resp.destinoOutro,
				'descricao': resp.descricao,
				'dt_saida': resp.dt_saida?$filter('date')(moment(resp.dt_saida).toDate(), 'yyyy-MM-dd'):null,
				'dt_retorno': resp.dt_retorno?$filter('date')(moment(resp.dt_retorno).toDate(), 'yyyy-MM-dd'):null,
			};

			RotinasService.adicionaProtoExpediente(dados).then(function(protoExpediente) {
				$uibModalInstance.close(protoExpediente);
				toastr.success("Proto Expediente inserido com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				toastr.error(erro, 'Erro', {});
			});
		};
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.rotinas.protocolo')
  		.controller('EditarRotinaExpedientePageCtrl', EditarRotinaExpedientePageCtrl);

	/** @ngInject */
	function EditarRotinaExpedientePageCtrl($scope, $timeout, $state, AuthService, RotinasService, $uibModalInstance, toastr, expediente, AreasService, $filter) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		$scope.expediente = expediente;

		RotinasService.getExpedientes(expediente.id).then(function(exp){
			exp.dt_cadastro = exp.dt_cadastro?moment(exp.dt_cadastro).toDate():null;
			$scope.expediente = exp;
		});
		$scope.destinos = [];

		$scope.programas = [];

		$timeout(function(){
			AreasService.listarAreas().then(function(areas) {
				areas.shift();
				$scope.programas = areas;
				var item = -1;
				var a = Object.values(areas).map(function(e,i){if(e.id==$scope.expediente.programa){item=i;return e;}}).filter(function(e){return !!e});
				if(a.length>0 && item != -1)
					$scope.expediente.programa = a[0];
			});

			RotinasService.listaDestinos().then(function(destinos) {
				destinos.push({id:0,local:'OUTROS'});
				$scope.destinos = destinos;
				var item = -1;
				var a = Object.values(destinos).map(function(e,i){if(e.id==$scope.expediente.destino){item=i;return e;}}).filter(function(e){return !!e});
				if(a.length>0 && item != -1)
					$scope.expediente.destino=a[0];
			});

		},300);


		$scope.enviar = function(resp) {
			//$scope.mensagem = null;
			var dados = $.extend(resp,{
				'destino': resp.destino.id,
				'programa': resp.programa.id,
				'dt_cadastro': resp.dt_cadastro?$filter('date')(resp.dt_cadastro,'yyyy-MM-dd'):null,
				'dt_saida': resp.dt_cadastro?$filter('date')(resp.dt_saida,'yyyy-MM-dd'):null,
			});

			RotinasService.atualizaExpediente(dados).then(function(expediente) {
				$uibModalInstance.close(expediente);
				toastr.success("Expediente atualizado com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				toastr.error(erro, 'Erro', {});
			});
		};
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.rotinas.protocolo')
  		.controller('EditarRotinaProtocoloPageCtrl', EditarRotinaProtocoloPageCtrl);

	/** @ngInject */
	function EditarRotinaProtocoloPageCtrl($scope, $state, $timeout, $stateParams, fileReader, AuthService, $uibModal, toastr, RotinasService, AreasService, $filter) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}
		var maxCod = 1;
		RotinasService.listaMaxProtocolo().then(function(result){
			// console.log(result,parseInt(result.replace(/\D\-\,\./gi,''))+1);
			maxCod = parseInt(result.replace(/\D\-\,\./gi,''))+1;
		});

		/*if(!$stateParams.maxCod){
			$state.go('rotinas.protocolo');
		}*/
		$scope.protocolo = RotinasService.getProtocolo();
		$scope.outros = [];
		$scope.protoExpedientes = [];
		$scope.SaveButton = "Salvar Modificações";
		$scope.novo = false;
		if($scope.protocolo == null ){
			//novo
			$scope.novo = true;
			$scope.protocolo = {};
			$scope.SaveButton = "Adicionar";
			$scope.protocolo.dt_create = moment().toDate();
			$timeout(function(){
				$scope.protocolo.nProtocolo = !$stateParams.maxCod?maxCod:$stateParams.maxCod;
			},500);
			//carrega assuntos
			$scope.assuntos = [];
			RotinasService.listaAssuntos().then(function(result){
				result.push({id:0,assunto:'OUTROS'});
				$scope.assuntos = result;
				$scope.protocolo.assunto = result[0];
			});
			$scope.programas = [];
			RotinasService.listarProgramas().then(function(areas) {
				areas.shift();
				// areas.unshift({"id":0,"value":"Nenhum programa"});
				$scope.programas = areas;
				$scope.protocolo.programa = areas[0];
			});
		}else{
			//editar
			RotinasService.getProtocolos($scope.protocolo.id).then(function(result){
				result.dt_create = moment(result.dt_create).toDate();
				result.dt_entrada = result.dt_entrada? moment(result.dt_entrada).toDate():null;
				result.dt_saida = result.dt_saida? moment(result.dt_saida).toDate():null;
				$scope.protocolo = result;

				$scope.assuntos = [];
				RotinasService.listaAssuntos().then(function(assuntos){
					var a = Object.values(assuntos).map(function(e){if(e.id==result.assunto){return e;}}).filter(function(e){return !!e});
					if(a.length > 0){
						$scope.protocolo.assunto = a[0];
					}
					assuntos.push({id:0,assunto:'OUTROS'});
					$scope.assuntos = assuntos;
				});
				$scope.programas = [];
				RotinasService.listarProgramas().then(function(areas) {
					areas.shift(); //remove a opção todos
					// areas.unshift({"id":0,"value":"Nenhum programa"});
					var a = Object.values(areas).map(function(e){if(e.id==result.programa){return e;}}).filter(function(e){return !!e});
					if(a.length > 0){
						$scope.protocolo.programa = a[0];
					}
					$scope.programas = areas;
				});
				$scope.protoExpedientes = [];
				RotinasService.listaProtoExpediente({'idProtocolo':$scope.protocolo.idProtocolo}).then(function(listagem) {
					$scope.outros = listagem;
					$scope.protoExpedientes = $scope.outros;
				}).catch(function(erro) {
					$scope.mensagem = {'aviso': erro};
				});
			});
		}

		$scope.salvar = function(){
			//$scope.mensagem = null;
			var dados = {
				'nProtocolo': $scope.protocolo.nProtocolo, 
				'dt_create': $scope.protocolo.dt_create?$filter('date')(moment($scope.protocolo.dt_create).toDate(), 'yyyy-MM-dd'):null,
				'interessado': $scope.protocolo.interessado, 
				'descricao': $scope.protocolo.descricao || '', 
				'assunto': $scope.protocolo.assunto.id || 0,
				'assuntoOutro': $scope.protocolo.assuntoOutro || 0,
				'programa': $scope.protocolo.programa.id || 0, 
				'dt_entrada': $scope.protocolo.dt_entrada?$filter('date')(moment($scope.protocolo.dt_entrada).toDate(), 'yyyy-MM-dd'):null,
				'dt_saida': $scope.protocolo.dt_saida?$filter('date')(moment($scope.protocolo.dt_saida).toDate(), 'yyyy-MM-dd'):null,
			}
			if( $scope.novo ){
				//adicionar
				RotinasService.adicionaProtocolo(dados).then(function(protocolo){
					toastr.success("Protocolo incluido com sucesso", 'Sucesso', {});
					RotinasService.setProtocolo(protocolo);
					$timeout(function(){
						$state.go('rotinas.protocolo');
					},1500);
				}).catch(function(data) {
					console.log(data)
					toastr.error(data, 'Erro', {});
				});
			}else{
				//atualizar
				dados.idProtocolo = $scope.protocolo.idProtocolo;
				RotinasService.atualizaProtocolo(dados).then(function(protocolo){
					toastr.success("Protocolo atualizado com sucesso", 'Sucesso', {});
					RotinasService.setProtocolo(protocolo);
					$timeout(function(){
						$state.go('rotinas.protocolo');
					},1500);
				}).catch(function(erro) {
					toastr.error(erro, 'Erro', {});//$scope.mensagem = {erro: erro};
				});
			}
		};
		$scope.adicionarProtoExpediente = function(){
			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/rotinas/widget/protocolo/cadastroProtoExpediente.html',
				size : 'md',
				controller : 'CadastroRotinaProtoExpedientePageCtrl',
				resolve : {
					protocolo: function(){
						return $scope.protocolo;
					}
				}
			});
			
			modalInstance.result.then(function(protoExpediente) {
		        $scope.outros.unshift(protoExpediente);
		        $scope.protoExpedientes = $scope.outros;
		    }, function (mensagem) {
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1){
		    		toastr.error(mensagem, 'Erro', {});
		    		modalInstance.dismiss();
		    	}
		    });
		};
		$scope.editar = function(protoExpediente){
			var reset = angular.copy(protoExpediente);
			
			var modalInstance = $uibModal.open({
				animation : true,
				templateUrl : 'app/pages/rotinas/widget/protocolo/editarProtoExpediente.html',
				size : 'md',
				controller : 'EditarRotinaProtoExpedientePageCtrl',
				resolve : {
							protoExpediente : function() {
								return protoExpediente;
							}
						}
			});
			
			modalInstance.result.then(function(protoExpediente) {
				var item = -1;
				var a = Object.values($scope.outros).map(function(e,i){if(e.idProtoExpediente==protoExpediente.idProtoExpediente){item=i;return e;}}).filter(function(e){return !!e});
		        if(a.length>0 && item != -1){
		        	$scope.outros[item] = protoExpediente;
		        }
		        $scope.protoExpedientes = $scope.outros;
		        
		    }, function (mensagem) {
		    	var item = -1;
				var a = Object.values($scope.outros).map(function(e,i){if(e.idProtoExpediente==reset.idProtoExpediente){item=i;return e;}}).filter(function(e){return !!e});
		    	if(a.length > 0 && item != -1){
		    		$scope.outros[item] = reset;
		    	}
		    	if(typeof(mensagem) != 'undefined' && resp.indexOf(mensagem) == -1 ){
		    		toastr.error(mensagem, 'Erro', {});
		    		error.dismiss();
		    	}
		    });
		};
		/*RotinasService.listaDestinos({'todos':true}).then(function(result){
			defaultDestino = result[0];
			$scope.destinos = result;
			$scope.busca.destino = defaultDestino;
		}).catch(function(error){
			$scope.destinos = [];
		});*/
		//carrega programas

	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.comissao')
  		.controller('EditarRotinaProtoExpedientePageCtrl', EditarRotinaProtoExpedientePageCtrl);

	/** @ngInject */
	function EditarRotinaProtoExpedientePageCtrl($scope, $state, AuthService, $uibModalInstance, toastr, protoExpediente, RotinasService, $filter,PdfService, LogService) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}

		$scope.protocolo = RotinasService.getProtocolo();

    $scope.protoExpediente = protoExpediente;
		$scope.protoExpediente.dt_saida = moment($scope.protoExpediente.dt_saida).toDate();
		$scope.protoExpediente.dt_retorno = moment($scope.protoExpediente.dt_retorno).toDate();

		RotinasService.listaDestinos().then(function(destinos) {
			destinos.push({id:0,local:'OUTROS'});
			$scope.destinos = destinos;
			var a = Object.values(destinos).map(function(e){if(e.id==$scope.protoExpediente.idDestino){return e;}}).filter(function(e){return !!e});
			if(a.length>0){
				$scope.protoExpediente._destino = a[0];
			}
		});
		
		
		$scope.enviar = function(resp) {
			$scope.mensagem = null;
			var dados = $.extend(resp,{
				'_destino': resp._destino.id,
				'dt_saida': resp.dt_saida?$filter('date')(moment(resp.dt_saida).toDate(), 'yyyy-MM-dd'):null,
				'dt_retorno': resp.dt_retorno?$filter('date')(moment(resp.dt_retorno).toDate(), 'yyyy-MM-dd'):null,
			});

			RotinasService.atualizaProtoExpediente(dados).then(function(protoExpediente) {
				$uibModalInstance.close(protoExpediente);
				toastr.success("Proto Expediente atualizado com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				toastr.error(erro, 'Erro', {});
			});
		};

		$scope.print = function() {
      LogService.cadastraLog(jQuery.extend($scope.protoExpediente, {msg:'Imprime ProtoExpediente',sub:AuthService.getUser()}) );
      console.log($scope.protoExpediente._destino);
			var content = [//
        {
          text: ['SERVIÇO DE PÓS-GRADUAÇÃO DA FMUSP\nPROTOCOLO DE ENTREGA DE EXPEDIENTE'],
          alignment:'center', 
          bold:true, 
          style:'textInicial', 
          margin:[0,60,0,60]},
        {text:
          [
            {text:'DESTINO: ', style:'variable'}, 
            {
              text: $filter('uppercase')
                (
                  $scope.protoExpediente._destino && $scope.protoExpediente._destino.local
                  ? $scope.protoExpediente._destino.local
                  : ''
                )
              }
          ]
          ,style:'paragraph', margin:[0,10,0,0]
        },
        {
          columns:
          [
            {text: 
              [
                {text:'Interessado: ', style:'variable'},
                $filter('uppercase')($scope.protocolo.interessado)
              ], alignment:'left'}, 
            {text: 
              [
                {text:'Data:', style:'variable'},
                $filter('date')(moment($scope.protoExpediente.dt_saida).toDate(), 'dd/MM/yyyy')
              ], alignment:'right'}
          ]
          ,style:'paragraph', margin:[0,10,0,0]
        },
        {text:
          [
            {text: $filter('uppercase')($scope.protoExpediente.descricao), style:'paragraph'}
          ]
          ,style:'default', margin:[20,45,0,0]
        },
        {
          text: 'Nome:______________________________________________________ Visto: ___________________', 
          alignment:'right',
          style:'variable', 
          margin:[0,60,0,0]
        },
        {
          text: 'Data:_______/_______/______________', 
          alignment:'right',
          style:'variable', 
          margin:[0,30,0,0]
        },
      ];
			PdfService.getPdf(content);
		};
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.rotinas.oficio')
  		.controller('CadastroRotinaTitulosPageCtrl', CadastroRotinaTitulosPageCtrl);

	/** @ngInject */
	function CadastroRotinaTitulosPageCtrl($scope, fileReader, $state, AuthService, $uibModalInstance, toastr, RotinasService, maxCod) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}

		$scope.titulos = {};
		$scope.titulos.codigo = maxCod+1;
		$scope.titulos.dataspg = moment().toDate();
		/*$scope.destinos = [];
		$scope.outros = [];

		RotinasService.listaDestinos().then(function(destinos) {
			$scope.outros = destinos;
			$scope.destinos = $scope.outros;
		});*/

		$scope.adicionar = function(resp) {
			$scope.mensagem = null;

			RotinasService.adicionaTitulos(resp).then(function(titulo) {
				$uibModalInstance.close(titulo);
				toastr.success("Tpitulo incluido com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				toastr.error(erro, 'Erro', {});
			});
		};
	}

})();

/*
*/
(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.manutencao.comissao')
  		.controller('EditarRotinaTitulosPageCtrl', EditarRotinaTitulosPageCtrl);

	/** @ngInject */
	function EditarRotinaTitulosPageCtrl($scope, fileReader, $state, AuthService, $uibModalInstance, toastr, titulo, RotinasService) {

		if( !AuthService.isAuthorizedToAccess([3]) ){ //admin
			$scope.mensagem = {'erro':'Usuário não autorizado!'};
			$state.go('administrador.login');
			return;
		}

		$scope.titulos = titulo;

		/*$scope.destinos = [];
		$scope.outros = [];

		RotinasService.listaDestinos().then(function(destinos) {
			$scope.outros = destinos;
			$scope.destinos = $scope.outros;
		});*/

		$scope.enviar = function(resp) {
			$scope.mensagem = null;
			resp.dataspg = resp.dataspg?moment(resp.dataspg).format('YYYY-MM-DD'):null;
			resp.datadef = resp.datadef?moment(resp.datadef).format('YYYY-MM-DD'):null;
			resp.aprocpg = resp.aprocpg?moment(resp.aprocpg).format('YYYY-MM-DD'):null;
			resp.aprogreg = resp.aprogreg?moment(resp.aprogreg).format('YYYY-MM-DD'):null;
			resp.aprocama = resp.aprocama?moment(resp.aprocama).format('YYYY-MM-DD'):null;

			RotinasService.atualizaTitulos(resp).then(function(titulos) {
				$uibModalInstance.close(titulos);
				toastr.success("Títulos incluido com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				toastr.error(erro, 'Erro', {});
			});
		};

		$scope.excluir = function(resp) {
			$scope.mensagem = null;
			
			ManutencaoService.removeTitulos(resp).then(function(titulos) {
				$uibModalInstance.close(titulos);
				toastr.success("Títulos excluido com sucesso", 'Sucesso', {});
			})
			.catch(function(erro) {
				$uibModalInstance.close();
				toastr.error(erro, 'Erro', {});
			});
		};
	}

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Your information has been saved successfully!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("You've got a new email!", 'Information');
    };

    $scope.showErrorMsg = function() {
      toastr.error("Your information hasn't been saved!", 'Error');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

/**
 * Created by n.poltoratsky
 * on 24.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.ui.modals')
        .controller('ProgressModalCtrl', ProgressModalCtrl);

    function ProgressModalCtrl($timeout, baProgressModal) {

        baProgressModal.setProgress(0);

        (function changeValue() {
            if (baProgressModal.getProgress() >= 100) {
                baProgressModal.close();
            } else {
                baProgressModal.setProgress(baProgressModal.getProgress() + 10);
                $timeout(changeValue, 300);
            }
        })();
    }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.alunos.relatorios.relatorio.listagens')
  		.controller('RelatorioListagensAlunosPageCtrl', RelatorioListagensAlunosPageCtrl);

  	RelatorioListagensAlunosPageCtrl.$inject = ['$scope', '$state', 'alunos.RelatoriosService','AuthService'];
  	
	/** @ngInject */
	function RelatorioListagensAlunosPageCtrl($scope, $state, RelatoriosService, AuthService) {
        
        if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
            $scope.mensagem = {'erro':'Usuário não autorizado!'};
            $state.go('administrador.login');
            return;
        }
		
		var relatorio = RelatoriosService.getRelatorio();
		
		if(relatorio == null) {
			$state.go('alunos.relatorios');
		}
		else {
			$scope.relatorio = relatorio;
		}
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.alunos.relatorios.relatorio.periodo')
  		.controller('RelatorioPeriodoAlunosPageCtrl', RelatorioPeriodoAlunosPageCtrl);

  	RelatorioPeriodoAlunosPageCtrl.$inject = ['$scope', '$state', 'alunos.RelatoriosService','AuthService'];
  	
	/** @ngInject */
	function RelatorioPeriodoAlunosPageCtrl($scope, $state, RelatoriosService, AuthService) {
        
        if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
            $scope.mensagem = {'erro':'Usuário não autorizado!'};
            $state.go('administrador.login');
            return;
        }
		
		var relatorio = RelatoriosService.getRelatorio();
		
		if(relatorio == null) {
			$state.go('alunos.relatorios');
		}
		else {
			$scope.relatorio = relatorio;
		}
	}

})();

/**
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.agendamento.relatorios.relatorio.agendamentos')
  		.controller('NumeroTesesPageCtrl', NumeroTesesPageCtrl);
  	
  	NumeroTesesPageCtrl.$inject = ['$scope', '$state', 'agendamento.RelatoriosService','AuthService'];

	/** @ngInject */
	function NumeroTesesPageCtrl($scope, $state, RelatoriosService, AuthService) {
        
        if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
            $scope.mensagem = {'erro':'Usuário não autorizado!'};
            $state.go('administrador.login');
            return;
        }
		
		$scope.mensagem = null;
		
		var relatorio = RelatoriosService.getRelatorio();

		if(relatorio == null) {
			$state.go('agendamento.relatorios');
		}
		else {
			$scope.relatorio = relatorio;
		}
	}

})();

/**
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.agendamento.relatorios.relatorio.agendamentos')
  		.controller('RelacaoBancasPageCtrl', RelacaoBancasPageCtrl);
  	
  	RelacaoBancasPageCtrl.$inject = ['$scope', '$state', 'agendamento.RelatoriosService','AuthService'];

	/** @ngInject */
	function RelacaoBancasPageCtrl($scope, $state, RelatoriosService, AuthService) {
        
        if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
            $scope.mensagem = {'erro':'Usuário não autorizado!'};
            $state.go('administrador.login');
            return;
        }
		
		$scope.mensagem = null;
		
		var relatorio = RelatoriosService.getRelatorio();

		if(relatorio == null) {
			$state.go('agendamento.relatorios');
		}
		else {
			$scope.relatorio = relatorio;
		}
	}

})();

/**
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.agendamento.relatorios.relatorio.agendamentos')
  		.controller('RelacaoDissertacaoTeseComOrientadorPageCtrl', RelacaoDissertacaoTeseComOrientadorPageCtrl);
  	
  	RelacaoDissertacaoTeseComOrientadorPageCtrl.$inject = ['$scope', '$state', 'agendamento.RelatoriosService','AuthService'];

	/** @ngInject */
	function RelacaoDissertacaoTeseComOrientadorPageCtrl($scope, $state, RelatoriosService, AuthService) {
        
        if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
            $scope.mensagem = {'erro':'Usuário não autorizado!'};
            $state.go('administrador.login');
            return;
        }
		
		$scope.mensagem = null;
		
		var relatorio = RelatoriosService.getRelatorio();

		if(relatorio == null) {
			$state.go('agendamento.relatorios');
		}
		else {
			$scope.relatorio = relatorio;
		}
	}

})();

/**
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.agendamento.relatorios.relatorio.agendamentos')
  		.controller('RelacaoDissertacaoTesePageCtrl', RelacaoDissertacaoTesePageCtrl);
  	
  	RelacaoDissertacaoTesePageCtrl.$inject = ['$scope', '$state', 'agendamento.RelatoriosService','AuthService'];

	/** @ngInject */
	function RelacaoDissertacaoTesePageCtrl($scope, $state, RelatoriosService, AuthService) {
        
        if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
            $scope.mensagem = {'erro':'Usuário não autorizado!'};
            $state.go('administrador.login');
            return;
        }
		
		$scope.mensagem = null;
		
		var relatorio = RelatoriosService.getRelatorio();

		if(relatorio == null) {
			$state.go('agendamento.relatorios');
		}
		else {
			$scope.relatorio = relatorio;
		}
	}

})();

/**
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.agendamento.relatorios.relatorio.agendamentos')
  		.controller('RelacaoDissertacaoTesePorDataPageCtrl', RelacaoDissertacaoTesePorDataPageCtrl);
  	
  	RelacaoDissertacaoTesePorDataPageCtrl.$inject = ['$scope', '$state', 'agendamento.RelatoriosService','AuthService'];

	/** @ngInject */
	function RelacaoDissertacaoTesePorDataPageCtrl($scope, $state, RelatoriosService, AuthService) {
        
        if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
            $scope.mensagem = {'erro':'Usuário não autorizado!'};
            $state.go('administrador.login');
            return;
        }
		
		$scope.mensagem = null;
		
		var relatorio = RelatoriosService.getRelatorio();

		if(relatorio == null) {
			$state.go('agendamento.relatorios');
		}
		else {
			$scope.relatorio = relatorio;
		}
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 07/03/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.agendamento.relatorios.relatorio.agendamentos')
  		.controller('RelatorioDefesaAgendamentoPageCtrl', RelatorioDefesaAgendamentoPageCtrl);
  	
  	RelatorioDefesaAgendamentoPageCtrl.$inject = ['$scope', '$state', 'agendamento.RelatoriosService','AuthService'];

	/** @ngInject */
	function RelatorioDefesaAgendamentoPageCtrl($scope, $state, RelatoriosService, AuthService) {
        
        if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
            $scope.mensagem = {'erro':'Usuário não autorizado!'};
            $state.go('administrador.login');
            return;
        }
		
		$scope.mensagem = null;
		
		var relatorio = RelatoriosService.getRelatorio();

		if(relatorio == null) {
			$state.go('agendamento.relatorios');
		}
		else {
			$scope.relatorio = relatorio;
		}
	}

})();

/**
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.agendamento.relatorios.relatorio.agendamentos')
  		.controller('ResumoTotalPageCtrl', ResumoTotalPageCtrl);
  	
  	ResumoTotalPageCtrl.$inject = ['$scope', '$state', 'agendamento.RelatoriosService','AuthService'];

	/** @ngInject */
	function ResumoTotalPageCtrl($scope, $state, RelatoriosService, AuthService) {
        
        if( !AuthService.isAuthorizedToAccess([2,3]) ){ //secretaria,admin
            $scope.mensagem = {'erro':'Usuário não autorizado!'};
            $state.go('administrador.login');
            return;
        }
		
		$scope.mensagem = null;
		
		var relatorio = RelatoriosService.getRelatorio();

		if(relatorio == null) {
			$state.go('agendamento.relatorios');
		}
		else {
			$scope.relatorio = relatorio;
		}
	}

})();

/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerCtrl', datepickerCtrl);

    /** @ngInject */
    function datepickerCtrl($scope) {

        $scope.dt = new Date();
        $scope.options = {
            showWeeks: false
        };

    }
})();
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerpopupCtrl', datepickerpopupCtrl);

    /** @ngInject */
    function datepickerpopupCtrl($scope) {

        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.altInputFormats = ['M!/d!/yyyy'];
        $scope.options = {
            showWeeks: false
        };
        $scope.opcoesMesAnoApenas = Object.assign({
			datepickerMode: "month",
		    minMode: "month"
		}, $scope.options);
        function open() {
            $scope.opened = true;
        }
    }
})();
/**
 * @author v.lugovsky
 * created on 22.04.2016
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSelectpickerPanelCtrl', OldSelectpickerPanelCtrl);

  /** @ngInject */
  function OldSelectpickerPanelCtrl() {
    var vm = this;

    vm.standardSelectItems = [
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
      { label: 'Option 4', value: 4 },
    ];

    vm.selectWithSearchItems = [
      { label: 'Hot Dog, Fries and a Soda', value: 1 },
      { label: 'Burger, Shake and a Smile', value: 2 },
      { label: 'Sugar, Spice and all things nice', value: 3 },
      { label: 'Baby Back Ribs', value: 4 },
    ];

    vm.groupedSelectItems = [
      { label: 'Group 1 - Option 1', value: 1, group: 'Group 1' },
      { label: 'Group 2 - Option 2', value: 2, group: 'Group 2' },
      { label: 'Group 1 - Option 3', value: 3, group: 'Group 1' },
      { label: 'Group 2 - Option 4', value: 4, group: 'Group 2' },
    ];

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        pre: function(scope, elem, attrs) {
          elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
        },
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel, refresh);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refresh);
          }

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
/**
 * @author v.lugovsky
 * created on 07.06.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSwitchPanelCtrl', OldSwitchPanelCtrl);

  /** @ngInject */
  function OldSwitchPanelCtrl() {
    var vm = this;

    vm.switcherValues = {
      primary: true,
      warning: true,
      danger: true,
      info: true,
      success: true
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 *
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('switch', switchDirective);

  /** @ngInject */
  function switchDirective($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        ngModel: '='
      },
      template: function(el, attrs) {
        return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
      },
      link: function (scope, elem, attr) {
        var input = $(elem).find('input');
        input.bootstrapSwitch({
          size: 'small',
          onColor: attr.color
        });
        input.on('switchChange.bootstrapSwitch', function(event, state) {
          scope.ngModel = state;
          scope.$apply();
        });

      }
    };
  }
})();

/**
 * @author p.maslava
 * created on 28.11.2016
 */

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .filter('groupSelectpickerOptions', GroupSelectpickerOptions);

  /** @ngInject */
  function GroupSelectpickerOptions() {
    return function (items, props) {
      var out = [];

      if (angular.isArray(items)) {
        var keys = Object.keys(props);

        items.forEach(function (item) {
          var itemMatches = false;

          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

      return out;
    };
  }
})();
/**
 * @author p.maslava
 * created on 28.11.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .controller('SelectpickerPanelCtrl', SelectpickerPanelCtrl);

  /** @ngInject */
  function SelectpickerPanelCtrl() {

    var vm = this;
    vm.disabled = undefined;


    vm.standardItem = {};
    vm.standardSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4}
    ];

    vm.withSearchItem = {};

    vm.selectWithSearchItems = [
      {label: 'Hot Dog, Fries and a Soda', value: 1},
      {label: 'Burger, Shake and a Smile', value: 2},
      {label: 'Sugar, Spice and all things nice', value: 3},
      {label: 'Baby Back Ribs', value: 4}
    ];
    vm.groupedItem = {};
    vm.groupedSelectItems = [
      {label: 'Group 1 - Option 1', value: 1, group: 'Group 1'},
      {label: 'Group 2 - Option 2', value: 2, group: 'Group 2'},
      {label: 'Group 1 - Option 3', value: 3, group: 'Group 1'},
      {label: 'Group 2 - Option 4', value: 4, group: 'Group 2'}
    ];

    vm.groupedByItem = {};
    vm.groupedBySelectItems = [
      {name: 'Adam', country: 'United States'},
      {name: 'Amalie', country: 'Argentina'},
      {name: 'Estefanía', country: 'Argentina'},
      {name: 'Adrian', country: 'Ecuador'},
      {name: 'Wladimir', country: 'Ecuador'},
      {name: 'Samantha', country: 'United States'},
      {name: 'Nicole', country: 'Colombia'},
      {name: 'Natasha', country: 'Ecuador'},
      {name: 'Michael', country: 'Colombia'},
      {name: 'Nicolás', country: 'Colombia'}
    ];
    vm.someGroupFn = function (item) {

      if (item.name[0] >= 'A' && item.name[0] <= 'M')
        return 'From A - M';
      if (item.name[0] >= 'N' && item.name[0] <= 'Z')
        return 'From N - Z';
    };

    vm.disableItem = {};
    vm.disableItems = [];

    vm.multipleItem = {};
    vm.multipleSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];
    vm.withDeleteItem = {};
    vm.withDeleteSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];

  }
})();



/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('SwitchDemoPanelCtrl', SwitchDemoPanelCtrl);

  /** @ngInject */
  function SwitchDemoPanelCtrl() {
    var vm = this;
    vm.switches = {
      s1: true,
      s2: false,
      s3: true,
      s4: true,
      s5: false
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('tagInput', tagInput);

  /** @ngInject */
  function tagInput() {
    return {
      restrict: 'A',
      link: function( $scope, elem, attr) {
        $(elem).tagsinput({
          tagClass:  'label label-' + attr.tagInput
        });
      }
    };
  }
})();
/**
 * @author Yury Tinos Pinheiro
 * created on 05/05/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.alunos.situacao.documentos.oficios.ata')
  		.controller('SituacaoAtaOficiosAlunosPageCtrl', SituacaoAtaOficiosAlunosPageCtrl);

	/** @ngInject */
	function SituacaoAtaOficiosAlunosPageCtrl($scope, $state, AlunosService, PdfService, $filter, LogService, AuthService) {

		$scope.mensagem = null;
		
		// Tela de Dados Basicos
		var aluno = AlunosService.getAluno();
		
		if(aluno == null) {
			$state.go('alunos.situacao');
		}
		else {
			AlunosService.buscarAta(aluno).then(function(data) {
				$scope.ata = data;
				if( $scope.ata.agenda && $scope.ata.agenda.dataDefesa && $scope.ata.agenda.dataDefesa != null){
					var data = $scope.ata.agenda.dataDefesa.split('/');
					$scope.ata.agenda.dataDefesa = $filter('date')(moment(data[2]+'-'+data[1]+'-'+data[0]).toDate(),"dd 'de' MMMM 'de' yyyy");
					$scope.ata.agenda.dataDefesa1 = $filter('date')(moment(data[2]+'-'+data[1]+'-'+data[0]).toDate(),"dd/MM/yyyy");
				}else{
					if(!$scope.ata.agenda){
						$scope.ata.agenda = {}
					}
					$scope.ata.agenda.dataDefesa = $filter('date')(moment().toDate(),"dd 'de' MMMM 'de' yyyy");
					$scope.ata.agenda.dataDefesa1 = $filter('date')(moment().toDate(),"dd/MM/yyyy");
				}
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
			$scope.print = function(){
				
				LogService.cadastraLog(jQuery.extend($scope.ata, {msg:'Imprime Ata',sub:AuthService.getUser()}) );
				var content = [
						{ text: 'JULGAMENTO DA '+$filter('uppercase')($scope.ata.nivelPrograma), style: 'header', margin: [0,15] },
						{ text: [
						    'ALUNO(A): ',
						    {text: $scope.ata.nomeAluno, style: 'variable'},
							], style: 'newRowAta', fontSize: 10
						},
						{ text: [
							$scope.ata.areaDeclaracao,
							' ',
							    {text: $scope.ata.nomeArea, style: 'variable'},
							], style: 'default', fontSize: 10
						},
						{ text: 'Relatório da Comissão Julgadora:', style: 'newRowAta', fontSize: 10 },
						{ text: [
						    { text: 'Aos '}, 
						    { text: $scope.ata.agenda.dataDefesa1, style: 'variable'},
						    ', atendendo ao disposto no Regimento da Pós-Graduação da Universidade ',
						    'de São Paulo, o(a) candidato(a) ',
						    { text: $scope.ata.nomeAluno, style: 'variable'},
						    ' ao título de ',
						    { text: $scope.ata.nivel, style: 'variable'},
						    ', apresentou sua ',
						    { text: $scope.ata.nivelPrograma, style: 'variable'},' com o título: ',
						    { text: $scope.ata.tituloTrabalho.replace(/(\r\n|\n|\r)/gm,""), style: 'variable'},'.', //rever quebras de linhas
							], style: 'newRowAta',alignment: 'justify', fontSize: 10
						},
						{ text: [
						    'Esta Comissão, indicada pela Comissão de Pós-Graduação, é de parecer que:'
							], style: 'newRowAta', fontSize: 10
						},
						{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 2 }],style:'newRowAta' },
						{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 2 }],style:'hr' },
						{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 2 }],style:'hr' },
						{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 2 }],style:'hr' },
						{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 2 }],style:'hr' },
						{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 2 }],style:'hr' },
						{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 2 }],style:'hr' },
						{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 2 }],style:'hr' },
						{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 2 }],style:'hr' },
						{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 2 }],style:'hr' },
						{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 2 }],style:'hr' },
						{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 2 }],style:'hr' },
						{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 2 }],style:'hr' },
						{ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 2 }],style:'hr' },
						{ text: [
						    'De acordo com o disposto no Regimento da Pós-Graduação da Universidade de São Paulo, os Examinadores consideraram o(a) candidato(a): ',
						    { text: $filter('uppercase')($scope.ata.nomeAluno), style: 'variable'}
							], style: 'newRowAta', alignment: 'justify', pageBreak: 'before', fontSize: 10
						},
						{ text: [
						    'São Paulo,  ',
						    { text: $scope.ata.agenda.dataDefesa, style: 'variable'}
							], style:'center', margin:[0,30], fontSize: 10
						},
						{text: {text:'COMISSÃO EXAMINADORA:',style:'variable'}, style: 'newRowAta', margin: [0, 0, 0, 30], fontSize: 10}
					];
				var mapItems = [];
				$('.sub-linha').map(function(i,v){mapItems.push($(v).val());});
				var i=0;
				for(var participante in $scope.ata.bancada){
					var l = { canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510, y2: 10, lineWidth: 0.5 }],style:'hr', margin: [0, 15, 0, 0] };
					content.push(l);
					if($scope.ata.bancada[participante].titulo != 'Presidente'){
						content.push({text:["(  "+mapItems[i++]+"  ) APR (  "+mapItems[i++]+"  ) REP - ",{text: $scope.ata.bancada[participante].nome,style:'variable'},{text: ' - '},{text: $filter('uppercase')($scope.ata.bancada[participante].titulo),style:'variable'}],style:'default', fontSize: 10});
					}else{
						content.push({text:[{text: $scope.ata.bancada[participante].nome,style:'variable'},{text: ' - '},{text: $filter('uppercase')($scope.ata.bancada[participante].titulo),style:'variable'}],style:'default', fontSize: 10});
					}
				}
				PdfService.getPdf(content);
			};
		}
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 05/05/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.alunos.situacao.documentos.oficios.aviso')
  		.controller('SituacaoAvisoOficiosAlunosPageCtrl', SituacaoAvisoOficiosAlunosPageCtrl);

	/** @ngInject */
	function SituacaoAvisoOficiosAlunosPageCtrl($scope, $state, AlunosService, $filter, PdfService, LogService, AuthService) {
		$scope.assinatura = '';
		PdfService.getAssinatura().then(function(assinatura) {
			$scope.assinatura = assinatura;
		});

		$scope.mensagem = null;
		$scope.titulacoes = [
			{ id: '0', value: 'Prof(a) Titular' },
			{ id: '1', value: 'Prof(a) Emérito' },
			{ id: '2', value: 'Prof(a) Adjunto' },
			{ id: '3', value: 'Prof(a) Associado(a)' },
			{ id: '4', value: 'Prof(a) Livre Docente' },
			{ id: '5', value: 'Doutor(a)' },
			{ id: '6', value: 'Especialista' },
		];
		
		// Tela de Dados Basicos
		var aluno = AlunosService.getAluno();
		
		if(aluno == null) {
			$state.go('alunos.situacao');
		}
		else {

			AlunosService.buscarAviso(aluno).then(function(data) {
				$scope.aviso = data;
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
			$scope.print = function(){
				LogService.cadastraLog(jQuery.extend($scope.aviso, {msg:'Imprime Aviso',sub:AuthService.getUser()}) );
				var content = [
					{text: $scope.aviso.dataAtual,style:'alignRight'},
					{text:'Prezados Senhores,',style:'textInicial'},
					{text:
						[
							'Informo a V.Sª, que a Defesa de ',
							{text: $scope.aviso.nivelPrograma, style:'variable'},
							' do(a) aluno(a) ',
							{text: $scope.aviso.nomeAluno, style:'variable'},
							', ',
							{text: $scope.aviso.areaDeclaracao, style:'default'},
							' está marcada para o dia ',
							{text: $scope.aviso.agenda.dataDefesa, style:'variable'},
							' às ',
							{text: $scope.aviso.agenda.horario, style:'variable'},
							' no Anfiteatro do(a) ',
							{text: $scope.aviso.agenda.local, style:'variable'},
							'.'
						], style:'paragraph', alignment: 'justify'
					},
					{text: 'A banca ficou assim constituída:', style:'newRow',bold:true},
				];
				var base = {
					table: {
						widths: [340, '*'],
						body: [],
						},
					layout: 'noBorders', style:'default',margin:[0,15,0,40]
				};
				var mapItems = [];
				$('.sub-linha').map(function(i,v){ mapItems.push($(v).find(':selected').html()); });
				var i=0;
				for(var participante in $scope.aviso.bancada){
					base.table.body.push ([{text: mapItems[i++] + ' - ' + ($scope.aviso.bancada[participante].nome || ''),style:'default'},{text: ($scope.aviso.bancada[participante].titulo || ''),style:'default'}]);
				}
				content.push(base);
				content.push({image: $scope.assinatura, width:'200', alignment:'center'});

				PdfService.getPdf(content);
				
			};
		}
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 05/05/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.alunos.situacao.documentos.oficios.certificado')
  		.controller('SituacaoCertificadoOficiosAlunosPageCtrl', SituacaoCertificadoOficiosAlunosPageCtrl);

	/** @ngInject */
	function SituacaoCertificadoOficiosAlunosPageCtrl($scope, $state, AlunosService, PdfService, $filter, LogService, AuthService) {
		$scope.assinatura = '';
		PdfService.getAssinatura().then(function(assinatura) {
			$scope.assinatura = assinatura;
		});
		$scope.erro = null;
		
		// Tela de Dados Basicos
		var aluno = AlunosService.getAluno();
		
		if(aluno == null) {
			$state.go('alunos.situacao');
		}
		else if(aluno.certificado == null) {
			$state.go('alunos.situacao.documentos.oficios.consultaCertificado');
		}
		else {
			$scope.certificado = aluno.certificado;
		}

		$scope.print = function(){
			LogService.cadastraLog(jQuery.extend($scope.certificado, {msg:'Imprime Cerificado',sub:AuthService.getUser()}) );
			var content = [];
			var total = $scope.certificado.bancada.length;
			var i = 1;
			for(var participante in $scope.certificado.bancada){
				if( typeof($scope.certificado.bancada[participante].titulacao.value) == "undefined"){
					continue;
				}
				
				content.push({text: 'Conferido ao(à) ' + ($scope.certificado.bancada[participante].titulacao.value || ''), style:'center', pageBreak:(i != 1?'before':'')});
				content.push({text: $filter('uppercase')($scope.certificado.bancada[participante].nome) || '',style:'header', margin:[0,60]});
				content.push({text:
				    [
				        'Pela participação, como ',
				        {text: $scope.certificado.bancada[participante].titulo || '', style: 'default'},
				        ' da Comissão Julgadora da ' + ($scope.certificado.nivelPrograma || '') + ', intitulada: ',
				        {text: $scope.certificado.tituloTrabalho.replace(/\r\n/gi,'') || '', style: 'variable'},
				        ' do(a) aluno(a) ',
						{text: $scope.certificado.nomeAluno || '', style: 'variable'},
						' ',
						$scope.certificado.areaDeclaracao || '',
				        ' ',
				        {text: $scope.certificado.nomeArea || '', style: 'variable'},
				        ', nesta data;',
				    ], style: 'paragraph'
				});
				content.push({text: $scope.certificado.agenda.dataDefesa || '', style:'center', bold:true, margin:[0,60]});
				content.push({image: $scope.assinatura, width:'200', alignment:'center'});
				i++;
			}
			PdfService.getPdf(content);
		}
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 05/05/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.alunos.situacao.documentos.oficios.certificado')
  		.controller('SituacaoConsultaCertificadoOficiosAlunosPageCtrl', SituacaoConsultaCertificadoOficiosAlunosPageCtrl);

	/** @ngInject */
	function SituacaoConsultaCertificadoOficiosAlunosPageCtrl($scope, $state, AlunosService) {

		$scope.mensagem = {'aviso':'Carregando...'};
		$scope.titulacoes = [
			{ id: '0', value: 'Prof(a) Titular' },
			{ id: '1', value: 'Prof(a) Emérito' },
			{ id: '2', value: 'Prof(a) Adjunto' },
			{ id: '3', value: 'Prof(a) Associado(a)' },
			{ id: '4', value: 'Prof(a) Livre Docente' },
			{ id: '5', value: 'Doutor(a)' },
			{ id: '6', value: 'Especialista' },
		];
		
		// Tela de Dados Basicos
		var aluno = AlunosService.getAluno();
		AlunosService.setAluno(aluno);
		
		if(aluno == null) {
			$state.go('alunos.situacao');
		}
		else {
			
			AlunosService.buscarCertificado(aluno).then(function(data) {
				$scope.mensagem = null;
				$scope.certificado = data;
				
				$scope.limpar = function() {
					if($scope.certificado.bancada.length == 0)
						return;
					
					for(var i = 0; i < $scope.certificado.bancada.length; i++) {
						$scope.certificado.bancada[i].titulacao = '';
					}
				}
				
				$scope.gerarDeclaracao = function() {

					aluno.certificado = $scope.certificado;
					AlunosService.setAluno(aluno);
					
					$state.go('alunos.situacao.documentos.oficios.certificado');
				}
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
		}
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 03/05/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.alunos.situacao.documentos.oficios.declaracao')
  		.controller('SituacaoDeclaracaoOficiosAlunosPageCtrl', SituacaoDeclaracaoOficiosAlunosPageCtrl);

	/** @ngInject */
	function SituacaoDeclaracaoOficiosAlunosPageCtrl($scope, $state, AlunosService, PdfService, $filter, LogService, AuthService) {
		// $scope.assinatura = '';
		// PdfService.getAssinatura().then(function(assinatura) {
		// 	$scope.assinatura = assinatura;
		// });
		$scope.chefe = {nome: '',cargo:''};
		PdfService.getChefe().then(function(chefe) {
			$scope.chefe = chefe;
		});
		$scope.mensagem = null;
		$scope.date = new Date();
		
		// Tela de Dados Basicos
		var aluno = AlunosService.getAluno();
		
		if(aluno == null) {
			$state.go('alunos.situacao');
		}
		else {
			
			AlunosService.buscarDeclaracao(aluno).then(function(data) {
				$scope.declaracao = data;
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});

			$scope.print = function(){
				LogService.cadastraLog(jQuery.extend($scope.declaracao, {msg:'Imprime Declaração',sub:AuthService.getUser()}) );
				var content = [
					{text:'DECLARAÇÃO',style:'header', margin:[0,60]},
					{text:
						[
						    {text: 'DECLARO', style:'variable'},
						    ', para os devidos fins, que o(a) aluno(a) ',
						    {text: $scope.declaracao.nomeAluno || '', style:'variable'},
						    ' defendeu a ',
						    {text: $scope.declaracao.nivelPrograma || '', style:'default'},
						    ' em ',
						    {text: $scope.declaracao.portaria.dataDefesa || ''},
						    ', intitulada: ',
						    {text: $scope.declaracao.tituloTrabalho.replace(/\r\n/gi,'') || '', style:'variable'},
						    ', tendo sido aprovado(a) ',
						    {text: $scope.declaracao.areaDeclaracao || '', style:'variable'},
						    ', reconhecido conforme Portaria ',
						    {text: $scope.declaracao.portaria.portaria || ''},
						    '.',
						], style:'newRowAta', margin:[0,60,0,0], alignment: 'justify'
					},
					{text: 
					    [
					        {text: 'Obs.:', style:'variable'},
					        ' O diploma está em fase de confecção.'
					    ], style:'newRow'
					},
					{text: $filter('date')($scope.date ,"'São Paulo', dd 'de' MMMM 'de' yyyy"), style: 'center', margin:[0,50]},
					{text: '________________________________________', style:'center'},
					{text: $scope.chefe.nome, style:'center', bold:true,margin:[0,0]},
					{text: $scope.chefe.cargo, style:'center',margin:[0,0]},
					//{image: $scope.assinatura, width:'200', alignment:'center'},
				];
				PdfService.getPdf(content);
			};
		}
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 03/05/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.alunos.situacao.documentos.oficios.diploma')
  		.controller('SituacaoDiplomaOficiosAlunosPageCtrl', SituacaoDiplomaOficiosAlunosPageCtrl);

	/** @ngInject */
	function SituacaoDiplomaOficiosAlunosPageCtrl($scope, $state, AlunosService, PdfService, $filter, LogService, AuthService) {
		$scope.assinatura = '';
		PdfService.getAssinatura().then(function(assinatura) {
			$scope.assinatura = assinatura;
		});
		$scope.mensagem = null;
		
		// Tela de Dados Basicos
		var aluno = AlunosService.getAluno();
		
		if(aluno == null) {
			$state.go('alunos.situacao.documentos');
		}
		else {
			
			AlunosService.buscarDiploma(aluno).then(function(data) {
				$scope.diploma = data;
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});
			$scope.print = function(){
				LogService.cadastraLog(jQuery.extend($scope.diploma, {msg:'Imprime Diploma',sub:AuthService.getUser()}) );
				var content = [
						{text: $scope.diploma.para || '',style:'textInicial', margin:[0,60,0,0]},
						{text:
						    [
						        'Interessado(a): ',
						        {text: $scope.diploma.interessado || '', style:'variable'}
						    ]
						    ,style:'default', margin:[0,90,0,0]
						},
						{text:
						    [
								$scope.diploma.areaDeclaracao || '',
								' ',
						        {text: $scope.diploma.programa, style:'variable'}
						    ]
						    ,style:'default'
						},
						{text:
						    [
						        'Data da defesa: ',
						        {text: $scope.diploma.especializacao.dataDefesa || '', style:'variable'}
						    ]
						    ,style:'default'
						},
						{text:
						    [
						        'Atendendo os dispositivos legais, segue a documentação para expedição e registro de diploma de  ',
						        {text: $scope.diploma.nivel || '', style:'variable'},
						        '.'
						    ]
						    ,style:'paragraph', margin:[0,90,0,90]
						},
						{image: $scope.assinatura, width:'200', alignment:'center'}
					];
				
				PdfService.getPdf(content);
			};
		}
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 03/05/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.alunos.situacao.documentos.oficios.membrosAluno')
  		.controller('SituacaoConsultaMembrosAlunoOficiosAlunosPageCtrl', SituacaoConsultaMembrosAlunoOficiosAlunosPageCtrl);

	/** @ngInject */
	function SituacaoConsultaMembrosAlunoOficiosAlunosPageCtrl($scope, $state, AlunosService) {

		// Tela de Dados Basicos
		var aluno = AlunosService.getAluno();
		$scope.membrosAluno = {};
		if(aluno == null) {
			$state.go('alunos.situacao');
		}
		else {
			$scope.mensagem = {'aviso':'Carregando'};
			AlunosService.buscarMembrosAluno(aluno).then(function(data) {
				$scope.mensagem = null;
				$scope.membrosAluno = data;
			})
			.catch(function(mensagem) {
				$scope.mensagem = mensagem;
			});

			$scope.limpar = function() {
				// Reset dos parametros de busca
				$scope.membrosAluno.coordenador = '';
				$scope.membrosAluno.programa = '';
			};

			$scope.gerarOficio = function() {
				$state.transitionTo('alunos.situacao.documentos.oficios.membrosAluno', { membrosAluno : JSON.stringify($scope.membrosAluno) });
			};
			
			$scope.limpar();
		}
	}

})();

/**
 * @author Yury Tinos Pinheiro
 * created on 03/05/2017
 */

(function () {
	'use strict';

  	angular.module('BlurAdmin.pages.alunos.situacao.documentos.oficios.membrosAluno')
  		.controller('SituacaoMembrosAlunoOficiosAlunosPageCtrl', SituacaoMembrosAlunoOficiosAlunosPageCtrl);

	/** @ngInject */
	function SituacaoMembrosAlunoOficiosAlunosPageCtrl($scope, $state, $stateParams, PdfService, $filter, AlunosService, LogService, AuthService) {

		// Tela de Dados Basicos
		var aluno = AlunosService.getAluno();
		$scope.date = new Date();
		$scope.membrosAluno = JSON.parse($stateParams.membrosAluno);
		
		if(aluno == null) {
			$state.go('alunos.situacao');
		}
		else if($scope.membrosAluno == null) {
			$state.go('alunos.situacao.documentos.oficios.consultaMembrosAluno');
		}

		$scope.print = function(){
			LogService.cadastraLog(jQuery.extend($scope.membrosAluno, {msg:'Imprime Membros e Alunos',sub:AuthService.getUser()}) );
			var content = [
				{text: $filter('date')($scope.date,"'São Paulo', dd 'de' MMMM 'de' yyyy"),style:'alignRight'},
				{text: 'Prezado(a) Professor(a),', style:'textInicial'},
				{text:
				[
					'O Sr. Presidente da Comissão de Pós-Graduação da FMUSP, Prof. ',
					$scope.membrosAluno.nomePresidente,
					', aprovou "',
				    {text:'ad referendum', style:'variable'},
				    '" em ',
				    {text: $scope.membrosAluno.dataProvaBanca },
				    ', a composição da Comissão Julgadora da ',
				    {text: $scope.membrosAluno.nivelPrograma, style:'variable'}, 
				    ' do(a) pós-graduando(a) ',
					{text: $scope.membrosAluno.nomeAluno, style:'variable'},
					' ',
				    $scope.membrosAluno.areaDeclaracao,
				    ' que ficou assim constituída:'
				], style:'paragraph'},
				{ canvas: [{ type: 'line', x1: 0, y1: -5, x2: 520, y2: -5, lineWidth: 0.5 }], style:'hr' }
			];
			var base = {
					table: {
					    widths: [340, '*'],
						body: [],
						},
					layout: 'noBorders', style:'default'
				};
			for(var participante in $scope.membrosAluno.bancada){
				base.table.body.push([
					{text: $scope.membrosAluno.bancada[participante].nome || '',style:'default'},
					{text: $filter('uppercase')($scope.membrosAluno.bancada[participante].titulo || ''),style:'default'}
				]);
			}
			content.push(base);
			content.push({canvas: [{ type: 'line', x1: 0, y1: 5, x2: 520, y2: 5, lineWidth: 0.5 }], style:'default' });
			content.push({text:
				[
				    'A arguição acontecerá no dia ',
				    {text: $scope.membrosAluno.agenda.dataDefesa, style:'variable'},
				    ' às ',
				    {text: $scope.membrosAluno.agenda.horario, style:'variable'},
				    ' no Anfiteatro do(a) ',
				    {text: $scope.membrosAluno.agenda.local, style:'variable'},
				    '.'
				], style:'hr'
			});
			content.push({text:'Atenciosamente,', style:'center'});
			content.push({text:
			    [
			        'Ilmo(a) Sr(a) ',
					{text:'Prof(a) Dr(a) ', style:'variable'},
					{text: $scope.membrosAluno.coordenador, style:'variable'}
			    ], style:'newRow'
			});
			content.push({text:
			    [
			        'MD. Coord(a). do Programa de Pós-Graduação em ',
			        {text: $scope.membrosAluno.programa, style:'variable'}
			    ], style:'default'
			});
			content.push({
				table: {
				    widths: [60, 'auto'],
					body: [
						['cc.:', '1) Pós-graduando(a)'],
						['', '2) Membros da Comissão Julgadora, com exemplar anexo.'],
					], 
				},
				layout: 'noBorders', style:'newRow'
			});
			PdfService.getPdf(content);
		};
		
	}

})();

angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/loading.html','<div class="modal-content"><div class="modal-body text-center">Carregando...</div></div>');
$templateCache.put('app/pages/alunos/footer.html','<tr><td><img ng-src="{{ ::(\'rodape\' | rootImage : \'png\') }}"></td></tr>');
$templateCache.put('app/pages/alunos/header.html','<tr><td><img ng-src="{{ ::(\'cabecalho\' | rootImage:\'png\') }}"></td></tr>');
$templateCache.put('app/pages/comissao/comissao.html','<div class="widgets"><div class="row"><div class="col-md-12" id="section-to-print"><div class="panel animated zoomIn"><div class="panel-body footer-panel"><div><div><div class="row" ng-repeat="item in listComissao.presidente"><div><div><div class="row title"><div class="col-md-12"><b><i>{{item.nome}}</i></b></div></div><div class="row"><div class="col-md-2">&nbsp; Presidente:</div><div class="col-md-6">{{item.titular}}</div></div><div class="row"><div class="col-md-2">&nbsp; Vice-Presidente:</div><div class="col-md-6">{{item.suplente}}</div></div></div></div></div><div class="row" ng-repeat="(nome, item) in listComissao.listas"><div><div><div class="row title"><div class="col-md-12"><b><i>{{nome}}</i></b></div></div><div class="row" ng-repeat="membro in item"><div class="col-md-2">&nbsp; Titular:</div><div class="col-md-3">{{membro.titular}}</div><div class="col-md-2">&nbsp; Suplente:</div><div class="col-md-3">{{membro.suplente}}</div></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<dashboard-pie-chart></dashboard-pie-chart><div class="row"><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Acquisition Channels" ba-panel-class="medium-panel traffic-panel"><traffic-chart></traffic-chart></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Users by Country" ba-panel-class="medium-panel"><dashboard-map></dashboard-map></div></div><div class="row"><div class="col-xlg-9 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="row"><div class="col-xlg-8 col-lg-12 col-md-12 col-sm-7 col-xs-12" ba-panel="" ba-panel-title="Revenue" ba-panel-class="medium-panel"><dashboard-line-chart></dashboard-line-chart></div><div class="col-xlg-4 col-lg-12 col-md-12 col-sm-5 col-xs-12" ba-panel="" ba-panel-class="popular-app medium-panel"><popular-app></popular-app></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-12 col-xs-12" ba-panel="" ba-panel-title="Feed" ba-panel-class="large-panel with-scroll feed-panel"><blur-feed></blur-feed></div></div><div class="row shift-up"><div class="col-xlg-3 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="To Do List" ba-panel-class="xmedium-panel feed-comply-panel with-scroll todo-panel"><dashboard-todo></dashboard-todo></div><div class="col-xlg-6 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="Calendar" ba-panel-class="xmedium-panel feed-comply-panel with-scroll calendar-panel"><dashboard-calendar></dashboard-calendar></div></div>');
$templateCache.put('app/pages/diploma/diploma.html','<div class="widgets" id="diploma"><div class="row"><div class="col-md-14"><div ba-panel="" ba-panel-title="Diploma"><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="row"><div class="col-md-3"><label for="matricula" class="control-label">Matr\xEDcula</label> <input type="text" class="form-control" id="matricula" ng-model="busca.matricula"></div><div class="col-md-9"><label for="nome" class="control-label">Nome</label> <input type="text" class="form-control" id="nome" ng-model="busca.nome"></div></div><div class="row"><div class="col-md-12"><hr><button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-primary pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button></div></div></form></div><response-message msg="mensagem" voltar="false"></response-message><div ba-panel="" ba-panel-title="Resultados" id="resultados" ba-panel-class="with-scroll" ng-if="diplomas.length > 0 && mensagem == null"><div class="horizontal-scroll row col-md-12"><div class="row"><label class="control-label col-md-2"><select class="form-control selectpicker show-tick" title="Diplomas por p\xE1ginas" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40]"></select></label></div><table class="table" st-table="diplomas" st-safe-src="outros"><thead><tr class="sortable"><th st-sort="nome" st-sort-default="true"><b>Nome</b></th><th st-sort="programa"><b>Programa</b></th><th st-sort="nivel"><b>N\xEDvel</b></th><th st-sort="situacao"><b>Situa\xE7\xE3o</b></th></tr><tbody><tr ng-repeat="item in diplomas"><td>{{item.nome}}</td><td>{{item.programa}}</td><td>{{item.nivel}}</td><td>{{item.situacao}}</td></tr></tbody><tfoot class="no-borders"><tr class="text-center"><td colspan="4" st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></td></tr></tfoot></thead></table></div></div></div></div></div>');
$templateCache.put('app/pages/maps/maps.html','<div class="widgets"><div class="row"><div class="col-md-12" ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div>');
$templateCache.put('app/pages/profile/profile.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><div class="progress-info">Your profile is 70% Complete</div><div class="progress"><div class="progress-bar progress-bar-primary progress-bar-striped active" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style="width: 70%"></div></div><h3 class="with-line">General Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Picture</label><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ picture }}" ng-click="uploadPicture()"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <a href="" class="change-userpic" ng-click="uploadPicture()">Change Profile Picture</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div></div><div class="col-md-6"></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">First Name</label><div class="col-sm-9"><input type="text" class="form-control" id="inputFirstName" placeholder="" value="Anastasiya"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Last Name</label><div class="col-sm-9"><input type="text" class="form-control" id="inputLastName" placeholder="" value=""></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Department</label><div class="col-sm-9"><select class="form-control" selectpicker=""><option>Web Development</option><option>System Development</option><option>Sales</option><option>Human Resources</option></select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Occupation</label><div class="col-sm-9"><input type="text" class="form-control" id="inputOccupation" placeholder="" value="Front End Web Developer"></div></div></div></div><h3 class="with-line">Change Password</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputPassword" placeholder="" value="12345678"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputConfirmPassword" class="col-sm-3 control-label">Confirm Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputConfirmPassword" placeholder=""></div></div></div></div><h3 class="with-line">Contact Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputEmail3" class="col-sm-3 control-label">Email</label><div class="col-sm-9"><input type="email" class="form-control" id="inputEmail3" placeholder="" value="contact@akveo.com"></div></div><div class="form-group row clearfix"><label for="inputPhone" class="col-sm-3 control-label">Phone</label><div class="col-sm-9"><input type="text" class="form-control" id="inputPhone" placeholder="" value="+1 (23) 456 7890"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Office Location</label><div class="col-sm-9"><select class="form-control" title="Standard Select" selectpicker=""><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class="form-group row clearfix"><label for="inputRoom" class="col-sm-3 control-label">Room</label><div class="col-sm-9"><input type="text" class="form-control" id="inputRoom" placeholder="" value="303"></div></div></div></div><h3 class="with-line">Social Profiles</h3><div class="social-profiles row clearfix"><div class="col-md-3 col-sm-4" ng-repeat="item in socialProfiles"><a class="sn-link" href="" ng-click="showModal(item)" ng-if="!item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span></a> <a class="sn-link connected" href="{{ item.href }}" target="_blank" ng-if="item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span> <em class="ion-ios-close-empty sn-link-close" ng-mousedown="unconnect(item)"></em></a></div></div><h3 class="with-line">Send Email Notifications</h3><div class="notification row clearfix"><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When I receive a message</label><div class="col-xs-4"><switch color="primary" ng-model="switches[0]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When Someone sends me an invitation</label><div class="col-xs-4"><switch color="primary" ng-model="switches[1]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When profile information changes</label><div class="col-xs-4"><switch color="primary" ng-model="switches[2]"></switch></div></div></div><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When anyone logs into your account from a new device or browser</label><div class="col-xs-4"><switch color="primary" ng-model="switches[3]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Weekly Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[4]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Daily Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[5]"></switch></div></div></div></div><button type="button" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Update Profile</button></div></div>');
$templateCache.put('app/pages/profile/profileModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Add Account</h4></div><form name="linkForm"><div class="modal-body"><p>Paste a link to your profile into the box below</p><div class="form-group"><input type="text" class="form-control" placeholder="Link to Profile" ng-model="link"></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="ok(link)">Save changes</button></div></form></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i> <span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/">Home</a></li><li ng-repeat="breadchumb in activePageBreadchumbs">{{ breadchumb }}</li></ul></div>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/" class="al-logo clearfix"><img ng-src="{{::( \'logo\' | rootImage )}}" width="116" height="60"></a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="user-profile clearfix"><div class="al-user-profile"><a ng-if="!isAuthenticated" href="#/administrador/login" class="signin"><i class="fa fa-sign-in"></i> Entrar</a><div><span ng-if="isAuthenticated">Ola, {{ user.name || \'Visitante\'}}</span> <a ng-if="isAuthenticated" href="#/administrador/logout" class="signout"><i class="fa fa-sign-out"></i> Sair</a></div></div><msg-center></msg-center></div></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown="" ng-show="notifications.length>0"><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>{{ notifications.length }}</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="" ng-show="notifications.length>0">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown="" ng-show="messages.length>0"><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>{{ messages.length }}</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="" ng-show="messages.length>0">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/responseMessage/responseMessage.html','<div class="panel-overlayed" ng-show="mensagem != null"><div class="panel panel-{{ type }} bootstrap-panel animated zoomIn closeable"><div class="panel-heading clearfix"><h3 class="panel-title">{{ title }}</h3></div><div class="panel-body"><div class="row"><div class="col-md-10 col-xs-10">{{ mensagem }}</div><div class="col-md-2 col-xs-2"><a href="javascript:void(0)" style="float: right;" onclick="history.back();" ng-show="voltar"><i class="icon ion-android-arrow-back"></i> Voltar</a> <a href="javascript:void(0)" style="float: right;" ng-click="limparMensagem()" ng-hide="voltar"><i class="icon ion-android-close" ng-hide="voltar"></i> Fechar</a></div></div></div></div></div>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">{{ switcherOnLabel }}</span> <span class="handle"></span> <span class="handle handle-off">{{ switcherOffLabel }}</span></div></div></label>');
$templateCache.put('app/pages/administrador/login/forgot.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Login"><form class="form-horizontal" ng-submit="login(credenciais)"><div class="form-group"><label for="usuario" class="col-md-2 control-label">Usu\xE1rio</label><div class="col-md-10"><input type="text" class="form-control" id="usuario" placeholder="Nome de Usu\xE1rio" ng-model="credenciais.usuario"></div></div><div class="form-group"><label for="senha" class="col-md-2 control-label">Senha</label><div class="col-md-10"><input type="password" class="form-control" id="senha" placeholder="Senha" ng-model="credenciais.senha"></div></div><div class="form-group"><div class="col-md-offset-2 col-md-10"><button type="submit" class="btn btn-default btn-auth">Entrar</button> <a href="" class="forgot-pass">Esqueceu a senha?</a></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/administrador/login/login.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Autentica\xE7\xE3o"><form class="form-horizontal" ng-submit="login(credenciais)"><div class="form-group"><label for="usuario" class="col-md-2 control-label">Usu\xE1rio</label><div class="col-md-10"><input type="text" class="form-control" id="usuario" placeholder="Nome de Usu\xE1rio" ng-model="credenciais.usuario"></div></div><div class="form-group"><label for="senha" class="col-md-2 control-label">Senha</label><div class="col-md-10"><input type="password" class="form-control" id="senha" placeholder="Senha" ng-model="credenciais.senha"></div></div><div class="form-group align-right"><div class="col-md-offset-2 col-md-10"><button type="submit" class="btn btn-info btn-auth">Entrar</button></div></div><div class="form-group align-right"><div class="col-md-offset-2 col-md-10"><a href="" class="forgot-pass" ng-click="forgotPass()">Relembrar minha senha?</a></div></div></form><hr></div><response-message msg="mensagem" voltar="false"></response-message></div></div></div>');
$templateCache.put('app/pages/administrador/register/register.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Preencha os dados abaixo"><form name="form" class="form-horizontal" ng-submit="register(data)"><div class="form-group"><label for="nome" class="col-md-2 control-label">Nome <b>*</b></label><div class="col-md-10"><input type="text" class="form-control" required="" id="nome" maxlength="100" ng-maxlength="100" placeholder="Nome" ng-model="data.nome"></div></div><div class="form-group"><label for="lastName" class="col-md-2 control-label">Sobrenome <b>*</b></label><div class="col-md-10"><input type="text" class="form-control" required="" id="lastName" maxlength="100" ng-maxlength="100" placeholder="\xDAltimo Sobrenome" ng-model="data.lastName"></div></div><div class="form-group"><label for="numUsp" class="col-md-2 control-label">Nro USP <b ng-show="data.nonCPF || (!data.nonNumUsp && !data.nonCPF)">*</b></label><div class="col-md-6"><input type="number" class="form-control" ng-required="!data.nonNumUsp" ng-disabled="data.nonNumUsp" id="numUsp" placeholder="N\xFAmero USP" ng-model="data.numUsp"></div><div class="col-md-4"><input type="checkbox" class="" id="nonNumUsp" ng-model="data.nonNumUsp" ng-disabled="data.nonCPF"> <label for="nonNumUsp">N\xE3o tenho USP</label></div></div><div class="form-group"><label for="cpf" class="col-md-2 control-label">CPF <b ng-show="data.nonNumUsp || (!data.nonNumUsp && !data.nonCPF)">*</b></label><div class="col-md-6"><input type="text" class="form-control" id="cpf" name="cpf" validador-cpf="" ng-required="!data.nonCPF" ng-disabled="data.nonCPF" ng-model="data.cpf" ui-mask="9?9?9?.999.999-99"></div><div class="col-md-4"><input type="checkbox" class="" id="nonCPF" ng-model="data.nonCPF" ng-disabled="data.nonNumUsp"> <label for="nonCPF">N\xE3o tenho CPF</label></div><div class="col-xs-12 error" ng-show="data.cpf && form.cpf.$invalid" style="color:red">CPF previsa ser v\xE1lido</div></div><div class="form-group"><label for="senha" class="col-md-2 control-label">E-mail <b>*</b></label><div class="col-md-10"><input type="email" class="form-control" required="" id="email" placeholder="email@pessoal.com" ng-model="data.email"></div></div><div class="form-group"><label for="senha" class="col-md-2 control-label">Senha <b>*</b></label><div class="col-md-10"><input type="password" class="form-control" required="" id="senha" placeholder="Senha" ng-model="data.senha"></div></div><div class="form-group"><label for="senha" class="col-md-2 control-label">Repetir Senha <b>*</b></label><div class="col-md-10"><input type="password" class="form-control" required="" id="repeatSenha" placeholder="Repetir Senha" ng-model="data.repeatSenha" ng-blur="senhafinal=true"></div><div class="col-xs-12 error" ng-show="senhafinal && (data.senha && data.repeatSenha) && data.repeatSenha != data.senha" style="color:red">Senha e Confirma\xE7\xE3o devem ser iguais</div></div><div class="form-group"><div class="col-md-2 align-right"><font color="red">* Campos Obrigat\xF3rios</font></div><div class="col-md-offset-1 col-md-2"><button type="reset" class="btn btn-lg btn-secondary btn-auth">Cancelar</button></div><div class="col-md-2"><button type="submit" class="btn btn-lg btn-primary btn-auth">Cadastrar</button></div></div></form></div><response-message msg="mensagem" voltar="false"></response-message></div></div></div>');
$templateCache.put('app/pages/agendamento/anfiteatro/anfiteatro.html','<div class="widgets"><div class="row"><div class="col-md-12 agendamento anfiteatro"><div class="panel animated zoomIn"><div class="panel-heading clearfix"><h3 class="panel-title">{{ acao }} Anfiteatro</h3></div><div class="panel-body footer-panel"><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="row"><div class="col-md-12"><div class="form-group"><label for="nome" class="col-md-2 control-label">Nome:</label><div class="col-md-10"><input type="text" class="form-control" id="nome" ng-model="anfiteatro.nome"></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="endereco" class="col-md-2 control-label">Endere\xE7o:</label><div class="col-md-10"><input type="text" class="form-control" id="endereco" ng-model="anfiteatro.endereco"></div></div></div></div></form></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-danger pull-right" ng-click="limpar()" style="margin-right: 20px; margin-top: -10px;">Limpar</button> <button type="button" class="btn btn-primary pull-right" ng-hide="anfiteatro.id" ng-click="inserirAnfiteatro(anfiteatro)" style="margin-right: 20px; margin-top: -10px;">Inserir</button> <button type="button" class="btn btn-primary pull-right" ng-show="anfiteatro.id" ng-click="alterarAnfiteatro(anfiteatro)" style="margin-right: 20px; margin-top: -10px;">Alterar</button><br></div></div><response-message msg="mensagem" voltar="true"></response-message></div></div></div>');
$templateCache.put('app/pages/agendamento/anfiteatro/consulta.html','<div class="widgets"><div class="row"><div class="col-md-12 agendamento anfiteatro"><div ba-panel="" ba-panel-title="Consulta de Anfiteatros"><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="row"><div class="col-md-12"><div class="form-group"><label for="nome" class="col-md-2 control-label">Nome:</label><div class="col-md-10"><input type="text" class="form-control" id="nome" ng-model="anfiteatro.nome"></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="endereco" class="col-md-2 control-label">Endere\xE7o:</label><div class="col-md-10"><input type="text" class="form-control" id="endereco" ng-model="anfiteatro.endereco"></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-default pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button> <button type="button" class="btn btn-primary pull-right" ng-click="inserirAnfiteatro()" style="margin-right: 20px;">Inserir novo anfiteatro</button></div></div></form></div><response-message msg="mensagem" voltar="false"></response-message><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll" class="panel-overlayed" ng-hide="anfiteatros == null"><table class="table table-striped" ng-show="anfiteatros.length == 0"><tr><td>N\xE3o foi encontrado nenhum registro!</td></tr></table><table class="table table-striped" ng-hide="anfiteatros.length == 0"><thead><tr><th width="5%">#</th><th id="nome-anfiteatro" width="45%">Nome</th><th id="endereco-anfiteatro" width="45%">Endere\xE7o</th><th width="5%">A\xE7\xF5es</th></tr></thead><tbody><tr ng-repeat="anfiteatro in anfiteatros"><td><a ng-click="editarAnfiteatro(anfiteatro)" title="Alterar">{{ anfiteatro.id }}</a></td><td id="nome-anfiteatro">{{ anfiteatro.nome | limitTo: 50 }}{{ anfiteatro.nome.length > 50 ? \'...\' : \'\'}}</td><td id="endereco-anfiteatro">{{ anfiteatro.endereco | limitTo: 50 }}{{ anfiteatro.endereco.length > 50 ? \'...\' : \'\'}}</td><td class="center"><a ng-click="editarAnfiteatro(anfiteatro)" title="Alterar"><i class="icon ion-edit"></i></a> | <a ng-click="excluirAnfiteatro(anfiteatro)" title="Excluir"><i class="icon ion-android-delete"></i></a></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/agendamento/calendarioFeriado/consulta.html','<div class="widgets"><div class="row"><div class="col-md-12 agendamento feriado"><div ba-panel="" ba-panel-title="Consulta Calend\xE1rio de Feriado"><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label for="nome" class="col-md-4 control-label">Ano de Refer\xEAncia</label><div class="col-md-8"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="ano" type="text" placeholder="Selecione o ano" class="form-control" ng-click="open();" uib-datepicker-popup="yyyy" ng-focus="open($event);" datepicker-options="opcoesAnoReferenciaApenas" ng-model="calendario.ano" is-open="opened" ng-required="true" close-text="Fechar" show-button-bar="false" date-disabled="disabled(date, mode)"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="col-md-6 col-xs-12"><button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-default pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button> <button type="button" class="btn btn-primary pull-right" ng-click="inserirFeriado()" style="margin-right: 20px;">Inserir novo feriado</button></div></div></form></div><response-message msg="mensagem" voltar="false"></response-message><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll" class="panel-overlayed" ng-hide="feriados == null"><table class="table table-striped" ng-show="feriados.length == 0"><tr><td>N\xE3o foi encontrado nenhum registro!</td></tr></table><table class="table table-striped" ng-hide="feriados.length == 0"><thead><tr><th width="5%">#</th><th width="20%">Data do Feriado</th><th width="20%">Data do Feriado (Fim)</th><th id="descricao">Descri\xE7\xE3o</th><th id="fixo">Dia Todo</th><th width="10%">A\xE7\xF5es</th></tr></thead><tbody><tr ng-repeat="feriado in feriados"><td>{{ feriado.id }}</td><td><a ng-click="editarFeriado(feriado)">{{ feriado.dataInicio | date: \'dd/MM/yyyy\' }}</a></td><td>{{ feriado.dataFim | date: \'dd/MM/yyyy\' }}</td><td id="descricao">{{ feriado.descricao }}</td><td id="fixo">{{ feriado.fixo }}</td><td class="center"><a ng-click="editarFeriado(feriado)" title="Alterar"><i class="icon ion-edit"></i></a> | <a ng-click="excluirFeriado(feriado)" title="Excluir"><i class="icon ion-android-delete"></i></a></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/agendamento/calendarioFeriado/feriado.html','<div class="widgets"><div class="row"><div class="col-md-12 agendamento feriado"><div class="panel animated zoomIn"><div class="panel-heading clearfix"><h3 class="panel-title">{{ acao }} Feriado</h3></div><div class="panel-body footer-panel"><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="row"><div class="col-md-12"><div class="form-group"><label for="data" class="col-md-2 control-label">Data do Feriado:</label><div class="col-md-5"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="data" type="text" placeholder="Inicio" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="feriado.dataInicio" is-open="opened" ng-required="true" close-text="Fechar" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-1" ng-if="!feriado.fixo"><label>Per\xEDodo</label></div><div class="col-md-4" ng-if="!feriado.fixo"><div class="input-group"><ui-select ng-model="feriado.periodo" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" placeholder="Per\xEDodo"><ui-select-match><span>{{ feriado.periodo.nome }}</span></ui-select-match><ui-select-choices repeat="periodo in periodos"><span>{{ periodo.nome }}</span></ui-select-choices></ui-select></div></div><div class="col-md-5" ng-if="feriado.fixo"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="data" type="text" placeholder="Fim (Opcional)" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="feriado.dataFim" is-open="opened" close-text="Fechar" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="descricao" class="col-md-2 control-label">Descri\xE7\xE3o</label><div class="col-md-10"><input type="text" class="form-control" id="descricao" ng-required="true" ng-model="feriado.descricao"></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="nome" class="col-md-2 control-label">Dia todo:</label><div class="col-md-10"><ba-switcher switcher-style="primary" switcher-value="feriado.fixo" ng-required="true" switcher-on-label="SIM" switcher-off-label="N\xC3O"></ba-switcher></div></div></div></div></form></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-danger pull-right" ng-click="limpar()" style="margin-right: 20px; margin-top: -10px;">Limpar</button> <button type="button" class="btn btn-primary pull-right" ng-hide="feriado.id" ng-click="inserirFeriado(feriado)" style="margin-right: 20px; margin-top: -10px;">Inserir</button> <button type="button" class="btn btn-primary pull-right" ng-show="feriado.id" ng-click="alterarFeriado(feriado)" style="margin-right: 20px; margin-top: -10px;">Alterar</button><br></div></div><response-message msg="mensagem" voltar="true"></response-message></div></div></div>');
$templateCache.put('app/pages/agendamento/preAgendamento/calendario.html','<div class="widgets"><div class="agendamento filtros" ng-if="filtrosPesquisa" ng-include="\'app/pages/agendamento/preAgendamento/widgets/filtros.html\'"></div><div class="row"><div class="col-md-12 agendamento pre-agendamento"><div class="panel animated zoomIn"><div class="panel-heading clearfix"><h3 class="panel-title">Agendamento de Defesa</h3></div><div class="panel-body footer-panel"><div id="calendar" class="blurCalendar"></div></div></div></div></div></div><response-message msg="mensagem" voltar="false" ng-if="mensagem != null"></response-message>');
$templateCache.put('app/pages/agendamento/relatorios/relatorios.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Agendamentos" ng-click="select(0)"><div class="agendamentos" ng-include="\'app/pages/agendamento/relatorios/widgets/agendamentos.html\'"></div></uib-tab><uib-tab heading="Consulta" ng-click="select(1)"><div class="agendamentos" ng-include="\'app/pages/agendamento/relatorios/widgets/consulta.html\'"></div></uib-tab></uib-tabset></div><response-message msg="mensagem[current]" voltar="false" ng-if="mensagem[current] != null"></response-message></div></div></div><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll" class="panel-overlayed" ng-hide="alunos == null || current != 1"><table class="table table-striped" ng-show="alunos.length == 0"><tr><td>N\xE3o h\xE1 Alunos para estes filtros!</td></tr></table><table class="table table-striped" ng-hide="alunos.length == 0"><thead><tr><th>Matr\xEDcula</th><th>Aluno</th><th>N\xEDvel</th><th>\xC1rea</th></tr></thead><tbody><tr ng-repeat="aluno in alunos"><td><a ng-click="mostrarAgendamento(aluno)">{{ aluno.matricula }}</a></td><td>{{ aluno.nomeAluno }}</td><td>{{ aluno.nivel }}</td><td>{{ aluno.areaId }} - {{ aluno.area }}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/alunos/dadosBasicos/consulta.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Consulta de Alunos"><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="row"><div class="col-md-4"><div class="form-group"><label for="nome" class="col-md-3 control-label">Matr\xEDcula</label><div class="col-md-9"><input type="text" class="form-control" id="nome" ng-model="aluno.matricula"></div></div></div><div class="col-md-4"><div class="form-group"><label for="cpf" class="col-md-3 control-label">CPF</label><div class="col-md-9"><input type="text" class="form-control" id="cpf" ng-model="aluno.cpf" ui-mask="9?9?9?.999.999-99"></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="nome" class="col-md-1 control-label">Nome</label><div class="col-md-7"><input type="text" class="form-control" id="nome" ng-model="aluno.nome"></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label for="nome" class="col-md-3 control-label">\xC1rea</label><div class="col-md-9"><ui-select ng-model="aluno.area" class="btn-group bootstrap-select form-control" ng-disabled="areas == null" append-to-body="true" search-enabled="false" close-on-select="true" spinner-enabled="true" on-select="getOrientadores($item)"><ui-select-match><span>{{ aluno.area.value }}</span></ui-select-match><ui-select-choices repeat="area in areas"><span>{{ area.value }}</span></ui-select-choices></ui-select></div></div></div><div class="col-md-4"><div class="form-group"><label for="nome" class="col-md-3 control-label">Orientador</label><div class="col-md-9"><ui-select ng-model="aluno.orientador" class="btn-group bootstrap-select form-control" ng-disabled="orientadores == null" append-to-body="true" search-enabled="true" close-on-select="true" spinner-enabled="true"><ui-select-match><span>{{ aluno.orientador.value }}</span></ui-select-match><ui-select-choices repeat="orientador in orientadores | filter:$select.search"><span>{{ orientador.value }}</span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-default pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button></div></div></form></div><response-message msg="mensagem"></response-message><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll" class="panel-overlayed" ng-hide="alunos == null"><table class="table table-striped" ng-show="alunos.length == 0"><tr><td>N\xE3o h\xE1 Alunos para estes filtros!</td></tr></table><table class="table table-striped" ng-hide="alunos.length == 0"><thead><tr><th>Matr\xEDcula</th><th>CPF</th><th>Aluno</th><th>N\xEDvel</th><th>\xC1rea</th></tr></thead><tbody><tr ng-repeat="item in alunos"><td><a ng-click="consultarDadosBasicos(item)">{{ item.matricula }}</a></td><td>{{ item.cpf | cpfFormat }}</td><td>{{ item.nome }}</td><td>{{ item.nivel }}</td><td>{{ item.areaId }} - {{ item.area }}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/alunos/dadosBasicos/dadosBasicos.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ficha de Aluno"><div class="row"><div class="col-md-4 col-xs-6 info"><label>Matr\xEDcula:</label><div>{{ aluno.matricula }}</div></div><div class="col-md-4 col-xs-6 info"><label>Nome:</label><div>{{ aluno.nome }}</div></div><div class="col-md-4 col-xs-12 info"><label>Pseud\xF4nimo:</label><div>{{ aluno.complemento.pseudonimo }}</div></div></div></div><div ba-panel="" ba-panel-title="Dados Pessoais"><div class="dados-basicos" ng-include="\'app/pages/alunos/dadosBasicos/widgets/dadosBasicos.html\'"></div></div><div ba-panel="" ba-panel-title="Complemento"><div class="complemento" ng-include="\'app/pages/alunos/dadosBasicos/widgets/complemento.html\'"></div></div><div ba-panel="" ba-panel-title="Institui\xE7\xF5es"><div class="documentos" ng-include="\'app/pages/alunos/dadosBasicos/widgets/documentos.html\'"></div></div><div ba-panel="" ba-panel-title="Complemento"><div class="complemento" ng-include="\'app/pages/alunos/situacao/widgets/complemento.html\'"></div></div><div ba-panel="" ba-panel-title="Documentos"><div class="documentos" ng-include="\'app/pages/alunos/situacao/widgets/disciplinas.html\'"></div></div><div ba-panel="" ba-panel-title="Agendamento"><div class="agendamento" ng-include="\'app/pages/alunos/dadosBasicos/widgets/agendamento.html\'"></div></div><div ba-panel="" ba-panel-title="Oficios"><div class="documentos" ng-include="\'app/pages/alunos/situacao/documentos/oficios.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/relatorios/relatorios.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Alunos" ng-click="select(0)"><div class="listagens" ng-include="\'app/pages/alunos/relatorios/widgets/listagens.html\'"></div></uib-tab><uib-tab heading="Exames" ng-click="select(1)"><div class="periodo" ng-include="\'app/pages/alunos/relatorios/widgets/periodo.html\'"></div></uib-tab></uib-tabset></div></div></div></div><response-message msg="mensagem[current]" voltar="false" ng-if="mensagem[current] != null"></response-message>');
$templateCache.put('app/pages/alunos/situacao/consulta.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title=""><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="row"><div class="col-md-4"><div class="form-group"><label for="cpf" class="col-md-3 control-label">CPF</label><div class="col-md-9"><input type="text" class="form-control" id="cpf" ng-model="aluno.cpf" ui-mask="9?9?9?.999.999-99"></div></div></div><div class="col-md-8"><div class="form-group"><label for="nome" class="col-md-3 control-label">Matr\xEDcula</label><div class="col-md-9"><input type="text" class="form-control" id="nome" ng-model="aluno.matricula"></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="nome" class="col-md-1 control-label">Nome</label><div class="col-md-11"><input type="text" class="form-control" id="nome" ng-model="aluno.nome"></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="nome" class="col-md-2 control-label">\xC1rea</label><div class="col-md-10"><ui-select ng-model="aluno.area" class="btn-group bootstrap-select form-control" ng-disabled="areas == null" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ aluno.area.value }}</span></ui-select-match><ui-select-choices repeat="area in areas"><span>{{ area.value }}</span></ui-select-choices></ui-select></div></div></div><div class="col-md-6"><div class="form-group"><label for="nome" class="col-md-2 control-label">Orientador</label><div class="col-md-10"><ui-select ng-model="aluno.orientador" class="btn-group bootstrap-select form-control" ng-disabled="orientadores == null" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ aluno.orientador.value }}</span></ui-select-match><ui-select-choices repeat="orientador in orientadores"><span>{{ orientador.value }}</span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-default pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button></div></div></form></div><response-message msg="mensagem"></response-message><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll" class="panel-overlayed" ng-hide="alunos == null"><table class="table table-striped" ng-show="alunos.length == 0"><tr><td>N\xE3o h\xE1 Alunos para estes filtros!</td></tr></table><table class="table table-striped" ng-hide="alunos.length == 0"><thead><tr><th>Matr\xEDcula</th><th>CPF</th><th>Aluno</th><th>N\xEDvel</th><th>\xC1rea</th></tr></thead><tbody><tr ng-repeat="item in alunos"><td><a ng-click="consultarSituacao(item)">{{ item.matricula }}</a></td><td>{{ item.cpf | cpfFormat }}</td><td>{{ item.nome }}</td><td>{{ item.nivel }}</td><td>{{ item.areaId }} - {{ item.area }}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/alunos/situacao/situacao.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Dados Basicos"><div class="row"><div class="col-md-4 col-xs-6 info"><label>Matr\xEDcula:</label><div>{{ aluno.matricula }}</div></div><div class="col-md-4 col-xs-6 info"><label>Nome:</label><div>{{ aluno.nome }}</div></div><div class="col-md-4 col-xs-6 info"><label>Aluno Especial:</label><div>{{ aluno.resumo.alunoEspecial }}</div></div></div></div><div ba-panel="" ba-panel-title="Dados Basicos"><div class="dados-basicos" ng-include="\'app/pages/alunos/situacao/widgets/dadosBasicos.html\'"></div></div><div ba-panel="" ba-panel-title="Complemento"><div class="complemento" ng-include="\'app/pages/alunos/situacao/widgets/complemento.html\'"></div></div><div ba-panel="" ba-panel-title="Documentos"><div class="documentos" ng-include="\'app/pages/alunos/situacao/widgets/disciplinas.html\'"></div></div><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab ng-init="$dropdownTabActive = 1" class="with-dropdown"><uib-tab-heading uib-dropdown=""><a uib-dropdown-toggle="" ng-click="$event.stopPropagation()">Documentos <i class="caret"></i></a><ul class="dropdown-menu" uib-dropdown-menu=""><li><a ng-click="$dropdownTabActive = 1; $tabSetStatus.activeTab = 3">Of\xEDcios</a></li><li><a ng-click="$dropdownTabActive = 2; $tabSetStatus.activeTab = 3" ui-sref="alunos.situacao.documentos.bancaDefesa">Banca Defesa</a></li><li><a ng-click="$dropdownTabActive = 3; $tabSetStatus.activeTab = 3" ui-sref="alunos.situacao.documentos.ataExqua">Ata Exqua</a></li></ul></uib-tab-heading><div ng-show="$dropdownTabActive == 1"><div class="documentos" ng-include="\'app/pages/alunos/situacao/documentos/oficios.html\'"></div></div><div ng-show="$dropdownTabActive == 2"><div class="documentos" ng-include="\'app/pages/alunos/situacao/documentos/oficios.html\'"></div></div><div ng-show="$dropdownTabActive == 3"><div class="documentos" ng-include="\'app/pages/alunos/situacao/documentos/oficios.html\'"></div></div></uib-tab></uib-tabset></div><response-message msg="mensagem" voltar="true"></response-message></div></div></div>');
$templateCache.put('app/pages/charts/amCharts/charts.html','<div class="widgets"><div class="row"><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/barChart/barChart.html\'"></div></div><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/areaChart/areaChart.html\'"></div></div><div class="col-lg-4 col-md-12" ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/lineChart/lineChart.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Pie Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/pieChart/pieChart.html\'"></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Funnel Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/funnelChart/funnelChart.html\'"></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Combined bullet/column and line graphs with multiple value axes" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/combinedChart/combinedChart.html\'"></div></div></div></div>');
$templateCache.put('app/pages/charts/chartist/chartist.html','<section ng-controller="chartistCtrl" class="chartist"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Lines" ba-panel-class="with-scroll"><h5>Simple line chart</h5><div id="line-chart" class="ct-chart"></div><h5>Line chart with area</h5><div id="area-chart" class="ct-chart"></div><h5>Bi-polar line chart with area only</h5><div id="bi-chart" class="ct-chart"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><h5>Simple bar chart</h5><div id="simple-bar" class="ct-chart"></div><h5>Multi-line labels bar chart</h5><div id="multi-bar" class="ct-chart"></div><h5>Stacked bar chart</h5><div id="stacked-bar" class="ct-chart stacked-bar"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Pies & Donuts" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12 col-lg-4"><h5>Simple Pie</h5><div id="simple-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Pie with labels</h5><div id="label-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Donut</h5><div id="donut" class="ct-chart"></div></div></div></div></div></div></section>');
$templateCache.put('app/pages/charts/chartJs/chartJs.html','<div class="row"><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Pie" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="pie" class="chart chart-pie" chart-options="options" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Doughnut" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" chart-options="options" class="chart chart-doughnut" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Polar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="polar-area" class="chart chart-polar-area" chart-data="data" chart-options="options" chart-labels="labels" chart-click="changeData"></canvas></div></div></div></div><div class="row"><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Radar" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveLine" class="chart chart-radar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Bars" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveBars" class="chart chart-bar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div></div><div class="row"><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Radar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="radar" class="chart chart-radar" chart-series="series" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Line" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="line" class="chart chart-line" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-12" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="bar" class="chart chart-bar" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData" chart-update="updateC"></canvas></div></div></div></div>');
$templateCache.put('app/pages/charts/morris/morris.html','<section ng-controller="morrisCtrl"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div line-chart="" line-data="lineData" line-xkey="y" line-ykeys=\'["a", "b"]\' line-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div><div class="row"><div class="col-md-4"><div ba-panel="" ba-panel-title="Donut" ba-panel-class="with-scroll"><div donut-chart="" donut-data="donutData" donut-colors="colors" donut-formatter=\'"currency"\'></div></div></div><div class="col-md-8"><div ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div bar-chart="" bar-data="barData" bar-x="y" bar-y=\'["a", "b"]\' bar-labels=\'["Series A", "Series B"]\' bar-colors="colors"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div area-chart="" area-data="areaData" area-xkey="y" area-ykeys=\'["a", "b"]\' %="" area-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div></section>');
$templateCache.put('app/pages/components/mail/mail.html','<div class="row mail-client-container transparent"><div class="col-md-12"><div ba-panel="" ba-panel-class="xmedium-panel mail-panel"><div class="letter-layout"><div class="mail-navigation-container" ng-class="{\'expanded\' : !tabCtrl.navigationCollapsed}"><div class="text-center"><button type="button" class="btn btn-default compose-button" ng-click="tabCtrl.showCompose(\'\',\'\',\'\')">Compose</button></div><div ng-repeat="t in tabCtrl.tabs" ui-sref-active="active" class="mail-navigation" ui-sref="components.mail.label({label: t.label})" ng-click="selectTab(t.label)">{{t.name}}<span class="new-mails" ng-show="t.newMails">{{t.newMails}}</span></div><div class="labels"><div class="labels-title"></div><div class="labels-container"><div class="label-item"><span class="tag label work">Work</span></div><div class="label-item"><span class="tag label family">Family</span></div><div class="label-item"><span class="tag label friend">Friend</span></div><div class="label-item"><span class="tag label study">Study</span></div></div></div><div class="add-label-container"><i class="ion-plus-round"></i><span class="label-input-stub">Add new label</span></div></div><ui-view></ui-view></div></div></div></div>');
$templateCache.put('app/pages/components/timeline/timeline.html','<div ba-panel=""><section id="cd-timeline" class="cd-container cssanimations" ng-controller="TimelineCtrl"><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Euro-Coin\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 1</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto, optio, dolorum provident rerum aut hic quasi placeat iure tempora laudantium ipsa ad debitis unde? Iste voluptatibus minus veritatis qui ut.</p><span class="cd-date">Jan 14</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Laptop-Signal\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 2</h5><p>Donec dapibus at leo eget volutpat. Praesent dolor tellus, ultricies venenatis molestie eu, luctus eget nibh. Curabitur ullamcorper eleifend nisl.</p><span class="cd-date">Jan 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Checklist\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 3</h5><p>Phasellus auctor tellus eget lacinia condimentum. Cum sociis natoque penatibus et magnis dis parturient montes.</p><span class="cd-date">Feb 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Boss-3\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 4</h5><p>Morbi fringilla in massa ac posuere. Fusce non sagittis massa, id accumsan odio. Nullam eget tempor est. Etiam eu felis eu purus aliquam tristique id quis nisl. Nam eros nibh, consequat sed pulvinar eu, ultrices ornare ligula. Aenean interdum sed nunc sed hendrerit.</p><span class="cd-date">Feb 20</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Online-Shopping\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 5</h5><p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Curabitur eget mattis metus. Nullam egestas eros metus, quis fringilla urna accumsan sed. Aliquam ultrices at arcu vitae tincidunt.</p><span class="cd-date">Feb 21</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Money-Increase\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 6</h5><p>Praesent bibendum ante mattis augue consectetur, ut commodo turpis consequat. Donec ligula eros, porta in iaculis vel, semper ac sem. Integer at mauris lorem.</p><span class="cd-date">Feb 23</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Vector\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 7</h5><p>Vivamus ut laoreet erat, vitae eleifend eros. Sed varius id tellus non lobortis. Sed dolor ante, cursus non scelerisque sed, euismod id eros.</p><span class="cd-date">Feb 24</span></div></div></section></div>');
$templateCache.put('app/pages/components/tree/tree.html','<div class="row" ng-controller="treeCtrl"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Action" ba-panel-class="with-scroll tree-panel"><div class="row"><div class="col-sm-4"><div class="control-side text-center"><div><button class="btn btn-primary" ng-click="addNewNode()">Add</button></div><div><button class="btn btn-primary" ng-click="collapse()">Collapse All</button></div><div><button class="btn btn-primary" ng-click="expand()">Expand All</button></div><div><button class="btn btn-primary" ng-click="refresh()">Refresh</button></div></div></div><div class="col-sm-8"><div js-tree="basicConfig" ng-model="treeData" should-apply="applyModelChanges()" tree="basicTree" tree-events="ready:readyCB"></div></div></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Drag & Drop" ba-panel-class="with-scroll tree-panel"><div js-tree="dragConfig" ng-model="dragData"></div></div></div></div>');
$templateCache.put('app/pages/dashboard/blurFeed/blurFeed.html','<div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message" ng-repeat="message in feed" ng-click="expandMessage(message)"><div class="message-icon" ng-if="message.type == \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"></div><div class="message-icon" ng-if="message.type != \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"> <span class="sub-photo-icon" ng-class="::message.type"></span></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::message.author }} {{ ::message.surname}}</span></div><div class="message-content line-clamp" ng-class="{\'line-clamp-2\' : !message.expanded}"><span ng-if="message.preview">{{message.header}}</span>{{::message.text}}</div><div class="preview" ng-show="message.expanded" ng-if="message.preview"><a href="{{::message.link}}" target="_blank"><img ng-src="{{ ::( message.preview | appImage )}}"></a></div><div ng-show="message.expanded" class="message-time"><div class="post-time">{{::message.time}}</div><div class="ago-time">{{::message.ago}}</div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardCalendar/dashboardCalendar.html','<div id="calendar" class="blurCalendar"></div>');
$templateCache.put('app/pages/dashboard/dashboardMap/dashboardMap.html','<div id="amChartMap"></div>');
$templateCache.put('app/pages/dashboard/dashboardPieChart/dashboardPieChart.html','<div class="row pie-charts"><div class="pie-chart-item-container" ng-repeat="chart in charts"><div ba-panel=""><div class="pie-chart-item"><div class="chart" rel="{{ ::chart.color }}" data-percent="60"><span class="percent"></span></div><div class="description"><div>{{ ::chart.description }}</div><div class="description-stats">{{ ::chart.stats }}</div></div><i class="chart-icon i-{{ ::chart.icon }}"></i></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardTodo/dashboardTodo.html','<div class="task-todo-container" ng-class="{\'transparent\': transparent}"><input type="text" value="" class="form-control task-todo" placeholder="Task to do.." ng-keyup="addToDoItem($event)" ng-model="newTodoText"> <i ng-click="addToDoItem(\'\',true)" class="add-item-icon ion-plus-round"></i><div class="box-shadow-border"></div><ul class="todo-list" ui-sortable="" ng-model="todoList"><li ng-repeat="item in todoList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false"><div class="blur-container"><div class="blur-box"></div></div><i class="mark" style="background-color: {{::item.color}}"></i> <label class="todo-checkbox custom-checkbox custom-input-success"><input type="checkbox" ng-model="isChecked"> <span class="cut-with-dots">{{ item.text }}</span></label> <i class="remove-todo ion-ios-close-empty" ng-click="item.deleted = true"></i></li></ul></div>');
$templateCache.put('app/pages/dashboard/popularApp/popularApp.html','<div class="popular-app-img-container"><div class="popular-app-img"><img ng-src="{{::( \'app/my-app-logo.png\' | appImage )}}"> <span class="logo-text">Super&nbspApp</span></div></div><div class="popular-app-cost row"><div class="col-xs-9">Most Popular App</div><div class="col-xs-3 text-right">175$</div></div><div class="popular-app-info row"><div class="col-xs-4 text-left"><div class="info-label">Total Visits</div><div>47,512</div></div><div class="col-xs-4 text-center"><div class="info-label">New Visits</div><div>9,217</div></div><div class="col-xs-4 text-right"><div class="info-label">Sales</div><div>2,928</div></div></div>');
$templateCache.put('app/pages/dashboard/trafficChart/trafficChart.html','<div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="chart-area" width="280" height="280"></canvas><div class="traffic-text">1,900,128 <span>Views Total</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in doughnutData.labels" ng-init="i = $index; data = doughnutData.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">+{{data.percentage[i]}}%</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width: {{item.percentage}}%"></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardLineChart/dashboardLineChart.html','<div id="amchart"></div>');
$templateCache.put('app/pages/dashboard/weather/weather.html','<div class="weather-wrapper"><div class="weather-main-info"><h5 class="city-date font-x1dot5"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class="weather-description font-x1dot5"><i class="font-x3 {{weatherIcons[weather.days[weather.current].icon]}}"></i><div class="weather-info">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class="weather-temp font-x1dot5"><i class="font-x2 ion-thermometer"></i><div class="weather-info" ng-switch="" on="units"><span ng-switch-when="metric">{{weather.days[weather.current].temp}} \xB0C | <a ng-click="switchUnits(\'imperial\')" href="">\xB0F</a></span> <span ng-switch-when="imperial">{{weather.days[weather.current].temp}} \xB0F | <a ng-click="switchUnits(\'metric\')" href="">\xB0C</a></span></div></div></div><div id="tempChart" class="temp-by-time"></div><div class="select-day"><div class="day" ng-repeat="day in weather.days" ng-click="switchDay($index)"><div><span class="font-x1dot25">{{day.temp}}</span></div><div><i class="weatherIcon font-x2 {{weatherIcons[day.icon]}}"></i> <span class="select-day-info">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>');
$templateCache.put('app/pages/downloads/ata/ata.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ata de Reuni\xE3o"><div class="row"><div class="form-group"><label for="de" class="col-md-4 control-label">Data da Ata:</label><div class="col-md-4"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="periodo-de" type="text" placeholder="De" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="ata.de" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false" datepicker-append-to-body="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-4"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="periodo-para" type="text" placeholder="At\xE9" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="ata.ate" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false" datepicker-append-to-body="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-default pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button></div></div></div><div ba-panel="" ba-panel-class="with-scroll"><div class="horizontal-scroll row col-md-12"><div class="form-group row"><label class="control-label col-md-2" ng-if="docs"><select class="form-control selectpicker show-tick" title="Atas por p\xE1gina" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [100,200]"></select></label><div class="add-row-editable-table col-md-12 align-right" ng-if="isAdmin"><button class="btn btn-primary" ng-click="addAta()">Novo</button></div></div><table class="table" st-table="usuarios" st-safe-src="outros" ng-if="docs.length>0"><thead><tr><th>Refer\xEAncia</th><th>T\xEDtulo</th><th>Descri\xE7\xE3o</th><th ng-if="isAdmin">A\xE7\xE3o</th></tr></thead><tbody><tr ng-repeat="item in docs"><td>{{item.referencia | date: \'MMM/yyyy\'}}</td><td><a class="btn btn-link" href="{{base}}{{item.namefile}}" download="" target="_blank">{{item.titulo}}</a></td><td>{{item.descricao}}</td><td ng-if="isAdmin"><div class="btn-group" ng-if="!item.statusText"><button class="btn btn-success btn-xs" ng-click="editar(item)">Editar</button> <button class="btn btn-danger btn-xs" ng-click="excluir(item)">Excluir</button></div></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="200"></div></td></tr></tfoot></table><response-message msg="mensagem"></response-message></div></div></div></div></div>');
$templateCache.put('app/pages/downloads/documentos/documentos.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Documentos e Legisla\xE7\xF5es"><div class="row"><div class="form-group"><label for="cpf" class="col-md-3 control-label">T\xEDtulo ou descri\xE7\xE3o</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.titulo"></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-default pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button></div></div></div><div ba-panel="" ba-panel-class="with-scroll"><div class="horizontal-scroll row col-md-12"><div class="form-group row"><div class="add-row-editable-table col-md-12 align-right"><button class="btn btn-primary" ng-click="addDocumento()" ng-if="isAdmin">Novo</button></div></div><table class="table" st-table="usuarios" st-safe-src="outros" ng-if="docs.length>0"><thead><tr><th>T\xEDtulo</th><th>Descri\xE7\xE3o</th><th ng-if="isAdmin">A\xE7\xE3o</th></tr></thead><tbody><tr ng-repeat="item in docs"><td><a class="btn btn-link" href="{{base}}{{item.namefile}}" download="" target="_blank">{{item.titulo}}</a></td><td>{{item.descricao}}</td><td ng-if="isAdmin"><div class="btn-group" ng-if="!item.statusText"><button class="btn btn-success btn-xs" ng-click="editar(item)">Editar</button> <button class="btn btn-danger btn-xs" ng-click="excluir(item)">Excluir</button></div></td></tr></tbody></table><response-message msg="mensagem"></response-message></div></div></div></div></div>');
$templateCache.put('app/pages/downloads/formularios/formularios.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Formul\xE1rios"><div class="row"><div class="form-group"><label for="cpf" class="col-md-3 control-label">T\xEDtulo ou descri\xE7\xE3o</label><div class="col-md-9"><input type="text" class="form-control" ng-model="form.titulo"></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-default pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button></div></div></div><div ba-panel="" ba-panel-class="with-scroll"><div class="horizontal-scroll row col-md-12"><div class="form-group row"><div class="add-row-editable-table col-md-12 align-right"><button class="btn btn-primary" ng-click="addFormulario()" ng-if="isAdmin">Novo</button></div></div><table class="table" st-table="usuarios" st-safe-src="outros" ng-if="docs.length>0"><thead><tr><th>T\xEDtulo</th><th>Descri\xE7\xE3o</th><th ng-if="isAdmin">A\xE7\xE3o</th></tr></thead><tbody><tr ng-repeat="item in docs"><td><a class="btn btn-link" href="{{base}}{{item.namefile}}" download="" target="_blank">{{item.titulo}}</a></td><td>{{item.descricao}}</td><td ng-if="isAdmin"><div class="btn-group" ng-if="!item.statusText"><button class="btn btn-success btn-xs" ng-click="editar(item)">Editar</button> <button class="btn btn-danger btn-xs" ng-click="excluir(item)">Excluir</button></div></td></tr></tbody></table><response-message msg="mensagem"></response-message></div></div></div></div></div>');
$templateCache.put('app/pages/downloads/ordem/ordem.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ordem do dia"><div class="row"><div class="form-group"><label for="de" class="col-md-4 control-label">Ordem do dia:</label><div class="col-md-4"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="periodo-de" type="text" placeholder="De" class="form-control" ng-click="open();" uib-datepicker-popup="MMM/yyyy" datepicker-options="opcoesMesAnoApenas" ng-model="ordem.de" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false" datepicker-append-to-body="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-4"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="periodo-para" type="text" placeholder="At\xE9" class="form-control" ng-click="open();" uib-datepicker-popup="MMM/yyyy" datepicker-options="opcoesMesAnoApenas" ng-model="ordem.ate" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false" datepicker-append-to-body="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-default pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button></div></div></div><div ba-panel="" ba-panel-class="with-scroll"><div class="horizontal-scroll row col-md-12"><div class="form-group row"><label class="control-label col-md-2" ng-if="docs.length>0"><select class="form-control selectpicker show-tick" title="Ordens por p\xE1gina" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [100,200]"></select></label><div class="add-row-editable-table col-md-12 align-right"><button class="btn btn-primary" ng-click="addOrdem()" ng-if="isAdmin">Novo</button></div></div><table class="table" st-table="usuarios" st-safe-src="outros" ng-if="docs.length>0"><thead><tr><th>Refer\xEAncia</th><th>T\xEDtulo</th><th>Descri\xE7\xE3o</th><th ng-if="isAdmin">A\xE7\xE3o</th></tr></thead><tbody><tr ng-repeat="item in docs"><td>{{item.referencia | date: \'MMM/yyyy\'}}</td><td><a class="btn btn-link" href="{{base}}{{item.namefile}}" download="" target="_blank">{{item.titulo}}</a></td><td>{{item.descricao}}</td><td ng-if="isAdmin"><div class="btn-group" ng-if="!item.statusText"><button class="btn btn-success btn-xs" ng-click="editar(item)">Editar</button> <button class="btn btn-danger btn-xs" ng-click="excluir(item)">Excluir</button></div></td></tr></tbody><tfoot><tr><td colspan="4" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="200"></div></td></tr></tfoot></table><response-message msg="mensagem"></response-message></div></div></div></div></div>');
$templateCache.put('app/pages/downloads/widget/cadastro.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Novo Arquivo</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="col-md-12"><div class="form-group"><label for="titulo" class="control-label">T\xEDtulo *</label> <input type="text" class="form-control" id="titulo" ng-required="true" ng-model="doc.titulo" placeholder="T\xEDtulo do Documento"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="matricula" class="control-label">Tipo *</label><ui-select ng-model="doc.tipo" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="items == null" append-to-body="true" reset-search-input="false" search-enabled="true" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Tipo do Documento"><span>{{ $select.selected.value }}</span></ui-select-match><ui-select-choices repeat="item in items" refresh-delay="0"><div ng-bind-html="item.value | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="data" class="control-label">M\xEAs Refer\xEAncia</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="data" type="text" placeholder="M\xEAs de Refer\xEAncia" class="form-control" ng-click="open();" uib-datepicker-popup="MMM/yyyy" datepicker-options="opcoesAnoReferenciaApenas" ng-model="doc.data" is-open="opened" close-text="Fechar" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="form-group row clearfix"><label for="inputFirstName" class="col-md-2 control-label">Arquivo *</label><div class="col-md-12"><div><a href="" ng-click="uploadFile()" class="btn btn-default btn-file filestyle"><i class="glyphicon glyphicon-upload"></i> {{ fileName }} <span ng-if="noFile">Selecione o arquivo a ser anexado...</span></a> <i class="glyphicon glyphicon-remove-circle" ng-click="removeFile()" ng-if="!noFile"></i> <input name="arquivo" type="file" accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/pdf,application/zip" required="" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="descricao" class="control-label">Descri\xE7\xE3o</label><div class="input-group"><textarea class="form-control" style="resize:none" placeholder="Descri\xE7\xE3o" ng-model="doc.descricao"></textarea></div></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="!cadastroForm.$valid" ng-click="enviar(doc)" ng-click-options="{preventDoubleClick: true}">Confirmar</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/downloads/widget/editar.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Editar Arquivo</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="col-md-12"><div class="form-group"><label for="titulo" class="control-label">T\xEDtulo *</label> <input type="text" class="form-control" id="titulo" ng-required="true" ng-model="doc.titulo" placeholder="T\xEDtulo do Documento"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="matricula" class="control-label">Tipo *</label><ui-select ng-model="doc.tipo" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="items == null" append-to-body="true" reset-search-input="false" search-enabled="true" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Tipo do Documento"><span>{{ $select.selected.value }}</span></ui-select-match><ui-select-choices repeat="item in items" refresh-delay="0"><div ng-bind-html="item.value | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="data" class="control-label">M\xEAs Refer\xEAncia</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="data" type="text" placeholder="M\xEAs de Refer\xEAncia" class="form-control" ng-click="open();" uib-datepicker-popup="MMM/yyyy" datepicker-options="opcoesAnoReferenciaApenas" ng-model="doc.data" is-open="opened" close-text="Fechar" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="form-group row clearfix"><label for="inputFirstName" class="col-md-2 control-label">Arquivo *</label><div class="col-md-12"><div><a href="{{base}}{{fileName}}" download="" target="_blank">{{ fileName }}</a></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="descricao" class="control-label">Descri\xE7\xE3o</label><div class="input-group"><textarea class="form-control" style="resize:none" placeholder="Descri\xE7\xE3o" ng-model="doc.descricao"></textarea></div></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="!cadastroForm.$valid" ng-click="enviar(doc)" ng-click-options="{preventDoubleClick: true}">Confirmar</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/form/inputs/inputs.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Standard Fields" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/standardFields.html\'"></div></div><div ba-panel="" ba-panel-title="Tags Input" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/tagsInput/tagsInput.html\'"></div></div><div ba-panel="" ba-panel-title="Input Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/inputGroups.html\'"></div></div><div ba-panel="" ba-panel-title="Checkboxes & Radios" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/checkboxesRadios.html\'"></div></div><div ba-panel="" ba-panel-title="On/Off Switches" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/switches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Old On/Off Switches (Deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSwitches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Datepicker" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/datePickers/datePickers.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Validation States" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/validationStates.html\'"></div></div><div ba-panel="" ba-panel-title="Selects" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/select/select.html\'"></div></div><div ba-panel="" ba-panel-title="Old selects(deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSelect/select.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/layouts/layouts.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/inlineForm.html\'"></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/basicForm.html\'"></div></div><div ba-panel="" ba-panel-title="Horizontal Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/horizontalForm.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Form Without Labels" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/formWithoutLabels.html\'"></div></div><div ba-panel="" ba-panel-title="Block Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/blockForm.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/wizard/wizard.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Form Wizard" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Personal info" form="vm.personalInfoForm"><form name="vm.personalInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.personalInfoForm.username.$invalid && (vm.personalInfoForm.username.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleUsername1">Username</label> <input type="text" class="form-control" id="exampleUsername1" name="username" placeholder="Username" ng-model="vm.personalInfo.username" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.email.$invalid && (vm.personalInfoForm.email.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" name="email" placeholder="Email" ng-model="vm.personalInfo.email" required=""> <span class="help-block error-block basic-block">Proper email required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.password.$invalid && (vm.personalInfoForm.password.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" name="password" placeholder="Password" ng-model="vm.personalInfo.password" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': !vm.arePersonalInfoPasswordsEqual() && (vm.personalInfoForm.confirmPassword.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputConfirmPassword1">Confirm Password</label> <input type="password" class="form-control" id="exampleInputConfirmPassword1" name="confirmPassword" placeholder="Confirm Password" ng-model="vm.personalInfo.confirmPassword" required=""> <span class="help-block error-block basic-block">Passwords should match</span></div></div></div></form></ba-wizard-step><ba-wizard-step title="Product Info" form="vm.productInfoForm"><form name="vm.productInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.productInfoForm.productName.$invalid && (vm.productInfoForm.productName.$dirty || vm.productInfoForm.$submitted)}"><label for="productName">Product name</label> <input type="text" class="form-control" id="productName" name="productName" placeholder="Product name" ng-model="vm.productInfo.productName" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.productInfoForm.productId.$invalid && (vm.productInfoForm.productId.$dirty || vm.productInfoForm.$submitted)}"><label for="productId">Product id</label> <input type="text" class="form-control" id="productId" name="productId" placeholder="productId" ng-model="vm.productInfo.productId" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Category</label><select class="form-control" title="Category" selectpicker=""><option selected="">Electronics</option><option>Toys</option><option>Accessories</option></select></div></div></div></form></ba-wizard-step><ba-wizard-step title="Shipment" form="vm.addressForm"><form name="vm.addressForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addressForm.address.$invalid && (vm.addressForm.address.$dirty || vm.addressForm.$submitted)}"><label for="productName">Shipment address</label> <input type="text" class="form-control" id="address" name="address" placeholder="Shipment address" ng-model="vm.shipment.address" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Shipment method</label><select class="form-control" title="Category" selectpicker=""><option selected="">Fast & expensive</option><option>Cheap & free</option></select></div></div></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Save shipment info</span></label></div></form></ba-wizard-step><ba-wizard-step title="Finish"><form class="form-horizontal" name="vm.finishForm" novalidate="">Congratulations! You have successfully filled the form!</form></ba-wizard-step></ba-wizard></div></div></div></div>');
$templateCache.put('app/pages/manutencao/adicionar/adicionar.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Preencha os dados abaixo"><form name="formAdicionar" class="form-horizontal" ng-submit="adicionar(usuario)"><div class="form-group"><label for="nome" class="col-md-2 control-label">Nome</label><div class="col-md-10"><input type="text" autocomplete="off" class="form-control" required="" id="firstName" name="nome" maxlength="100" ng-maxlength="100" placeholder="Nome" ng-model="usuario.firstName"></div></div><div class="form-group"><label for="lastName" class="col-md-2 control-label">Sobrenome</label><div class="col-md-10"><input type="text" autocomplete="off" class="form-control" required="" id="lastName" name="sobrenome" maxlength="100" ng-maxlength="100" placeholder="\xDAltimo Sobrenome" ng-model="usuario.lastName"></div></div><div class="form-group"><label for="numUsp" class="col-md-2 control-label">Nro USP</label><div class="col-md-6"><input type="number" autocomplete="off" class="form-control" id="numUsp" name="matricula" placeholder="N\xFAmero USP" ng-required="!usuario.nonNumUsp" ng-disabled="usuario.nonNumUsp" ng-model="usuario.matricula"></div><div class="col-md-4"><input type="checkbox" class="" id="nonNumUsp" ng-model="usuario.nonNumUsp" ng-disabled="usuario.nonCPF"> <label for="nonNumUsp">N\xE3o tem USP</label></div></div><div class="form-group"><label for="cpf" class="col-md-2 control-label">CPF</label><div class="col-md-6"><input type="text" autocomplete="off" class="form-control" id="cpf" name="cpf" validador-cpf="" ng-required="!usuario.nonCPF" ng-disabled="usuario.nonCPF" ng-model="usuario.cpf" ui-mask="9?9?9?.999.999-99"></div><div class="col-md-4"><input type="checkbox" class="" id="nonCPF" ng-model="usuario.nonCPF" ng-disabled="usuario.nonNumUsp"> <label for="nonCPF">N\xE3o tem CPF</label></div><div class="col-xs-12 error" ng-show="usuario.cpf && formAdicionar.cpf.$invalid" style="color:red">CPF previsa ser v\xE1lido</div></div><div class="form-group"><label for="senha" class="col-md-2 control-label">E-mail</label><div class="col-md-10"><input type="email" autocomplete="off" class="form-control" required="" name="e-mail" id="email" placeholder="email@pessoal.com" ng-model="usuario.email"></div></div><div class="form-group"><label for="senha" class="col-md-2 control-label">Senha</label><div class="col-md-10"><input type="password" autocomplete="off" class="form-control" id="senha" name="senha" placeholder="Senha" required="" ng-model="usuario.senha"></div></div><div class="form-group"><label for="perfil" class="col-md-2 control-label">Perfil</label><div class="col-md-10"><select class="form-control btn btn-group bootstrap-select" required="" name="perfil" ng-model="usuario.perfil" style="padding-left:5px;border:1px solid #ccc;"><option ng-repeat="p in perfis" value="{{p.id}}">{{p.text}}</option></select></div></div><div class="form-group"><label for="areas" class="col-md-2 control-label">Areas</label><div class="col-md-10"><select class="form-control btn btn-group selectpicker dropdown" selectpicker="" multiple="" required="" data-size="12" ng-model="usuario.areas" id="select-areas" name="areas"><option ng-repeat="p in areas" value="{{p.id}}">{{p.nome_area}}</option></select></div></div><div class="form-group"><label for="perfil" class="col-md-2 control-label">Status</label><div class="col-md-10"><select class="form-control btn btn-group bootstrap-select" name="status" ng-model="usuario.status" required="" style="padding-left:5px;border:1px solid #ccc;"><option ng-repeat="p in statusList" value="{{p.id}}">{{p.text}}</option></select></div></div><div class="form-group"><div class="col-md-offset-1 col-md-5 align-right"><input type="reset" class="btn btn-lg btn-secondary btn-auth" value="Limpar" ng-click="reset"></div><div class="col-md-5 align-left"><input type="submit" class="btn btn-lg btn-primary btn-auth" value="Adicionar"></div></div></form></div><response-message msg="mensagem"></response-message></div></div></div>');
$templateCache.put('app/pages/manutencao/comissao/comissao.html','<div class="widgets"><div class="row"><div class="col-md-14"><div ba-panel="" ba-panel-title="Comiss\xE3o de p\xF3s-gradua\xE7\xE3o"><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="row"><div class="col-md-3"><label for="cargo" class="control-label">Cargo</label><ui-select ng-model="busca.cargo" id="cargo" class="btn-group bootstrap-select form-control" ng-disabled="cargos == null" append-to-body="true" search-enabled="false" close-on-select="true" spinner-enabled="true"><ui-select-match><span>{{ busca.cargo.nome }}</span></ui-select-match><ui-select-choices repeat="cargo in cargos"><span>{{ cargo.nome }}</span></ui-select-choices></ui-select></div><div class="col-md-6"><label for="Nome" class="control-label">Nome</label> <input type="text" class="form-control" id="nome" placeholder="Digite o nome" ng-model="busca.nome"></div></div><div class="row"><div class="col-md-12"><hr><button type="button" class="btn btn-lg btn-success pull-left" ng-click="adicionar()">Novo</button> <button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-primary pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button></div></div></form></div><response-message msg="mensagem" voltar="false"></response-message><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll" ng-if="comissao != null && mensagem == null"><div class="horizontal-scroll row col-md-12"><div class="row"><label class="control-label col-md-2"><select class="form-control selectpicker show-tick" title="Logs por p\xE1ginas" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,20]"></select></label></div><table class="table" st-table="comissao" st-safe-src="outros"><thead><tr><th><b>Cargo</b></th><th><b>Titular</b></th><th><b>Suplente</b></th></tr></thead><tbody><tr ng-repeat="item in comissao"><td>{{item.nome}}</td><td><a class="btn btn-link" ng-click="editar(item)">{{item.titular}}</a></td><td>{{item.suplente}}</td></tr></tbody><tfoot class="no-borders"><tr class="text-center"><td colspan="3" st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/manutencao/editar/editar.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Preencha os dados abaixo"><form name="form" class="form-horizontal" ng-submit="salvar(usuario)"><div class="form-group"><label for="cod" class="col-md-2 control-label">ID</label><div class="col-md-10"><span class="input input-group-addon" id="cod">{{ usuario.id }}</span></div></div><div class="form-group"><label for="nome" class="col-md-2 control-label">Nome</label><div class="col-md-10"><input type="text" autocomplete="off" class="form-control" required="" id="firstName" maxlength="100" ng-maxlength="100" placeholder="Nome" ng-model="usuario.firstName"></div></div><div class="form-group"><label for="lastName" class="col-md-2 control-label">Sobrenome</label><div class="col-md-10"><input type="text" autocomplete="off" class="form-control" required="" id="lastName" maxlength="100" ng-maxlength="100" placeholder="\xDAltimo Sobrenome" ng-model="usuario.lastName"></div></div><div class="form-group"><label for="numUsp" class="col-md-2 control-label">Nro USP</label><div class="col-md-10"><input type="{{ usuario.editarMatricula ? \'text\' : \'number\'}}" autocomplete="off" class="form-control" id="numUsp" ng-disabled="usuario.editarMatricula" placeholder="N\xFAmero USP" ng-model="usuario.matricula"></div></div><div class="form-group"><label for="cpf" class="col-md-2 control-label">CPF</label><div class="col-md-10"><input type="text" autocomplete="off" class="form-control" id="cpf" name="cpf" ng-disabled="usuario.editarCpf" validador-cpf="" ng-model="usuario.cpf" ui-mask="9?9?9?.999.999-99"></div><div class="col-xs-12 error" ng-show="usuario.cpf && form.cpf.$invalid" style="color:red">CPF previsa ser v\xE1lido</div></div><div class="form-group"><label for="login" class="col-md-2 control-label">Login</label><div class="col-md-10"><input type="text" autocomplete="off" class="form-control" id="login" ng-disabled="true" placeholder="Login" ng-model="usuario.login"></div></div><div class="form-group"><label for="senha" class="col-md-2 control-label">E-mail</label><div class="col-md-10"><input type="email" autocomplete="off" class="form-control" required="" ng-disabled="usuario.flag_ad==0" id="email" placeholder="email@pessoal.com" ng-model="usuario.email"></div></div><div class="form-group"><label for="senha" class="col-md-2 control-label">Senha</label><div class="col-md-10"><input type="password" autocomplete="off" class="form-control" id="senha" ng-disabled="usuario.flag_ad==1" placeholder="Senha" ng-model="usuario.senha"></div></div><div class="form-group"><label for="perfil" class="col-md-2 control-label">Perfil</label><div class="col-md-10"><select class="form-control btn btn-group bootstrap-select" required="" ng-model="usuario.perfil" style="padding-left:5px;border:1px solid #ccc;"><option ng-repeat="p in perfis" value="{{p.id}}">{{p.text}}</option></select></div></div><div class="form-group"><label for="areas" class="col-md-2 control-label">Areas</label><div class="col-md-10"><select class="form-control btn btn-group selectpicker dropdown" selectpicker="" multiple="" required="" data-size="12" ng-model="usuario.areas" id="select-areas"><option ng-repeat="p in areas" value="{{p.id}}">{{p.nome_area}}</option></select></div></div><div class="form-group"><label for="perfil" class="col-md-2 control-label">Status</label><div class="col-md-10"><select class="form-control btn btn-group bootstrap-select" ng-model="usuario.status" style="padding-left:5px;border:1px solid #ccc;"><option ng-repeat="p in statusList" value="{{p.id}}">{{p.text}}</option></select></div></div><div class="form-group"><div class="col-md-offset-1 col-md-5 align-right"><button class="btn btn-lg btn-secondary btn-auth" onclick="return false" ng-click="cancelar()">Cancelar</button></div><div class="col-md-5 align-left"><input type="submit" class="btn btn-lg btn-primary btn-auth" value="Salvar"></div></div></form></div><response-message msg="mensagem"></response-message></div></div></div>');
$templateCache.put('app/pages/manutencao/equipe/equipe.html','<div class="widgets"><div class="row"><div class="col-md-14"><div ba-panel="" ba-panel-title="Equipe"><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="row"><div class="col-md-5"><label for="nome" class="control-label">Nome</label> <input type="text" class="form-control" id="nome" placeholder="Digite o nome" ng-model="busca.nome"></div><div class="col-md-7"><label for="funcao" class="control-label">Fun\xE7\xE3o</label> <input type="text" class="form-control" id="funcao" placeholder="Digite a fun\xE7\xE3o" ng-model="busca.funcao"></div></div><div class="row"><div class="col-md-12"><hr><button type="button" class="btn btn-lg btn-success pull-left" ng-click="adicionar()">Novo</button> <button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-primary pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button></div></div></form></div><response-message msg="mensagem" voltar="false"></response-message><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll" ng-if="equipe != null && mensagem == null"><div class="horizontal-scroll row col-md-12"><div class="row"><label class="control-label col-md-2"><select class="form-control selectpicker show-tick" title="Colaboradores por p\xE1ginas" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,20]"></select></label></div><table class="table" st-table="equipe" st-safe-src="outros"><thead><tr><th><b>Fun\xE7\xE3o</b></th><th><b>Nome</b></th><th><b>Telefone</b></th><th><b>E-mail</b></th></tr></thead><tbody><tr ng-repeat="item in equipe"><td><a class="btn btn-link" ng-click="editar(item)">{{item.cargo}}</a></td><td>{{item.nome}}</td><td>{{item.fone}}</td><td>{{item.email}}</td></tr></tbody><tfoot class="no-borders"><tr class="text-center"><td colspan="3" st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/manutencao/log/log.html','<div class="widgets"><div class="row"><div class="col-md-14"><div ba-panel="" ba-panel-title="Consulta de Alunos"><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="row"><div class="col-md-3"><label for="identificador" class="control-label">Identificador</label> <input type="number" class="form-control" id="identificador" ng-model="busca.id"></div><div class="col-md-3"><label for="periodo-de" class="control-label">Data in\xEDcio</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="periodo-de" type="text" placeholder="De" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="busca.de" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-3"><label for="periodo-ate" class="control-label">Data Fim</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="periodo-ate" type="text" placeholder="Ate" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="busca.ate" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-3"><label for="tipo" class="control-label">Filtro Tipo</label><ui-select ng-model="busca.tipo" id="tipo" class="btn-group bootstrap-select form-control" ng-disabled="tipos == null" append-to-body="true" search-enabled="false" close-on-select="true" spinner-enabled="true"><ui-select-match><span>{{ busca.tipo.descricao }}</span></ui-select-match><ui-select-choices repeat="tipo in tipos"><span>{{ tipo.descricao }}</span></ui-select-choices></ui-select></div></div><div class="row"><div class="col-md-3"><label for="categoria" class="control-label">Filtro por Categoria</label><ui-select ng-model="busca.categoria" id="categoria" class="btn-group bootstrap-select form-control" ng-disabled="categorias == null" append-to-body="true" search-enabled="false" close-on-select="true" spinner-enabled="true"><ui-select-match><span>{{ busca.categoria.descricao }}</span></ui-select-match><ui-select-choices repeat="categoria in categorias"><span>{{ categoria.descricao }}</span></ui-select-choices></ui-select></div><div class="col-md-6"><label for="usuario" class="control-label">Usu\xE1rios</label><ui-select ng-model="busca.usuario" id="usuario" class="btn-group bootstrap-select form-control" ng-disabled="usuarios == null" append-to-body="true" search-enabled="false" close-on-select="true" spinner-enabled="true"><ui-select-match><span>{{ busca.usuario.nome }}</span></ui-select-match><ui-select-choices repeat="usuario in usuarios"><span>{{ usuario.nome }}</span></ui-select-choices></ui-select></div><div class="col-md-3"><label for="IP" class="control-label">IP</label> <input type="text" class="form-control" id="IP" ng-model="busca.ip" placeholder="XXX.XXX.XXX.XXX"></div></div><div class="row">&nbsp;<br>&nbsp;<br></div><div class="row"><div class="col-md-12"><hr><button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-success pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button></div></div><div class="row">&nbsp;<br>&nbsp;<br></div></form></div><response-message msg="mensagem"></response-message><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll" ng-if="log != null"><div class="horizontal-scroll row col-md-12"><div class="row"><label class="control-label col-md-2"><select class="form-control selectpicker show-tick" title="Logs por p\xE1ginas" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [100,200,300]"></select></label></div><div class="table" st-table="log" st-safe-src="outros"><div><div class="row sortable"><div class="col-md-1" st-sort="idLog">ID</div><div class="col-md-1" st-sort="dtLog">Data</div><div class="col-md-1" st-sort="ip">IP</div><div class="col-md-1" st-sort="idTipo">Tipo</div><div class="col-md-1" st-sort="idCategoria">Categoria</div><div class="col-md-2" st-sort="msgBreve">Msg Simples</div><div class="col-md-4" st-sort="msgTecnica">Msg Tec</div><div class="col-md-1" st-sort="idUsuario">Usuario</div></div><div class="row" ng-repeat="item in log"><div class="col-md-1">{{item.idLog}}</div><div class="col-md-1">{{item.dtLog}}</div><div class="col-md-1">{{item.ip}}</div><div class="col-md-1">{{item.tipo}}</div><div class="col-md-1">{{item.categoria}}</div><div class="col-md-2">{{item.msgBreve}}</div><div class="col-md-4">{{item.msgTecnica}}</div><div class="col-md-1">{{item.usuario}}</div></div></div><div class="row no-borders"><div colspan="9" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="100"></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/manutencao/portaria/portaria.html','<div class="widgets"><div class="row"><div class="col-md-14"><div ba-panel="" ba-panel-title="Portaria"><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="row"><div class="col-md-5"><label for="lei" class="control-label">Lei</label> <input type="text" class="form-control" id="lei" placeholder="Digite o lei" ng-model="busca.lei"></div><div class="col-md-7"><label for="descricao" class="control-label">Descri\xE7\xE3o</label> <input type="text" class="form-control" id="descricao" placeholder="Digite a Descri\xE7\xE3o" ng-model="busca.descricao"></div></div><div class="row"><div class="col-md-12"><hr><button type="button" class="btn btn-lg btn-success pull-left" ng-click="adicionar()">Novo</button> <button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-primary pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button></div></div></form></div><response-message msg="mensagem" voltar="false"></response-message><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll" ng-if="portaria != null && mensagem == null"><div class="horizontal-scroll row col-md-12"><div class="row"><label class="control-label col-md-2"><select class="form-control selectpicker show-tick" title="Portarias por p\xE1ginas" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,20]"></select></label></div><table class="table" st-table="equipe" st-safe-src="outros"><thead><tr><th><b>Lei</b></th><th><b>Descri\xE7\xE3o</b></th><th><b>Data Assinatura</b></th><th><b>Publica\xE7\xE3o</b></th><th><b>Per\xEDodo</b></th></tr></thead><tbody><tr ng-repeat="item in equipe"><td><a class="btn btn-link" ng-click="editar(item)">{{item.lei}}</a></td><td>{{item.descricao}}</td><td>{{item.data | date: \'dd/MM/yyyy\'}}</td><td>{{item.publicacao}}</td><td>{{item.periodo}}</td></tr></tbody><tfoot class="no-borders"><tr class="text-center"><td colspan="3" st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/manutencao/programas/programas.html','<div class="widgets" id="programas"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Programas"><div class="row"><div class="col-md-4"><label for="codigo" class="control-label">C\xF3digo</label> <input type="number" ng-maxlength="4" class="form-control" id="codigo" ng-model="busca.codigo"></div><div class="col-md-8"><label for="programa" class="control-label">Programa</label> <input type="text" class="form-control" id="programa" ng-model="busca.programa"></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-lg btn-success pull-left" ng-click="adicionar()">Novo</button> <button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-primary pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button></div></div></div><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll" ng-if="programas.length>0"><div class="horizontal-scroll row col-md-12"><label class="control-label col-md-2"><select class="form-control selectpicker show-tick" title="Programas por p\xE1ginas" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,15,20,40,50]"></select></label><table class="table" st-table="programas" st-safe-src="outros"><thead><tr><th>C\xF3digo</th><th>Programa</th><th>Coordenador</th><th>Secret\xE1ria</th></tr></thead><tbody><tr ng-repeat="item in programas"><td>{{item.arg_cod}}</td><td><a class="btn btn-link" ng-click="editar(item)">{{item.arg_desc}}</a></td><td>{{item.arl_coord}}</td><td>{{item.arl_secret}}</td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div></div><response-message msg="mensagem" voltar="false"></response-message></div></div></div>');
$templateCache.put('app/pages/manutencao/usuario/usuario.html','<div ba-panel="" ba-panel-title="Edi\xE7\xE3o de usu\xE1rios" ba-panel-class="with-scroll"><div class="horizontal-scroll row col-md-12"><div class="form-group row"><label class="control-label col-md-2">Usu\xE1rios por P\xE1gina<select class="form-control selectpicker show-tick" title="Usu\xE1rios por p\xE1ginas" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,40,50]"></select></label><div class="add-row-editable-table col-md-10 align-right"><button class="btn btn-primary" ng-click="addUsuarios()">Adicionar Novo</button></div></div><table class="table" st-table="usuarios" st-safe-src="outros"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">Nome</th><th st-sort="lastName">Sobrenome</th><th st-sort="nroUSP">Nro USP</th><th st-sort="cpf">CPF</th><th>Aprovado</th><th st-sort="profile">Perfil</th></tr><tr><th></th><th><input st-search="firstName" placeholder="Buscar por Nome" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastName" placeholder="Buscar por Sobrenome" class="input-sm form-control search-input" type="search"></th><th><input st-search="matricula" placeholder="Buscar por Nro USP" class="input-sm form-control search-input" type="search"></th><th><input st-search="cpf" placeholder="Buscar por CPF" class="input-sm form-control search-input" type="search"></th><th><select class="input-sm btn btn-group form-control search-input" st-search="status" ng-model="aprovados"><option value="">Todos</option><option ng-repeat="row in statusList" value="{{row.id}}">{{row.text}}</option></select></th><th><select class="input-sm btn btn-group form-control search-input" st-search="perfil" ng-model="perfis"><option value="">Todos</option><option ng-repeat="row in perfil" value="{{row.id}}">{{row.text}}</option></select></th></tr></thead><tbody><tr ng-repeat="item in usuarios"><td class="table-id">{{ $index+1 }}</td><td><a class="btn btn-link" ng-click="editar(item)">{{item.firstName}}</a></td><td>{{item.lastName}}</td><td>{{item.matricula}}</td><td>{{item.cpf |cpf}}</td><td><div class="btn-group" ng-if="!item.statusText"><button class="btn btn-success btn-xs" ng-click="aprovar(item)">Aprovar</button> <button class="btn btn-danger btn-xs" ng-click="reprovar(item)">Reprovar</button></div><div class="btn btn-xs" ng-if="item.statusText">{{ item.statusText }}</div></td><td class="select-td form-group"><select ng-if="!item.statusText || status == 1" class="input-sm btn btn-group form-control bootstrap-select show-tick" ng-model="item.perfilUser" style="border:1px solid #ccc;"><option ng-repeat="row in perfil" value="{{row.id}}">{{row.text}}</option></select><span ng-if="item.statusText && status != 1">{{ showProfiles(item) }}</span></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><response-message msg="mensagem"></response-message></div></div>');
$templateCache.put('app/pages/manutencao/widget/cadastroComissao.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Nova Comiss\xE3o</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="col-md-12"><div class="form-group"><label for="matricula" class="control-label">Cargo *</label><ui-select ng-model="comissao.cargo" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="cargos == null" append-to-body="true" reset-search-input="false" search-enabled="true" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Membros"><span>{{ $select.selected.nome }}</span></ui-select-match><ui-select-choices repeat="item in cargos" refresh-delay="0"><div ng-bind-html="item.nome | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="titular" class="control-label">Titular</label> <input type="text" class="form-control" id="titular" ng-model="comissao.titular" placeholder="Titular"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="suplente" class="control-label">Suplente</label> <input type="text" class="form-control" id="suplente" ng-model="comissao.suplente" placeholder="Suplente"></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="!cadastroForm.$valid" ng-click="adicionar(comissao)" ng-click-options="{preventDoubleClick: true}">Confirmar</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/manutencao/widget/cadastroEquipe.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Equipe</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal" name="cadastroForm"><div class="row"><div class="col-md-12"><div class="form-group"><label for="cargo" class="control-label">Fun\xE7\xE3o</label> <input type="text" ng-required="" required="" ng-maxlength="50" maxlength="50" ng-minlength="2" class="form-control" id="cargo" ng-model="equipe.cargo" placeholder="Fun\xE7\xE3o"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="nome" class="control-label">Nome</label> <input type="text" ng-pattern="/[a-zA-Z\\s]/" ng-maxlength="60" maxlength="60" class="form-control" id="nome" ng-model="equipe.nome" placeholder="Nome"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="fone" class="control-label">Telefone</label> <input type="tel" phone="" class="form-control tel" ng-maxlength="20" maxlength="20" id="fone" ng-model="equipe.fone" placeholder="Telefone"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="email" class="control-label">E-mail</label> <input type="email" class="form-control" id="email" ng-maxlength="70" maxlength="70" ng-model="equipe.email" placeholder="E-mail"></div></div></div><div class="row" ng-hide="equipe.cargo != cargo_chefe"><div class="col-md-12"><div class="form-group"><label for="assinatura" class="control-label">Assinatura</label></div></div><div class="col-md-12"><div class="form-group"><a href="" ng-click="uploadFile()" class="btn btn-default btn-file filestyle"><i class="glyphicon glyphicon-upload"></i> {{ fileName }} <span ng-if="noFile">Selecione o arquivo da assinatura...</span></a> <i class="glyphicon glyphicon-remove-circle" ng-click="removeFile()" ng-if="!noFile"></i> <input name="assintura" type="file" accept=".jpg,.jpeg,.png,.svg" ng-required="equipe.cargo == cargo_chefe" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="cadastroForm.$invalid || !equipe || !equipe.cargo" ng-click="adicionar(equipe)" ng-click-options="{preventDoubleClick: true}">Confirmar</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/manutencao/widget/cadastroPortaria.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Portaria</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="col-md-12"><div class="form-group"><label for="lei" class="control-label">Lei *</label> <input type="text" class="form-control" id="lei" ng-required="true" ng-model="portaria.lei" placeholder="Lei"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="descricao" class="control-label">Descri\xE7\xE3o *</label> <input type="text" class="form-control" id="descricao" ng-required="true" ng-model="portaria.descricao" placeholder="Descri\xE7\xE3o"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="data" class="control-label">Data</label><div class="input-group sidebar" ng-controller="datepickerpopupCtrl"><input id="data" type="text" placeholder="Data" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="portaria.data" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-6"><div class="form-group"><label for="publicacao" class="control-label">Publica\xE7\xE3o</label> <input type="text" class="form-control" id="publicacao" ng-model="portaria.publicacao" placeholder="Publica\xE7\xE3o"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="periodo" class="control-label">Per\xEDodo</label> <input type="text" class="form-control" id="periodo" ng-model="portaria.periodo" placeholder="Per\xEDodo"></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="!cadastroForm.$valid || !cadastroForm.$dirty" ng-click="adicionar(portaria)" ng-click-options="{preventDoubleClick: true}">Confirmar</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/manutencao/widget/cadastroProgramas.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Programa</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="col-md-3"><label for="codigo" class="control-label">C\xF3digo *</label> <input type="number" ng-blur="setProgram(programas.codigo)" ng-maxlength="6" class="form-control" id="codigo" ng-model="programas.codigo" ng-required="true" placeholder="C\xF3digo"></div><div class="col-md-9"><label for="nome" class="control-label">Nome do Programa *</label> <input type="text" readonly="" disabled="" class="form-control" id="nome" ng-model="programas.nome" ng-required="true" placeholder="Nome do programa"></div></div><div class="row"><div class="col-md-12"><label for="coordenador" class="control-label">Coordenador *</label> <input type="text" class="form-control" id="coordenador" ng-model="programas.coordenador" ng-required="true" placeholder="Coordenador"></div></div><div class="row"><div class="col-md-12"><label for="secretaria" class="control-label">Secret\xE1ria(o)</label> <input type="text" class="form-control" id="secretaria" ng-model="programas.secretaria" placeholder="Secret\xE1ria(o)"></div></div><div class="row"><div class="col-md-12"><label for="local" class="control-label">Local</label> <input type="text" class="form-control" id="local" ng-model="programas.local" placeholder="Local"></div></div><div class="row"><div class="col-md-12"><label for="endereco" class="control-label">Endere\xE7o</label> <input type="text" class="form-control" id="endereco" ng-model="programas.endereco" placeholder="Endereco"></div></div><div class="row"><div class="col-md-12"><label for="telefone" class="control-label">Telefone</label> <input type="text" class="form-control" id="telefone" ng-model="programas.telefone" placeholder="Telefone"></div></div><div class="row"><div class="col-md-12"><label for="email" class="control-label">E-mail</label> <input type="email" class="form-control" id="email" ng-model="programas.email" placeholder="E-mail"></div></div></form></div><div class="modal-footer"><hr><button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="!cadastroForm.$valid" ng-click="adicionar(programas)" ng-click-options="{preventDoubleClick: true}">Confirmar</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/manutencao/widget/editarComissao.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Editar Comiss\xE3o</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="col-md-12"><div class="form-group"><label for="matricula" class="control-label">Cargo *</label><ui-select ng-model="comissao.cargo" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="cargos == null" append-to-body="true" reset-search-input="false" search-enabled="true" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Membros"><span>{{ $select.selected.nome }}</span></ui-select-match><ui-select-choices repeat="item in cargos" refresh-delay="0"><div ng-bind-html="item.nome | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="titular" class="control-label">Titular</label> <input type="text" class="form-control" id="titular" ng-model="comissao.titular" placeholder="Titular"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="suplente" class="control-label">Suplente</label> <input type="text" class="form-control" id="suplente" ng-model="comissao.suplente" placeholder="Suplente"></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-danger pull-left" ng-click="excluir(comissao)">Excluir</button> <button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="!cadastroForm.$valid" ng-click="enviar(comissao)" ng-click-options="{preventDoubleClick: true}">Confirmar</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/manutencao/widget/editarEquipe.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Equipe</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-scope" name="cadastroForm"><div class="row"><div class="col-md-12"><div class="form-group"><label for="cargo" class="control-label">Fun\xE7\xE3o</label> <input type="text" ng-required="" required="" ng-maxlength="50" maxlength="50" ng-minlength="2" class="form-control" id="cargo" ng-model="equipe.cargo" placeholder="Fun\xE7\xE3o"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="nome" class="control-label">Nome</label> <input type="text" ng-pattern="/[a-zA-Z\\s]/" ng-maxlength="60" maxlength="60" class="form-control" id="nome" ng-model="equipe.nome" placeholder="Nome"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="fone" class="control-label">Telefone</label> <input type="tel" phone="" class="form-control tel" ng-maxlength="20" maxlength="20" id="fone" ng-model="equipe.fone" placeholder="Telefone"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="email" class="control-label">E-mail</label> <input type="email" class="form-control" id="email" ng-maxlength="70" maxlength="70" ng-model="equipe.email" placeholder="E-mail"></div></div></div><div class="row" ng-hide="equipe.cargo != cargo_chefe"><div class="col-md-12"><div class="form-group"><label for="assinatura" class="control-label">Assinatura</label></div></div><div class="col-md-12"><div class="form-group"><a href="" ng-click="uploadFile()" class="btn btn-default btn-file filestyle"><i class="glyphicon glyphicon-upload"></i> {{ fileName }} <span ng-if="noFile">Selecione o arquivo da assinatura...</span></a> <i class="glyphicon glyphicon-remove-circle" ng-click="removeFile()" ng-if="!noFile"></i> <input name="assintura" type="file" accept=".jpg,.jpeg,.png,.svg" ng-required="equipe.cargo == cargo_chefe" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-danger pull-left" ng-click="excluir(equipe)">Excluir</button> <button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="cadastroForm.$invalid || !equipe || !equipe.cargo" ng-click="enviar(equipe)" ng-click-options="{preventDoubleClick: true}">Confirmar</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/manutencao/widget/editarPortaria.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Portaria</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="col-md-12"><div class="form-group"><label for="lei" class="control-label">Lei *</label> <input type="text" class="form-control" id="lei" ng-required="true" ng-model="portaria.lei" placeholder="Lei"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="descricao" class="control-label">Descri\xE7\xE3o *</label> <input type="text" class="form-control" id="descricao" ng-required="true" ng-model="portaria.descricao" placeholder="Descri\xE7\xE3o"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="data" class="control-label">Data</label><div class="input-group sidebar" ng-controller="datepickerpopupCtrl"><input id="data" type="text" placeholder="Data" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="portaria.data" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-6"><div class="form-group"><label for="publicacao" class="control-label">Publica\xE7\xE3o</label> <input type="text" class="form-control" id="publicacao" ng-model="portaria.publicacao" placeholder="Publica\xE7\xE3o"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="periodo" class="control-label">Per\xEDodo</label> <input type="text" class="form-control" id="periodo" ng-model="portaria.periodo" placeholder="Per\xEDodo"></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-danger pull-left" ng-click="excluir(portaria)">Excluir</button> <button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="!cadastroForm.$valid" ng-click="enviar(portaria)" ng-click-options="{preventDoubleClick: true}">Confirmar</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/manutencao/widget/editarProgramas.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Programa</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="col-md-3"><label for="codigo" class="control-label">C\xF3digo *</label> <input type="number" ng-blur="setProgram(programas.codigo)" ng-maxlength="6" class="form-control" id="codigo" ng-model="programas.codigo" ng-required="true" placeholder="C\xF3digo"></div><div class="col-md-9"><label for="nome" class="control-label">Nome do Programa *</label> <input type="text" readonly="" disabled="" class="form-control" id="nome" ng-model="programas.nome" ng-required="true" placeholder="Nome do programa"></div></div><div class="row"><div class="col-md-12"><label for="coordenador" class="control-label">Coordenador *</label> <input type="text" class="form-control" id="coordenador" ng-model="programas.coordenador" ng-required="true" placeholder="Coordenador"></div></div><div class="row"><div class="col-md-12"><label for="secretaria" class="control-label">Secret\xE1ria(o)</label> <input type="text" class="form-control" id="secretaria" ng-model="programas.secretaria" placeholder="Secret\xE1ria(o)"></div></div><div class="row"><div class="col-md-12"><label for="local" class="control-label">Local</label> <input type="text" class="form-control" id="local" ng-model="programas.local" placeholder="Local"></div></div><div class="row"><div class="col-md-12"><label for="endereco" class="control-label">Endere\xE7o</label> <input type="text" class="form-control" id="endereco" ng-model="programas.endereco" placeholder="Endereco"></div></div><div class="row"><div class="col-md-12"><label for="telefone" class="control-label">Telefone</label> <input type="text" class="form-control" id="telefone" ng-model="programas.telefone" placeholder="Telefone"></div></div><div class="row"><div class="col-md-12"><label for="email" class="control-label">E-mail</label> <input type="email" class="form-control" id="email" ng-model="programas.email" placeholder="E-mail"></div></div></form></div><div class="modal-footer"><hr><button type="button" class="btn btn-danger pull-left" ng-click="excluir(programas)" ng-click-options="{preventDoubleClick: true}">Apagar</button> <button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="!cadastroForm.$valid" ng-click="enviar(programas)" ng-click-options="{preventDoubleClick: true}">Confirmar</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/maps/google-maps/google-maps.html','<div ba-panel="" ba-panel-title="Google Maps" class="viewport100"><div id="google-maps"></div></div>');
$templateCache.put('app/pages/maps/leaflet/leaflet.html','<div ba-panel="" ba-panel-title="Leaflet" class="viewport100"><div id="leaflet-map"></div></div>');
$templateCache.put('app/pages/maps/map-bubbles/map-bubbles.html','<div ba-panel="" ba-panel-title="Map with Bubbles" class="viewport100"><div id="map-bubbles"></div></div>');
$templateCache.put('app/pages/maps/map-lines/map-lines.html','<div ba-panel="" ba-panel-title="Line Map" class="viewport100"><div id="map-lines"></div></div>');
$templateCache.put('app/pages/parecer/consulta/parecer.html','<div class="widgets" id="parecer"><div class="row"><div class="col-md-14"><div ba-panel=""><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="row"><div class="col-md-2"><label for="cod" class="control-label">C\xF3digo</label> <input type="text" class="form-control" id="cod" ng-model="busca.cod"></div><div class="col-md-5" ng-if="isAdmin"><label for="interessado" class="control-label">Interessado</label> <input type="text" class="form-control" id="interessado" ng-model="busca.interessado"></div><fieldset class="form-group" ng-if="isAdmin"><legend class="col-form-legend">Datas</legend><div class="col-md-4"><label for="dt-tipos" class="control-label">Considerar datas de</label><ui-select ng-model="busca.dt_tipo" class="btn-group bootstrap-select form-control" ng-disabled="dt_tipos == null" id="dt-tipos" append-to-body="true" reset-search-input="false" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Considerar datas de"><span>{{ $select.selected.value }}</span></ui-select-match><ui-select-choices repeat="item in dt_tipos" refresh-delay="0"><div ng-bind-html="item.value"></div></ui-select-choices></ui-select></div><div class="col-md-4"><label for="dt-inicial" class="control-label">Inicial</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-inicial" type="text" placeholder="Data Inicial" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="busca.dt_inicial" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-4"><label for="dt-final" class="control-label">Final</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-final" type="text" placeholder="Data Final" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="busca.dt_final" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></fieldset></div><div class="row" ng-if="isAdmin"><div class="col-md-4"><label for="tipo" class="control-label">Tipo</label><ui-select ng-model="busca.tipo" class="btn-group bootstrap-select form-control" ng-disabled="tipos == null" id="tipo" append-to-body="true" reset-search-input="false" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Tipo"><span>{{ $select.selected.value }}</span></ui-select-match><ui-select-choices repeat="item in tipos" refresh-delay="0"><div ng-bind-html="item.value"></div></ui-select-choices></ui-select></div><div class="col-md-5"><label for="parecerista" class="control-label">Parecerista</label> <input type="text" class="form-control" id="parecerista" ng-model="busca.parecerista"></div><div class="col-md-3"><label for="tipo" class="control-label">Status</label><ui-select ng-model="busca.status" class="btn-group bootstrap-select form-control" ng-disabled="listStatus == null" id="tipo" append-to-body="true" reset-search-input="false" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Status"><span>{{ $select.selected.value }}</span></ui-select-match><ui-select-choices repeat="item in listStatus" refresh-delay="0"><div ng-bind-html="item.value"></div></ui-select-choices></ui-select></div></div><div class="row"><div class="col-md-12"><br><hr><br><button type="button" class="btn btn-primary pull-left" ng-click="novo()" ng-if="isAdmin">Novo Parecer</button> <button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-primary pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button></div></div></form></div><response-message msg="mensagem" voltar="false"></response-message><div ba-panel="" ba-panel-title="Parecer" ba-panel-class="with-scroll" ng-if="parecer.length>0 && mensagem == null"><div class="horizontal-scroll row"><button type="button" class="btn btn-primary pull-right" ng-click="pdf();">Gerar PDF do Resultado</button><div class="row"><label class="control-label col-md-2"><select class="form-control selectpicker show-tick" title="Parecer por p\xE1ginas" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,40,60,100]"></select></label></div><table class="table" st-table="parecer" st-safe-src="outros"><thead><tr><th>C\xF3digo</th><th>Interessado</th><th>Encaminhado</th><th>Assunto</th><th>Programa</th><th>Parecerista</th></tr></thead><tbody><tr ng-repeat="item in parecer track by $index"><td>{{item.cod}}</td><td><a class="btn btn-link" ng-click="editar(item)">{{ item.interessado == "" ? \'_\':item.interessado }}</a></td><td>{{item.dt_encam | date: \'dd/MM/yyyy\'}}</td><td>{{item.assunto}}</td><td>{{item.area}}</td><td>{{item.nomeRelator}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize || 20" st-displayed-pages="20"></div></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/parecer/editar/editarParecer.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel=""><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="col-md-2"><label for="cod" class="control-label">C\xF3digo</label><br><span id="cod">{{parecer.cod?parecer.cod:\'-\'}}</span></div><div class="col-md-3"><label for="dt-entrada" class="control-label">Entrada*</label><div ng-if="isAdmin"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-entrada" type="text" placeholder="Entrada" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="parecer.dt_pedido" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div ng-if="!isAdmin"><input type="text" ng-readonly="" ng-disabled="true" class="form-control" id="dt-entrada" ng-model="parecer.dt_pedido"></div></div><div class="col-md-3"><label for="tipo" class="control-label">Tipo*</label><ui-select ng-if="isAdmin" ng-model="parecer.tipo" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="tipos == null" id="tipo" append-to-body="true" reset-search-input="false" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Tipo"><span>{{ $select.selected.value }}</span></ui-select-match><ui-select-choices repeat="item in tipos" refresh-delay="0"><div ng-bind-html="item.value"></div></ui-select-choices></ui-select><input ng-if="!isAdmin" type="text" ng-readonly="" ng-disabled="true" class="form-control" id="tipo" ng-model="parecer.tipo.value"></div><div class="col-md-4"><label for="programa" class="control-label">Programa*</label><ui-select ng-if="isAdmin" ng-model="parecer.programa" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="programas == null" id="programa" append-to-body="true" reset-search-input="true" search-enabled="true"><ui-select-match placeholder="Programa"><span>{{ $select.selected.value }}</span></ui-select-match><ui-select-choices repeat="item in programas | filter:$select.search" refresh-delay="0"><div ng-bind-html="item.value"></div></ui-select-choices></ui-select><input ng-if="!isAdmin" type="text" readonly="" ng-readonly="true" ng-disabled="true" class="form-control" id="programa" ng-model="parecer.programa.value"></div></div><div class="row"><div class="col-md-12"><label for="Interessado" class="control-label">Interessado*</label> <input ng-if="isAdmin" type="text" class="form-control" id="interessado" ng-required="true" ng-model="parecer.interessado"> <input ng-if="!isAdmin" type="text" class="form-control" id="interessado" ng-readonly="" ng-disabled="true" ng-model="parecer.interessado"></div></div><div class="row"><div class="col-md-12"><div class=""><div class="row"><div class="col-xs-12"><label class="control-label">Links para curr\xEDculo Lattes</label></div></div><div class="row"><div class="col-xs-{{parecer.url?\'3\':\'4\'}}"><input ng-if="isAdmin" type="text" class="form-control" id="url" ng-model="parecer.url"> <input ng-if="!isAdmin" type="text" class="form-control" id="url" ng-readonly="" ng-disabled="true" ng-model="parecer.url"></div><div class="col-xs-1" ng-if="parecer.url"><a href="{{parecer.url}}" class="btn btn-primary" target="_blank">Ver</a></div><div class="col-xs-{{parecer.url2?\'3\':\'4\'}}"><input ng-if="isAdmin" type="text" class="form-control" id="url2" ng-model="parecer.url2"> <input ng-if="!isAdmin" type="text" class="form-control" id="url2" ng-readonly="" ng-disabled="true" ng-model="parecer.url2"></div><div class="col-xs-1" ng-if="parecer.url2"><a href="{{parecer.url2}}" class="btn btn-primary" target="_blank">Ver</a></div><div class="col-xs-{{parecer.url3?\'3\':\'4\'}}"><input ng-if="isAdmin" type="text" class="form-control" id="url3" ng-model="parecer.url3"> <input ng-if="!isAdmin" type="text" class="form-control" id="url3" ng-readonly="" ng-disabled="true" ng-model="parecer.url3"></div><div class="col-xs-1" ng-if="parecer.url3"><a href="{{parecer.url3}}" class="btn btn-primary" target="_blank">Ver</a></div><div class="col-xs-{{parecer.url4?\'3\':\'4\'}}"><input ng-if="isAdmin" type="text" class="form-control" id="url4" ng-model="parecer.url4"> <input ng-if="!isAdmin" type="text" class="form-control" id="url4" ng-readonly="" ng-disabled="true" ng-model="parecer.url4"></div><div class="col-xs-1" ng-if="parecer.url4"><a href="{{parecer.url4}}" class="btn btn-primary" target="_blank">Ver</a></div><div class="col-xs-{{parecer.url5?\'3\':\'4\'}}"><input ng-if="isAdmin" type="text" class="form-control" id="url5" ng-model="parecer.url5"> <input ng-if="!isAdmin" type="text" class="form-control" id="url5" ng-readonly="" ng-disabled="true" ng-model="parecer.url5"></div><div class="col-xs-1" ng-if="parecer.url5"><a href="{{parecer.url5}}" class="btn btn-primary" target="_blank">Ver</a></div><div class="col-xs-{{parecer.url6?\'3\':\'4\'}}"><input ng-if="isAdmin" type="text" class="form-control" id="url6" ng-model="parecer.url6"> <input ng-if="!isAdmin" type="text" class="form-control" id="url6" ng-readonly="" ng-disabled="true" ng-model="parecer.url6"></div><div class="col-xs-1" ng-if="parecer.url6"><a href="{{parecer.url6}}" class="btn btn-primary" target="_blank">Ver</a></div></div></div></div></div><div class="row"><div class="col-md-6"><label for="assunto" class="control-label">Assunto*</label> <textarea ng-if="isAdmin" id="assunto" ng-model="parecer.assunto" ng-required="true" class="form-control textarea" style="resize:none"></textarea> <textarea ng-if="!isAdmin" id="assunto" ng-model="parecer.assunto" class="form-control textarea" style="resize:none" ng-readonly="" ng-disabled="true"> </textarea></div><div class="col-md-3"><label for="relator" class="control-label">Relator</label><ui-select ng-if="isAdmin" ng-model="parecer.nomeRelator" theme="bootstrap" class="btn-group bootstrap-select form-control" ng-disabled="pareceristas == null" id="relator" append-to-body="true" reset-search-input="true" search-enabled="true"><ui-select-match placeholder="Relator"><span>{{ $select.selected.value }}</span></ui-select-match><ui-select-choices repeat="item in pareceristas | filter:$select.search" refresh-delay="0"><div ng-bind-html="item.value | highlight: $select.search"></div></ui-select-choices></ui-select><input ng-if="!isAdmin" type="text" readonly="" ng-readonly="true" ng-disabled="true" class="form-control" id="relator" ng-model="parecer.nomeRelator.value"></div><div class="col-md-3"><label for="dt-encam" class="control-label">Encaminhamento</label><div ng-if="isAdmin"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-encam" type="text" placeholder="Encaminhamento" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="parecer.dt_encam" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div ng-if="!isAdmin"><input type="text" readonly="" ng-readonly="true" ng-disabled="true" class="form-control" id="dt-encam" ng-model="parecer.dt_encam"></div></div><div class="col-md-3"><label for="dt-retorno" class="control-label">Retorno</label><div ng-if="isAdmin"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-retorno" type="text" placeholder="Encaminhamento" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="parecer.dt_retorno" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div ng-if="!isAdmin"><input type="text" readonly="" ng-readonly="true" ng-disabled="true" class="form-control" id="dt-retorno" ng-model="parecer.dt_retorno"></div></div><div class="col-md-3"><label for="resultado" class="control-label">Resultado</label><ui-select ng-if="isAdmin" ng-model="parecer.resultado" class="btn-group bootstrap-select form-control" ng-disabled="resultados == null" id="resultado" append-to-body="true" reset-search-input="false" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Resultado"><span>{{ $select.selected.value }}</span></ui-select-match><ui-select-choices repeat="item in resultados" refresh-delay="0"><div ng-bind-html="item.value"></div></ui-select-choices></ui-select><input ng-if="!isAdmin" type="text" readonly="" ng-readonly="true" ng-disabled="true" class="form-control" id="resultado" ng-model="parecer.resultado.value"></div></div><div class="row"><div class="col-md-12"><label for="parecer" class="control-label">Parecer</label><br><span ng-if="parecer.tipo.id==10"><em>I. (Analise o m\xE9rito e a import\xE2ncia da disciplina junto ao programa)</em></span> <textarea id="parecer" ng-model="parecer.parecer_i" class="form-control textarea" style="resize:none"></textarea> <span ng-if="parecer.tipo.id==10"><em>II. (Analise se o conte\xFAdo est\xE1 ligado \xE0s linhas de pesquisa)</em></span> <span class="pull-right" ng-if="parecer.tipo.id==10"><font color="red"><em>N\xC3O CONSIDERAR SE A DISCIPLINA ESTIVER RELACIONADA A FORMATA\xC7\xC3O B\xC1SICA DE PESQUISADOR</em></font></span> <textarea ng-if="parecer.tipo.id==10" id="parecer2" ng-model="parecer.parecer_ii" class="form-control textarea" style="resize:none">{{parecer.parecer2}}</textarea> <span ng-if="parecer.tipo.id==10"><em>III. (Analise a compet\xEAncia espec\xEDfica dos(s) respons\xE1vel(eis), avaliada por produ\xE7\xE3o cient\xEDfica: publica\xE7\xE3o de artigos completos em revistas de corpo editorial rigoroso, de prefer\xEAncia em n\xEDvel internacional; livros; cap\xEDtulos de livros; participa\xE7\xE3o em congressos internacionais e nacionais; coordena\xE7\xE3o e participa\xE7\xE3o em projetos de pesquisa financiados)</em></span> <textarea ng-if="parecer.tipo.id==10" id="parecer3" ng-model="parecer.parecer_iii" class="form-control textarea" style="resize:none"></textarea> <span ng-if="parecer.tipo.id==10"><em>IV. (Analise, no caso de recredenciamento ou reformula\xE7\xE3o de disciplina, a frequ\xEAncia que a disciplina foi oferecida)</em></span> <textarea ng-if="parecer.tipo.id==10" id="parecer4" ng-model="parecer.parecer_iv" class="form-control textarea" style="resize:none"></textarea></div></div><div class="row"><div class="col-md-4"><label for="resultado_parecer" class="control-label">Resultado do Parecer</label><ui-select ng-model="parecer.resultado_parecer" class="btn-group bootstrap-select form-control" ng-disabled="resultados_parecer == null" id="resultado_parecer" append-to-body="true" reset-search-input="false" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Resultado do Parecer"><span>{{ $select.selected.value }}</span></ui-select-match><ui-select-choices repeat="item in resultados_parecer" refresh-delay="0"><div ng-bind-html="item.value"></div></ui-select-choices></ui-select></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-primary pull-right" ng-disabled="!cadastroForm.$valid" ng-click="salvar()">Gravar</button> <button type="button" class="btn btn-secondary pull-right" ng-if="!novo" ng-click="printParecer()" onclick="alerta()" style="margin-right: 20px;">Imprimir Parecer</button> <button type="button" class="btn btn-secondary pull-right" ng-if="!novo" ng-click="printCapa()" style="margin-right: 20px;">Imprimir Capa</button></div></div></form></div></div></div></div><script>\r\n\tfunction alerta(){\r\n\t\talert("Aten\xE7\xE3o! Abrir\xE1 nova aba para impress\xE3o do Parecer, volte na aba anterior e clique em Gravar, para n\xE3o perder o que digitou!");\r\n\t}\r\n</script>');
$templateCache.put('app/pages/proficiencias/carga/carga.html','<div class="widgets"><form name="cargaForm" class="form-horizontal ng-pristine ng-valid ng-scope" enctype="multipart/form-data"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title=""><div class="row"><div class="col-md-12"><div class="form-group"><label for="de" class="col-md-2 control-label">Data do Exame:</label><div class="col-md-9"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="data" type="text" placeholder="Data da Carga" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="proficiencias.carga.data" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false" name="data" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="nome" class="col-md-2 control-label">Escola:</label><div class="col-md-9"><ui-select ng-model="proficiencias.carga.escola" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false" name="escola" required=""><ui-select-match><span>{{ proficiencias.carga.escola.value }}</span></ui-select-match><ui-select-choices repeat="escola in escolas"><span>{{ escola.value }}</span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="inputFirstName" class="col-md-2 control-label">Arquivo</label><div class="col-md-9"><div><a href="" ng-click="uploadFile()" class="btn btn-default btn-file filestyle"><i class="glyphicon glyphicon-upload"></i> {{ fileName }} <span ng-if="noFile">Selecione o arquivo da carga...</span></a> <i class="glyphicon glyphicon-remove-circle" ng-click="removeFile()" ng-if="!noFile"></i> <input name="arquivo" type="file" accept=".xlsx" required="" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div></div></div><div class="row"><div class="col-md-11"><button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-default pull-right" ng-click="enviar(proficiencias.carga)" style="margin-right: 20px;">Processar</button></div></div></div></div></div></form><response-message msg="mensagem"></response-message></div>');
$templateCache.put('app/pages/proficiencias/certificado/certificado.html','');
$templateCache.put('app/pages/proficiencias/consulta/consulta.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title=""><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="row"><div class="col-md-12"><div class="form-group"><label for="de" class="col-md-2 control-label">Per\xEDodo do Exame:</label><div class="col-md-5"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="de" type="text" placeholder="De" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="proficiente.periodo.de" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-5"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="para" type="text" placeholder="At\xE9" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="proficiente.periodo.ate" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label for="cpf" class="col-md-6 control-label">CPF</label><div class="col-md-6"><input type="text" class="form-control" id="cpf" ng-model="proficiente.cpf" ui-mask="9?9?9?.999.999-99"></div></div></div><div class="col-md-8"><div class="form-group"><label for="nome" class="col-md-3 control-label">e/ou Nome do Aluno</label><div class="col-md-9"><input type="text" class="form-control" id="nome" ng-model="proficiente.nome"></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="nome" class="col-sm-2 control-label">Conceito (Nota)</label><div class="col-sm-10"><ui-select ng-model="proficiente.conceito" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ proficiente.conceito.label }}</span></ui-select-match><ui-select-choices repeat="conceito in conceitos"><span>{{ conceito.label }}</span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-default pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button></div></div></form></div><response-message msg="mensagem" voltar="true"></response-message><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll" class="panel-overlayed" ng-hide="proficientes == null"><table class="table table-striped"><thead><tr><th>Data do Exame</th><th>Aluno</th><th>Escola</th><th>Nota</th><th>A\xE7\xF5es</th><th ng-if="isAdmin"><i class="icon ion-edit"></i></th></tr></thead><tbody><tr ng-repeat="item in proficientes"><td>{{ item.dataExame | date:\'dd/MM/yyyy\' }}</td><td>{{ item.nomeAluno }}</td><td>{{ item.nomeEscola }}</td><td>{{ item.notaExame | number:1}}</td><td><a ng-if="item.notaExame >= 50.0" ng-click="gerarDeclaracao(item)">Gerar Declara\xE7\xE3o</a></td><td ng-if="isAdmin"><a ng-click="editarProficiencia(item)"><i class="icon ion-edit"></i></a></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/proficiencias/consulta/editar.html','<div class="widgets"><div class="row"><div class="col-md-12 agendamento feriado"><div class="panel animated zoomIn"><div class="panel-heading clearfix"><h3 class="panel-title">{{ acao }} Proficiecia</h3></div><div class="panel-body footer-panel"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="form"><div class="row" ng-if="proficiencia.id"><div class="col-md-12"><div class="form-group"><label for="descricao" class="col-md-2 control-label">id</label><div class="col-md-10"><span class="form-control" ng-disabled="">{{ proficiencia.id }}</span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="data" class="col-md-2 control-label">Data do Exame:</label><div class="col-md-10"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="data" type="text" placeholder="Inicio" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="proficiencia.dataExame" is-open="opened" ng-required="true" close-text="Fechar" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="data" class="col-md-2 control-label">CPF:</label><div class="col-md-10"><input type="text" autocomplete="off" class="form-control" id="cpf" name="cpf" validador-cpf="" ng-model="proficiencia.cpf" ui-mask="9?9?9?.999.999-99"></div></div></div></div><div class="row" ng-show="proficiencia.cpf && form.cpf.$invalid"><div class="col-xs-12 error" style="color:red">CPF previsa ser v\xE1lido</div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="data" class="col-md-2 control-label">Nome:</label><div class="col-md-10"><input type="text" class="form-control" ng-model="proficiencia.nomeAluno"></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="data" class="col-md-2 control-label">Escola:</label><div class="col-md-10"><ui-select ng-model="proficiencia.escola" class="btn-group bootstrap-select form-control" ng-disabled="escolas == null" append-to-body="true" search-enabled="false" close-on-select="true" spinner-enabled="true"><ui-select-match><span>{{ proficiencia.escola.value }}</span></ui-select-match><ui-select-choices repeat="escola in escolas"><span>{{ escola.value }}</span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="data" class="col-md-2 control-label">Nota:</label><div class="col-md-10"><input type="number" step="0.1" class="form-control" ng-model="proficiencia.notaExame"></div></div></div></div></form></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-danger pull-right" ng-click="limpar()" style="margin-right: 20px; margin-top: -10px;">Limpar</button> <button type="button" class="btn btn-primary pull-right" ng-hide="proficiencia.id" ng-click="inserirProficiencia(proficiencia)" style="margin-right: 20px; margin-top: -10px;">Inserir</button> <button type="button" class="btn btn-primary pull-right" ng-show="proficiencia.id" ng-click="alterarProficiencia(proficiencia)" style="margin-right: 20px; margin-top: -10px;">Alterar</button><br></div></div><response-message msg="mensagem" voltar="true"></response-message></div></div></div>');
$templateCache.put('app/pages/proficiencias/declaracao/declaracao.html','<div class="widgets"><div class="row"><div class="col-md-12"><div class="panel animated zoomIn" ng-show="proficiente != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de Impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>Declara\xE7\xE3o</h2></td><td></td></tr><tr><td></td><td class="texto-principal">Declaro que o Sr(a). <span id="nome">{{ proficiente.nomeAluno }}</span> realizou exame de profici\xEAncia em l\xEDngua inglesa na Cultura Inglesa, para fins de inscri\xE7\xE3o em programa de p\xF3s-gradua\xE7\xE3o na Faculdade de Medicina da Universidade de S\xE3o Paulo, no dia <span id="data-exame">{{ proficiente.dataExame | date:\'dd/MM/yyyy\' }}</span>, obtendo <span id="nota">{{ proficiente.notaExame | number:1 }} pontos</span>.</td><td></td></tr><tr><td></td><td>{{ dataAtual | date:"\'S\xE3o Paulo\', dd" | capitalize}} de {{ dataAtual | date:"MMMM" | capitalize}} de {{ dataAtual | date:"yyyy"}}</td><td></td></tr><tr><td></td><td><i>Este documento eletr\xF4nico dispensa carimbo e assinatura. Sua autenticidade pode ser comprovada pelo Servi\xE7o de P\xF3s-gradua\xE7\xE3o da FMUSP atrav\xE9s do e-mail: <a href="mailto:posfm@fm.usp.br">posfm@fm.usp.br</a></i></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="proficiente == null" style="margin: -10px 10px;" ng-click="print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/rotinas/oficio/oficio.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Consulta"><div class="row"><div class="col-md-3"><label for="codigo" class="control-label">C\xF3digo</label> <input type="text" class="form-control" id="codigo" ng-model="busca.codigo"></div><div class="col-md-5"><label for="Interessado" class="control-label">Interessado</label> <input type="text" class="form-control" id="interessado" ng-model="busca.interessado"></div><div class="col-md-2"><label for="dt-inicial" class="control-label">Data Inicial</label><div><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-inicial" type="text" placeholder="Data Inicial" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="busca.dataInicial" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-2"><label for="dt-final" class="control-label">Data Final</label><div><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-final" type="text" placeholder="Data Final" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="busca.dataFinal" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><br><div class="row"><div class="col-md-4"><label for="assunto" class="control-label">Assunto</label> <input type="text" class="form-control" id="assunto" ng-model="busca.assunto"></div><div class="col-md-8"><label for="local" class="control-label">Local</label> <input type="text" class="form-control" id="local" ng-model="busca.local"></div></div><hr><div class="row"><div class="col-md-12"><button type="button" class="btn btn-lg btn-success pull-left" ng-click="adicionar()">Novo</button> <button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-primary pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button></div></div><br></div><div ba-panel="" ba-panel-class="with-scroll" ng-if="oficio.length>0"><div class="horizontal-scroll row col-md-12"><div class="row"><label class="control-label col-md-2"><select class="form-control selectpicker show-tick" title="Of\xEDcios por p\xE1ginas" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,40,60,100]"></select></label></div><table class="table" st-table="oficio" st-safe-src="outros" ng-if="oficio.length>0"><thead><tr><th>Data</th><th>Interessado</th><th>C\xF3digo</th><th>Assunto</th><th>Local</th></tr></thead><tbody><tr ng-repeat="item in oficio"><td>{{item.dt_insert | date: \'dd/MM/yyyy\'}}</td><td><a class="btn btn-link" ng-click="editar(item)">{{item.interessado}}</a></td><td>{{item.nOficio}}</td><td>{{item.assunto}}</td><td>{{item.locades}}</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize || 20" st-displayed-pages="20"></div></td></tr></tfoot></table></div></div><response-message msg="mensagem" voltar="false"></response-message></div></div></div>');
$templateCache.put('app/pages/rotinas/protocolo/protocolo.html','<div id="protocolo" class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Consulta"><div class="row"><div class="col-md-3"><label for="codigo" class="control-label">C\xF3digo</label> <input type="text" class="form-control" id="codigo" ng-model="busca.codigo"></div><div class="col-md-5"><label for="Interessado" class="control-label">Interessado</label> <input type="text" class="form-control" id="interessado" ng-model="busca.interessado"></div><div class="col-md-2"><label for="dt-inicial" class="control-label">Data Inicial</label><div><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-inicial" type="text" placeholder="Data Inicial" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="busca.dataInicial" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-2"><label for="dt-final" class="control-label">Data Final</label><div><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-final" type="text" placeholder="Data Final" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="busca.dataFinal" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><br><div class="row"><div class="col-md-6"><label for="matricula" class="control-label">Assunto</label><ui-select ng-model="busca.assunto" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="assuntos == null" append-to-body="true" reset-search-input="false" search-enabled="true" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Assunto"><span>{{ $select.selected.assunto }}</span></ui-select-match><ui-select-choices repeat="item in assuntos | filter:$select.search" refresh-delay="0"><div ng-bind-html="item.assunto | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-6"><label for="matricula" class="control-label">Destino</label><ui-select ng-model="busca.destino" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="destinos == null" append-to-body="true" reset-search-input="false" search-enabled="true" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Destino"><span>{{ $select.selected.local }}</span></ui-select-match><ui-select-choices repeat="item in destinos | filter:$select.search" refresh-delay="0"><div ng-bind-html="item.local | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><br><hr><div class="row"><div class="col-md-12"><button type="button" class="btn btn-lg btn-success pull-left" ng-click="adicionarExpediente()" style="margin-right: 20px;"><i class="ion-android-list"></i> Novo Expediente</button> <button type="button" class="btn btn-lg btn-success pull-left" ng-click="adicionarProtocolo()"><i class="ion-android-document"></i> Novo Protocolo</button> <button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-primary pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button></div></div><br><br></div><div ba-panel="" ba-panel-class="with-scroll" ng-if="protocolos.length>0"><div class="horizontal-scroll row col-md-12"><div class="row"><label class="control-label col-md-2"><select class="form-control selectpicker show-tick" title="Protocolos por p\xE1ginas" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,40,60,100]"></select></label></div><table class="table" st-table="protocolos" st-safe-src="outros" ng-if="protocolos.length>0"><thead><tr><th>Data Cadastro</th><th>Interessado</th><th>Protocolo/Expediente</th><th>Assunto</th><th>Tipo</th></tr></thead><tbody><tr ng-repeat="item in protocolos track by $index"><td>{{item.dt_create | date: \'dd/MM/yyyy\'}}</td><td><a class="btn btn-link" ng-click="editar(item)">{{ item.interessado == "" ? \'_\':item.interessado }}</a></td><td>{{item.cod}}</td><td>{{item.assunto}}</td><td>{{item.tipo}}</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize || 20" st-displayed-pages="20"></div></td></tr></tfoot></table></div></div><response-message msg="mensagem" voltar="false"></response-message></div></div></div>');
$templateCache.put('app/pages/rotinas/titulo/titulo.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Consulta"><div class="row"><div class="col-md-3"><label for="codigo" class="control-label">C\xF3digo</label> <input type="text" class="form-control" id="codigo" ng-model="busca.codigo"></div><div class="col-md-5"><label for="Nome" class="control-label">Nome</label> <input type="text" class="form-control" id="Nome" ng-model="busca.nome"></div><div class="col-md-2"><label for="dt-inicial" class="control-label">Data Inicial</label><div><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-inicial" type="text" placeholder="Data Inicial" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="busca.dataInicial" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-2"><label for="dt-final" class="control-label">Data Final</label><div><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-final" type="text" placeholder="Data Final" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="busca.dataFinal" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><br><br><hr><br><br><div class="row"><div class="col-md-12"><button type="button" class="btn btn-lg btn-success pull-left" ng-click="adicionar()">Novo</button> <button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-primary pull-right" ng-click="pesquisar()" style="margin-right: 20px;">Pesquisar</button></div></div><br><br><br></div><div ba-panel="" ba-panel-class="with-scroll" ng-if="titulos.length>0"><div class="horizontal-scroll row col-md-12"><div class="row"><label class="control-label col-md-2"><select class="form-control selectpicker show-tick" title="T\xEDtulos por p\xE1ginas" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,40,60,100]"></select></label></div><table class="table" st-table="titulos" st-safe-src="outros" ng-if="titulos.length>0"><thead><tr><th>Data</th><th>Nome</th><th>C\xF3digo</th><th>T\xEDtulo</th><th>Programa</th></tr></thead><tbody><tr ng-repeat="item in titulos track by $index"><td>{{item.dataspg | date: \'dd/MM/yyyy\'}}</td><td><a class="btn btn-link" ng-click="editar(item)">{{item.nome}}</a></td><td>{{item.codigo}}</td><td>{{item.titulo}}</td><td>{{item.area}}</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize || 20" st-displayed-pages="20"></div></td></tr></tfoot></table></div></div><response-message msg="mensagem" voltar="false"></response-message></div></div></div>');
$templateCache.put('app/pages/tables/basic/tables.html','<div class="widgets"><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Hover Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/hoverRows.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Bordered Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/borderedTable.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Condensed Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/condensedTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Striped Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/stripedRows.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Contextual Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/contextualTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Responsive Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/responsiveTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/smart/tables.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Rows" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableRowTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Cells" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Smart Table With Filtering, Sorting And Pagination" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/smartTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/widgets/basicTable.html','<div class="horizontal-scroll"><table class="table"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Downloads</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">DAU</th><th class="table-arr"></th><th class="align-right">MAU</th><th class="table-arr"></th><th class="align-right">LTV</th><th class="table-arr"></th><th class="align-right">Users %</th><th class="table-arr"></th></tr></thead><tbody><tr><td><img src="img/chrome.svg" width="20" height="20"></td><td class="nowrap">Google Chrome</td><td class="align-right">10,392</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">3,822</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,214</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">899</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">7,098</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">178</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">45%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/firefox.svg" width="20" height="20"></td><td class="nowrap">Mozilla Firefox</td><td class="align-right">7,873</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">6,003</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,031</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">897</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">8,997</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">28%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/ie.svg" width="20" height="20"></td><td class="nowrap">Internet Explorer</td><td class="align-right">5,890</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,492</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">2,102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">27</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,039</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">99</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">17%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/safari.svg" width="20" height="20"></td><td class="nowrap">Safari</td><td class="align-right">4,001</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">2,039</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">1,001</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">104</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,983</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">209</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">14%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/opera.svg" width="20" height="20"></td><td class="nowrap">Opera</td><td class="align-right">1,833</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">983</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">83</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">19</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">1,099</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">103</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">5%</td><td class="table-arr"><i class="icon-up"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/borderedTable.html','<div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="align-right">Purchases</th><th class="align-right">%</th></tr></thead><tbody><tr ng-repeat="item in metricsTableData"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="align-right">{{item.purchases}}</td><td class="align-right">{{item.percent}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/condensedTable.html','<div class="horizontal-scroll"><table class="table table-condensed"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat="item in peopleTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><button class="status-button btn btn-xs btn-{{item.status}}">{{item.status}}</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/contextualTable.html','<table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class="primary"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr class="success"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr class="warning"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr class="danger"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr class="info"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableRowTable.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addUser()">Add row</button></div><table class="table table-bordered table-hover table-condensed"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat="user in users" class="editable-row"><td>{{$index}}</td><td><span editable-text="user.name" e-name="name" e-form="rowform" e-required="">{{ user.name || \'empty\' }}</span></td><td class="select-td"><span editable-select="user.status" e-name="status" e-form="rowform" e-selectpicker="" e-ng-options="s.value as s.text for s in statuses">{{ showStatus(user) }}</span></td><td class="select-td"><span editable-select="user.group" e-name="group" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.text for g in groups">{{ showGroup(user) }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == user"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUser($index)">Delete</button></div></td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableTable.html','<div class="horizontal-scroll"><table class="table table-hover" st-table="editableTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr></thead><tbody><tr ng-repeat="item in editableTableData" class="editable-tr-wrap"><td class="table-id">{{item.id}}</td><td><span editable-text="item.firstName" blur="cancel">{{item.firstName}}</span></td><td><span editable-text="item.lastName" blur="cancel">{{item.lastName}}</span></td><td><span editable-text="item.username" blur="cancel">{{item.username}}</span></td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><span editable-text="item.age" blur="cancel">{{item.age}}</span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="12" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/hoverRows.html','<div class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">%</th><th class="table-arr"></th></tr></thead><tbody><tr ng-repeat="item in metricsTableData" class="no-top-border"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }"></i></td><td class="align-right">{{item.purchases}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }"></i></td><td class="align-right">{{item.percent}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/responsiveTable.html','<div class="table-responsive"><table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/smartTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr><tr><th></th><th><input st-search="firstName" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastName" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" placeholder="Search Email" class="input-sm form-control search-input" type="search"></th><th><input st-search="age" placeholder="Search Age" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/stripedRows.html','<div class="vertical-scroll"><table class="table table-striped"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/alerts/alerts.html','<div class="widgets"><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info"><strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger"><strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Dismissible alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Links in alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read <a href="" class="alert-link">this important alert message</a>.</div><div class="alert bg-info"><strong>Heads up!</strong> This <a href="" class="alert-link">alert needs your attention</a>, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re <a href="" class="alert-link">not looking too good</a>.</div><div class="alert bg-danger"><strong>Oh snap!</strong> <a href="" class="alert-link">Change a few things up</a> and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Composite alerts" ba-panel-class="with-scroll"><div><div class="alert bg-warning"><h4>Warning!</h4><strong>Pay attention.</strong> Change a few things up and try submitting again.<div class="control-alert"><button type="button" class="btn btn-danger">Pay Attention</button> <button type="button" class="btn btn-primary">Ignore</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/buttons.html','<div class="widgets"><div class="row"><div class="col-md-3" ba-panel="" ba-panel-title="Flat Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Raised Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-raised">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-raised">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-raised">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-raised">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-raised">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Different sizes" ba-panel-class="with-scroll button-panel df-size-button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-mm">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-md">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-xm">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Disabled" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Icon Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/iconButtons.html\'"></div></div><div ba-panel="" ba-panel-title="Large Buttons" ba-panel-class="with-scroll large-buttons-panel"><div ng-include="\'app/pages/ui/buttons/widgets/largeButtons.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Button Dropdowns" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/dropdowns.html\'"></div></div><div ba-panel="" ba-panel-title="Button Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/buttonGroups.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Progress Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/progressButtons.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/grid/baseGrid.html','<h4 class="grid-h">Stacked to horizontal</h4><div class="row show-grid"><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div></div><div class="row show-grid"><div class="col-md-8"><div>.col-md-8</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-6"><div>.col-md-6</div></div><div class="col-md-6"><div>.col-md-6</div></div></div><h4 class="grid-h">Mobile and desktop</h4><div class="row show-grid"><div class="col-xs-12 col-md-8"><div>xs-12 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6"><div>.col-xs-6</div></div><div class="col-xs-6"><div>.col-xs-6</div></div></div><h4 class="grid-h">Mobile, tablet, desktop</h4><div class="row show-grid"><div class="col-xs-12 col-sm-6 col-md-8"><div>.col-xs-12 .col-sm-6 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>.col-xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div></div><h4 class="grid-h">Column wrapping</h4><div class="row show-grid"><div class="col-xs-9"><div>.col-xs-9</div></div><div class="col-xs-4"><div>.col-xs-4<br>Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one contiguous unit.</div></div><div class="col-xs-6"><div>.col-xs-6<br>Subsequent columns continue along the new line.</div></div></div><h4 class="grid-h">Responsive column resets</h4><div class="row show-grid"><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3<p>Resize your viewport or check it out on your phone for an example.</p></div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div></div><h4 class="grid-h">Offsetting columns</h4><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4 col-md-offset-4"><div>.col-md-4 .col-md-offset-4</div></div></div><div class="row show-grid"><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div></div><div class="row show-grid"><div class="col-md-6 col-md-offset-3"><div>.col-md-6 .col-md-offset-3</div></div></div><h4 class="grid-h">Grid options</h4><div class="table-responsive"><table class="table table-bordered table-striped"><thead><tr><th></th><th>Extra small devices <small>Phones (&lt;768px)</small></th><th>Small devices <small>Tablets (\u2265768px)</small></th><th>Medium devices <small>Desktops (\u2265992px)</small></th><th>Large devices <small>Desktops (\u22651200px)</small></th></tr></thead><tbody><tr><th class="text-nowrap" scope="row">Grid behavior</th><td>Horizontal at all times</td><td colspan="3">Collapsed to start, horizontal above breakpoints</td></tr><tr><th class="text-nowrap" scope="row">Container width</th><td>None (auto)</td><td>750px</td><td>970px</td><td>1170px</td></tr><tr><th class="text-nowrap" scope="row">Class prefix</th><td><code>.col-xs-</code></td><td><code>.col-sm-</code></td><td><code>.col-md-</code></td><td><code>.col-lg-</code></td></tr><tr><th class="text-nowrap" scope="row"># of columns</th><td colspan="4">12</td></tr><tr><th class="text-nowrap" scope="row">Column width</th><td class="text-muted">Auto</td><td>~62px</td><td>~81px</td><td>~97px</td></tr><tr><th class="text-nowrap" scope="row">Gutter width</th><td colspan="4">30px (15px on each side of a column)</td></tr><tr><th class="text-nowrap" scope="row">Nestable</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Offsets</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Column ordering</th><td colspan="4">Yes</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/grid/grid.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/grid/baseGrid.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/icons/icons.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Kameleon SVG Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleon.html"></div></div><div ba-panel="" ba-panel-title="Socicon" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/socicon.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Icons With Rounded Background" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleonRounded.html"></div></div><div ba-panel="" ba-panel-title="ionicons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/ionicons.html"></div></div><div ba-panel="" ba-panel-title="Font Awesome Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/fontAwesomeIcons.html"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/modals/modals.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Modals" ba-panel-class="with-scroll"><div class="modal-buttons clearfix"><button type="button" class="btn btn-primary" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'md\')">Default modal</button> <button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/largeModal.html\', \'lg\')">Large modal</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/smallModal.html\', \'sm\')">Small modal</button></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Message Modals" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/successModal.html\')">Success Message</button> <button type="button" class="btn btn-info" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/infoModal.html\')">Info Message</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/warningModal.html\')">Warning Message</button> <button type="button" class="btn btn-danger" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/dangerModal.html\')">Danger Message</button></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Notifications" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/modals/notifications/notifications.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Progress dialogs" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-info" data-toggle="modal" ng-click="openProgressDialog()">Progress dialog</button></div></div></div></div>');
$templateCache.put('app/pages/ui/notifications/notifications.html','<div ba-panel="" ba-panel-class="with-scroll notification-panel"><div class="row"><div class="col-md-3 col-sm-4"><div class="control"><label for="title">Title</label> <input ng-model="options.title" type="text" class="form-control" id="title" placeholder="Enter a title ..."></div><div class="control"><label for="message">Message</label> <textarea ng-model="options.msg" class="form-control" id="message" rows="3" placeholder="Enter a message ..."></textarea></div><div class="control-group"><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.closeButton" type="checkbox" id="closeButton"> <span>Close Button</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.allowHtml" type="checkbox" id="html"> <span>Allow html</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.progressBar" type="checkbox" id="progressBar"> <span>Progress bar</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventDuplicates" type="checkbox" id="preventDuplicates"> <span>Prevent duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventOpenDuplicates" type="checkbox" id="preventOpenDuplicates"> <span>Prevent open duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.tapToDismiss" type="checkbox" id="tapToDismiss"> <span>Tap to dismiss</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.newestOnTop" type="checkbox" id="newestOnTop"> <span>Newest on top</span></label></div></div></div><div class="col-md-2 col-sm-3 toastr-radio-setup"><div id="toastTypeGroup"><div class="controls radio-controls"><label class="radio-header">Toast Type</label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="success"><span>Success</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="info"><span>Info</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="warning"><span>Warning</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="error"><span>Error</span></label></div></div><div id="positionGroup"><div class="controls radio-controls"><label class="radio-header position-header">Position</label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-right"> <span>Top Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-right"> <span>Bottom Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-left"> <span>Bottom Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-left"> <span>Top Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-full-width"> <span>Top Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-full-width"> <span>Bottom Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-center"> <span>Top Center</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-center"> <span>Bottom Center</span></label></div></div></div><div class="col-md-2 col-sm-3"><div class="control"><label for="timeOut">Time out</label> <input type="text" class="form-control" id="timeOut" ng-model="options.timeOut" placeholder="ms"> <label class="sub-label" for="timeOut">If you set it to 0, it will stick</label></div><div class="control"><label for="extendedTimeOut">Extended time out</label> <input type="text" class="form-control" id="extendedTimeOut" ng-model="options.extendedTimeOut" placeholder="ms"></div><div class="control"><label for="maxOpened">Maximum number of toasts</label> <input type="text" class="form-control" id="maxOpened" ng-model="options.maxOpened" value="0"> <label for="maxOpened" class="sub-label">0 means no limit</label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.autoDismiss" type="checkbox" id="autoDismiss"> <span>Auto dismiss</span></label></div></div><div class="col-md-5 col-sm-12"><label>Result:</label><pre class="result-toastr" id="toastrOptions">{{optionsStr}}</pre></div></div><div class="row"><div class="col-md-12 button-row"><button ng-click="openToast()" class="btn btn-primary">Open Toast</button> <button ng-click="openRandomToast()" class="btn btn-primary">Random Toast</button> <button ng-click="clearToasts()" class="btn btn-danger">Clear Toasts</button> <button ng-click="clearLastToast()" class="btn btn-danger">Clear Last Toast</button></div></div></div>');
$templateCache.put('app/pages/ui/panels/panels.html','<h2>Default panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-class="xsmall-panel light-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ac mi erat. Phasellus placerat, elit a laoreet semper, enim ipsum ultricies orci, ac tincidunt tellus massa eu est. Nam non porta purus, sed facilisis justo. Nam pulvinar sagittis quam.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header" ba-panel-class="xsmall-panel light-text">Phasellus maximus venenatis augue, et vestibulum neque aliquam ut. Morbi mattis libero vitae vulputate dignissim. Praesent placerat, sem non dapibus cursus, lacus nisi blandit quam, vitae porttitor lectus lacus non turpis. Donec suscipit consequat tellus.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header & scroll" ba-panel-class="xsmall-panel with-scroll light-text"><p>Suspendisse nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Sed dapibus, purus vel hendrerit consectetur, lectus orci gravida massa, sed bibendum dui mauris et eros. Nulla dolor massa, posuere et dictum sit amet, dignissim quis odio. Fusce mollis finibus dignissim. Integer sodales augue erat. Pellentesque laoreet vestibulum urna at iaculis. Nulla libero augue, euismod at diam eget, aliquam condimentum ligula. Donec a leo eu est molestie lacinia hendrerit sed lorem. Duis id diam eu metus sodales consequat vel eu elit. Praesent dolor nibh, convallis eleifend feugiat a, finibus porttitor nibh. Ut non libero vel velit pulvinar scelerisque non vel lorem. Integer porta tempor nulla. Sed nibh erat, ultrices vel lorem eu, rutrum vehicula sem.</p><p>Donec nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum nec ligula egestas rhoncus. Sed dignissim, augue vel scelerisque vulputate, nisi ante posuere lorem, quis iaculis eros dolor eu nisl. Etiam sagittis, ipsum ac tempor iaculis, justo neque mattis ante, ac maximus sapien risus eu sapien. Morbi erat urna, varius et lectus vel, porta dictum orci. Duis bibendum euismod elit, et lobortis purus venenatis in. Mauris eget lacus enim. Cras quis sem et magna fringilla convallis. Proin hendrerit nulla vel gravida mollis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Vestibulum consectetur quis purus vel aliquam.</p></div></div></div><h2>Bootstrap panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-body"><p>A panel in bootstrap is a bordered box with some padding around its content.</p><p class="p-with-code">Panels are created with the <code>.panel</code> class, and content inside the panel has a <code>.panel-body</code> class. The <code>.panel-default .panel-primary .panel-danger</code> and other classes are used to style the color of the panel. See the next example on this page for more contextual classes.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-heading">Panel Heading</div><div class="panel-body"><p class="p-with-code">The <code>.panel-heading</code> class adds a heading to the panel.Easily add a heading container to your panel with .panel-heading. You may also include any <code>h1-h6</code> with a <code>.panel-title</code> class to add a pre-styled heading.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel"><div class="panel-body footer-panel"><p class="p-with-code">Wrap buttons or secondary text in <code>.panel-footer</code>. Note that panel footers do not inherit colors and borders when using contextual variations as they are not meant to be in the foreground.</p></div><div class="panel-footer">Panel Footer</div></div></div></div><h2>Panels with Contextual Classes</h2><div class="row"><div class="col-md-6 col-lg-4"><div class="panel panel-default contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-default class</div><div class="panel-body">To color the panel, use contextual classes. This is sample <code>.panel-default</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-primary contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-primary class</div><div class="panel-body">Sample <code>.panel-primary</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-success contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-success class</div><div class="panel-body">Sample <code>.panel-success</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-info contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-info class</div><div class="panel-body">Sample <code>.panel-info</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-warning contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-warning class</div><div class="panel-body">Sample <code>.panel-warning</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-danger contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-danger class</div><div class="panel-body">Sample <code>.panel-danger</code> panel</div></div></div></div><div class="row"><div class="col-md-12"><h2>Panel Group</h2><div class="panel-group"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 1</div><div class="panel-body"><p>To group many panels together, wrap a <code>&lt;div&gt;</code> with class <code>\r\n            .panel-group</code> around them.</p></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 2</div><div class="panel-body"><p>The <code>.panel-group</code> class clears the bottom-margin of each panel.</p></div></div></div></div></div>');
$templateCache.put('app/pages/ui/progressBars/progressBars.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/basic.html\'"></div></div><div ba-panel="" ba-panel-title="Striped" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/striped.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="With label" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/label.html\'"></div></div><div ba-panel="" ba-panel-title="Animated" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/animated.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Stacked" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/stacked.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/slider/slider.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ion Range Slider" ba-panel-class="with-scroll"><div class="slider-box"><h5>Basic</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="false"></ion-slider></div><div class="slider-box"><h5>With prefix</h5><ion-slider type="single" grid="true" min="100" max="1200" prefix="$" from="420" disable="false"></ion-slider></div><div class="slider-box"><h5>With postfix</h5><ion-slider type="single" grid="true" min="-90" max="90" postfix="\xB0" from="36" disable="false"></ion-slider></div><div class="slider-box"><h5>Two way range</h5><ion-slider type="double" grid="true" min="100" max="1200" from="420" to="900" disable="false"></ion-slider></div><div class="slider-box"><h5>With Steps</h5><ion-slider type="single" grid="true" min="0" max="1000" from="300" step="50" disable="false"></ion-slider></div><div class="slider-box"><h5>Decorating numbers</h5><ion-slider type="single" grid="true" min="0" max="1000000" from="300000" step="1000" prettify-separator="." prettify="true" disable="false"></ion-slider></div><div class="slider-box"><h5>Using custom values array</h5><ion-slider type="single" grid="true" from="5" step="1000" values="[\'January\', \'February\', \'March\', \'April\', \'May\', \'June\', \'July\', \'August\', \'September\', \'October\', \'November\', \'December\']" disable="false"></ion-slider></div><div class="slider-box"><h5>Disabled</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="true"></ion-slider></div></div></div></div>');
$templateCache.put('app/pages/ui/tabs/contextualAccordion.html','<uib-accordion><uib-accordion-group heading="Primary" panel-class="panel-primary bootstrap-panel accordion-panel">Primary <i class="ion-heart"></i></uib-accordion-group><uib-accordion-group heading="Success" panel-class="panel-success bootstrap-panel accordion-panel">Success <i class="ion-checkmark-round"></i></uib-accordion-group><uib-accordion-group heading="Info" panel-class="panel-info bootstrap-panel accordion-panel">Info <i class="ion-information-circled"></i></uib-accordion-group><uib-accordion-group heading="Warning" panel-class="panel-warning bootstrap-panel accordion-panel">Warning <i class="ion-alert"></i></uib-accordion-group><uib-accordion-group heading="Danger" panel-class="panel-danger bootstrap-panel accordion-panel">Danger <i class="ion-nuclear"></i></uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/mainTabs.html','<uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Start"><p>Take up one idea. Make that one idea your life--think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success.</p><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed. Similarly, when someone is failing, the tendency is to get on a downward spiral that can even become a self-fulfilling prophecy.</p><div class="text-center"><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Shop\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Programming\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Dna\' | kameleonImg )}}"></div></div><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Getting Done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab ng-init="$dropdownTabActive = 1" class="with-dropdown"><uib-tab-heading uib-dropdown=""><a uib-dropdown-toggle="" ng-click="$event.stopPropagation()">Dropdown tab <i class="caret"></i></a><ul class="dropdown-menu" uib-dropdown-menu=""><li><a ng-click="$dropdownTabActive = 1; $tabSetStatus.activeTab = 3">Tab 1</a></li><li><a ng-click="$dropdownTabActive = 2; $tabSetStatus.activeTab = 3">Tab 2</a></li></ul></uib-tab-heading><div ng-show="$dropdownTabActive == 1"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></div><div ng-show="$dropdownTabActive == 2"><p class="text-center"><button class="btn btn-danger">I\'m just a dummy button</button></p></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/ui/tabs/sampleAccordion.html','<uib-accordion><uib-accordion-group is-open="true" heading="Static Header, initially expanded" panel-class="bootstrap-panel accordion-panel panel-default">This content is straight in the template.</uib-accordion-group><uib-accordion-group heading="Dynamic Body Content" panel-class="bootstrap-panel accordion-panel panel-default"><p>The body of the uib-accordion group grows to fit the contents</p><button type="button" class="btn btn-primary btn-sm">Add Item</button></uib-accordion-group><uib-accordion-group heading="Custom template" panel-class="bootstrap-panel accordion-panel panel-default">Hello</uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading>I can have markup, too! <i class="fa pull-right ion-settings"></i></uib-accordion-heading>This is just some content to illustrate fancy headings.</uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/sideTabs.html','<div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-left"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Key\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div><div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-right"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Phone-Booth\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/ui/tabs/tabs.html','<div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel medium-panel"><div ng-include="\'app/pages/ui/tabs/mainTabs.html\'"></div></div></div><div class="col-md-6 tabset-group" ng-include="\'app/pages/ui/tabs/sideTabs.html\'"></div></div><div class="row accordions-row"><div class="col-md-6" ng-include="\'app/pages/ui/tabs/sampleAccordion.html\'"></div><div class="col-md-6" ng-include="\'app/pages/ui/tabs/contextualAccordion.html\'"></div></div></div>');
$templateCache.put('app/pages/ui/typography/typography.html','<div class="typography-document-samples row-fluid"><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll heading-widget" ba-panel-title="Text Size"><div class="section-block"><h1>H1. Heading 1</h1><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h2>H2. Heading 2</h2><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h3>H3. Heading 3</h3><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h4>H4. Heading 4</h4><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra,.</p></div><div class="section-block"><h5>H5. Heading 5</h5><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll more-text-widget" ba-panel-title="Some more text"><div class="section-block light-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis.</p></div><div class="section-block regular-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id.</p></div><div class="section-block upper-text bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullam-corper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block small-text"><p>Secondary text. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar,</p><p>lacinia scelerisque pharetra, placerat vestibulum eleifend</p><p>pellentesque, mi nam.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll lists-widget" ba-panel-title="Lists"><div class="section-block"><h5 class="list-header">Unordered list:</h5><ul class="blur"><li>Lorem ipsum dolor sit amet</li><li>\u0421lacinia scelerisque pharetra<ul><li>Dui rhoncus quisque integer lorem<ul><li>Libero iaculis vestibulum eu vitae</li></ul></li></ul></li><li>Nisl lectus nibh habitasse suspendisse ut</li><li><span>Posuere cursus hac, vestibulum wisi nulla bibendum</span></li></ul><h5 class="list-header">Ordered Lists:</h5><ol class="blur"><li><span>Eu non nec cursus quis mollis, amet quam nec</span></li><li><span>Et suspendisse, adipiscing fringilla ornare sit ligula sed</span><ol><li><span>Interdum et justo nulla</span><ol><li><span>Magna amet, suscipit suscipit non amet</span></li></ol></li></ol></li><li><span>Metus duis eu non eu ridiculus turpis</span></li><li><span>Neque egestas id fringilla consectetuer justo curabitur, wisi magna neque commodo volutpat</span></li></ol><div class="accent">Important text fragment. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</div></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll color-widget" ba-panel-title="Text Color"><div class="section-block red-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p></div><div class="section-block yellow-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula ut id elit. In sed ornare nulla.</p></div><div class="section-block links"><p>Lorem ipsum <a href="">dolor</a> sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis <a href="">ullamcorper</a> ligula sodales at. Nulla tellus elit, varius non commodo eget, <a href="">mattis</a> vel eros. In sed ornare nulla.</p></div><div class="section-block links"><p><a href="">Active link \u2014 #209e91</a></p><p class="hovered"><a href="">Hover link \u2014 #17857a</a></p></div></div></div></div><div class="row-fluid"><div class="col-lg-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="banner-column-panel"><div class="banner"><div class="large-banner-wrapper"><img ng-src="{{::( \'app/typography/banner.png\' | appImage )}}" alt=""></div><div class="banner-text-wrapper"><div class="banner-text"><h1>Simple Banner Text</h1><p>Lorem ipsum dolor sit amet</p><p>Odio amet viverra rutrum</p></div></div></div><div class="section"><h2>Columns</h2><div class="row"><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo03.png\' | appImage )}}" alt="" title=""></div><p>Vel elit, eros elementum, id lacinia, duis non ut ut tortor blandit. Mauris <a href="">dapibus</a> magna rutrum. Ornare neque suspendisse <a href="">phasellus wisi</a>, quam cras pede rutrum suspendisse, <a href="">felis amet eu</a>. Congue magna elit quisque quia, nullam justo sagittis, ante erat libero placerat, proin condimentum consectetuer lacus. Velit condimentum velit, sed penatibus arcu nulla.</p></div><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo01.png\' | appImage )}}" alt="" title=""></div><p>Et suspendisse, adipiscing fringilla ornare sit ligula sed, vel nam. Interdum et justo nulla, fermentum lobortis purus ut eu, duis nibh dolor massa tristique elementum, nibh iste potenti risus fusce aliquet fusce, ullamcorper debitis primis arcu tellus vestibulum ac.</p></div></div><div class="separator"></div><div class="row"><div class="col-sm-4"><h4>Column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo04.png\' | appImage )}}" alt=""></div><p>Eget augue, lacus erat ante egestas scelerisque aliquam, metus molestie leo in habitasse magna maecenas</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Yet another column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo05.png\' | appImage )}}" alt=""></div><p>Augue massa et parturient, suspendisse orci nec scelerisque sit, integer nam mauris pede consequat in velit</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Third column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo06.png\' | appImage )}}" alt=""></div><p>Eget turpis, tortor lobortis porttitor, vestibulum nullam vehicula aliquam</p><a href="" class="learn-more">Lean more</a></div></div><div class="separator"></div></div></div></div></div>');
$templateCache.put('app/pages/agendamento/preAgendamento/cadastro/cadastro.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Criar Agendamento</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="form-group"><div ng-show="!error && isAdmin" class="alert">*Digite ou selecione o nome/matricula</div><div ng-show="error" class="alert alert-danger">{{error}}</div><div class="col-md-7"><label for="nome" class="control-label">Nome:</label> <input type="text" class="form-control" id="nome" ng-required="true" ng-model="aluno.nome" ng-if="!isAdmin"><ui-select ng-model="aluno.nome" ng-required="true" ng-if="isAdmin" class="btn-group bootstrap-select form-control" ng-disabled="alunos == null" append-to-body="true" reset-search-input="false" search-enabled="true" close-on-select="true" spinner-enabled="true" on-select="setMatricula($select.selected)"><ui-select-match placeholder="Nome do aluno"><span>{{ $select.selected.nompes }}</span></ui-select-match><ui-select-choices repeat="aluno in alunos" refresh="querySearch($select.search)" refresh-delay="0"><div ng-bind-html="aluno.nompes | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-5"><label for="nome" class="control-label">N\xEDvel:</label> <input type="text" class="form-control" id="nivel" ng-required="true" ng-model="aluno.nivel" ng-if="!isAdmin"><ui-select ng-model="aluno.nivel" ng-required="true" ng-if="isAdmin" class="btn-group bootstrap-select form-control" ng-disabled="niveis == null" append-to-body="true" search-enabled="false" on-select="setAluno($select.selected.nivpgm, aluno.matricula, aluno.area)"><ui-select-match placeholder="N\xEDvel"><span>{{ $select.selected.nivpgm }}</span></ui-select-match><ui-select-choices repeat="nivel in niveis"><div ng-bind-html="nivel.nivpgm"></div></ui-select-choices></ui-select></div></div></div><div class="row"><div class="form-group"><div class="col-md-6"><label for="matricula" class="control-label">Matr\xEDcula</label> <input type="text" class="form-control" id="matricula" ng-required="true" ng-model="aluno.matricula" ng-blur="setNome(aluno.matricula)"></div><div class="col-md-6"><label for="nome" class="control-label">\xC1rea:</label><div><ui-select ng-model="aluno.area" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="areas == null" append-to-body="true" search-enabled="false" on-select="setAluno(aluno.nivel, aluno.matricula, $select.selected.codare)"><ui-select-match><span>{{ $select.selected.nomare }}</span></ui-select-match><ui-select-choices repeat="area in areas"><span>{{area.codare}} - {{area.nomare}}</span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-9"><div class="form-group"><label for="data" class="control-label">Data</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="data" type="text" placeholder="Inicio" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="datePickerOptions" ng-model="aluno.evento.dataAgendamento" is-open="opened" ng-required="true" close-text="Fechar" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-3"><div class="input-group"><label for="data" class="">Periodo</label><ui-select ng-model="aluno.evento.horaAgendamento" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{ aluno.evento.horaAgendamento.nome }}</span></ui-select-match><ui-select-choices repeat="hora in horaAgendamento"><span>{{ hora.nome }}</span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="form-group"><div class="col-md-6"><label for="dataLimite" class="control-label">Data Limite:</label><div class="input-group" ng-controller="datepickerpopupCtrl"><span class="{{ classRed }}">{{ aluno.evento.dataLimite | date: \'dd/MM/yyyy\' }}</span><br></div></div><div class="col-md-6"><label for="dataSolicitacao" class="control-label">Data Solicita\xE7\xE3o:</label><div class="input-group" ng-controller="datepickerpopupCtrl"><span class="">{{ aluno.evento.dataSolicitacao | date: \'dd/MM/yyyy\' }}</span><br></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="anfiteatro" class="control-label">Anfiteatro</label><ui-select ng-model="aluno.evento.anfiteatro" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" on-select="setAnfiteatro($select.selected)"><ui-select-match><span>{{ aluno.evento.anfiteatro.nome }}</span></ui-select-match><ui-select-choices repeat="anfiteatro in anfiteatros"><span>{{ anfiteatro.nome }}</span></ui-select-choices></ui-select></div></div></div></form></div><div class="modal-footer"><button type="button" ng-if="isAdmin" class="btn btn-secondary" ng-click="excluir()" ng-click-options="{preventDoubleClick: true}">{{ BotaoExcluir }}</button> <button type="button" ng-if="isAdmin" class="btn btn-primary" ng-disabled="!cadastroForm.$valid || bloquear" ng-click="salvar()" ng-click-options="{preventDoubleClick: true}">{{ BotaoSalvar }}</button> <button type="button" class="btn btn-secondary" ng-if="!isAdmin"></button></div></div>');
$templateCache.put('app/pages/agendamento/preAgendamento/edicao/editar.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Editar Agendamento</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="form-group"><div class="col-md-7"><label for="nome" class="control-label">Nome:</label> <input type="text" class="form-control" id="nome" ng-required="true" ng-model="aluno.nome" ng-disabled="!isAdmin"></div><div class="col-md-5"><label for="nome" class="control-label">N\xEDvel:</label> <input type="text" class="form-control" id="nivel" ng-required="true" ng-model="aluno.nivel" ng-disabled="!isAdmin"></div></div></div><div class="row"><div class="form-group"><div class="col-md-6"><label for="matricula" class="control-label">Matr\xEDcula</label> <input type="text" class="form-control" id="matricula" ng-required="true" ng-model="aluno.matricula" ng-disabled="!isAdmin"></div><div class="col-md-6"><label for="area" class="control-label">\xC1rea</label> <input type="text" class="form-control" id="area" ng-required="true" ng-model="aluno.area" ng-disabled="!isAdmin"></div></div></div><div class="row"><div class="col-md-9"><div class="form-group"><label for="data" class="control-label">Data</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="data" type="text" placeholder="Inicio" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="datePickerOptions" ng-model="aluno.evento.dataAgendamento" is-open="opened" ng-required="true" close-text="Fechar" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-3"><div class="input-group"><label for="data" class="">Periodo</label><ui-select ng-model="aluno.evento.horaAgendamento" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{ aluno.evento.horaAgendamento }}</span></ui-select-match><ui-select-choices repeat="hora.nome as hora in horaAgendamento"><span>{{ hora.nome }}</span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="form-group"><div class="col-md-6"><label for="dataLimite" class="control-label">Data Limite:</label><div class="input-group" ng-controller="datepickerpopupCtrl"><span class="">{{ aluno.evento.dataLimite | date: \'dd/MM/yyyy\' }}</span><br></div></div><div class="col-md-6"><label for="dataSolicitacao" class="control-label">Data Solicita\xE7\xE3o:</label><div class="input-group" ng-controller="datepickerpopupCtrl"><span class="">{{ aluno.evento.dataSolicitacao | date: \'dd/MM/yyyy\' }}</span><br></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="anfiteatro" class="control-label">Anfiteatro</label><ui-select ng-model="aluno.evento.anfiteatro" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" on-select="setAnfiteatro($select.selected)"><ui-select-match><span>{{ aluno.evento.anfiteatro.id }} {{ aluno.evento.anfiteatro.nome }}</span></ui-select-match><ui-select-choices repeat="anfiteatro in anfiteatros"><span>{{ anfiteatro.nome }}</span></ui-select-choices></ui-select></div></div></div></form></div><div class="modal-footer"><button type="button" ng-if="isAdmin" class="btn btn-secondary" ng-click="excluir()" ng-click-options="{preventDoubleClick: true}">{{ BotaoExcluir }}</button> <button type="button" ng-if="isAdmin" class="btn btn-primary" ng-disabled="!cadastroForm.$valid" ng-click="salvar()" ng-click-options="{preventDoubleClick: true}">{{ BotaoSalvar }}</button> <button type="button" class="btn btn-secondary" ng-if="!isAdmin"></button></div></div>');
$templateCache.put('app/pages/agendamento/relatorios/aluno/aluno.html','<div class="widgets"><div class="row"><div class="col-md-12 agendamento aluno"><div class="panel animated zoomIn" ng-show="aluno != null"><div class="panel-heading clearfix"><h3 class="panel-title">Agendamento de Defesa</h3></div><div class="panel-body footer-panel"><div class="row"><div class="col-md-4 col-xs-6 info"><label>Matr\xEDcula:</label><div>{{ aluno.matricula }}</div></div><div class="col-md-4 col-xs-6 info"><label>Nome:</label><div>{{ aluno.nomeAluno }}</div></div><div class="col-md-4 col-xs-12 info"><label>N\xEDvel:</label><div>{{ aluno.nivel }}</div></div></div><div class="row"><div class="col-md-12 info"><label>\xC1rea de concentra\xE7\xE3o:</label><div>{{ aluno.area }}</div></div></div><div class="row"><div class="col-md-12 info"><label>T\xEDtulo Trabalho:</label><div>{{ aluno.tituloTrabalho }}</div></div></div><div class="row"><div class="col-md-4 col-xs-6 info"><label>Data:</label><div>{{ aluno.dataDefesa | date:\'dd/MM/yyyy\' }}</div></div><div class="col-md-4 col-xs-6 info"><label>Hor\xE1rio:</label><div>{{ aluno.horarioDefesa }}</div></div><div class="col-md-4 col-xs-12 info"><label>Agenda:</label><div>{{ aluno.agendamento }}</div></div></div><div class="row"><div class="col-md-12 info"><label>Anfiteatro:</label><div>{{ aluno.anfiteatro }}</div></div></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/agendamento/relatorios/widgets/agendamentos.html','<div class="row"><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="col-md-6 col-xs-12 info"><label class="custom-radio" ng-repeat="(key, item) in relatorios.agendamentos"><input type="radio" id="agendamentoRelatorios" value="{{ key }}" ng-model="relatorio.opcao"> <span>{{ item.label }}</span></label></div><div class="col-md-6 col-xs-12"><div class="row"><div class="form-group"><label for="de" class="col-md-4 control-label">Per\xEDodo do Exame:</label><div class="col-md-4"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="de" type="text" placeholder="De" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="relatorio.periodo.de" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-4"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="para" type="text" placeholder="At\xE9" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="relatorio.periodo.ate" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="form-group"><label for="nome" class="col-md-4 control-label">Programa:</label><div class="col-md-8"><ui-select ng-model="relatorio.area" class="btn-group bootstrap-select form-control" ng-disabled="areas == null" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ relatorio.area.value }}</span></ui-select-match><ui-select-choices repeat="area in areas"><span>{{ area.value }}</span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="form-group"><label for="nome" class="col-md-4 control-label">Orientador</label><div class="col-md-8"><ui-select ng-model="relatorio.orientador" class="btn-group bootstrap-select form-control" ng-disabled="orientadores == null" append-to-body="true" search-enabled="true" close-on-select="true" spinner-enabled="true"><ui-select-match><span>{{ relatorio.orientador.value }}</span></ui-select-match><ui-select-choices repeat="orientador in orientadores | filter:$select.search"><span>{{ orientador.value }}</span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-danger pull-right" ng-click="limparAgendamentos()">Limpar</button> <button type="button" class="btn btn-default pull-right" ng-click="pesquisarAgendamentos()" style="margin-right: 20px;">Pesquisar</button></div></div></form></div>');
$templateCache.put('app/pages/agendamento/relatorios/widgets/consulta.html','<div class="row"><div class="col-md-12"><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="row"><div class="col-md-12"><div class="form-group"><div class="col-md-3"><label for="nome" class="control-label">Nome do Aluno</label></div><div class="col-md-9"><input type="text" class="form-control" id="nome" ng-model="consulta.nome"></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><div class="col-md-3"><label for="nome" class="control-label">Matr\xEDcula</label></div><div class="col-md-9"><input type="text" class="form-control" id="nome" ng-model="consulta.matricula"></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-danger pull-right" ng-click="limparConsulta()">Limpar</button> <button type="button" class="btn btn-default pull-right" ng-click="pesquisarConsulta(consulta)" style="margin-right: 20px;">Pesquisar</button></div></div></form></div></div>');
$templateCache.put('app/pages/agendamento/preAgendamento/widgets/aceite.html','<div class="col-md-12"><div class="form-group"><label class="control-label">Termos de aceite de agendamento</label><div class="form-control pre-scrollable aceite"><h5><center>INSTRU\xC7\xD5ES PARA AGENDAMENTO DE ANFITEATROS PARA DEFESAS<br>(MESTRADO E DOUTORADO)</center></h5><p>Por delibera\xE7\xE3o da Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o em 14/12/2017 poder\xE3o ser realizadas at\xE9 <strong>seis defesas ao dia</strong>, conforme segue:</p><ul><li>Em at\xE9 <strong>quatro defesas ser\xE1 assegurada a utiliza\xE7\xE3o de becas</strong>, desde que a Defesa ocorra no Pr\xE9dio principal da FMUSP (Anfiteatro da Farmacologia).</li><li>Para as defesas agendadas em anfiteatros externos ao Pr\xE9dio Principal da FMUSP ser\xE1 necess\xE1rio que a Comiss\xE3o Coordenadora do Programa (CCP) designe um respons\xE1vel para a retirada das becas com anteced\xEAncia, e as devolva ao final da defesa na sala de becas da FMUSP(3\xBA andar).</li><li><strong>\xC9 obrigat\xF3rio</strong> que a secretaria do Programa receba a informa\xE7\xE3o, por e-mail, da confirma\xE7\xE3o da reserva em anfiteatros externos ao Pr\xE9dio Principal.</li><li>O crit\xE9rio a ser adotado para disponibiliza\xE7\xE3o das BECAS ser\xE1 a ordem de confirma\xE7\xE3o do agendamento, ou seja, para <strong>quinta e sexta defesa</strong> poder\xE1 n\xE3o haver becas.</li><li>A Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o <strong>realiza reserva exclusivamente para o Anfiteatro de Farmacologia,</strong></li></ul><p>Por delibera\xE7\xE3o da Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o, a defesa s\xF3 poder\xE1 ocorrer, no m\xEDnimo, 30 (trinta) dias a contar da <strong>CONFIRMA\xC7\xC3O</strong>/RESERVA.</p><p>Importante:</p><ul><li>A defesa dever\xE1 ocorrer no m\xE1ximo, at\xE9 90 dias ap\xF3s o cadastramento da Banca pela CPG para os alunos matriculados no Regimento de 2008 e em at\xE9 105 dias para os alunos matriculados no Regimento de 2013.</li></ul><p>Os hor\xE1rios de inicio para realiza\xE7\xE3o das defesas no Anfiteatro da Farmacologia, obrigatoriamente dever\xE3o ser \xE0s 8h00 e 14h00.</p><p>DECLARO que estou ciente que todas as informa\xE7\xF5es referente ao AGENDAMENTO DE ANFITEATROS PARA DEFESAS e que desejo prosseguir a solicita\xE7\xE3o.</p><p>D\xFAvidas e informa\xE7\xF5es dever\xE3o ser obtidas atrav\xE9s do e-mail: <strong>posfm@fm.usp.br</strong></p><label class="col-md-12 align-left"><input ng-model="termos.aceite" type="checkbox" ng-required=""> Li e estou ciente</label></div><sub>*Leia e aceite os termos do final do texto</sub></div></div>');
$templateCache.put('app/pages/agendamento/preAgendamento/widgets/filtros.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Consulta Agendamento de Defesa"><form class="form-horizontal ng-pristine ng-valid ng-scope" ng-submit="pesquisar(agendamento)"><div class="row"><div class="col-md-12"><div class="form-group"><label for="nome" class="col-md-2 control-label">Nome do Aluno</label><div class="col-md-3"><input type="text" class="form-control" id="nome" ng-model="agendamento.nome"></div><label for="de" class="col-md-3 control-label">Per\xEDodo do Exame:</label><div class="col-md-2"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="de" type="text" placeholder="De" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="agendamento.periodo.de" is-open="opened" required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-2"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="para" type="text" placeholder="At\xE9" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="agendamento.periodo.ate" is-open="opened" required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="matricula" class="col-md-2 control-label">Matr\xEDcula</label><div class="col-md-3"><input type="text" class="form-control" id="matricula" ng-model="agendamento.matricula"></div><label for="nome" class="col-md-3 control-label">Programa:</label><div class="col-md-4"><ui-select ng-model="agendamento.area" class="btn-group bootstrap-select form-control" ng-disabled="areas == null" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ agendamento.area.value }}</span></ui-select-match><ui-select-choices repeat="area in areas"><span>{{ area.value }}</span></ui-select-choices></ui-select></div></div></div></div><div class="row"><br></div><div class="row"><br><br><hr><br><br></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <input type="submit" class="btn btn-default pull-right" style="margin-right: 20px;" value="Pesquisar"></div></div></form></div><response-message msg="mensagem" voltar="true"></response-message></div></div>');
$templateCache.put('app/pages/alunos/dadosBasicos/widgets/agendamento.html','<div class="row"><div class="col-md-4 col-xs-6 info"><label>Data:</label><div>{{ aluno.agendamento.dataDefesa | date:\'dd/MM/yyyy\' }}</div></div><div class="col-md-4 col-xs-6 info"><label>Hor\xE1rio:</label><div>{{ aluno.agendamento.horarioDefesa }}</div></div><div class="col-md-4 col-xs-12 info"><label>Agenda:</label><div>{{ aluno.agendamento.agendamento }}</div></div></div><div class="row"><div class="col-md-12 info"><label>Anfiteatro:</label><div>{{ aluno.agendamento.anfiteatro }}</div></div></div>');
$templateCache.put('app/pages/alunos/dadosBasicos/widgets/complemento.html','<div class="row"><div class="col-md-12"><label>Endere\xE7os:</label></div><div class="col-md-12 table-responsive info"><table class="table"><thead><tr class="black-muted-bg"><th>Tipo</th><th>Endere\xE7o</th><th>N\xFAmero</th><th>Complemento</th><th>CEP</th><th>Bairro</th><th>Cidade</th><th>Estado</th><th>Pa\xEDs</th></tr></thead><tbody><tr ng-repeat="endereco in aluno.enderecos"><td>{{ endereco.tipo }}</td><td>{{ endereco.logradouro }}</td><td>{{ endereco.numero }}</td><td>{{ endereco.complemento }}</td><td>{{ endereco.cep }}</td><td>{{ endereco.bairro }}</td><td>{{ endereco.cidade }}</td><td>{{ endereco.estado }}</td><td>{{ endereco.pais }}</td></tr></tbody></table></div></div><div class="row"><div class="col-md-12"><label>Telefones:</label></div><div class="col-md-4 table-responsive info"><table class="table"><thead><tr class="black-muted-bg"><th>Tipo</th><th>N\xFAmero</th><th>Ramal</th></tr></thead><tbody><tr ng-repeat="telefone in aluno.telefones"><td>{{ telefone.tipo }}</td><td>{{ telefone.numero }}</td><td><span ng-if="telefone.tipo == \'BIP\'">*</span>{{ telefone.ramal }}</td></tr></tbody></table></div><div class="col-md-12" ng-if="telefone.tipo == \'BIP\'"><label>* Valores referentes ao C\xF3digo do BIP</label></div></div>');
$templateCache.put('app/pages/alunos/dadosBasicos/widgets/dadosBasicos.html','<div class="row"><div class="col-md-6 col-xs-6 info"><label>Nome da M\xE3e:</label><div>{{ aluno.complemento.nomeMae }}</div></div><div class="col-md-6 col-xs-6 info"><label>Nome do Pai:</label><div>{{ aluno.complemento.nomePai }}</div></div></div><div class="row"><div class="col-md-3 col-xs-6 info"><label>Data Nascimento:</label><div>{{ aluno.nascimento.data }}</div></div><div class="col-md-3 col-xs-6 info"><label>Cidade:</label><div>{{ aluno.nascimento.cidade }}</div></div><div class="col-md-3 col-xs-6 info"><label>UF:</label><div>{{ aluno.nascimento.estado }}</div></div><div class="col-md-3 col-xs-6 info"><label>Outra UF:</label><div>{{ aluno.nascimento.outroEstado }}</div></div></div><hr><div class="row"><div class="col-md-3 col-xs-6 info"><label>Pa\xEDs:</label><div>{{ aluno.nascimento.pais }}</div></div><div class="col-md-3 col-xs-6 info"><label>Sexo:</label><div>{{ aluno.complemento.sexo }}</div></div><div class="col-md-3 col-xs-6 info"><label>Estado Civil:</label><div>{{ aluno.complemento.estadoCivil }}</div></div><div class="col-md-3 col-xs-6 info"><label>CPF:</label><div ng-if="aluno.complemento.cpf">{{ aluno.complemento.cpf | cpfFormat }}</div></div></div><hr><div class="row"><div class="col-md-3 col-xs-6 info"><label>Tipo de Documento:</label><div>{{ aluno.documento.tipo }}</div></div><div class="col-md-3 col-xs-6 info"><label>N\xFAmero:</label><div>{{ aluno.documento.numero }}</div></div><div class="col-md-2 col-xs-6 info"><label>Org\xE3o Expeditor:</label><div>{{ aluno.documento.orgaoExpeditor }}</div></div><div class="col-md-2 col-xs-6 info"><label>UF:</label><div>{{ aluno.documento.estado }}</div></div><div class="col-md-2 col-xs-6 info"><label>Expedi\xE7\xE3o:</label><div>{{ aluno.documento.expedicao }}</div></div></div><hr><div class="row"><div class="col-md-6 col-xs-12 info"><label>E-mails:</label><div class="table-responsive info"><table class="table"><thead><tr class="black-muted-bg"><th>E-mail</th><th>USP?</th></tr></thead><tbody><tr ng-repeat="email in aluno.emails"><td>{{ email.email }}</td><td>{{ email.usp }}</td></tr></tbody></table></div></div><div class="col-md-3 col-xs-6 info"><label>\xC1rea de concentra\xE7\xE3o:</label><div>{{ aluno.area }}</div></div><div class="col-md-3 col-xs-12 info"><label>N\xEDvel:</label><div>{{ aluno.nivel }}</div></div></div>');
$templateCache.put('app/pages/alunos/dadosBasicos/widgets/diploma.html','<br><div class="widgets"><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="row"><div class="col-md-12"><label for="dtpronto" class="col-md-3 control-label">Data Pronto:</label><div class="col-md-9"><div class="input-group sidebar" ng-controller="datepickerpopupCtrl"><input id="dtpronto" type="text" placeholder="{{aluno.diploma == null? \'Data Pronto\' : aluno.diploma.dtpronto | date:\'dd/MM/yyyy\' }}" class="form-control" ng-click="clear(\'#dtpronto\');open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="aluno.diploma.dtpronto" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="clear(\'#dtpronto\');open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><label for="dtretirada" class="col-md-3 control-label">Data Retirada:</label><div class="col-md-9"><div class="input-group sidebar" ng-controller="datepickerpopupCtrl"><input id="dtretirada" type="text" placeholder="{{aluno.diploma == null? \'Data Retirada\' : aluno.diploma.dtretirada | date:\'dd/MM/yyyy\' }}" class="form-control" ng-click="clear(\'#dtretirada\');open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="aluno.diploma.dtretirada" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="clear(\'#dtretirada\');open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><label for="dpantigo" class="col-md-3 control-label">Observa\xE7\xE3o:</label><div class="col-md-9"><div class="input-group"><textarea class="form-control" id="obs" ng-model="aluno.diploma.obs" placeholder="Observa\xE7\xE3o" style="resize:none">\r\n\t\t\t\t\t\t</textarea></div></div><br></div></div><br><br><div class="row"><div class="col-md-12"><input type="reset" class="btn btn-danger pull-right" value="Limpar"> <button type="button" class="btn btn-default pull-right" ng-click="salvarDiploma(aluno)" style="margin-right: 20px;">Salvar</button></div></div></form></div>');
$templateCache.put('app/pages/alunos/dadosBasicos/widgets/documentos.html','<div class="row"><div class="col-md-12 table-responsive info"><table class="table"><thead><tr class="black-muted-bg"><th>Institui\xE7\xE3o</th><th>Titulo Obtido</th><th>Cidade</th><th>Estado</th><th>Outro Estado</th><th>Pa\xEDs</th><th>Data Obten\xE7\xE3o T\xEDtulo</th><th>Data Inscri\xE7\xE3o</th></tr></thead><tbody><tr ng-repeat="instituicao in aluno.instituicoes"><td>{{ instituicao.instituicao }}</td><td>{{ instituicao.tituloObtido }}</td><td>{{ instituicao.cidade }}</td><td>{{ instituicao.estado }}</td><td>{{ instituicao.outroEstado }}</td><td>{{ instituicao.pais }}</td><td>{{ instituicao.dataObtencaoTitulo | date:\'d/M/y\' }}</td><td>{{ instituicao.dataInscricao | date:\'d/M/y\' }}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/alunos/relatorios/widgets/listagens.html','<div class="row"><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="col-md-6 col-xs-12 info"><label class="custom-radio" ng-repeat="(key, item) in relatorios.listagens"><input type="radio" id="listagensRelatorios" value="{{ key }}" ng-model="relatorio.listagens.opcao"> <span>{{ item.label }}</span></label></div><div class="col-md-6 col-xs-12"><div class="col-md-12 col-xs-12"><div class="row"><div class="form-group"><label for="de" class="col-md-4 control-label">Data da Matricula:</label><div class="col-md-4"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="periodo-de" type="text" placeholder="De" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="relatorio.listagens.matricula.de" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-4"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="periodo-para" type="text" placeholder="At\xE9" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="relatorio.listagens.matricula.ate" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="form-group"><label for="nome" class="col-md-4 control-label">\xC1rea</label><div class="col-md-8"><ui-select ng-model="relatorio.listagens.area" class="btn-group bootstrap-select form-control" ng-disabled="areas == null" append-to-body="true" search-enabled="false" close-on-select="true" spinner-enabled="true" on-select="getOrientadores($item)"><ui-select-match><span>{{ relatorio.listagens.area.value }}</span></ui-select-match><ui-select-choices repeat="area in areas"><span>{{ area.value }}</span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="form-group"><label for="nome" class="col-md-4 control-label">Orientador</label><div class="col-md-8"><ui-select ng-model="relatorio.listagens.orientador" class="btn-group bootstrap-select form-control" ng-disabled="orientadores == null" append-to-body="true" search-enabled="true" close-on-select="true" spinner-enabled="true"><ui-select-match><span>{{ relatorio.listagens.orientador.value }}</span></ui-select-match><ui-select-choices repeat="orientador in orientadores | filter:$select.search"><span>{{ orientador.value }}</span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="form-group"><label for="nome" class="col-md-4 control-label">Situa\xE7\xE3o do Aluno</label><div class="col-md-8"><ui-select ng-model="relatorio.listagens.situacao" class="btn-group bootstrap-select form-control" ng-disabled="situacoes == null || relatorio.listagens.opcao == \'relatorio.listagens.numeroAlunosRegularmenteMatriculadosPorArea\'" append-to-body="true" search-enabled="false" close-on-select="true" spinner-enabled="true"><ui-select-match><span>{{ relatorio.listagens.situacao.value }}</span></ui-select-match><ui-select-choices repeat="situacao in situacoes"><span>{{ situacao.value }}</span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-default pull-right" ng-click="pesquisarListagens()" style="margin-right: 20px;">Pesquisar</button></div></div></div></form></div>');
$templateCache.put('app/pages/alunos/relatorios/widgets/periodo.html','<div class="row"><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="col-md-5 col-xs-12 info"><label class="custom-radio" ng-repeat="(key, item) in relatorios.periodo"><input type="radio" id="periodoRelatorios" value="{{ key }}" ng-model="relatorio.periodo.opcao"> <span>{{ item.label }}</span></label></div><div class="col-md-7 col-xs-12"><div class="row"><div class="form-group"><label for="de" class="col-md-4 control-label">Per\xEDodo:</label><div class="col-md-4"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="de" type="text" placeholder="De" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="relatorio.periodo.periodo.de" is-open="opened" ng-required="true" close-text="Close" ng-disabled="relatorio.periodo.opcao == \'relatorio.periodo.semExameQualificacao\'" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-4"><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="para" type="text" placeholder="At\xE9" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="relatorio.periodo.periodo.ate" is-open="opened" ng-required="true" close-text="Close" ng-disabled="relatorio.periodo.opcao == \'relatorio.periodo.semExameQualificacao\'" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="form-group"><label for="nome" class="col-md-4 control-label">\xC1rea</label><div class="col-md-8"><ui-select ng-model="relatorio.periodo.area" class="btn-group bootstrap-select form-control" ng-disabled="areas == null" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ relatorio.periodo.area.value }}</span></ui-select-match><ui-select-choices repeat="area in areas"><span>{{ area.value }}</span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-default pull-right" ng-click="pesquisarPeriodo()" style="margin-right: 20px;">Pesquisar</button></div></div></form></div>');
$templateCache.put('app/pages/alunos/situacao/documentos/ataExqua.html','<div class="widgets"><div class="row"><div class="col-md-12"><response-message msg="mensagem" voltar="true"></response-message><div id="ata-exqua" class="panel animated zoomIn" ng-show="ataExqua != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><thead ng-include="\'app/pages/alunos/header.html\'"></thead><tbody><tr><td><h2>Ata de Exame de Qualifica\xE7\xE3o</h2></td></tr><tr><td class="texto-principal">O(A) aluno(a) <strong>{{ ataExqua.nomeAluno }}</strong> - matr\xEDcula <strong>{{ ataExqua.matricula }}</strong> - curso de <strong>{{ ataExqua.grauAcademico }}</strong> {{ ataExqua.areaDeclaracao }} {{ ataExqua.area }}, submeteu-se ao exame de qualifica\xE7\xE3o, perante a Comiss\xE3o Examinadora, atendendo ao disposto no Regimento da P\xF3s-Gradua\xE7\xE3o da Universidade de S\xE3o Paulo.</td></tr><tr><td class="texto-principal">A Comiss\xE3o Examinadora, indicada pela Comiss\xE3o Coordenadora do Programa, \xE9 de parecer que:</td></tr><tr><td><hr><hr><hr><hr><hr><hr><hr><hr></td></tr><tr><td><strong>Membros Participantes da Comiss\xE3o Examinadora<br>Assinale com um "X" - Aprovado (APR) ou Reprovado (REP) e assine</strong></td></tr><tr><td>S\xE3o Paulo, <input class="linha pequena" type="textfield"> de <input class="linha media" type="textfield"> de 20<input style="text-align: left;" class="linha pequena" type="textfield"></td></tr><tr><td class="left"><strong><table class="bancada"><tr class="row-bancada" ng-repeat="participante in ataExqua.bancada"><td class="col-bancada" width="15%">(<input class="sub-linha" type="textfield">) APR (<input class="sub-linha" type="textfield">) REP - {{ participante.nome }} - <span style="text-transform: capitalize;">{{ participante.titulo }}</span></td></tr></table></strong></td></tr><tr><td>DATA DE HOMOLOGA\xC7\xC3O PELA CCP <input class="linha pequena" type="textfield">/<input class="linha pequena" type="textfield">/<input class="linha pequena" type="textfield"><br><br><br>COORDENADOR <input class="linha assinatura" type="textfield"><br><span class="assinatura">ASSINATURA</span></td></tr></tbody><tfoot ng-include="\'app/pages/alunos/footer.html\'"></tfoot></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="ataExqua == null" style="margin: -10px 10px;" ng-click="print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/situacao/documentos/bancaDefesa.html','<div class="widgets"><div class="row"><div class="col-md-12"><response-message msg="mensagem"></response-message><div id="banca-defesa" class="panel animated zoomIn" ng-show="bancaDefesa != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><thead ng-include="\'app/pages/alunos/header.html\'"></thead><tbody><tr><td class="left">Senhor(a) Professor(a),</td></tr><tr><td class="texto-principal">Encaminho-lhe a composi\xE7\xE3o da Comiss\xE3o Julgadora da <strong>{{ bancaDefesa.nivel }}</strong> do(a) p\xF3s-graduando(a) <strong>{{ bancaDefesa.nomeAluno }}</strong> devidamente aprovada pelo Sr. Presidente da Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o da FMUSP. Prof. {{ bancaDefesa.nomePresidente }} "ad referendum" em <strong>{{ bancaDefesa.dataProvaBanca }}</strong> , solicitando-lhe a fineza de agendar a data, horario e local.<table class="bancada" ng-if="bancaDefesa.bancada.length > 0 && bancaDefesa.bancada[0].nome != null"><tr class="row-bancada" ng-repeat="participante in bancaDefesa.bancada"><td class="col-bancada">{{ participante.nome }}</td><td class="col-bancada"><span style="text-transform: capitalize;">{{ participante.titulo }}</span></td></tr></table></td></tr><tr><td class="left"><strong>Obs.:</strong> Por delibera\xE7\xE3o da CPG, a defesa s\xF3 pode ocorrer, no m\xEDnimo, 30(trinta) dias a contar da data do agendamento da mesma.</td></tr><tr><td>Atenciosamente,</td></tr><tr><td class="left">Para ci\xEAncia:<br><strong>{{ bancaDefesa.descricaoCargo }}</strong></td></tr></tbody><tfoot ng-include="\'app/pages/alunos/footer.html\'"></tfoot></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="bancaDefesa == null" style="margin: -10px 10px;" ng-click="print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/situacao/documentos/oficios.html','<div class="row"><div class="col-md-6 col-xs-12 info"><div class="button-wrapper"><button type="button" class="btn btn-default" style="width: 150px;" ui-sref="alunos.situacao.documentos.oficios.consultaMembrosAluno">Membros e Aluno</button></div></div><div class="col-md-6 col-xs-12 info"><div class="button-wrapper"><button type="button" class="btn btn-default" style="width: 150px;" ui-sref="alunos.situacao.documentos.oficios.aviso">Aviso</button></div></div></div><div class="row"><div class="col-md-6 col-xs-12 info"><div class="button-wrapper"><button type="button" class="btn btn-default" style="width: 150px;" ui-sref="alunos.situacao.documentos.oficios.declaracao">Declara\xE7\xE3o</button></div></div><div class="col-md-6 col-xs-12 info"><div class="button-wrapper"><button type="button" class="btn btn-default" style="width: 150px;" ui-sref="alunos.situacao.documentos.oficios.ata">Ata</button></div></div></div><div class="row"><div class="col-md-6 col-xs-12 info"><div class="button-wrapper"><button type="button" class="btn btn-default" style="width: 150px;" ui-sref="alunos.situacao.documentos.oficios.diploma">Diploma</button></div></div><div class="col-md-6 col-xs-12 info"><div class="button-wrapper"><button type="button" class="btn btn-default" style="width: 150px;" ui-sref="alunos.situacao.documentos.oficios.consultaCertificado">Certificado</button></div></div></div><div class="row"><div class="col-md-6 col-xs-12 info"><div class="button-wrapper"><button type="button" class="btn btn-default" style="width: 150px;" ui-sref="alunos.situacao.documentos.bancaDefesa">Banca de Defesa</button></div></div><div class="col-md-6 col-xs-12 info"><div class="button-wrapper"><button type="button" class="btn btn-default" style="width: 150px;" ui-sref="alunos.situacao.documentos.ataExqua">Ata Exqua</button></div></div></div><div class="row"><div class="col-md-6 col-xs-12 info"><div class="button-wrapper"><button type="button" class="btn btn-default" style="width: 150px;" ui-sref="alunos.situacao.documentos.recibo">Recibo</button></div></div></div>');
$templateCache.put('app/pages/alunos/situacao/documentos/recibo.html','<div class="widgets"><div class="row"><div class="col-md-12"><response-message msg="mensagem"></response-message><div id="recibo" class="panel animated zoomIn" ng-show="recibo != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><thead ng-include="\'app/pages/alunos/header.html\'"></thead><tbody><tr><th class="center" colspan="3"><strong>Diploma e Hist\xF3rico de P\xF3s-Gradua\xE7\xE3o<br>Comprovante de Retirada</strong></th></tr><tr><td class="left">&nbsp;</td></tr><tr><td class="texto-principal">O p\xF3s-graduando {{recibo.nome}} retirou o diploma e o hist\xF3rico escolar de {{recibo.nivel}}, nesta data.</td></tr><tr><td class="left">&nbsp;</td></tr><tr><td class="left"><strong>Observa\xE7\xF5es:</strong></td></tr><tr><td class="left">(&nbsp;&nbsp;&nbsp;) enviado para corre\xE7\xE3o</td></tr><tr><td class="left">&nbsp;</td></tr><tr><td class="left">{{recibo.dataExtenso}}</td></tr><tr><td class="center"><table border="0" cellpadding="0" cellspacing="0"><tr><td>&nbsp;</td><td width="300" height="10" class="assinatura">&nbsp;</td><td>&nbsp;</td></tr><tr><td>&nbsp;</td><td width="300" height="20"><strong>{{recibo.nome}}</strong></td><td>&nbsp;</td></tr></table></td></tr></tbody><tfoot ng-include="\'app/pages/alunos/footer.html\'"></tfoot></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="recibo == null" style="margin: -10px 10px;" ng-click="print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/situacao/widgets/complemento.html','<div class="row"><div class="col-md-12 col-xs-12 info"><label>Institui\xE7\xE3o:</label><div>{{ aluno.instituicao }}</div></div></div><div class="row"><div class="col-md-6 col-xs-6 info"><label>\xC1rea:</label><div>{{ aluno.area }}</div></div><div class="col-md-6 col-xs-6 info"><label>Data de Obten\xE7\xE3o do T\xEDtulo Mestre:</label><div>{{ aluno.resumo.dataObtencaoTituloMestre }}</div></div></div><hr><div class="row"><div class="col-md-3 col-xs-6 info"><label>Data de Inicio:</label><div>{{ aluno.resumo.dataInicio }}</div></div><div class="col-md-3 col-xs-6 info"><label>Prazo Final:</label><div>{{ aluno.resumo.prazoFinal }}</div></div><div class="col-md-3 col-xs-6 info"><label>Data de Matr\xEDcula:</label><div>{{ aluno.resumo.dataMatricula }}</div></div><div class="col-md-3 col-xs-6 info"><label>Resolu\xE7\xE3o:</label><ui-select ng-model="aluno.portaria" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false" on-select="setPortaria($select.selected,aluno)"><ui-select-match><span>{{ aluno.portaria.lei }}</span></ui-select-match><ui-select-choices repeat="portaria in aluno.portarias"><span>{{ portaria.lei }}</span></ui-select-choices></ui-select></div></div><div class="row"><div class="col-md-12 col-xs-12 info"><label>Data de Transfer\xEAncia do N\xEDvel:</label><div>{{ aluno.dataTransferenciaNivel }}</div></div></div><hr><div class="row"><div class="col-md-6 col-xs-6 info"><label>Orientador:</label><div>{{ aluno.resumo.orientador }}</div></div><div class="col-md-6 col-xs-6 info"><label>Programa:</label><div>{{ aluno.programa }}</div></div></div><div class="row"><div class="col-md-6 col-xs-6 info"><label>Co-Orientador:</label><div>{{ aluno.resumo.coOrientador }}</div></div><div class="col-md-6 col-xs-6 info"><label>Data de Entrada (Co-orientador):</label><div>{{ aluno.resumo.dataEntrada }}</div></div></div><hr><div class="row"><div class="col-md-12 col-xs-12 info"><label>Trancamentos:</label><div class="table-responsive info"><table class="table"><thead><tr class="black-muted-bg"><th>Trancamento</th><th>N\xFAmero de dias</th><th>Data (Inicio do Trancamento)</th><th>Data (Retorno do Trancamento)</th></tr></thead><tbody><tr ng-repeat="trancamento in aluno.trancamentos"><td>{{ trancamento.trancamento }}</td><td>{{ trancamento.numeroDias }}</td><td>{{ trancamento.dataInicio }}</td><td>{{ trancamento.dataRetorno }}</td></tr></tbody></table></div></div></div><hr><div class="row"><div class="col-md-4 col-xs-6 info"><label>Prorroga\xE7\xE3o do Prazo:</label><div>{{ aluno.prorrogacaoPrazo }}</div></div><div class="col-md-4 col-xs-6 info"><label>N\xFAmero de dias:</label><div>{{ aluno.numeroDias }}</div></div><div class="col-md-4 col-xs-6 info"><label>Data Inicio da Prorroga\xE7\xE3o:</label><div>{{ aluno.dataInicioProrrogacao }}</div></div></div>');
$templateCache.put('app/pages/alunos/situacao/widgets/dadosBasicos.html','<div class="row"><div class="col-md-3 col-xs-6 info"><label>\xC1rea de concentra\xE7\xE3o:</label><div>{{ aluno.area }}</div></div><div class="col-md-3 col-xs-12 info"><label>N\xEDvel:</label><div>{{ aluno.nivel }}</div></div><div class="col-md-3 col-xs-6 info"><label>Aluno Especial:</label><div>{{ aluno.alunoEspecial }}</div></div><div class="col-md-3 col-xs-12 info"><label>M\xE9dia Profici\xEAncia:</label><div>{{ aluno.mediaProficiencia }}</div></div></div><div class="row"><div class="col-md-4 col-xs-6 info"><label>Mestrado Anterior:</label><div>{{ aluno.resumo.mestradoAnterior }}</div></div><div class="col-md-4 col-xs-12 info"><label>Data de Reconhecimento de T\xEDtulo:</label><div>{{ aluno.dataReconhecimentoTitulo }}</div></div></div><hr><div class="row"><div class="col-md-6 col-xs-12 info"><label>E-mails:</label><div class="table-responsive info"><table class="table"><thead><tr class="black-muted-bg"><th>E-mail</th><th>USP?</th></tr></thead><tbody><tr ng-repeat="email in aluno.emails"><td>{{ email.email }}</td><td>{{ email.usp }}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/alunos/situacao/widgets/diploma.html','<br><div class="row"><div class="col-md-6"><label for="dtpedido" class="control-label">Diploma - Pedido:</label><div ng-if="isAdmin"><div class="input-group sidebar" ng-controller="datepickerpopupCtrl"><input id="dtpedido" type="text" placeholder="{{aluno.diploma.dtpedido == null? \'Data Pronto\' : aluno.diploma.dtpedido | date:\'dd/MM/yyyy\' }}" class="form-control" ng-click="clear(\'#dtpedido\');open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="aluno.diploma.dtpedido" is-open="opened" ng-required="true" close-text="Close" ng-blur="salvarDatasDiploma(aluno)" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="clear(\'#dtpedido\');open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div ng-if="!isAdmin">{{ aluno.diploma.dtpedido | date:\'dd/MM/yyyy\' }}</div></div><div class="col-md-6"><label for="dtpronto" class="control-label">Diploma - Pronto:</label><div ng-if="isAdmin"><div class="input-group sidebar" ng-controller="datepickerpopupCtrl"><input id="dtpronto" type="text" placeholder="{{aluno.diploma.dtpronto == null? \'Data Pronto\' : aluno.diploma.dtpronto | date:\'dd/MM/yyyy\' }}" class="form-control" ng-click="clear(\'#dtpronto\');open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="aluno.diploma.dtpronto" is-open="opened" ng-required="true" close-text="Close" ng-blur="salvarDatasDiploma(aluno)" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="clear(\'#dtpronto\');open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div ng-if="!isAdmin">{{ aluno.diploma.dtpronto | date:\'dd/MM/yyyy\' }}</div></div></div><div class="row"><div class="col-md-6"><label for="dtretirada" class="control-label">Diploma - Entregue:</label><div ng-if="isAdmin"><div class="input-group sidebar" ng-controller="datepickerpopupCtrl"><input id="dtretirada" type="text" placeholder="{{aluno.diploma.dtretirada == null? \'Data Entregue\' : aluno.diploma.dtretirada | date:\'dd/MM/yyyy\' }}" class="form-control" ng-click="clear(\'#dtretirada\');open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="aluno.diploma.dtretirada" is-open="opened" ng-required="true" close-text="Close" ng-blur="salvarDatasDiploma(aluno)" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="clear(\'#dtretirada\');open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div ng-if="!isAdmin">{{ aluno.diploma.dtretirada | date:\'dd/MM/yyyy\' }}</div></div></div>');
$templateCache.put('app/pages/alunos/situacao/widgets/disciplinas.html','<div class="row"><div class="col-md-6 col-xs-6 info"><label>Data de Entrega (Plano de Pesquisa):</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dataEnt" type="text" placeholder="{{aluno.pesquisa.dataEntrega | date:\'dd/MM/yyyy\' || \'Data de Entrega\'}}" class="form-control" ng-click="clear(\'#dataEnt\');open();" uib-datepicker-popup="dd/MM/yyyy" date-disabled="disabled(date, mode)" datepicker-options="dateOptions" ng-model="aluno.pesquisa.dataEntrega" is-open="opened" ng-blur="salvarPlanoPesquisa(aluno)" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="clear(\'#dataEnt\');open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-6 col-xs-6 info"><label>T\xEDtulo Plano de Pesquisa:</label><div><input type="text" class="form-control" ng-blur="salvarPlanoPesquisa(aluno)" ng-model="aluno.pesquisa.titulo"></div></div></div><div class="diploma" ng-include="\'app/pages/alunos/situacao/widgets/diploma.html\'"></div><hr><div class="row"><div class="col-md-12"><label>Disciplinas:</label></div><div class="col-md-12 table-responsive info"><table class="table"><thead><tr class="black-muted-bg"><th>Disciplinas</th><th>Descri\xE7\xE3o</th><th>Cr\xE9ditos</th><th>Conceito</th></tr></thead><tbody><tr ng-repeat="disciplina in aluno.disciplinas"><td>{{ disciplina.disciplina }}</td><td align="left">{{ disciplina.descricao }}</td><td>{{ disciplina.creditos.obtidos }}</td><td>{{ disciplina.conceito }}</td></tr></tbody></table></div></div><div class="row"><div class="col-md-6 col-xs-6 info"><label>Exigidos:</label><div>{{ aluno.exigidos }}</div></div><div class="col-md-6 col-xs-6 info"><label>Obtidos:</label><div>{{ aluno.obtidos }}</div></div></div><hr><div class="row"><div class="col-md-6 col-xs-6 info"><label>Data (Declara\xE7\xE3o de Apto):</label><div>{{ aluno.dataDeclaracaoApto }}</div></div><div class="col-md-6 col-xs-6 info"><label>Data (Exame Qualifica\xE7\xE3o):</label><div>{{ aluno.resumo.dataExameQualificacao }}</div></div></div><div class="row"><div class="col-md-6 col-xs-6 info"><label>Data (Dep\xF3sito do Trabalho):</label><div>{{ aluno.resumo.dataDepositoTrabalho }}</div></div><div class="col-md-6 col-xs-6 info"><label>T\xEDtulo do Trabalho:</label><div>{{aluno.resumo.tituloTrabalho}}</div></div></div><div class="row"><div class="col-md-12 col-xs-12 info"><label>Situa\xE7\xE3o do Aluno:</label><div>{{ aluno.situacao }}</div></div></div>');
$templateCache.put('app/pages/alunos/situacao/widgets/documentos.html','<div class="row"><div class="col-md-12"><label>Institui\uFFFD\uFFFDes:</label></div><div class="col-md-12 table-responsive info"><table class="table"><thead><tr class="black-muted-bg"><th>Institui\uFFFD\uFFFDo</th><th>Titulo Obtido</th><th>Cidade</th><th>Estado</th><th>Outro Estado</th><th>Pa\uFFFDs</th><th>Data Obten\uFFFD\uFFFDo T\uFFFDtulo</th><th>Data Inscri\uFFFD\uFFFDo</th><th>Especial</th></tr></thead><tbody><tr ng-repeat="instituicao in aluno.instituicoes"><td>{{ instituicao.instituicao }}</td><td>{{ instituicao.tituloObtido }}</td><td>{{ instituicao.cidade }}</td><td>{{ instituicao.estado }}</td><td>{{ instituicao.outroEstado }}</td><td>{{ instituicao.pais }}</td><td>{{ instituicao.dataObtencaoTitulo | date:\'d/M/y\' }}</td><td>{{ instituicao.dataInscricao | date:\'d/M/y\' }}</td><td>{{ instituicao.especial }}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/charts/amCharts/areaChart/areaChart.html','<div id="areaChart" class="admin-chart" ng-controller="AreaChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/barChart/barChart.html','<div id="barChart" class="admin-chart" ng-controller="BarChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/combinedChart/combinedChart.html','<div id="zoomAxisChart" class="admin-chart" ng-controller="combinedChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/funnelChart/funnelChart.html','<div id="funnelChart" class="admin-chart" ng-controller="FunnelChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/ganttChart/ganttChart.html','<div id="gnattChart" class="admin-chart" ng-controller="ganttChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/lineChart/lineChart.html','<div id="lineChart" class="admin-chart" ng-controller="LineChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/pieChart/pieChart.html','<div id="pieChart" class="admin-chart" ng-controller="PieChartCtrl"></div>');
$templateCache.put('app/pages/components/mail/composeBox/compose.html','<div class="compose-header"><span>New message</span> <span class="header-controls"><i class="ion-minus-round"></i> <i class="ion-arrow-resize"></i> <i ng-click="$dismiss()" class="ion-close-round"></i></span></div><div><input type="text" class="form-control compose-input default-color" placeholder="To" ng-model="boxCtrl.to"> <input type="text" class="form-control compose-input default-color" placeholder="Subject" ng-model="boxCtrl.subject"><div class="compose-container"><text-angular-toolbar ta-toolbar-class="toolbarMain" name="toolbarMain" ta-toolbar="[[\'h1\',\'h2\',\'h3\',\'bold\',\'italics\', \'underline\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\']]"></text-angular-toolbar><text-angular name="htmlcontent" ta-target-toolbars="toolbarMain,toolbarFooter" ng-model="boxCtrl.text"></text-angular></div></div><div class="compose-footer clearfix"><button type="button" ng-click="$dismiss()" class="btn btn-send">Send</button><text-angular-toolbar ta-toolbar-class="toolbarFooter" name="toolbarFooter" ta-toolbar="[[\'insertLink\', \'insertImage\', \'html\', \'quote\',\'insertVideo\']]"></text-angular-toolbar><div class="footer-controls"><i class="footer-control-first compose-footer-icon ion-arrow-down-b"></i> <i ng-click="$dismiss()" class="compose-footer-icon ion-android-delete"></i></div></div>');
$templateCache.put('app/pages/components/mail/detail/mailDetail.html','<div class="message-container" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="message"><div class="row"><div class="toggle-navigation-container detail-page"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><button ui-sref="components.mail.label({label : detailCtrl.label})" type="button" class="back-button btn btn-default btn-with-icon"><i class="ion-chevron-left"></i>Back</button></div><div class="person-info row"><div class="col-lg-4 col-md-12 no-padding"><img ng-src="{{detailCtrl.mail.name.split(\' \')[0] | profilePicture}}" class="human-picture"><div class="name"><h2 class="name-h">{{detailCtrl.mail.name.split(\' \')[0]}}</h2><h2 class="name-h second-name">{{detailCtrl.mail.name.split(\' \')[1]}}</h2><div><span class="mail-tag tag label {{detailCtrl.mail.tag}}">{{detailCtrl.mail.tag}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info phone-email"><div><i class="ion-iphone"></i> <span class="phone">777-777-7777</span></div><div><i class="ion-email"></i> <span class="email">{{detailCtrl.mail.email}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info position-address"><div><span class="position">{{detailCtrl.mail.position}}</span></div><div><span class="address">12 Nezavisimosti st. Vilnius, Lithuania</span></div></div></div></div><div class="row"></div><div class="line"></div><div class="message-details"><span class="subject">{{detailCtrl.mail.subject}}</span> <span class="date">\u2022 {{detailCtrl.mail.date | date : \'h:mm a MMMM d \'}}</span></div><div class="line"></div><div ng-bind-html="detailCtrl.mail.body" class="message-body"></div><div class="line"></div><div class="attachment" ng-show="detailCtrl.mail.attachment"><span class="file-links">1 Attachment - <a href="">View</a> | <a href="">Download</a></span><div><i class="file-icon ion-document"></i> <span class="file-name">{{detailCtrl.mail.attachment}}</span></div></div><div class="line" ng-show="detailCtrl.mail.attachment"></div><div class="answer-container"><button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,detailCtrl.mail.email,\'\')"><i class="ion-reply"></i>Reply</button> <button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,\'\',detailCtrl.mail.body)"><i class="ion-forward"></i>Forward</button> <button type="button" class="btn btn-with-icon"><i class="ion-printer"></i>Print</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-remove-circle"></i>Spam</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-delete"></i>Delete</button></div></div><div ng-show="!detailCtrl.mail"><h5 ng-class="text-center">Nothing to show</h5></div></div>');
$templateCache.put('app/pages/components/mail/list/mailList.html','<div class="side-message-navigation" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="mail-messages-control side-message-navigation-item"><div class="toggle-navigation-container"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span class="select-all-label">Select All</span></label> <button type="button" class="btn btn-icon refresh-button"><i class="ion-refresh"></i></button><div class="btn-group" uib-dropdown=""><button type="button" class="btn more-button" uib-dropdown-toggle="">More <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="messages"><table><tr ng-repeat="m in listCtrl.messages track by m.id | orderBy:\'-date\'" class="side-message-navigation-item little-human shineHover {{m.tag}}"><td class="check-td"><div class="mail-checkbox"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox"> <span></span></label></div></td><td class="photo-td" ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><img ng-src="{{m.name.split(\' \')[0] | profilePicture}}" class="little-human-picture"></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="name-container"><div><span class="name">{{m.name}}</span></div><div><span class="tag label label-primary {{m.tag}}">{{m.tag}}</span></div></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="additional-info"><span class="subject">{{m.subject}}</span></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="mail-body-part">{{m.body | plainText}}</div></td><td class="date"><span>{{m.date | date : \'MMM d HH:mm\'}}</span></td></tr></table></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/checkboxesRadios.html','<div class="checkbox-demo-row"><div class="input-demo checkbox-demo row"><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span>Check 1</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox02" value="option2"> <span>Check 2</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Check 3</span></label></div></div><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Option 1</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> <span>Option 2</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> <span>Option3</span></label></div></div></div><div><div class="checkbox disabled"><label class="custom-checkbox nowrap"><input type="checkbox" value="" disabled=""> <span>Checkbox is disabled</span></label></div><div class="radio disabled"><label class="custom-radio nowrap"><input type="radio" name="optionsRadios" id="optionsRadios3" value="option3" disabled=""> <span>Disabled option</span></label></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/inputGroups.html','<div class="input-group"><span class="input-group-addon input-group-addon-primary addon-left" id="basic-addon1">@</span> <input type="text" class="form-control with-primary-addon" placeholder="Username" aria-describedby="basic-addon1"></div><div class="input-group"><input type="text" class="form-control with-warning-addon" placeholder="Recipient\'s username" aria-describedby="basic-addon2"> <span class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2">@example.com</span></div><div class="input-group"><span class="input-group-addon addon-left input-group-addon-success">$</span> <input type="text" class="form-control with-success-addon" aria-label="Amount (to the nearest dollar)"> <span class="input-group-addon addon-right input-group-addon-success">.00</span></div><div class="input-group"><input type="text" class="form-control with-danger-addon" placeholder="Search for..."> <span class="input-group-btn"><button class="btn btn-danger" type="button">Go!</button></span></div>');
$templateCache.put('app/pages/form/inputs/widgets/standardFields.html','<form><div class="form-group"><label for="input01">Text</label> <input type="text" class="form-control" id="input01" placeholder="Text"></div><div class="form-group"><label for="input02">Password</label> <input type="password" class="form-control" id="input02" placeholder="Password"></div><div class="form-group"><label for="input03">Rounded Corners</label> <input type="text" class="form-control form-control-rounded" id="input03" placeholder="Rounded Corners"></div><div class="form-group"><label for="input04">With help</label> <input type="text" class="form-control" id="input04" placeholder="With help"> <span class="help-block sub-little-text">A block of help text that breaks onto a new line and may extend beyond one line.</span></div><div class="form-group"><label for="input05">Disabled Input</label> <input type="text" class="form-control" id="input05" placeholder="Disabled Input" disabled=""></div><div class="form-group"><label for="textarea01">Textarea</label> <textarea placeholder="Default Input" class="form-control" id="textarea01"></textarea></div><div class="form-group"><input type="text" class="form-control input-sm" id="input2" placeholder="Small Input"></div><div class="form-group"><input type="text" class="form-control input-lg" id="input4" placeholder="Large Input"></div></form>');
$templateCache.put('app/pages/form/inputs/widgets/validationStates.html','<div class="form-group has-success"><label class="control-label" for="inputSuccess1">Input with success</label> <input type="text" class="form-control" id="inputSuccess1"></div><div class="form-group has-warning"><label class="control-label" for="inputWarning1">Input with warning</label> <input type="text" class="form-control" id="inputWarning1"></div><div class="form-group has-error"><label class="control-label" for="inputError1">Input with error</label> <input type="text" class="form-control" id="inputError1"></div><div class="has-success"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxSuccess" value="option1"> <span>Checkbox with success</span></label></div></div><div class="has-warning"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxWarning" value="option1"> <span>Checkbox with warning</span></label></div></div><div class="has-error"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxError" value="option1"> <span>Checkbox with error</span></label></div></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputSuccess2">Input with success</label> <input type="text" class="form-control" id="inputSuccess2" aria-describedby="inputSuccess2Status"> <i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputSuccess2Status" class="sr-only">(success)</span></div><div class="form-group has-warning has-feedback"><label class="control-label" for="inputWarning2">Input with warning</label> <input type="text" class="form-control" id="inputWarning2" aria-describedby="inputWarning2Status"> <i class="ion-alert-circled form-control-feedback" aria-hidden="true"></i> <span id="inputWarning2Status" class="sr-only">(warning)</span></div><div class="form-group has-error has-feedback"><label class="control-label" for="inputError2">Input with error</label> <input type="text" class="form-control" id="inputError2" aria-describedby="inputError2Status"> <i class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <span id="inputError2Status" class="sr-only">(error)</span></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputGroupSuccess1">Input group with success</label><div class="input-group"><span class="input-group-addon addon-left">@</span> <input type="text" class="form-control" id="inputGroupSuccess1" aria-describedby="inputGroupSuccess1Status"></div><i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputGroupSuccess1Status" class="sr-only">(success)</span></div>');
$templateCache.put('app/pages/form/layouts/widgets/basicForm.html','<form><div class="form-group"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" placeholder="Email"></div><div class="form-group"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Check me out</span></label></div><button type="submit" class="btn btn-danger">Submit</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/blockForm.html','<div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">First Name</label> <input type="text" class="form-control" id="inputFirstName" placeholder="First Name"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputLastName">Last Name</label> <input type="text" class="form-control" id="inputLastName" placeholder="Last Name"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">Email</label> <input type="email" class="form-control" id="inputEmail" placeholder="Email"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputWebsite">Website</label> <input type="text" class="form-control" id="inputWebsite" placeholder="Website"></div></div></div><button type="submit" class="btn btn-primary">Submit</button>');
$templateCache.put('app/pages/form/layouts/widgets/formWithoutLabels.html','<form><div class="form-group"><input type="text" class="form-control" placeholder="Recipients"></div><div class="form-group"><input type="text" class="form-control" placeholder="Subject"></div><div class="form-group"><textarea class="form-control" placeholder="Message"></textarea></div><button type="submit" class="btn btn-success">Send</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/horizontalForm.html','<form class="form-horizontal"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="email" class="form-control" id="inputEmail3" placeholder="Email"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-warning">Sign in</button></div></div></form>');
$templateCache.put('app/pages/form/layouts/widgets/inlineForm.html','<form class="row form-inline"><div class="form-group col-sm-3 col-xs-6"><input type="text" class="form-control" id="exampleInputName2" placeholder="Name"></div><div class="form-group col-sm-3 col-xs-6"><input type="email" class="form-control" id="exampleInputEmail2" placeholder="Email"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div><button type="submit" class="btn btn-primary">Send invitation</button></form>');
$templateCache.put('app/pages/rotinas/widget/oficio/cadastroOficio.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Novo</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="col-md-12"><div class="form-group"><label for="interessado" class="control-label">Interessado *</label> <input type="text" class="form-control" id="interessado" ng-required="true" ng-model="oficio.interessado" placeholder="Interessado"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="assunto" class="control-label">Assunto *</label> <textarea id="assunto" ng-model="oficio.assunto" ng-required="true" class="form-control textarea" style="resize:none"></textarea></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="suplente" class="control-label">Destino *</label><ui-select ng-model="oficio.destino" ng-required="true && !oficio.locades" class="btn-group bootstrap-select form-control" ng-disabled="destinos == null" append-to-body="true" reset-search-input="false" search-enabled="true" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Destino"><span>{{ $select.selected.local }}</span></ui-select-match><ui-select-choices repeat="item in destinos" refresh-delay="0"><div ng-bind-html="item.local | highlight: $select.search"></div></ui-select-choices></ui-select><input type="text" ng-required="true && !oficio.destino" class="form-control" id="local" ng-model="oficio.locades"></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="!cadastroForm.$valid" ng-click="adicionar(oficio)" ng-click-options="{preventDoubleClick: true}">Confirmar</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/rotinas/widget/oficio/editarOficio.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Editar</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="col-md-12"><div class="form-group"><label for="nOficio" class="control-label"><b>N\xBA Oficio</b></label> <span>{{ oficio.nOficio }}</span></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="dt_insert" class="control-label"><b>Data</b></label> <span>{{ oficio.dt_insert | date: \'dd/MM/yyyy\' }}</span></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="interessado" class="control-label">Interessado *</label> <input type="text" class="form-control" id="interessado" ng-required="true" ng-model="oficio.interessado" placeholder="Interessado"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="assunto" class="control-label">Assunto *</label> <textarea id="assunto" ng-model="oficio.assunto" ng-required="true" class="form-control textarea" style="resize:none"></textarea></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="suplente" class="control-label">Destino *</label><ui-select ng-model="oficio.destino" ng-required="true && !oficio.locades" class="btn-group bootstrap-select form-control" ng-disabled="destinos == null" append-to-body="true" reset-search-input="false" search-enabled="true" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Destino"><span>{{ $select.selected.local }}</span></ui-select-match><ui-select-choices repeat="item in destinos" refresh-delay="0"><div ng-bind-html="item.local | highlight: $select.search"></div></ui-select-choices></ui-select><input type="text" ng-required="true && !oficio.destino" class="form-control" id="local" ng-model="oficio.locades"></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="!cadastroForm.$valid" ng-click="enviar(oficio)" ng-click-options="{preventDoubleClick: true}">Confirmar</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/rotinas/widget/titulos/cadastroTitulos.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Novo</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="col-md-12"><div class="form-group"><label for="codigo" class="control-label">C\xF3digo *</label> <input type="text" class="form-control" id="codigo" ng-model="titulos.codigo" placeholder="C\xF3digo" ng-required="true"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="dataspg" class="control-label">Data Entrada *</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dataspg" type="text" placeholder="Data Entrada" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="titulos.dataspg" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="nome" class="control-label">Nome *</label> <input type="text" ng-required="true" class="form-control" id="nome" ng-model="titulos.nome" placeholder="Nome"></div></div></div><div class="row"><label for="nome" class="control-label">T\xEDtulo *</label><select ng-required="true" class="form-control selectpicker show-tick" title="Titulo" selectpicker="" ng-model="titulos.titulo" ng-options="i for i in [\'ACEI/TITULO\',\'RECO/TITULO\']"></select></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="nivel" class="control-label">N\xEDvel *</label> <input type="text" ng-required="true" class="form-control" id="nivel" ng-model="titulos.nivel" placeholder="N\xEDvel"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="programa" class="control-label">Programa *</label> <input type="text" ng-required="true" class="form-control" id="programa" ng-model="titulos.area" placeholder="Programa"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="obtido" class="control-label">Obtido *</label> <input type="text" ng-required="true" class="form-control" id="obtido" ng-model="titulos.obtido" placeholder=""> <input type="text" class="form-control" id="obtido2" ng-model="titulos.obtido2" placeholder=""></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="datadef" class="control-label">Data da Defesa</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="datadef" type="text" placeholder="Data da Defesa" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="titulos.datadef" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="portaria" class="control-label">Portaria</label> <input type="text" class="form-control" id="portaria" ng-model="titulos.portaria" placeholder="Portaria"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="aprocpg" class="control-label">Data Aprova\xE7\xE3o CPG</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="aprocpg" type="text" placeholder="Data Aprova\xE7\xE3o CPG" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="titulos.aprocpg" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="aprogreg" class="control-label">Data Aprova\xE7\xE3o Congrega\xE7\xE3o</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="aprogreg" type="text" placeholder="Data Aprova\xE7\xE3o Congrega\xE7\xE3o" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="titulos.aprogreg" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="aprocama" class="control-label">Data Aprova\xE7\xE3o Camara</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="aprocama" type="text" placeholder="Data Aprova\xE7\xE3o Camara" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="titulos.aprocama" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="processo" class="control-label">Processo</label> <input type="text" class="form-control" id="processo" ng-model="titulos.processo" placeholder="Processo"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="ncapa" class="control-label">N\xBA Capa</label> <input type="text" class="form-control" id="ncapa" ng-model="titulos.ncapa" placeholder="N\xBA Capa"></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="!cadastroForm.$valid" ng-click="adicionar(titulos)" ng-click-options="{preventDoubleClick: true}">Confirmar</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/rotinas/widget/titulos/editarTitulos.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Editar</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="col-md-12"><div class="form-group"><label for="codigo" class="control-label">C\xF3digo *</label> <input type="text" class="form-control" id="codigo" ng-model="titulos.codigo" placeholder="C\xF3digo" ng-required="true"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="dataspg" class="control-label">Data Entrada *</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dataspg" type="text" placeholder="Data Entrada" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="titulos.dataspg" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="nome" class="control-label">Nome *</label> <input type="text" ng-required="true" class="form-control" id="nome" ng-model="titulos.nome" placeholder="Nome"></div></div></div><div class="row"><label for="nome" class="control-label">T\xEDtulo *</label><select ng-required="true" class="form-control selectpicker show-tick" selectpicker="" ng-model="titulos.titulo" ng-options="i for i in [\'ACEI/TITULO\',\'RECO/TITULO\']"></select></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="nivel" class="control-label">N\xEDvel *</label> <input type="text" ng-required="true" class="form-control" id="nivel" ng-model="titulos.nivel" placeholder="N\xEDvel"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="programa" class="control-label">Programa *</label> <input type="text" ng-required="true" class="form-control" id="programa" ng-model="titulos.area" placeholder="Programa"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="obtido" class="control-label">Obtido *</label> <input type="text" ng-required="true" class="form-control" id="obtido" ng-model="titulos.obtido" placeholder=""> <input type="text" class="form-control" id="obtido2" ng-model="titulos.obtido2" placeholder=""></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="datadef" class="control-label">Data da Defesa</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="datadef" type="text" placeholder="Data da Defesa" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="titulos.datadef" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="portaria" class="control-label">Portaria</label> <input type="text" class="form-control" id="portaria" ng-model="titulos.portaria" placeholder="Portaria"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="aprocpg" class="control-label">Data Aprova\xE7\xE3o CPG</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="aprocpg" type="text" placeholder="Data Aprova\xE7\xE3o CPG" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="titulos.aprocpg" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="aprogreg" class="control-label">Data Aprova\xE7\xE3o Congrega\xE7\xE3o</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="aprogreg" type="text" placeholder="Data Aprova\xE7\xE3o Congrega\xE7\xE3o" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="titulos.aprogreg" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="aprocama" class="control-label">Data Aprova\xE7\xE3o Camara</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="aprocama" type="text" placeholder="Data Aprova\xE7\xE3o Camara" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="titulos.aprocama" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="processo" class="control-label">Processo</label> <input type="text" class="form-control" id="processo" ng-model="titulos.processo" placeholder="Processo"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="ncapa" class="control-label">N\xBA Capa</label> <input type="text" class="form-control" id="ncapa" ng-model="titulos.ncapa" placeholder="N\xBA Capa"></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="!cadastroForm.$valid" ng-click="enviar(titulos)" ng-click-options="{preventDoubleClick: true}">Confirmar</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/rotinas/widget/protocolo/cadastroExpediente.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Novo</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="col-md-12"><div class="form-group"><label for="nregistro" class="control-label">N\xFAmero de Registro</label> <input type="text" class="form-control" ng-required="true" id="nregistro" ng-model="expediente.nExpediente" placeholder="N\xFAmero de Registro"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="dt-cadastro" class="control-label">Data Cadastro *</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-cadastro" type="text" placeholder="Data Cadastro" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="expediente.dt_cadastro" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="dt-saida" class="control-label">Data Sa\xEDda</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-saida" type="text" placeholder="Data Sa\xEDda" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="expediente.dt_saida" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="Interessado" class="control-label">Interessado</label> <input type="text" class="form-control" id="interessado" ng-required="true" ng-model="expediente.interessado"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="destino" class="control-label">Destino *</label><ui-select ng-model="expediente.destino" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="destinos == null" id="destino" append-to-body="true" reset-search-input="false" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Destino"><span>{{ $select.selected.local }}</span></ui-select-match><ui-select-choices repeat="item in destinos" refresh-delay="0"><div ng-bind-html="item.local"></div></ui-select-choices></ui-select><input type="text" ng-required="expediente.destino.local == \'OUTROS\'" class="form-control" id="local" ng-if="expediente.destino.local == \'OUTROS\'" ng-model="expediente.destinoOutro"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="assunto" class="control-label">Assunto</label> <input type="text" class="form-control" id="assunto" ng-model="expediente.assunto"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="obs" class="control-label">Observa\xE7\xF5es</label> <textarea id="obs" ng-model="expediente.obs" class="form-control textarea" style="resize:none"></textarea></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="programa" class="control-label">Programa</label><ui-select ng-model="expediente.programa" class="btn-group bootstrap-select form-control" ng-disabled="programas == null" id="programa" append-to-body="true" reset-search-input="true" search-enabled="true"><ui-select-match placeholder="Programa"><span>{{ $select.selected.value }}</span></ui-select-match><ui-select-choices repeat="item in programas | filter:$select.search" refresh-delay="0"><div ng-bind-html="item.value"></div></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-md-5 pull-left"><div class="form-group"><label for="numero" class="control-label">N\xFAmero</label> <input type="text" class="form-control" id="numero" ng-model="expediente.numero"></div></div><div class="col-md-5 pull-right"><div class="form-group"><label for="protocolo" class="control-label">Protocolo</label> <input type="text" class="form-control" id="protocolo" ng-model="expediente.protocolo"></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="!cadastroForm.$valid" ng-click="adicionar(expediente)" ng-click-options="{preventDoubleClick: true}">Confirmar</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/rotinas/widget/protocolo/cadastroProtoExpediente.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Novo Proto Expediente</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="col-md-12"><div class="form-group"><label for="dt-saida" class="control-label">Data Cadastro *</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-saida" type="text" placeholder="Data Cadastro" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="protoExpediente.dt_saida" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="suplente" class="control-label">Destino *</label><ui-select ng-model="protoExpediente.destino" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="destinos == null" append-to-body="true" reset-search-input="false" search-enabled="true" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Destino"><span>{{ $select.selected.local }}</span></ui-select-match><ui-select-choices repeat="item in destinos" refresh-delay="0"><div ng-bind-html="item.local | highlight: $select.search"></div></ui-select-choices></ui-select><input type="text" ng-required="protoExpediente.destino.local == \'OUTROS\'" class="form-control" id="local" ng-if="protoExpediente.destino.local == \'OUTROS\'" ng-model="protoExpediente.destinoOutro"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="descricao" class="control-label">Descri\xE7\xE3o</label> <textarea id="descricao" ng-model="protoExpediente.descricao" class="form-control textarea" style="resize:none"></textarea></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="dt-retorno" class="control-label">Data Retorno</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-retorno" type="text" placeholder="Data Retorno" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" close-text="Close" datepicker-options="options" ng-model="protoExpediente.dt_retorno" is-open="opened" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="!cadastroForm.$valid" ng-click="enviar(protoExpediente)" ng-click-options="{preventDoubleClick: true}">Confirmar</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/rotinas/widget/protocolo/editarExpediente.html','<div class="modal-content section-to-print"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Editar</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="col-md-12"><div class="form-group"><label for="nregistro" class="control-label">N\xFAmero de Registro</label> <input type="text" class="form-control" ng-required="true" id="nregistro" ng-model="expediente.nExpediente" placeholder="N\xFAmero de Registro"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="dt-cadastro" class="control-label">Data Cadastro *</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-cadastro" type="text" placeholder="Data Cadastro" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="expediente.dt_cadastro" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="dt-saida" class="control-label">Data Sa\xEDda</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-saida" type="text" placeholder="Data Sa\xEDda" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="expediente.dt_saida" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="Interessado" class="control-label">Interessado</label> <input type="text" class="form-control" id="interessado" ng-required="true" ng-model="expediente.interessado"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="destino" class="control-label">Destino *</label><ui-select ng-model="expediente.destino" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="destinos == null" id="destino" append-to-body="true" reset-search-input="false" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Destino"><span>{{ $select.selected.local }}</span></ui-select-match><ui-select-choices repeat="item in destinos" refresh-delay="0"><div ng-bind-html="item.local"></div></ui-select-choices></ui-select><input type="text" ng-required="expediente.destino.local == \'OUTROS\'" class="form-control" id="local" ng-if="expediente.destino.local == \'OUTROS\'" ng-model="expediente.destinoOutro"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="assunto" class="control-label">Assunto</label> <input type="text" class="form-control" id="assunto" ng-model="expediente.assunto"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="obs" class="control-label">Observa\xE7\xF5es</label> <textarea id="obs" ng-model="expediente.obs" class="form-control textarea" style="resize:none"></textarea></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="programa" class="control-label">Programa</label><ui-select ng-model="expediente.programa" class="btn-group bootstrap-select form-control" ng-disabled="programas == null" id="programa" append-to-body="true" reset-search-input="false" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Programa"><span>{{ $select.selected.value }}</span></ui-select-match><ui-select-choices repeat="item in programas" refresh-delay="0"><div ng-bind-html="item.value"></div></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-md-5 pull-left"><div class="form-group"><label for="numero" class="control-label">N\xFAmero</label> <input type="text" class="form-control" id="numero" ng-model="expediente.numero"></div></div><div class="col-md-5 pull-right"><div class="form-group"><label for="protocolo" class="control-label">Protocolo</label> <input type="text" class="form-control" id="protocolo" ng-model="expediente.protocolo"></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="!cadastroForm.$valid" ng-click="enviar(expediente)" ng-click-options="{preventDoubleClick: true}">Confirmar</button> <button type="button" class="btn btn-default pull-right" style="margin:0 10px;" onclick="window.print();">Imprimir</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/rotinas/widget/protocolo/editarProtocolo.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Consulta"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm" id="section-to-print"><div class="row"><div class="col-md-3"><label for="nprotocolo" class="control-label">Protocolo <span>*<span></span></span></label> <input type="text" class="form-control" id="nprotocolo" ng-required="true" ng-model="protocolo.nProtocolo"></div><div class="col-md-3"><label for="dt-inicial" class="control-label">Data Criacao <span>*<span></span></span></label><div><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-inicial" type="text" placeholder="Data Criacao" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="protocolo.dt_create" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-6"><label for="Interessado" class="control-label">Interessado <span>*<span></span></span></label> <input type="text" class="form-control" id="interessado" ng-required="true" ng-model="protocolo.interessado"></div></div><div class="row"><div class="col-sm-6"><label for="descricao" class="control-label">Descri\xE7\xE3o <span ng-if="protocolo.assunto.assunto == \'OUTROS\'">*<span></span></span></label> <textarea id="descricao" class="form-control" ng-required="protocolo.assunto.assunto == \'OUTROS\'" ng-model="protocolo.descricao" style="resize:none;height:150px"></textarea></div><div class="col-sm-6"><div class="row"><label for="assunto" class="control-label">Assunto <span>*<span></span></span></label><ui-select ng-model="protocolo.assunto" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="assuntos == null" id="assunto" append-to-body="true" reset-search-input="false" search-enabled="false" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Assunto"><span>{{ $select.selected.assunto }}</span></ui-select-match><ui-select-choices repeat="item in assuntos" refresh-delay="0"><div ng-bind-html="item.assunto"></div></ui-select-choices></ui-select><div><input type="text" class="form-control" id="assuntoOutro" ng-model="protocolo.assuntoOutro" ng-if="protocolo.assunto.assunto == \'OUTROS\'" ng-required="protocolo.assunto.assunto == \'OUTROS\'"></div></div><div class="row"><label for="programa" class="control-label">Programa</label><ui-select ng-model="protocolo.programa" class="btn-group bootstrap-select form-control" ng-disabled="programas == null" id="programa" append-to-body="true" reset-search-input="true" search-enabled="true"><ui-select-match placeholder="Programa"><span>{{ $select.selected.value }}</span></ui-select-match><ui-select-choices repeat="item in programas | filter:$select.search" refresh-delay="0"><div ng-bind-html="item.value"></div></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-md-6"><label for="dt-saida" class="control-label">Data Sa\xEDda</label><div><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-saida" type="text" placeholder="Data Sa\xEDda" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="protocolo.dt_saida" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-6"><label for="dt-entrada" class="control-label">Data Entrada</label><div><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-entrada" type="text" placeholder="Data Entrada" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="protocolo.dt_entrada" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="row"><div class="col-md-12"><i class="pull-right">* Itens obrigat\xF3rios</i></div></div></div></form><br><hr><div class="row"><div class="col-md-12"><button type="button" class="btn btn-success pull-left" ng-click="adicionarProtoExpediente()" ng-disabled="novo"><i class="ion-android-list"></i> Novo Expediente de Protocolo</button> <button type="button" class="btn btn-primary pull-right" ng-disabled="!cadastroForm.$valid" ng-click="salvar()" ng-click-options="{preventDoubleClick: true}">{{SaveButton}}</button> <button type="button" class="btn btn-default pull-right" style="margin:0 50px;" onclick="window.print();">Imprimir</button></div></div><br><br></div><div ba-panel="" ba-panel-class="with-scroll" ng-if="protoExpedientes.length>0" class=""><div class="horizontal-scroll row col-md-12"><div class="row"><label class="control-label col-md-2"><select class="form-control selectpicker show-tick" title="T\xEDtulos por p\xE1ginas" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,40,60,100]"></select></label></div><table class="table section-to-print" st-table="protoExpedientes" st-safe-src="outros" ng-if="protoExpedientes.length>0"><thead><tr><th>Data Sa\xEDda</th><th>Destino</th><th>Programa</th><th>Data Retorno</th></tr></thead><tbody><tr ng-repeat="item in protoExpedientes track by $index"><td>{{item.dt_saida | date: \'dd/MM/yyyy\'}}</td><td><a class="btn btn-link" ng-click="editar(item)">{{item.destino}}</a></td><td>{{item.programa}}</td><td>{{item.dt_retorno | date: \'dd/MM/yyyy\'}}</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize || 20" st-displayed-pages="20"></div></td></tr></tfoot></table></div></div><response-message msg="mensagem" voltar="false"></response-message></div></div></div>');
$templateCache.put('app/pages/rotinas/widget/protocolo/editarProtoExpediente.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Editar Proto Expediente</h4></div><div class="modal-body agendamento cadastro"><form class="form-horizontal ng-pristine ng-valid ng-scope" name="cadastroForm"><div class="row"><div class="col-md-12"><div class="form-group"><label for="dt-saida" class="control-label">Data Cadastro *</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-saida" type="text" placeholder="Data Cadastro" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="protoExpediente.dt_saida" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="suplente" class="control-label">Destino *</label><ui-select ng-model="protoExpediente._destino" ng-required="true" class="btn-group bootstrap-select form-control" ng-disabled="destinos == null" append-to-body="true" reset-search-input="false" close-on-select="true" spinner-enabled="true"><ui-select-match placeholder="Destino"><span>{{ $select.selected.local }}</span></ui-select-match><ui-select-choices repeat="item in destinos" refresh-delay="0"><div ng-bind-html="item.local"></div></ui-select-choices></ui-select><input type="text" ng-required="protoExpediente._destino.local == \'OUTROS\'" class="form-control" id="local" ng-if="protoExpediente._destino.local == \'OUTROS\'" ng-model="protoExpediente.destinoOutro"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="descricao" class="control-label">Descri\xE7\xE3o</label> <textarea id="descricao" ng-model="protoExpediente.descricao" class="form-control textarea" style="resize:none"></textarea></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="dt-retorno" class="control-label">Data Retorno</label><div class="input-group" ng-controller="datepickerpopupCtrl"><input id="dt-retorno" type="text" placeholder="Data Retorno" class="form-control" ng-click="open();" uib-datepicker-popup="dd/MM/yyyy" close-text="Close" datepicker-options="options" ng-model="protoExpediente.dt_retorno" is-open="opened" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open();"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-secondary" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="!cadastroForm.$valid" ng-click="enviar(protoExpediente)" ng-click-options="{preventDoubleClick: true}">Confirmar</button> <button type="button" class="btn btn-default pull-right" ng-hide="protoExpediente == null" style="margin: 0 10px;" ng-click="print();">Imprimir</button></div><response-message msg="mensagem" voltar="false"></response-message></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttonGroups.html','<div class="btn-group-example"><div class="btn-group" role="group" aria-label="Basic example"><button type="button" class="btn btn-danger">Left</button> <button type="button" class="btn btn-danger">Middle</button> <button type="button" class="btn btn-danger">Right</button></div></div><div class="btn-toolbar-example"><div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups"><div class="btn-group" role="group" aria-label="First group"><button type="button" class="btn btn-primary">1</button> <button type="button" class="btn btn-primary">2</button> <button type="button" class="btn btn-primary">3</button> <button type="button" class="btn btn-primary">4</button></div><div class="btn-group" role="group" aria-label="Second group"><button type="button" class="btn btn-primary">5</button> <button type="button" class="btn btn-primary">6</button> <button type="button" class="btn btn-primary">7</button></div><div class="btn-group" role="group" aria-label="Third group"><button type="button" class="btn btn-primary">8</button></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttons.html','<div class="basic-btns"><div class="row"><div class="col-md-2"><h5>Default button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-sm">Small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-sm">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-sm">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-sm">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-sm">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-sm">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-xs">Extra small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-xs">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-xs">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-xs">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-xs">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-xs">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5>Disabled button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/dropdowns.html','<div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary" uib-dropdown-toggle="">Primary <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success" uib-dropdown-toggle="">Success <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info" uib-dropdown-toggle="">Info <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default" uib-dropdown-toggle="">Default <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning" uib-dropdown-toggle="">Warning <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger" uib-dropdown-toggle="">Danger <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div><h5 class="panel-subtitle">Split button dropdowns</h5><div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary">Primary</button> <button type="button" class="btn btn-primary" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success">Success</button> <button type="button" class="btn btn-success" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info">Info</button> <button type="button" class="btn btn-info" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default">Default</button> <button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning">Warning</button> <button type="button" class="btn btn-warning" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger">Danger</button> <button type="button" class="btn btn-danger" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/iconButtons.html','<ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-icon"><i class="ion-android-download"></i></button></li><li><button type="button" class="btn btn-default btn-icon"><i class="ion-stats-bars"></i></button></li><li><button type="button" class="btn btn-success btn-icon"><i class="ion-android-checkmark-circle"></i></button></li><li><button type="button" class="btn btn-info btn-icon"><i class="ion-information"></i></button></li><li><button type="button" class="btn btn-warning btn-icon"><i class="ion-android-warning"></i></button></li><li><button type="button" class="btn btn-danger btn-icon"><i class="ion-nuclear"></i></button></li></ul><h5 class="panel-subtitle">Buttons with icons</h5><ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-with-icon"><i class="ion-android-download"></i>Primary</button></li><li><button type="button" class="btn btn-default btn-with-icon"><i class="ion-stats-bars"></i>Default</button></li><li><button type="button" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Success</button></li><li><button type="button" class="btn btn-info btn-with-icon"><i class="ion-information"></i>Info</button></li><li><button type="button" class="btn btn-warning btn-with-icon"><i class="ion-android-warning"></i>Warning</button></li><li><button type="button" class="btn btn-danger btn-with-icon"><i class="ion-nuclear"></i>Danger</button></li></ul>');
$templateCache.put('app/pages/ui/buttons/widgets/largeButtons.html','<div class="row btns-row btns-same-width-lg"><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-primary btn-lg">Primary</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-success btn-lg">Success</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-info btn-lg">Info</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-default btn-lg">Default</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-warning btn-lg">Warning</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/progressButtons.html','<div class="progress-buttons-container text-center default-text"><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">fill horizontal</span> <button progress-button="progressFunction()" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">fill vertical</span> <button progress-button="progressFunction()" pb-direction="vertical" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink horizontal</span> <button progress-button="progressFunction()" pb-style="shrink" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink vertical</span> <button progress-button="progressFunction()" pb-style="shrink" pb-direction="vertical" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-bottom<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-bottom" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-top<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-top" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-down<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-down" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-up<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-up" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-back<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-back" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">flip-open<br>perspective</span> <button progress-button="progressFunction()" pb-style="flip-open" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">slide-down<br>horizontal</span> <button progress-button="progressFunction()" pb-style="slide-down" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">move-up<br>horizontal</span> <button progress-button="progressFunction()" pb-style="move-up" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6"><span class="button-title">top-line<br>horizontal</span> <button progress-button="progressFunction()" pb-style="top-line" class="btn btn-success">Submit</button></section><section class="col-md-6"><span class="button-title">lateral-lines<br>vertical</span> <button progress-button="progressFunction()" pb-style="lateral-lines" class="btn btn-info">Submit</button></section></div></div>');
$templateCache.put('app/pages/ui/modals/progressModal/progressModal.html','<div class="modal-content" ng-controller="ProgressModalCtrl"><div class="modal-body"><progress-bar-round></progress-bar-round></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/ui/icons/widgets/fontAwesomeIcons.html','<div class="row icons-list success awesomeIcons"><div class="col-xs-2" ng-repeat="icon in icons.fontAwesomeIcons"><i class="fa {{icon}}"></i></div></div><a href="http://fortawesome.github.io/Font-Awesome/icons/" target="_blank" class="see-all-icons">See all Font Awesome icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/ionicons.html','<div class="row icons-list primary"><div class="col-xs-2" ng-repeat="icon in icons.ionicons"><i class="{{icon}}"></i></div></div><a href="http://ionicons.com/" target="_blank" class="see-all-icons">See all ionicons icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleon.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonIcons"><div class="kameleon-icon"><img ng-src="{{:: (icon.img | kameleonImg )}}"><span>{{icon.name}}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleonRounded.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonRoundedIcons"><div class="kameleon-icon with-round-bg {{icon.color}}"><img ng-src="{{::( icon.img | kameleonImg )}}"><span>{{ icon.name }}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/socicon.html','<div class="row icons-list danger"><div class="col-xs-2" ng-repeat="icon in icons.socicon"><i class="socicon">{{ icon }}</i></div></div><a href="http://www.socicon.com/chart.php" target="_blank" class="see-all-icons">See all Socicon icons</a>');
$templateCache.put('app/pages/ui/modals/notifications/notifications.html','<div class="modal-buttons same-width clearfix" ng-controller="NotificationsCtrl"><button type="button" class="btn btn-success" ng-click="showSuccessMsg()">Success Notification</button> <button type="button" class="btn btn-info" ng-click="showInfoMsg()">Info Notification</button> <button type="button" class="btn btn-warning" ng-click="showWarningMsg()">Warning Notification</button> <button type="button" class="btn btn-danger" ng-click="showErrorMsg()">Danger Notification</button></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/basicModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Error</span></div><div class="modal-body text-center">Your information hasn\'t been saved!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/infoModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Information</span></div><div class="modal-body text-center">You\'ve got a new email!</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/largeModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/smallModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/successModal.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-checkmark modal-icon"></i><span>Success</span></div><div class="modal-body text-center">Your information has been saved successfully</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/warningModal.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>Warning</span></div><div class="modal-body text-center">Your computer is about to explode!</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/animated.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped active" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped active" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/basic.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/label.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">40% Complete (success)</div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">20% Complete</div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">60% Complete (warning)</div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">80% Complete (danger)</div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/stacked.html','<div class="progress"><div class="progress-bar progress-bar-success" style="width: 35%"><span class="sr-only">35% Complete (success)</span></div><div class="progress-bar progress-bar-warning progress-bar-striped" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div><div class="progress-bar progress-bar-danger" style="width: 10%"><span class="sr-only">10% Complete (danger)</span></div><div class="progress-bar progress-bar-info progress-bar-striped active" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/striped.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/agendamento/relatorios/relatorio/agendamentos/numeroTeses.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio agendamentos"><div id="numeroTeses" class="panel animated zoomIn" ng-show="relatorio.numeroTeses != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>N\xFAmero de Teses e Disserta\xE7\xF5es Defendidas</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th colspan="5"><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td colspan="5"><strong>N\xFAmero de Teses e Disserta\xE7\xF5es Defendidas</strong></td></tr><tr><td colspan="5">Per\xEDodo: {{ relatorio.periodoAgendamento.de | date:"dd/MM/yyyy" }} \xE0 {{ relatorio.periodoAgendamento.ate | date:"dd/MM/yyyy" }}</td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo"><tr><td><table class="agendamentos"><tr><th id="programa">Programa</th><th id="mestrado">Mestrado</th><th id="doutorado">Doutorado</th><th id="total">Total</th></tr><tr ng-repeat="item in relatorio.numeroTeses"><td>{{ item.nomare }}</td><td>{{ item.ME }}</td><td>{{ item.DO }}</td><td>{{ item.TOTAL }}</td></tr></table></td></tr></table></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.numeroTeses == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/agendamento/relatorios/relatorio/agendamentos/relacaoAgendamentoDefesa.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio agendamentos"><div id="relacaoAgendamentoDefesa" class="panel animated zoomIn" ng-show="relatorio.relacaoAgendamentoDefesa != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>Rela\xE7\xE3o de Agendamentos de Defesa</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th colspan="5"><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td colspan="5"><strong>Rela\xE7\xE3o de Defesas Agendadas</strong></td></tr><tr><td colspan="5">Per\xEDodo: {{ relatorio.periodoAgendamento.de | date:"dd/MM/yyyy" }} \xE0 {{ relatorio.periodoAgendamento.ate | date:"dd/MM/yyyy" }}</td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo" ng-repeat="(area, itens) in relatorio.relacaoAgendamentoDefesa"><thead><tr><th class="area"><strong>{{ area }}</strong></th></tr></thead><tbody><tr ng-repeat="item in itens"><td><table class="agendamentos"><tr><th id="data-defesa">Data</th><th id="horario-defesa">Hor\xE1rio</th><th id="matricula">matricula</th><th id="nome">Nome</th><th id="nivel">N\xEDvel</th></tr><tr><td id="data-defesa">{{ item.dataDefesa }}</td><td id="horario">{{ item.horarioDefesa }}</td><td id="matricula">{{ item.matricula }}</td><td id="nome">{{ item.nomeAluno }}</td><td id="nivel">{{ item.nivel }}</td></tr><tr><th colspan="5" id="area">\xC1rea</th></tr><tr><td colspan="5" id="area">{{ item.area }}</td></tr><tr><th colspan="5" id="titulo-trabalho">T\xEDtulo Trabalho</th></tr><tr><td colspan="5" id="titulo-trabalho">{{ item.tituloTrabalho }}</td></tr><tr><th colspan="5" id="anfiteatro">Anfiteatro</th></tr><tr><td colspan="5" id="anfiteatro">{{ item.anfiteatro }}</td></tr><tr><th colspan="5" id="orientador">Orientador(es)</th></tr><tr><td colspan="5" id="orientador">{{ relatorio.orientadores[item.matricula] }}</td></tr><tr><th colspan="5" id="agendamento">Agendamento</th></tr><tr><td colspan="5" id="agendamento">{{ item.agendamento }}</td></tr></table></td></tr></tbody></table></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.relacaoAgendamentoDefesa == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/agendamento/relatorios/relatorio/agendamentos/relacaoBancas.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio agendamentos"><div id="relacaoBancas" class="panel animated zoomIn" ng-show="relatorio.relacaoBancas != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>Rela\xE7\xE3o de Participa\xE7\xE3o em Bancas</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th colspan="5"><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td colspan="5"><strong>Rela\xE7\xE3o de Participa\xE7\xE3o em Bancas</strong></td></tr><tr><td colspan="5">Per\xEDodo: {{ relatorio.periodoAgendamento.de | date:"dd/MM/yyyy" }} \xE0 {{ relatorio.periodoAgendamento.ate | date:"dd/MM/yyyy" }} Nome "{{ relatorio.orientador }}"</td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo"><tbody><tr><td><table class="agendamentos"><tr><th id="data-defesa">Data</th><th id="nome">Nome</th><th id="orientador">Orientador</th><th id="nivel">N\xEDvel</th></tr><tbody ng-repeat="item in relatorio.relacaoBancas"><tr><td colspan="4">&nbsp;</td></tr><tr><td>{{ item.dtdefesa | limitTo:10 | date:"dd/MM/yyyy" }}</td><td>{{ item.nomealuno }}</td><td>{{ item.nomepartbanca }}</td><td>{{ item.nivelprograma }}</td></tr><tr><th colspan="4">Tema</th></tr><tr class="final"><td colspan="4">{{ item.tittrabalho }}</td></tr></tbody></table></td></tr></tbody></table></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.relacaoBancas == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/agendamento/relatorios/relatorio/agendamentos/relacaoDissertacaoTese.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio agendamentos"><div id="relacaoAgendamentoDefesa" class="panel animated zoomIn" ng-show="relatorio.dissertacaoTese != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>Rela\xE7\xE3o Descritiva de Disserta\xE7\xF5es e Teses Defendidas</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th colspan="5"><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td colspan="5"><strong>Rela\xE7\xE3o Descritiva de Disserta\xE7\xF5es e Teses Defendidas</strong></td></tr><tr><td colspan="5">Per\xEDodo: {{ relatorio.periodoAgendamento.de | date:"dd/MM/yyyy" }} \xE0 {{ relatorio.periodoAgendamento.ate | date:"dd/MM/yyyy" }}</td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo" ng-repeat="(area, itens) in relatorio.dissertacaoTese"><thead><tr><th class="area"><strong>{{ area }}</strong></th></tr></thead><tbody><tr ng-repeat="item in itens"><td><table class="agendamentos"><tr><th id="data-defesa" colspan="2">Data</th><th id="nome" colspan="2">Nome</th><th id="nivel">N\xEDvel</th></tr><tr><td id="data-defesa" colspan="2">{{ item.dtdefesa | date:"dd/MM/yyyy" }}</td><td id="nome" colspan="2">{{ item.nomealuno }}</td><td id="nivel">{{ item.nivelprograma }}</td></tr><tr><th colspan="5" id="titulo-trabalho">Tema</th></tr><tr><td colspan="5" id="titulo-trabalho">{{ item.tittrabalho }}</td></tr></table></td></tr></tbody></table></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.dissertacaoTese == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/agendamento/relatorios/relatorio/agendamentos/relacaoDissertacaoTeseComOrientador.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio agendamentos"><div id="RelacaoDissertacaoTeseComOrientador" class="panel animated zoomIn" ng-show="relatorio.relacaoDissertacaoTeseComOrientador != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>Rela\xE7\xE3o de Disserta\xE7\xF5es e Teses Defendidas</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th colspan="5"><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td colspan="5"><strong>Rela\xE7\xE3o de Disserta\xE7\xF5es e Teses Defendidas</strong></td></tr><tr><td colspan="5">Per\xEDodo: {{ relatorio.periodoAgendamento.de | date:"dd/MM/yyyy" }} \xE0 {{ relatorio.periodoAgendamento.ate | date:"dd/MM/yyyy" }}</td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo" ng-repeat="(area, itens) in relatorio.relacaoDissertacaoTeseComOrientador"><thead><tr><th class="area"><strong>{{ area }}</strong></th></tr></thead><tbody><tr ng-repeat="item in itens"><td><table class="agendamentos"><tr><th id="data-defesa">Data</th><th id="nome">Nome</th><th id="nivel">N\xEDvel</th><th id="orientador">Orientador</th></tr><tr><td>{{ item.dtdefesa | date:"dd/MM/yyyy" }}</td><td>{{ item.nomealuno }}</td><td>{{ item.nivelprograma }}</td><td>{{ item.nomeorientador }}</td></tr><tr><td colspan="4"><b>Tema:</b> {{ item.tittrabalho }}</td></tr></table></td></tr></tbody></table></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.relacaoDissertacaoTeseComOrientador == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/agendamento/relatorios/relatorio/agendamentos/relacaoDissertacaoTesePorData.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio agendamentos"><div id="relacaoDissertacaoTesePorData" class="panel animated zoomIn" ng-show="relatorio.relacaoDissertacaoTesePorData != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>Rela\xE7\xE3o de Disserta\xE7\xF5es e Teses Defendidas</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th colspan="5"><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td colspan="5"><strong>Rela\xE7\xE3o de Disserta\xE7\xF5es e Teses Defendidas</strong></td></tr><tr><td colspan="5">Per\xEDodo: {{ relatorio.periodoAgendamento.de | date:"dd/MM/yyyy" }} \xE0 {{ relatorio.periodoAgendamento.ate | date:"dd/MM/yyyy" }}</td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo"><tbody><tr><td><table class="agendamentos"><tr><th id="data-defesa">Data</th><th id="nome">Nome</th><th id="nivel">N\xEDvel</th><th id="orientador">Orientador</th></tr><tbody ng-repeat="item in relatorio.relacaoDissertacaoTesePorData"><tr><td colspan="4">&nbsp;</td></tr><tr><td colspan="4"><b>{{ item.nomare }}</b></td></tr><tr><td>{{ item.dtdefesa | date:"dd/MM/yyyy" }}</td><td>{{ item.nomealuno }}</td><td>{{ item.nivelprograma }}</td><td>{{ item.nomeorientador }}</td></tr><tr><td colspan="4"><b>Tema:</b> {{ item.tittrabalho }}</td></tr><tr><td colspan="4">&nbsp;</td></tr></tbody></table></td></tr></tbody></table></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.relacaoDissertacaoTesePorData == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/agendamento/relatorios/relatorio/agendamentos/resumoTotal.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio agendamentos"><div id="resumoTotal" class="panel animated zoomIn" ng-show="relatorio.resumoTotal != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>Total de Defesas de Mestrado e Doutorado Anual</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th colspan="5"><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td colspan="5"><strong>Total de Defesas de Mestrado e Doutorado Anual</strong></td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo"><tr><td><table class="agendamentos"><tr><th id="ano">Ano</th><th id="mestrado">Mestrado</th><th id="doutorado">Doutorado</th><th id="total">Total</th></tr><tr ng-repeat="item in relatorio.resumoTotal"><td>{{ item.ano }}</td><td>{{ item.ME }}</td><td>{{ item.DO }}</td><td>{{ item.TOTAL }}</td></tr></table></td></tr></table></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.resumoTotal == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/relatorios/relatorio/listagens/aptosQualificacao.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio listagens"><div id="aptosQualificacao" class="panel animated zoomIn" ng-show="relatorio.aptosQualificacao != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>Alunos Aptos para Qualifica\xE7\xE3o</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th colspan="5"><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td colspan="5"><strong>Rela\xE7\xE3o de Alunos Aptos para Qualifica\xE7\xE3o</strong></td></tr><tr><td class="left" width="10%">N\xBA Fenix</td><td class="left" width="55%">Nome</td><td class="left" width="10%">N\xEDvel</td><td class="left" width="10%">Situa\xE7\xE3o</td><td class="left" width="15%">Data Apto</td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo" ng-repeat="(area, itens) in relatorio.aptosQualificacao"><thead><tr><th class="area"><strong>{{ area }}</strong></th></tr></thead><tbody><tr ng-repeat="item in itens"><td><table class="aluno"><tr><td id="matricula">{{ item.matricula }}</td><td id="nome">{{ item.nomeAluno }}</td><td id="nivel">{{ item.nivel }}</td><td id="situacao">{{ item.situacao }}</td><td id="data-apto">{{ item.dataApto }}</td></tr></table></td></tr></tbody></table></td><td></td></tr><tr><td></td><td class="right"><table class="subtotais"><tr><td ng-repeat="(nivel, total) in relatorio.total"><strong>{{ nivel }}:</strong>{{ total }}</td></tr></table></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.aptosQualificacao == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/relatorios/relatorio/listagens/numeroAlunosRegularmenteMatriculadosPorArea.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio listagens"><div id="numeroAlunosRegularmenteMatriculadosPorArea" class="panel animated zoomIn" ng-show="relatorio.numeroAlunosRegularmenteMatriculadosPorArea != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>N\xBA de Alunos Regularmente Matriculados por \xC1rea</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th colspan="5"><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td colspan="5"><strong>N\xBA de Alunos Regularmente Matriculados por \xC1rea</strong></td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo"><thead><th class="left">PROGRAMA</th><th class="center">ME</th><th class="center">DO</th><th class="center">TOTAL</th></thead><tbody ng-repeat="(area, niveis) in relatorio.numeroAlunosRegularmenteMatriculadosPorArea"><tr><td width="70%" class="area"><strong>{{ area }}</strong></td><td width="10%" class="center" ng-repeat="total in niveis">{{ total }}</td></tr></tbody></table></td><td></td></tr><tr><td></td><td class="right"><table class="totais"><tr ng-repeat="(nivel, total) in relatorio.total" class="{{ nivel | lowercase }}"><th>{{ nivel }}</th><td>{{ total }}</td></tr></table></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.numeroAlunosRegularmenteMatriculadosPorArea == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/relatorios/relatorio/listagens/numeroGeralAlunosPorArea.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio listagens"><div id="numeroGeralAlunosPorArea" class="panel animated zoomIn" ng-show="relatorio.numeroGeralAlunosPorArea != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>N\xFAmero Geral de Alunos por \xC1rea</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th colspan="5"><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td colspan="5"><strong>N\xBA Geral de Alunos por \xC1rea</strong></td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo breakable" ng-repeat="(area, situacoes) in relatorio.numeroGeralAlunosPorArea"><thead><tr><th class="area"><strong>{{ area }}</strong></th></tr></thead><tbody><tr><td><table class="subtotais"><tr><th></th><th>ME</th><th>DO</th><th>DD</th><th>ME + DO + DD</th></tr><tr ng-repeat="(situacao, niveis) in situacoes" class="{{ situacao | lowercase }}"><th colspan="{{ situacao.indexOf(\'otal\') >= 0 ? 3 : 1 }}">{{ situacao }}</th><td ng-repeat="total in niveis">{{ total }}</td></tr></table></td></tr></tbody><tfoot></tfoot></table></td><td></td></tr><tr><td></td><td class="right"><table class="totais"><tr ng-repeat="(key, total) in relatorio.total" class="{{ key | lowercase }}"><th>{{ key }}</th><td>{{ total }}</td></tr></table></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.numeroGeralAlunosPorArea == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/relatorios/relatorio/listagens/porArea.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio listagens"><div id="porArea" class="panel animated zoomIn" ng-show="relatorio.porArea != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>Alunos por \xC1rea</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th colspan="5"><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td colspan="5"><strong>Rela\xE7\xE3o de Alunos por \xC1rea</strong></td></tr><tr><td class="left" width="10%">Matr\xEDcula</td><td class="left" width="55%">Aluno</td><td class="left" width="10%">Situa\xE7\xE3o</td><td class="left" width="15%">Data Situa\xE7\xE3o</td><td class="left" width="10%">N\xEDvel</td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo" ng-repeat="(area, itens) in relatorio.porArea"><thead><tr><th class="area"><strong>{{ area }}</strong></th></tr></thead><tbody><tr ng-repeat="item in itens"><td><table class="aluno"><tr><td id="matricula">{{ item.matricula }}</td><td id="nome">{{ item.nomeAluno }}</td><td id="situacao">{{ item.situacao }}</td><td id="data-situacao">{{ item.dataSituacao }}</td><td id="nivel">{{ item.nivel }}</td></tr></table></td></tr></tbody></table></td><td></td></tr><tr><td></td><td class="right"><table class="subtotais"><tr><th class="center" colspan="6">Subtotais por n\xEDvel e situa\xE7\xE3o</th></tr><tr><th></th><th>MA</th><th>TR</th><th>PR</th><th>CO</th><th>DE</th></tr><tr ng-repeat="(nivel, situacoes) in relatorio.total" class="{{ nivel | lowercase }}"><th>{{ nivel }}</th><td ng-repeat="(situacao, total) in situacoes">{{ total }}</td></tr></table></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.porArea == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/relatorios/relatorio/listagens/porOrientador.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio listagens"><div id="porOrientador" class="panel animated zoomIn" ng-show="relatorio.porOrientador != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>Alunos por Orientador</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th colspan="5"><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td colspan="5"><strong>Rela\xE7\xE3o de Alunos por Orientador</strong></td></tr><tr><td class="left" width="10%">N\xBA Fenix</td><td class="left" width="50%">Nome</td><td class="left" width="10%">Situa\xE7\xE3o</td><td class="left" width="15%">In\xEDcio</td><td class="left" width="15%">Data Entrega</td></tr><tr><td class="left" colspan="5">Titulo do Plano de Pesquisa</td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo breakable" ng-repeat="(area, orientadores) in relatorio.porOrientador"><thead><tr><th class="area"><strong>{{ area }}</strong></th></tr></thead><tbody ng-repeat="(orientador, itens) in orientadores"><tr><td class="orientador"><strong>Orientador:</strong> {{ orientador }}</td><td></td></tr><tr ng-repeat="item in itens"><td><table class="plano-pesquisa"><tr><td id="matricula">{{ item.matricula }}</td><td id="nome">{{ item.nomeAluno }}</td><td id="situacao">{{ item.situacao }}</td><td id="data-inicio">{{ item.dataInicio }}</td><td id="data-entrega">{{ item.dataEntrega }}</td></tr><tr><td id="titulo" colspan="5" ng-if="item.tituloPlanoPesquisa">{{item.tituloPlanoPesquisa}}</td><td id="titulo" colspan="5" ng-if="!item.tituloPlanoPesquisa" class="sem-plano">Sem Plano de Pesquisa</td></tr><tr class="page-break"></tr></table></td></tr></tbody></table></td><td></td></tr><tr><td></td><td class="right"><strong>Total Geral: {{ relatorio.totalGeral }}</strong></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.porOrientador == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/relatorios/relatorio/listagens/semPlanoPesquisa.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio listagens"><div id="semPlanoPesquisa" class="panel animated zoomIn" ng-show="relatorio.semPlanoPesquisa != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>Alunos sem Plano de Pesquisa</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th colspan="5"><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td colspan="5"><strong>Rela\xE7\xE3o de Alunos sem Plano de Pesquisa</strong></td></tr><tr><td class="left" width="10%">N\xBA Fenix</td><td class="left" width="65%">Nome</td><td class="left" width="10%">Situa\xE7\xE3o</td><td class="left" width="15%">In\xEDcio</td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo" ng-repeat="(area, orientadores) in relatorio.semPlanoPesquisa"><thead><tr><th class="area"><strong>{{ area }}</strong></th></tr></thead><tbody ng-repeat="(orientador, itens) in orientadores"><tr><td class="orientador"><strong>Orientador:</strong> {{ orientador }}</td><td></td></tr><tr ng-repeat="item in itens"><td><table class="plano-pesquisa"><tr><td id="matricula">{{ item.matricula }}</td><td id="nome">{{ item.nomeAluno }}</td><td id="situacao">{{ item.situacao }}</td><td id="data-inicio">{{ item.dataInicio }}</td></tr></table></td></tr></tbody></table></td><td></td></tr><tr><td></td><td class="right"><strong>Total Geral: {{ relatorio.totalGeral }}</strong></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.semPlanoPesquisa == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/relatorios/relatorio/periodo/comExameQualificacao.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio periodo"><div id="comExameQualificacao" class="panel animated zoomIn" ng-show="relatorio.comExameQualificacao != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>Alunos com Exame de Qualifica\xE7\xE3o</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th colspan="6"><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td colspan="6"><strong>Rela\xE7\xE3o de Exame de Qualifica\xE7\xE3o</strong></td></tr><tr><td class="left" width="10%">N\xBA Fenix</td><td class="left" width="45%">Nome</td><td class="center" width="5%">N\xEDvel</td><td class="center" width="10%">Situa\xE7\xE3o</td><td class="center" width="15%">Ex. Qualif.</td><td class="center" width="15%">Prazo Final</td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo" ng-repeat="(area, itens) in relatorio.comExameQualificacao"><thead><tr><th class="area"><strong>{{ area }}</strong></th></tr></thead><tbody><tr ng-repeat="(key, item) in itens"><td ng-if="!$last"><table class="aluno"><tr><td id="matricula">{{ item.matricula }}</td><td id="nome">{{ item.nomeAluno }}</td><td id="nivel">{{ item.nivel }}</td><td id="situacao">{{ item.situacao }}</td><td id="exame-qualificacao">{{ item.dataExameQualificacao }}</td><td id="prazo-final">{{ item.dataPrazoFinal }}</td></tr></table></td><td ng-if="$last"><table class="subtotais"><tr><td ng-repeat="(nivel, total) in item"><strong>{{ nivel }}:</strong>{{ total }}</td></tr></table></td></tr></tbody></table></td><td></td></tr><tr><td></td><td class="right"><table class="subtotais"><tr><td ng-repeat="(nivel, total) in relatorio.total"><strong>{{ nivel }}:</strong>{{ total }}</td></tr></table></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.comExameQualificacao == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/relatorios/relatorio/periodo/comPrazoFinal.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio periodo"><div id="comPrazoFinal" class="panel animated zoomIn" ng-show="relatorio.comPrazoFinal != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>Alunos com Prazo Final</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th colspan="5"><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td colspan="5"><strong>Rela\xE7\xE3o de Alunos com Prazo Final</strong></td></tr><tr><td colspan="5">Per\xEDodo: {{ relatorio.periodoExame.de | date:"dd/MM/yyyy" }} \xE0 {{ relatorio.periodoExame.ate | date:"dd/MM/yyyy" }}</td></tr><tr><td class="left" width="10%">N\xBA Fenix</td><td class="left" width="50%">Nome</td><td class="center" width="10%">N\xEDvel</td><td class="center" width="15%">Prazo Final</td><td class="center" width="15%">Dep. Trabalho</td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo" ng-repeat="(area, itens) in relatorio.comPrazoFinal"><thead><tr><th class="area"><strong>{{ area }}</strong></th></tr></thead><tbody><tr ng-repeat="item in itens"><td><table class="aluno"><tr><td id="matricula">{{ item.matricula }}</td><td id="nome">{{ item.nomeAluno }}</td><td id="nivel">{{ item.nivel }}</td><td id="prazo-final">{{ item.dataPrazoFinal }}</td><td id="deposito-trabalho">{{ item.dataDepositoTrabalho }}</td></tr></table></td></tr></tbody></table></td><td></td></tr><tr><td></td><td class="right"><table class="subtotais"><tr><td ng-repeat="(nivel, total) in relatorio.total"><strong>{{ nivel }}:</strong>{{ total }}</td></tr></table></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.comPrazoFinal == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/relatorios/relatorio/periodo/comPrazoFinalTrancamento.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio periodo"><div id="comPrazoFinalTrancamento" class="panel animated zoomIn" ng-show="relatorio.comPrazoFinalTrancamento != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>Alunos com Prazo Final do Trancamento</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th colspan="5"><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td colspan="5"><strong>Rela\xE7\xE3o de Alunos com Prazo Final do Trancamento</strong></td></tr><tr><td colspan="5">Per\xEDodo: {{ relatorio.periodoExame.de | date:"dd/MM/yyyy" }} \xE0 {{ relatorio.periodoExame.ate | date:"dd/MM/yyyy" }}</td></tr><tr><td class="left" width="10%">N\xBA Fenix</td><td class="left" width="50%" center="">Nome</td><td class="center" width="10%">N\xEDvel</td><td class="center" width="15%">Inicio Tranc.</td><td class="center" width="15%">Final Tranc.</td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo" ng-repeat="(area, itens) in relatorio.comPrazoFinalTrancamento"><thead><tr><th class="area"><strong>{{ area }}</strong></th></tr></thead><tbody><tr ng-repeat="item in itens"><td><table class="aluno"><tr><td id="matricula">{{ item.matricula }}</td><td id="nome">{{ item.nomeAluno }}</td><td id="nivel">{{ item.nivel }}</td><td id="inicio-trancamento">{{ item.dataInicioTrancamento }}</td><td id="fim-trancamento">{{ item.dataFimTrancamento }}</td></tr></table></td></tr></tbody></table></td><td></td></tr><tr><td></td><td class="right"><table class="subtotais"><tr><td ng-repeat="(nivel, total) in relatorio.total"><strong>{{ nivel }}:</strong>{{ total }}</td></tr></table></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.comPrazoFinalTrancamento == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/relatorios/relatorio/periodo/numeroGeralAlunosPorArea.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio periodo"><div id="numeroGeralAlunosPorArea" class="panel animated zoomIn" ng-show="relatorio.numeroGeralAlunosPorArea != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>N\xBA de Alunos por \xC1rea</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td><strong>N\xBA de Alunos por \xC1rea</strong></td></tr><tr><td>Per\xEDodo: {{ relatorio.periodoExame.de | date:"dd/MM/yyyy" }} \xE0 {{ relatorio.periodoExame.ate | date:"dd/MM/yyyy" }}</td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo"><thead><th class="left">PROGRAMA</th><th class="center">ME</th><th class="center">DO</th><th class="center">TOTAL</th></thead><tbody ng-repeat="(area, niveis) in relatorio.numeroGeralAlunosPorArea"><tr><td width="70%" class="area"><strong>{{ area }}</strong></td><td width="10%" class="center" ng-repeat="total in niveis">{{ total }}</td></tr></tbody></table></td><td></td></tr><tr><td></td><td class="right"><table class="totais"><tr ng-repeat="(nivel, total) in relatorio.total" class="{{ nivel | lowercase }}"><th>{{ nivel }}</th><td>{{ total }}</td></tr></table></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.numeroGeralAlunosPorArea == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/relatorios/relatorio/periodo/semExameQualificacao.html','<div class="widgets"><div class="row"><div class="col-md-12 relatorio periodo"><div id="semExameQualificacao" class="panel animated zoomIn" ng-show="relatorio.semExameQualificacao != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><tr><th></th><th><img ng-src="{{::( \'logo\' | rootImage )}}"></th><th></th></tr><tr><td></td><td><h2>Alunos sem Exame de Qualifica\xE7\xE3o</h2></td><td></td></tr><tr><td></td><td><table class="cabecalho"><tr><th colspan="6"><span class="texto-grande">Faculdade de Medicina da Universidade de S\xE3o Paulo</span><br><span class="texto-medio">Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o</span></th></tr><tr><td colspan="6"><strong>Rela\xE7\xE3o de Alunos sem Exame de Qualifica\xE7\xE3o</strong></td></tr><tr><td class="left" width="10%">N\xBA Fenix</td><td class="left" width="45%">Nome</td><td class="center" width="5%">N\xEDvel</td><td class="center" width="10%">Situa\xE7\xE3o</td><td class="center" width="15%">Ex. Qualif.</td><td class="center" width="15%">Prazo Final</td></tr></table></td><td></td></tr><tr><td></td><td><table class="corpo" ng-repeat="(area, itens) in relatorio.semExameQualificacao"><thead><tr><th class="area"><strong>{{ area }}</strong></th></tr></thead><tbody><tr ng-repeat="(key, item) in itens"><td ng-if="!$last"><table class="aluno"><tr><td id="matricula">{{ item.matricula }}</td><td id="nome">{{ item.nomeAluno }}</td><td id="nivel">{{ item.nivel }}</td><td id="situacao">{{ item.situacao }}</td><td id="exame-qualificacao">{{ item.dataExameQualificacao }}</td><td id="prazo-final">{{ item.dataPrazoFinal }}</td></tr></table></td><td ng-if="$last"><table class="subtotais"><tr><td ng-repeat="(nivel, total) in item"><strong>{{ nivel }}:</strong>{{ total }}</td></tr></table></td></tr></tbody></table></td><td></td></tr><tr><td></td><td><table class="subtotais"><tr><td ng-repeat="(nivel, total) in relatorio.total"><strong>{{ nivel }}:</strong>{{ total }}</td></tr></table></td><td></td></tr></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="relatorio.semExameQualificacao == null" style="margin: -10px 10px;" onclick="window.print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/datePickers/datePickers.html','<div class="datepicker row"><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerCtrl"><h4>Inline</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><div class="uib-datepicker-wrap"><uib-datepicker ng-model="dt" datepicker-options="options"></uib-datepicker></div></div><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerpopupCtrl"><h4>Popup</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label>Format: <span class="muted-text">(manual alternate <em>{{altInputFormats[0]}}</em>)</span></label><select class="form-control" ng-model="format" ng-options="f for f in formats"><option></option></select></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSwitches/switch.html','<div ng-controller="OldSwitchPanelCtrl as switchPanelVm" class="switches clearfix"><switch color="primary" ng-model="switchPanelVm.switcherValues.primary"></switch><switch color="warning" ng-model="switchPanelVm.switcherValues.warning"></switch><switch color="danger" ng-model="switchPanelVm.switcherValues.danger"></switch><switch color="info" ng-model="switchPanelVm.switcherValues.info"></switch><switch color="success" ng-model="switchPanelVm.switcherValues.success"></switch></div>');
$templateCache.put('app/pages/form/inputs/widgets/select/select.html','<div class="ng-cloak" ng-controller="SelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><ui-select ng-model="selectpickerVm.selectedItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Standard Select"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="standardItem in selectpickerVm.standardSelectItems | filter: $select.search"><span ng-bind-html="standardItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.withSearchItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Search">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="withSearchItem in selectpickerVm.selectWithSearchItems | filter: $select.search"><span ng-bind-html="withSearchItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.disableItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Disabled Selection"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="disableItem in selectpickerVm.disableItems | filter: $select.search"><span ng-bind-html="disableItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="groupedItems in selectpickerVm.groupedSelectItems | groupSelectpickerOptions: {label: $select.search}" group-by="\'group\'"><span ng-bind-html="groupedItems.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedByItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups Function">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="groupedByItems in selectpickerVm.groupedBySelectItems | filter: $select.search" group-by="selectpickerVm.someGroupFn"><span ng-bind-html="groupedByItems.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select multiple="" ng-model="selectpickerVm.multipleItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control"><ui-select-match placeholder="Multiple Select">{{$item.label}}</ui-select-match><ui-select-choices repeat="multipleItem in selectpickerVm.multipleSelectItems | filter: $select.search">{{multipleItem.label}}</ui-select-choices></ui-select></div><div class="form-group"><div class="input-group"><ui-select multiple="" ng-model="selectpickerVm.withDeleteItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control form-control"><ui-select-match placeholder="Select With Clear Button">{{$item.label}}</ui-select-match><ui-select-choices repeat="withDeleteItem in selectpickerVm.withDeleteSelectItems | filter: $select.search">{{withDeleteItem.label}}</ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="selectpickerVm.withDeleteItem.selected = undefined" class="btn btn-danger"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/switches/switch.html','<div ng-controller="SwitchDemoPanelCtrl as vm"><ba-switcher switcher-style="primary" switcher-value="vm.switches.s1"></ba-switcher><ba-switcher switcher-style="success" switcher-value="vm.switches.s2"></ba-switcher><ba-switcher switcher-style="warning" switcher-value="vm.switches.s3"></ba-switcher><ba-switcher switcher-style="danger" switcher-value="vm.switches.s4"></ba-switcher><ba-switcher switcher-style="info" switcher-value="vm.switches.s5"></ba-switcher></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSelect/select.html','<div ng-controller="OldSelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><select class="form-control selectpicker" selectpicker="" title="Standard Select" ng-model="selectpickerVm.standardSelected" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"></select></div><div class="form-group"><select class="form-control selectpicker with-search" data-live-search="true" title="Select With Search" selectpicker="" ng-model="selectpickerVm.searchSelectedItem" ng-options="item as item.label for item in selectpickerVm.selectWithSearchItems"></select></div><div class="form-group"><select class="form-control selectpicker" title="Option Types" selectpicker=""><option>Standard option</option><option data-subtext="option subtext">Option with subtext</option><option disabled="">Disabled Option</option><option data-icon="glyphicon-heart">Option with cion</option></select></div><div class="form-group"><select class="form-control selectpicker" disabled="" title="Disabled Select" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Option Groups" selectpicker="" ng-model="selectpickerVm.groupedSelectedItem" ng-options="item as item.label group by item.group for item in selectpickerVm.groupedSelectItems"></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Divider" selectpicker=""><option>Group 1 - Option 1</option><option>Group 1 - Option 2</option><option data-divider="true"></option><option>Group 2 - Option 1</option><option>Group 2 - Option 2</option></select></div></div></div><div class="form-group"><select class="form-control" title="Multiple Select" multiple="" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="form-group"><select class="form-control" title="Multiple Select with Limit" multiple="" data-max-options="2" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems2" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Primary Select" data-style="btn-primary" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Success Select" data-style="btn-success" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Warning Select" data-style="btn-warning" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Info Select" data-style="btn-info" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Danger Select" data-style="btn-danger" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Inverse Select" data-style="btn-inverse" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/tagsInput/tagsInput.html','<div class="form-group"><div class="form-group"><input type="text" tag-input="primary" value="Amsterdam,Washington,Sydney,Beijing,Cairo" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="warning" value="Minsk,Prague,Vilnius,Warsaw" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="danger" value="London,Berlin,Paris,Rome,Munich" data-role="tagsinput" placeholder="Add Tag"></div></div>');
$templateCache.put('app/pages/alunos/situacao/documentos/oficios/ata/ata.html','<div class="widgets"><div class="row"><div class="col-md-12"><response-message msg="mensagem"></response-message><div id="ata" class="panel animated zoomIn" ng-show="ata != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><thead ng-include="\'app/pages/alunos/header.html\'"></thead><tbody><tr><th><h2>Julgamento da {{ ata.nivelPrograma }}</h2></th></tr><tr><td class="left">ALUNO(A): <strong>{{ ata.nomeAluno }}</strong></td></tr><tr><td class="left">{{ata.areaDeclaracao}} <strong>{{ ata.nomeArea }}</strong></td></tr><tr><td class="left">Relat\xF3rio da Comiss\xE3o Julgadora:</td></tr><tr><td class="texto-principal">Aos <strong>{{ ata.agenda.dataDefesa1 }}</strong>, atendendo ao disposto no Regimento da P\xF3s-Gradua\xE7\xE3o da Universidade de S\xE3o Paulo, o(a) candidato(a) <strong>{{ ata.nomeAluno }}</strong> ao t\xEDtulo de <strong>{{ ata.nivel }}</strong>, apresentou sua <strong>{{ ata.nivelPrograma }}</strong> com o t\xEDtulo: {{ ata.tituloTrabalho }}.</td></tr><tr><td class="texto-principal">Esta Comiss\xE3o, indicada pela Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o, \xE9 de parecer que:</td></tr><tr><td><hr><hr><hr><hr><hr><hr><hr><hr><hr><hr><hr><hr><hr><hr></td></tr><tr><td class="left">De acordo com o disposto no Regimento da P\xF3s-Gradua\xE7\xE3o da Universidade de S\xE3o Paulo, os Examinadores consideraram o(a) candidato(a): <strong>{{ ata.nomeAluno }}</strong></td></tr><tr class="data"><td>S\xE3o Paulo, <strong>{{ ata.agenda.dataDefesa }}</strong></td></tr><tr class="page-break {{ ata.bancada.length >= 3 ? \'next-page\':\'\' }}"><td class="left"><strong>COMISS\xC3O EXAMINADORA:</strong></td></tr><tr><td class="left"><div class="bancada"><div ng-repeat="participante in ata.bancada" class="row-bancada"><div width="15%" class="col-bancada"><span ng-if="participante.titulo != \'Presidente\'">(<input class="sub-linha" type="textfield">) APR (<input class="sub-linha" type="textfield">) REP -</span>{{ participante.nome }} - <span style="text-transform: capitalize;">{{ participante.titulo }}</span></div></div></div></td></tr></tbody><tfoot ng-include="\'app/pages/alunos/footer.html\'"></tfoot></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="ata == null" style="margin: -10px 10px;" ng-click="print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/situacao/documentos/oficios/aviso/aviso.html','<div class="widgets"><div class="row"><div class="col-md-12"><response-message msg="mensagem"></response-message><div id="aviso" class="panel animated zoomIn" ng-show="aviso != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><thead ng-include="\'app/pages/alunos/header.html\'"></thead><tbody><tr><td class="right">{{ aviso.dataAtual }}</td></tr><tr><td class="left">Prezados Senhores,</td></tr><tr><td class="texto-principal">Informo a V.S\xAA, que a Defesa de <strong>{{ aviso.nivelPrograma }}</strong> do(a) aluno(a) {{ aviso.nomeAluno }}, {{ aviso.areaDeclaracao }} est\xE1 marcada para o dia <strong>{{ aviso.agenda.dataDefesa }}</strong> \xE0s <strong>{{ aviso.agenda.horario }}</strong> no Anfiteatro do(a) <strong>{{ aviso.agenda.local }}</strong>.<br><br><strong>A banca ficou assim constitu\xEDda:</strong><table class="bancada"><tr class="row-bancada" ng-repeat="participante in aviso.bancada"><td class="col-bancada"><select class="sub-linha media"><option value="" selected="selected">Selecione a titula\xE7\xE3o</option><option ng-repeat="titulacao in titulacoes" value="{{ titulacao.id }}">{{ titulacao.value }}</option></select>- {{ participante.nome }}</td><td class="col-bancada"><span style="text-transform: capitalize;">{{ participante.titulo }}</span></td></tr></table></td></tr><tr><td class="center"><img class="assinatura" ng-src="{{assinatura}}"></td></tr></tbody><tfoot ng-include="\'app/pages/alunos/footer.html\'"></tfoot></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="aviso == null" style="margin: -10px 10px;" ng-click="print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/situacao/documentos/oficios/certificado/certificado.html','<div class="widgets"><div class="row"><div class="col-md-12"><response-message msg="mensagem"></response-message><div id="certificado" class="panel animated zoomIn" ng-repeat="participante in certificado.bancada" ng-show="participante.titulacao != \'\'"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><thead ng-include="\'app/pages/alunos/header.html\'"></thead><tbody><tr><td>Conferido ao(\xE0) {{ participante.titulacao.value }}<br></td></tr><tr><td><h2>{{ participante.nome }}</h2></td></tr><tr><td class="texto-principal">Pela participa\xE7\xE3o, como {{ participante.titulo }} da Comiss\xE3o Julgadora da {{ certificado.nivelPrograma }}, intitulada: <strong>{{ certificado.tituloTrabalho }}</strong> do(a) aluno(a) <strong>{{ certificado.nomeAluno }}</strong> {{ certificado.areaDeclaracao }} <strong>{{ certificado.nomeArea }}</strong>, nesta data;</td></tr><tr><td><strong>{{ certificado.agenda.dataDefesa }}</strong></td></tr><tr><td><img class="assinatura" ng-src="{{ assinatura }}"></td></tr></tbody><tfoot ng-include="\'app/pages/alunos/footer.html\'"></tfoot></table><div class="page-break"></div></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="certificado == null" style="margin: -10px 10px;" ng-click="print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/situacao/documentos/oficios/certificado/consulta.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Certificado de Participa\xE7\xE3o" ng-show="!mensagem"><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="row" ng-repeat="participante in certificado.bancada"><div class="col-md-12"><div class="form-group"><label class="col-md-6 col-xs-12">{{ participante.nome }}</label><div class="col-md-6 col-xs-12"><ui-select ng-model="participante.titulacao" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{ participante.titulacao.value }}</span></ui-select-match><ui-select-choices repeat="titulacao in titulacoes"><span>{{ titulacao.value }}</span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-left: 20px;">Voltar</button> <button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-default pull-right" ng-disabled="participante.titulacao == \'\'" ng-click="gerarDeclaracao()" style="margin-right: 20px;">Gerar Declara\xE7\xF5es</button></div></div></form></div><response-message msg="mensagem"></response-message></div></div></div>');
$templateCache.put('app/pages/alunos/situacao/documentos/oficios/declaracao/declaracao.html','<div class="widgets"><div class="row"><div class="col-md-12"><response-message msg="mensagem"></response-message><div id="declaracao" class="panel animated zoomIn" ng-show="declaracao != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><thead ng-include="\'app/pages/alunos/header.html\'"></thead><tbody><tr><td><h2>DECLARA\xC7\xC3O</h2><br><br></td></tr><tr><td class="texto-principal"><strong>DECLARO</strong>, para os devidos fins, que o(a) aluno(a) <strong>{{ declaracao.nomeAluno }}</strong> defendeu a <strong>{{ declaracao.nivelPrograma }}</strong> em {{ declaracao.portaria.dataDefesa }}, intitulada: <strong>{{ declaracao.tituloTrabalho }}</strong>, tendo sido aprovado(a) {{ declaracao.areaDeclaracao }}, reconhecido conforme Portaria {{ declaracao.portaria.portaria }}<br><br><br></td></tr><tr><td class="left"><strong>Obs.:</strong> O diploma est\xE1 em fase de confec\xE7\xE3o.<br><br></td></tr><tr><td>{{ date | date:"\'S\xE3o Paulo\', dd \'de\' MMMM \'de\' yyyy"}}<br><br><br></td></tr><tr><td class="center"><strong>{{ declaracao.nomeChefeServicoPosGraduacao }}</strong><br>{{ declaracao.cargo }}</td></tr></tbody><tfoot ng-include="\'app/pages/alunos/footer.html\'"></tfoot></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="declaracao == null" style="margin: -10px 10px;" ng-click="print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/situacao/documentos/oficios/diploma/diploma.html','<div class="widgets" id="oficio"><div class="row"><div class="col-md-12"><response-message msg="mensagem"></response-message><div id="diploma" class="panel animated zoomIn" ng-show="diploma != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><thead ng-include="\'app/pages/alunos/header.html\'"></thead><tbody><tr><td class="left">Para: {{ diploma.para }}<br><br><br></td></tr><tr><td class="left">Interessado(a): <strong>{{ diploma.interessado }}</strong><br>{{ diploma.areaDeclaracao }} <strong>{{ diploma.programa }}</strong><br>Data da defesa: <strong>{{ diploma.especializacao.dataDefesa }}</strong><br><br><br></td></tr><tr><td class="texto-principal">Atendendo os dispositivos legais, segue a documenta\xE7\xE3o para expedi\xE7\xE3o e registro de diploma de <strong>{{ diploma.nivel }}</strong>.<br><br><br></td></tr><tr><td><strong>{{ diploma.nomeChefeServicoPosGraduacao }}</strong><br>{{ diploma.cargo }}</td></tr></tbody><tfoot ng-include="\'app/pages/alunos/footer.html\'"></tfoot></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="diploma == null" style="margin: -10px 10px;" ng-click="print();">Imprimir</button><br></div></div></div></div></div>');
$templateCache.put('app/pages/alunos/situacao/documentos/oficios/membrosAluno/consulta.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Of\xEDcio - Membros e Aluno" ng-show="!mensagem"><form class="form-horizontal ng-pristine ng-valid ng-scope"><div class="row"><div class="col-md-12"><div class="form-group"><label for="coordenador" class="col-md-2 control-label">Coordenador</label><div class="col-md-10"><input type="text" class="form-control" id="coordenador" ng-model="membrosAluno.coordenador"></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="programa" class="col-md-2 control-label">Programa</label><div class="col-md-10"><input type="text" class="form-control" id="programa" ng-model="membrosAluno.programa"></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-left: 20px;">Voltar</button> <button type="button" class="btn btn-danger pull-right" ng-click="limpar()">Limpar</button> <button type="button" class="btn btn-default pull-right" ng-click="gerarOficio()" style="margin-right: 20px;">Gerar Of\xEDcio</button></div></div></form></div><response-message msg="mensagem"></response-message></div></div></div>');
$templateCache.put('app/pages/alunos/situacao/documentos/oficios/membrosAluno/membrosAluno.html','<div class="widgets"><div class="row"><div class="col-md-12"><response-message msg="mensagem"></response-message><div id="membros-aluno" class="panel animated zoomIn" ng-show="membrosAluno != null"><div class="panel-heading clearfix"><h3 class="panel-title">Folha de impress\xE3o</h3></div><div class="panel-body footer-panel"><div id="section-to-print"><table><thead ng-include="\'app/pages/alunos/header.html\'"></thead><tbody><tr><td class="right">{{ date | date:"\'S\xE3o Paulo\', dd \'de\' MMMM \'de\' yyyy"}}<br><br><br></td></tr><tr><td class="left">Prezado(a) Professor(a),<br><br><br></td></tr><tr><td class="texto-principal">O Sr. Presidente da Comiss\xE3o de P\xF3s-Gradua\xE7\xE3o da FMUSP, Prof. {{ membrosAluno.nomePresidente }}, aprovou "<strong>ad referendum</strong>" em {{ membrosAluno.dataProvaBanca }}, a composi\xE7\xE3o da Comiss\xE3o Julgadora da <strong>{{ membrosAluno.nivelPrograma }}</strong> do(a) p\xF3s-graduando(a) <strong>{{ membrosAluno.nomeAluno }}</strong>, {{membrosAluno.areaDeclaracao}} que ficou assim constitu\xEDda:<table class="bancada"><tr class="row-bancada" ng-repeat="participante in membrosAluno.bancada"><td class="col-bancada">{{ participante.nome }}</td><td class="col-bancada"><span style="text-transform: capitalize;">{{ participante.titulo | uppercase }}</span></td></tr></table></td></tr><tr><td class="left">A argui\xE7\xE3o acontecer\xE1 no dia <strong>{{ membrosAluno.agenda.dataDefesa }}</strong> \xE0s <strong>{{ membrosAluno.agenda.horario }}</strong> no Anfiteatro do(a) <strong>{{ membrosAluno.agenda.local }}</strong>.</td></tr><tr><td><br><br><br>Atenciosamente,<br><br><br></td></tr><tr><td class="left">Ilmo(a) Sr(a) <strong>Prof(a) Dr(a) {{ membrosAluno.coordenador }}</strong><br>MD. Coord(a). do Programa de P\xF3s-Gradua\xE7\xE3o em <strong>{{ membrosAluno.programa }}</strong><br><br><br></td></tr><tr><td class="left"><table class="info"><tr><td width="10%">cc.:</td><td>1) P\xF3s-graduando(a)</td></tr><tr><td></td><td>2) Membros da Comiss\xE3o Julgadora, com exemplar anexo.</td></tr></table></td></tr></tbody><tfoot ng-include="\'app/pages/alunos/footer.html\'"></tfoot></table></div></div><div class="panel-footer"><button type="button" class="btn btn-default pull-right" onclick="history.back();" style="margin-top: -10px;">Voltar</button> <button type="button" class="btn btn-default pull-right" ng-hide="membrosAluno == null" style="margin: -10px 10px;" ng-click="print();">Imprimir</button><br></div></div></div></div></div>');}]);